function _typeof(mt) {
    return (_typeof =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
            ? function (se) {
                  return typeof se;
              }
            : function (se) {
                  return se && typeof Symbol == "function" && se.constructor === Symbol && se !== Symbol.prototype ? "symbol" : typeof se;
              })(mt);
}
(function (mt, se) {
    "use strict";
    (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && _typeof(module.exports) == "object"
        ? (module.exports = mt.document
              ? se(mt, !0)
              : function (Le) {
                    if (!Le.document) throw new Error("jQuery requires a window with a document");
                    return se(Le);
                })
        : se(mt);
})(typeof window != "undefined" ? window : this, function (mt, se) {
    "use strict";
    function Le(t) {
        return t != null && t === t.window;
    }
    var ve = [],
        jn = Object.getPrototypeOf,
        be = ve.slice,
        Ln = ve.flat
            ? function (t) {
                  return ve.flat.call(t);
              }
            : function (t) {
                  return ve.concat.apply([], t);
              },
        sn = ve.push,
        bn = ve.indexOf,
        Ve = {},
        Pn = Ve.toString,
        ue = Ve.hasOwnProperty,
        ei = ue.toString,
        $n = ei.call(Object),
        St = {},
        yt = function (t) {
            return typeof t == "function" && typeof t.nodeType != "number";
        },
        xt = mt.document,
        Nn = { type: !0, src: !0, nonce: !0, noModule: !0 };
    function Yn(t, n, o) {
        var a,
            g,
            w = (o = o || xt).createElement("script");
        if (((w.text = t), n)) for (a in Nn) (g = n[a] || (n.getAttribute && n.getAttribute(a))) && w.setAttribute(a, g);
        o.head.appendChild(w).parentNode.removeChild(w);
    }
    function fn(t) {
        return t == null ? t + "" : _typeof(t) == "object" || typeof t == "function" ? Ve[Pn.call(t)] || "object" : _typeof(t);
    }
    var Jt = "3.5.1",
        c = function t(n, o) {
            return new t.fn.init(n, o);
        };
    function Mn(t) {
        var n = !!t && "length" in t && t.length,
            o = fn(t);
        return !yt(t) && !Le(t) && (o === "array" || n === 0 || (typeof n == "number" && 0 < n && n - 1 in t));
    }
    (c.fn = c.prototype = {
        jquery: Jt,
        constructor: c,
        length: 0,
        toArray: function () {
            return be.call(this);
        },
        get: function (t) {
            return t == null ? be.call(this) : t < 0 ? this[t + this.length] : this[t];
        },
        pushStack: function (t) {
            return (t = c.merge(this.constructor(), t)), (t.prevObject = this), t;
        },
        each: function (t) {
            return c.each(this, t);
        },
        map: function (t) {
            return this.pushStack(
                c.map(this, function (n, o) {
                    return t.call(n, o, n);
                })
            );
        },
        slice: function () {
            return this.pushStack(be.apply(this, arguments));
        },
        first: function () {
            return this.eq(0);
        },
        last: function () {
            return this.eq(-1);
        },
        even: function () {
            return this.pushStack(
                c.grep(this, function (t, n) {
                    return (n + 1) % 2;
                })
            );
        },
        odd: function () {
            return this.pushStack(
                c.grep(this, function (t, n) {
                    return n % 2;
                })
            );
        },
        eq: function (t) {
            var n = this.length,
                t = +t + (t < 0 ? n : 0);
            return this.pushStack(0 <= t && t < n ? [this[t]] : []);
        },
        end: function () {
            return this.prevObject || this.constructor();
        },
        push: sn,
        sort: ve.sort,
        splice: ve.splice,
    }),
        (c.extend = c.fn.extend = function () {
            var t,
                n,
                o,
                a,
                g,
                w = arguments[0] || {},
                C = 1,
                E = arguments.length,
                P = !1;
            for (typeof w == "boolean" && ((P = w), (w = arguments[C] || {}), C++), _typeof(w) == "object" || yt(w) || (w = {}), C === E && ((w = this), C--); C < E; C++)
                if ((t = arguments[C]) != null)
                    for (n in t)
                        (o = t[n]),
                            n !== "__proto__" &&
                                w !== o &&
                                (P && o && (c.isPlainObject(o) || (a = Array.isArray(o)))
                                    ? ((g = w[n]), (g = a && !Array.isArray(g) ? [] : a || c.isPlainObject(g) ? g : {}), (a = !1), (w[n] = c.extend(P, g, o)))
                                    : o !== void 0 && (w[n] = o));
            return w;
        }),
        c.extend({
            expando: "jQuery" + (Jt + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function (t) {
                throw new Error(t);
            },
            noop: function () {},
            isPlainObject: function (t) {
                return !(!t || Pn.call(t) !== "[object Object]" || ((t = jn(t)) && (typeof (t = ue.call(t, "constructor") && t.constructor) != "function" || ei.call(t) !== $n)));
            },
            isEmptyObject: function (t) {
                for (var n in t) return !1;
                return !0;
            },
            globalEval: function (t, n, o) {
                Yn(t, { nonce: n && n.nonce }, o);
            },
            each: function (t, n) {
                var o,
                    a = 0;
                if (Mn(t)) for (o = t.length; a < o && n.call(t[a], a, t[a]) !== !1; a++);
                else for (a in t) if (n.call(t[a], a, t[a]) === !1) break;
                return t;
            },
            makeArray: function (t, n) {
                return (n = n || []), t != null && (Mn(Object(t)) ? c.merge(n, typeof t == "string" ? [t] : t) : sn.call(n, t)), n;
            },
            inArray: function (t, n, o) {
                return n == null ? -1 : bn.call(n, t, o);
            },
            merge: function (t, n) {
                for (var o = +n.length, a = 0, g = t.length; a < o; a++) t[g++] = n[a];
                return (t.length = g), t;
            },
            grep: function (t, n, o) {
                for (var a = [], g = 0, w = t.length, C = !o; g < w; g++) !n(t[g], g) != C && a.push(t[g]);
                return a;
            },
            map: function (t, n, o) {
                var a,
                    g,
                    w = 0,
                    C = [];
                if (Mn(t)) for (a = t.length; w < a; w++) (g = n(t[w], w, o)) != null && C.push(g);
                else for (w in t) (g = n(t[w], w, o)) != null && C.push(g);
                return Ln(C);
            },
            guid: 1,
            support: St,
        }),
        typeof Symbol == "function" && (c.fn[Symbol.iterator] = ve[Symbol.iterator]),
        c.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (t, n) {
            Ve["[object " + n + "]"] = n.toLowerCase();
        });
    var xe = (function (t) {
        function n(x, z) {
            return (x = "0x" + x.slice(1) - 65536), z || (x < 0 ? String.fromCharCode(65536 + x) : String.fromCharCode((x >> 10) | 55296, (1023 & x) | 56320));
        }
        function o() {
            nt();
        }
        var a,
            g,
            w,
            C,
            E,
            P,
            N,
            R,
            M,
            B,
            V,
            nt,
            st,
            bt,
            Bt,
            Lt,
            Ee,
            $t,
            yn,
            pt = "sizzle" + +new Date(),
            Ht = t.document,
            Se = 0,
            dn = 0,
            ti = vi(),
            Xn = vi(),
            Tn = vi(),
            ze = vi(),
            fe = function (x, z) {
                return x === z && (V = !0), 0;
            },
            tn = {}.hasOwnProperty,
            Ye = [],
            On = Ye.pop,
            De = Ye.push,
            Nt = Ye.push,
            de = Ye.slice,
            we = function (x, z) {
                for (var S = 0, q = x.length; S < q; S++) if (x[S] === z) return S;
                return -1;
            },
            Kt = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            Tt = "[\\x20\\t\\r\\n\\f]",
            en = "(?:\\\\[\\da-fA-F]{1,6}" + Tt + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            fi = "\\[" + Tt + "*(" + en + ")(?:" + Tt + "*([*^$|!~]?=)" + Tt + `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + en + "))|)" + Tt + "*\\]",
            Si = ":(" + en + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + fi + ")*)|.*)\\)|)",
            Vi = new RegExp(Tt + "+", "g"),
            gi = new RegExp("^" + Tt + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Tt + "+$", "g"),
            Qi = new RegExp("^" + Tt + "*," + Tt + "*"),
            Pi = new RegExp("^" + Tt + "*([>+~]|" + Tt + ")" + Tt + "*"),
            Zi = new RegExp(Tt + "|>"),
            Ki = new RegExp(Si),
            Ji = new RegExp("^" + en + "$"),
            mi = {
                ID: new RegExp("^#(" + en + ")"),
                CLASS: new RegExp("^\\.(" + en + ")"),
                TAG: new RegExp("^(" + en + "|[*])"),
                ATTR: new RegExp("^" + fi),
                PSEUDO: new RegExp("^" + Si),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + Tt + "*(even|odd|(([+-]|)(\\d*)n|)" + Tt + "*(?:([+-]|)" + Tt + "*(\\d+)|))" + Tt + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + Kt + ")$", "i"),
                needsContext: new RegExp("^" + Tt + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + Tt + "*((?:-\\d)?\\d*)" + Tt + "*\\)|)(?=[^-]|$)", "i"),
            },
            ts = /HTML$/i,
            es = /^(?:input|select|textarea|button)$/i,
            ns = /^h\d$/i,
            ci = /^[^{]+\{\s*\[native \w/,
            is = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            $i = /[+~]/,
            Sn = new RegExp("\\\\[\\da-fA-F]{1,6}" + Tt + "?|\\\\([^\\r\\n\\f])", "g"),
            Ni = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            Mi = function (x, z) {
                return z ? (x === "\0" ? "\uFFFD" : x.slice(0, -1) + "\\" + x.charCodeAt(x.length - 1).toString(16) + " ") : "\\" + x;
            },
            ss = wi(
                function (x) {
                    return x.disabled === !0 && x.nodeName.toLowerCase() === "fieldset";
                },
                { dir: "parentNode", next: "legend" }
            );
        try {
            Nt.apply((Ye = de.call(Ht.childNodes)), Ht.childNodes), Ye[Ht.childNodes.length].nodeType;
        } catch {
            Nt = {
                apply: Ye.length
                    ? function (z, S) {
                          De.apply(z, de.call(S));
                      }
                    : function (z, S) {
                          for (var q = z.length, U = 0; (z[q++] = S[U++]); );
                          z.length = q - 1;
                      },
            };
        }
        function Rt(x, z, S, q) {
            var U,
                ot,
                rt,
                ut,
                dt,
                Et,
                jt = z && z.ownerDocument,
                Mt = z ? z.nodeType : 9;
            if (((S = S || []), typeof x != "string" || !x || (Mt !== 1 && Mt !== 9 && Mt !== 11))) return S;
            if (!q && (nt(z), (z = z || st), Bt)) {
                if (Mt !== 11 && (ut = is.exec(x)))
                    if ((Et = ut[1])) {
                        if (Mt === 9) {
                            if (!(ot = z.getElementById(Et))) return S;
                            if (ot.id === Et) return S.push(ot), S;
                        } else if (jt && (ot = jt.getElementById(Et)) && yn(z, ot) && ot.id === Et) return S.push(ot), S;
                    } else {
                        if (ut[2]) return Nt.apply(S, z.getElementsByTagName(x)), S;
                        if ((Et = ut[3]) && g.getElementsByClassName && z.getElementsByClassName) return Nt.apply(S, z.getElementsByClassName(Et)), S;
                    }
                if (g.qsa && !ze[x + " "] && (!Lt || !Lt.test(x)) && (Mt !== 1 || z.nodeName.toLowerCase() !== "object")) {
                    if (((Et = x), (jt = z), Mt === 1 && (Zi.test(x) || Pi.test(x)))) {
                        for (((jt = ($i.test(x) && Ai(z.parentNode)) || z) === z && g.scope) || ((rt = z.getAttribute("id")) ? (rt = rt.replace(Ni, Mi)) : z.setAttribute("id", (rt = pt))), U = (dt = P(x)).length; U--; )
                            dt[U] = (rt ? "#" + rt : ":scope") + " " + yi(dt[U]);
                        Et = dt.join(",");
                    }
                    try {
                        return Nt.apply(S, jt.querySelectorAll(Et)), S;
                    } catch {
                        ze(x, !0);
                    } finally {
                        rt === pt && z.removeAttribute("id");
                    }
                }
            }
            return R(x.replace(gi, "$1"), z, S, q);
        }
        function vi() {
            var x = [];
            return function z(S, q) {
                return x.push(S + " ") > w.cacheLength && delete z[x.shift()], (z[S + " "] = q);
            };
        }
        function pn(x) {
            return (x[pt] = !0), x;
        }
        function hn(x) {
            var z = st.createElement("fieldset");
            try {
                return !!x(z);
            } catch {
                return !1;
            } finally {
                z.parentNode && z.parentNode.removeChild(z), (z = null);
            }
        }
        function ki(x, z) {
            for (var S = x.split("|"), q = S.length; q--; ) w.attrHandle[S[q]] = z;
        }
        function qi(x, z) {
            var S = z && x,
                q = S && x.nodeType === 1 && z.nodeType === 1 && x.sourceIndex - z.sourceIndex;
            if (q) return q;
            if (S) {
                for (; (S = S.nextSibling); ) if (S === z) return -1;
            }
            return x ? 1 : -1;
        }
        function Ii(x) {
            return function (z) {
                return "form" in z
                    ? z.parentNode && z.disabled === !1
                        ? "label" in z
                            ? "label" in z.parentNode
                                ? z.parentNode.disabled === x
                                : z.disabled === x
                            : z.isDisabled === x || (z.isDisabled !== !x && ss(z) === x)
                        : z.disabled === x
                    : "label" in z && z.disabled === x;
            };
        }
        function Gn(x) {
            return pn(function (z) {
                return (
                    (z = +z),
                    pn(function (S, q) {
                        for (var U, ot = x([], S.length, z), rt = ot.length; rt--; ) S[(U = ot[rt])] && (S[U] = !(q[U] = S[U]));
                    })
                );
            });
        }
        function Ai(x) {
            return x && x.getElementsByTagName !== void 0 && x;
        }
        for (a in ((g = Rt.support = {}),
        (E = Rt.isXML = function (x) {
            var z = x.namespaceURI,
                x = (x.ownerDocument || x).documentElement;
            return !ts.test(z || (x && x.nodeName) || "HTML");
        }),
        (nt = Rt.setDocument = function (x) {
            var z,
                x = x ? x.ownerDocument || x : Ht;
            return (
                x != st &&
                    x.nodeType === 9 &&
                    x.documentElement &&
                    ((bt = (st = x).documentElement),
                    (Bt = !E(st)),
                    Ht != st && (z = st.defaultView) && z.top !== z && (z.addEventListener ? z.addEventListener("unload", o, !1) : z.attachEvent && z.attachEvent("onunload", o)),
                    (g.scope = hn(function (S) {
                        return bt.appendChild(S).appendChild(st.createElement("div")), S.querySelectorAll !== void 0 && !S.querySelectorAll(":scope fieldset div").length;
                    })),
                    (g.attributes = hn(function (S) {
                        return (S.className = "i"), !S.getAttribute("className");
                    })),
                    (g.getElementsByTagName = hn(function (S) {
                        return S.appendChild(st.createComment("")), !S.getElementsByTagName("*").length;
                    })),
                    (g.getElementsByClassName = ci.test(st.getElementsByClassName)),
                    (g.getById = hn(function (S) {
                        return (bt.appendChild(S).id = pt), !st.getElementsByName || !st.getElementsByName(pt).length;
                    })),
                    g.getById
                        ? ((w.filter.ID = function (S) {
                              var q = S.replace(Sn, n);
                              return function (U) {
                                  return U.getAttribute("id") === q;
                              };
                          }),
                          (w.find.ID = function (S, q) {
                              if (q.getElementById !== void 0 && Bt) return (S = q.getElementById(S)), S ? [S] : [];
                          }))
                        : ((w.filter.ID = function (S) {
                              var q = S.replace(Sn, n);
                              return function (U) {
                                  return (U = U.getAttributeNode !== void 0 && U.getAttributeNode("id")), U && U.value === q;
                              };
                          }),
                          (w.find.ID = function (S, q) {
                              if (q.getElementById !== void 0 && Bt) {
                                  var U,
                                      ot,
                                      rt,
                                      ut = q.getElementById(S);
                                  if (ut) {
                                      if ((U = ut.getAttributeNode("id")) && U.value === S) return [ut];
                                      for (rt = q.getElementsByName(S), ot = 0; (ut = rt[ot++]); ) if ((U = ut.getAttributeNode("id")) && U.value === S) return [ut];
                                  }
                                  return [];
                              }
                          })),
                    (w.find.TAG = g.getElementsByTagName
                        ? function (S, q) {
                              return q.getElementsByTagName !== void 0 ? q.getElementsByTagName(S) : g.qsa ? q.querySelectorAll(S) : void 0;
                          }
                        : function (S, q) {
                              var U,
                                  ot = [],
                                  rt = 0,
                                  ut = q.getElementsByTagName(S);
                              if (S !== "*") return ut;
                              for (; (U = ut[rt++]); ) U.nodeType === 1 && ot.push(U);
                              return ot;
                          }),
                    (w.find.CLASS =
                        g.getElementsByClassName &&
                        function (S, q) {
                            if (q.getElementsByClassName !== void 0 && Bt) return q.getElementsByClassName(S);
                        }),
                    (Ee = []),
                    (Lt = []),
                    (g.qsa = ci.test(st.querySelectorAll)) &&
                        (hn(function (S) {
                            var q;
                            (bt.appendChild(S).innerHTML = "<a id='" + pt + "'></a><select id='" + pt + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                S.querySelectorAll("[msallowcapture^='']").length && Lt.push("[*^$]=" + Tt + `*(?:''|"")`),
                                S.querySelectorAll("[selected]").length || Lt.push("\\[" + Tt + "*(?:value|" + Kt + ")"),
                                S.querySelectorAll("[id~=" + pt + "-]").length || Lt.push("~="),
                                (q = st.createElement("input")).setAttribute("name", ""),
                                S.appendChild(q),
                                S.querySelectorAll("[name='']").length || Lt.push("\\[" + Tt + "*name" + Tt + "*=" + Tt + `*(?:''|"")`),
                                S.querySelectorAll(":checked").length || Lt.push(":checked"),
                                S.querySelectorAll("a#" + pt + "+*").length || Lt.push(".#.+[+~]"),
                                S.querySelectorAll("\\\f"),
                                Lt.push("[\\r\\n\\f]");
                        }),
                        hn(function (S) {
                            S.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                            var q = st.createElement("input");
                            q.setAttribute("type", "hidden"),
                                S.appendChild(q).setAttribute("name", "D"),
                                S.querySelectorAll("[name=d]").length && Lt.push("name" + Tt + "*[*^$|!~]?="),
                                S.querySelectorAll(":enabled").length !== 2 && Lt.push(":enabled", ":disabled"),
                                (bt.appendChild(S).disabled = !0),
                                S.querySelectorAll(":disabled").length !== 2 && Lt.push(":enabled", ":disabled"),
                                S.querySelectorAll("*,:x"),
                                Lt.push(",.*:");
                        })),
                    (g.matchesSelector = ci.test(($t = bt.matches || bt.webkitMatchesSelector || bt.mozMatchesSelector || bt.oMatchesSelector || bt.msMatchesSelector))) &&
                        hn(function (S) {
                            (g.disconnectedMatch = $t.call(S, "*")), $t.call(S, "[s!='']:x"), Ee.push("!=", Si);
                        }),
                    (Lt = Lt.length && new RegExp(Lt.join("|"))),
                    (Ee = Ee.length && new RegExp(Ee.join("|"))),
                    (z = ci.test(bt.compareDocumentPosition)),
                    (yn =
                        z || ci.test(bt.contains)
                            ? function (S, q) {
                                  var U = S.nodeType === 9 ? S.documentElement : S,
                                      q = q && q.parentNode;
                                  return S === q || !(!q || q.nodeType !== 1 || !(U.contains ? U.contains(q) : S.compareDocumentPosition && 16 & S.compareDocumentPosition(q)));
                              }
                            : function (S, q) {
                                  if (q) {
                                      for (; (q = q.parentNode); ) if (q === S) return !0;
                                  }
                                  return !1;
                              }),
                    (fe = z
                        ? function (S, q) {
                              if (S === q) return (V = !0), 0;
                              var U = !S.compareDocumentPosition - !q.compareDocumentPosition;
                              return (
                                  U ||
                                  (1 & (U = (S.ownerDocument || S) == (q.ownerDocument || q) ? S.compareDocumentPosition(q) : 1) || (!g.sortDetached && q.compareDocumentPosition(S) === U)
                                      ? S == st || (S.ownerDocument == Ht && yn(Ht, S))
                                          ? -1
                                          : q == st || (q.ownerDocument == Ht && yn(Ht, q))
                                          ? 1
                                          : B
                                          ? we(B, S) - we(B, q)
                                          : 0
                                      : 4 & U
                                      ? -1
                                      : 1)
                              );
                          }
                        : function (S, q) {
                              if (S === q) return (V = !0), 0;
                              var U,
                                  ot = 0,
                                  rt = S.parentNode,
                                  ut = q.parentNode,
                                  dt = [S],
                                  Et = [q];
                              if (!rt || !ut) return S == st ? -1 : q == st ? 1 : rt ? -1 : ut ? 1 : B ? we(B, S) - we(B, q) : 0;
                              if (rt === ut) return qi(S, q);
                              for (U = S; (U = U.parentNode); ) dt.unshift(U);
                              for (U = q; (U = U.parentNode); ) Et.unshift(U);
                              for (; dt[ot] === Et[ot]; ) ot++;
                              return ot ? qi(dt[ot], Et[ot]) : dt[ot] == Ht ? -1 : Et[ot] == Ht ? 1 : 0;
                          })),
                st
            );
        }),
        (Rt.matches = function (x, z) {
            return Rt(x, null, null, z);
        }),
        (Rt.matchesSelector = function (x, z) {
            if ((nt(x), g.matchesSelector && Bt && !ze[z + " "] && (!Ee || !Ee.test(z)) && (!Lt || !Lt.test(z))))
                try {
                    var S = $t.call(x, z);
                    if (S || g.disconnectedMatch || (x.document && x.document.nodeType !== 11)) return S;
                } catch {
                    ze(z, !0);
                }
            return 0 < Rt(z, st, null, [x]).length;
        }),
        (Rt.contains = function (x, z) {
            return (x.ownerDocument || x) != st && nt(x), yn(x, z);
        }),
        (Rt.attr = function (x, z) {
            (x.ownerDocument || x) != st && nt(x);
            var S = w.attrHandle[z.toLowerCase()],
                S = S && tn.call(w.attrHandle, z.toLowerCase()) ? S(x, z, !Bt) : void 0;
            return S !== void 0 ? S : g.attributes || !Bt ? x.getAttribute(z) : (S = x.getAttributeNode(z)) && S.specified ? S.value : null;
        }),
        (Rt.escape = function (x) {
            return (x + "").replace(Ni, Mi);
        }),
        (Rt.error = function (x) {
            throw new Error("Syntax error, unrecognized expression: " + x);
        }),
        (Rt.uniqueSort = function (x) {
            var z,
                S = [],
                q = 0,
                U = 0;
            if (((V = !g.detectDuplicates), (B = !g.sortStable && x.slice(0)), x.sort(fe), V)) {
                for (; (z = x[U++]); ) z === x[U] && (q = S.push(U));
                for (; q--; ) x.splice(S[q], 1);
            }
            return (B = null), x;
        }),
        (C = Rt.getText = function (x) {
            var z,
                S = "",
                q = 0,
                U = x.nodeType;
            if (U) {
                if (U === 1 || U === 9 || U === 11) {
                    if (typeof x.textContent == "string") return x.textContent;
                    for (x = x.firstChild; x; x = x.nextSibling) S += C(x);
                } else if (U === 3 || U === 4) return x.nodeValue;
            } else for (; (z = x[q++]); ) S += C(z);
            return S;
        }),
        ((w = Rt.selectors = {
            cacheLength: 50,
            createPseudo: pn,
            match: mi,
            attrHandle: {},
            find: {},
            relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
            preFilter: {
                ATTR: function (x) {
                    return (x[1] = x[1].replace(Sn, n)), (x[3] = (x[3] || x[4] || x[5] || "").replace(Sn, n)), x[2] === "~=" && (x[3] = " " + x[3] + " "), x.slice(0, 4);
                },
                CHILD: function (x) {
                    return (
                        (x[1] = x[1].toLowerCase()),
                        x[1].slice(0, 3) === "nth" ? (x[3] || Rt.error(x[0]), (x[4] = +(x[4] ? x[5] + (x[6] || 1) : 2 * (x[3] === "even" || x[3] === "odd"))), (x[5] = +(x[7] + x[8] || x[3] === "odd"))) : x[3] && Rt.error(x[0]),
                        x
                    );
                },
                PSEUDO: function (x) {
                    var z,
                        S = !x[6] && x[2];
                    return mi.CHILD.test(x[0])
                        ? null
                        : (x[3] ? (x[2] = x[4] || x[5] || "") : S && Ki.test(S) && (z = P(S, !0)) && (z = S.indexOf(")", S.length - z) - S.length) && ((x[0] = x[0].slice(0, z)), (x[2] = S.slice(0, z))), x.slice(0, 3));
                },
            },
            filter: {
                TAG: function (x) {
                    var z = x.replace(Sn, n).toLowerCase();
                    return x === "*"
                        ? function () {
                              return !0;
                          }
                        : function (S) {
                              return S.nodeName && S.nodeName.toLowerCase() === z;
                          };
                },
                CLASS: function (x) {
                    var z = ti[x + " "];
                    return (
                        z ||
                        ((z = new RegExp("(^|" + Tt + ")" + x + "(" + Tt + "|$)")) &&
                            ti(x, function (S) {
                                return z.test((typeof S.className == "string" && S.className) || (S.getAttribute !== void 0 && S.getAttribute("class")) || "");
                            }))
                    );
                },
                ATTR: function (x, z, S) {
                    return function (q) {
                        return (
                            (q = Rt.attr(q, x)),
                            q == null
                                ? z === "!="
                                : !z ||
                                  ((q += ""),
                                  z === "="
                                      ? q === S
                                      : z === "!="
                                      ? q !== S
                                      : z === "^="
                                      ? S && q.indexOf(S) === 0
                                      : z === "*="
                                      ? S && -1 < q.indexOf(S)
                                      : z === "$="
                                      ? S && q.slice(-S.length) === S
                                      : z === "~="
                                      ? -1 < (" " + q.replace(Vi, " ") + " ").indexOf(S)
                                      : z === "|=" && (q === S || q.slice(0, S.length + 1) === S + "-"))
                        );
                    };
                },
                CHILD: function (x, z, S, q, U) {
                    var ot = x.slice(0, 3) !== "nth",
                        rt = x.slice(-4) !== "last",
                        ut = z === "of-type";
                    return q === 1 && U === 0
                        ? function (dt) {
                              return !!dt.parentNode;
                          }
                        : function (dt, Et, jt) {
                              var Mt,
                                  Wt,
                                  ie,
                                  kt,
                                  Xt,
                                  Ft,
                                  nn = ot != rt ? "nextSibling" : "previousSibling",
                                  ge = dt.parentNode,
                                  Oe = ut && dt.nodeName.toLowerCase(),
                                  ce = !jt && !ut,
                                  Yt = !1;
                              if (ge) {
                                  if (ot) {
                                      for (; nn; ) {
                                          for (kt = dt; (kt = kt[nn]); ) if (ut ? kt.nodeName.toLowerCase() === Oe : kt.nodeType === 1) return !1;
                                          Ft = nn = x === "only" && !Ft && "nextSibling";
                                      }
                                      return !0;
                                  }
                                  if (((Ft = [rt ? ge.firstChild : ge.lastChild]), rt && ce)) {
                                      for (
                                          Yt = (Xt = (Mt = (Wt = (ie = (kt = ge)[pt] || (kt[pt] = {}))[kt.uniqueID] || (ie[kt.uniqueID] = {}))[x] || [])[0] === Se && Mt[1]) && Mt[2], kt = Xt && ge.childNodes[Xt];
                                          (kt = (++Xt && kt && kt[nn]) || (Yt = Xt = 0) || Ft.pop());

                                      )
                                          if (kt.nodeType === 1 && ++Yt && kt === dt) {
                                              Wt[x] = [Se, Xt, Yt];
                                              break;
                                          }
                                  } else if ((Yt = ce ? (Xt = (Mt = (Wt = (ie = (kt = dt)[pt] || (kt[pt] = {}))[kt.uniqueID] || (ie[kt.uniqueID] = {}))[x] || [])[0] === Se && Mt[1]) : Yt) === !1)
                                      for (
                                          ;
                                          (kt = (++Xt && kt && kt[nn]) || (Yt = Xt = 0) || Ft.pop()) &&
                                          ((ut ? kt.nodeName.toLowerCase() !== Oe : kt.nodeType !== 1) || !++Yt || (ce && ((Wt = (ie = kt[pt] || (kt[pt] = {}))[kt.uniqueID] || (ie[kt.uniqueID] = {}))[x] = [Se, Yt]), kt !== dt));

                                      );
                                  return (Yt -= U) === q || (Yt % q == 0 && 0 <= Yt / q);
                              }
                          };
                },
                PSEUDO: function (x, z) {
                    var S,
                        q = w.pseudos[x] || w.setFilters[x.toLowerCase()] || Rt.error("unsupported pseudo: " + x);
                    return q[pt]
                        ? q(z)
                        : 1 < q.length
                        ? ((S = [x, x, "", z]),
                          w.setFilters.hasOwnProperty(x.toLowerCase())
                              ? pn(function (U, ot) {
                                    for (var rt, ut = q(U, z), dt = ut.length; dt--; ) U[(rt = we(U, ut[dt]))] = !(ot[rt] = ut[dt]);
                                })
                              : function (U) {
                                    return q(U, 0, S);
                                })
                        : q;
                },
            },
            pseudos: {
                not: pn(function (x) {
                    var z = [],
                        S = [],
                        q = N(x.replace(gi, "$1"));
                    return q[pt]
                        ? pn(function (U, ot, rt, ut) {
                              for (var dt, Et = q(U, null, ut, []), jt = U.length; jt--; ) (dt = Et[jt]) && (U[jt] = !(ot[jt] = dt));
                          })
                        : function (U, ot, rt) {
                              return (z[0] = U), q(z, null, rt, S), (z[0] = null), !S.pop();
                          };
                }),
                has: pn(function (x) {
                    return function (z) {
                        return 0 < Rt(x, z).length;
                    };
                }),
                contains: pn(function (x) {
                    return (
                        (x = x.replace(Sn, n)),
                        function (z) {
                            return -1 < (z.textContent || C(z)).indexOf(x);
                        }
                    );
                }),
                lang: pn(function (x) {
                    return (
                        Ji.test(x || "") || Rt.error("unsupported lang: " + x),
                        (x = x.replace(Sn, n).toLowerCase()),
                        function (z) {
                            var S;
                            do if ((S = Bt ? z.lang : z.getAttribute("xml:lang") || z.getAttribute("lang"))) return (S = S.toLowerCase()) === x || S.indexOf(x + "-") === 0;
                            while ((z = z.parentNode) && z.nodeType === 1);
                            return !1;
                        }
                    );
                }),
                target: function (x) {
                    var z = t.location && t.location.hash;
                    return z && z.slice(1) === x.id;
                },
                root: function (x) {
                    return x === bt;
                },
                focus: function (x) {
                    return x === st.activeElement && (!st.hasFocus || st.hasFocus()) && !!(x.type || x.href || ~x.tabIndex);
                },
                enabled: Ii(!1),
                disabled: Ii(!0),
                checked: function (x) {
                    var z = x.nodeName.toLowerCase();
                    return (z === "input" && !!x.checked) || (z === "option" && !!x.selected);
                },
                selected: function (x) {
                    return x.parentNode && x.parentNode.selectedIndex, x.selected === !0;
                },
                empty: function (x) {
                    for (x = x.firstChild; x; x = x.nextSibling) if (x.nodeType < 6) return !1;
                    return !0;
                },
                parent: function (x) {
                    return !w.pseudos.empty(x);
                },
                header: function (x) {
                    return ns.test(x.nodeName);
                },
                input: function (x) {
                    return es.test(x.nodeName);
                },
                button: function (x) {
                    var z = x.nodeName.toLowerCase();
                    return (z === "input" && x.type === "button") || z === "button";
                },
                text: function (x) {
                    return x.nodeName.toLowerCase() === "input" && x.type === "text" && ((x = x.getAttribute("type")) == null || x.toLowerCase() === "text");
                },
                first: Gn(function () {
                    return [0];
                }),
                last: Gn(function (x, z) {
                    return [z - 1];
                }),
                eq: Gn(function (x, z, S) {
                    return [S < 0 ? S + z : S];
                }),
                even: Gn(function (x, z) {
                    for (var S = 0; S < z; S += 2) x.push(S);
                    return x;
                }),
                odd: Gn(function (x, z) {
                    for (var S = 1; S < z; S += 2) x.push(S);
                    return x;
                }),
                lt: Gn(function (x, z, S) {
                    for (var q = S < 0 ? S + z : z < S ? z : S; 0 <= --q; ) x.push(q);
                    return x;
                }),
                gt: Gn(function (x, z, S) {
                    for (var q = S < 0 ? S + z : S; ++q < z; ) x.push(q);
                    return x;
                }),
            },
        }).pseudos.nth = w.pseudos.eq),
        { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
            w.pseudos[a] = (function (x) {
                return function (z) {
                    return z.nodeName.toLowerCase() === "input" && z.type === x;
                };
            })(a);
        for (a in { submit: !0, reset: !0 })
            w.pseudos[a] = (function (x) {
                return function (z) {
                    var S = z.nodeName.toLowerCase();
                    return (S === "input" || S === "button") && z.type === x;
                };
            })(a);
        function Hi() {}
        function yi(x) {
            for (var z = 0, S = x.length, q = ""; z < S; z++) q += x[z].value;
            return q;
        }
        function wi(x, z, S) {
            var q = z.dir,
                U = z.next,
                ot = U || q,
                rt = S && ot === "parentNode",
                ut = dn++;
            return z.first
                ? function (dt, Et, jt) {
                      for (; (dt = dt[q]); ) if (dt.nodeType === 1 || rt) return x(dt, Et, jt);
                      return !1;
                  }
                : function (dt, Et, jt) {
                      var Mt,
                          Wt,
                          ie = [Se, ut];
                      if (jt) {
                          for (; (dt = dt[q]); ) if ((dt.nodeType === 1 || rt) && x(dt, Et, jt)) return !0;
                      } else
                          for (; (dt = dt[q]); )
                              if (dt.nodeType === 1 || rt)
                                  if (((Mt = (Wt = dt[pt] || (dt[pt] = {}))[dt.uniqueID] || (Wt[dt.uniqueID] = {})), U && U === dt.nodeName.toLowerCase())) dt = dt[q] || dt;
                                  else {
                                      if ((Wt = Mt[ot]) && Wt[0] === Se && Wt[1] === ut) return (ie[2] = Wt[2]);
                                      if (((Mt[ot] = ie)[2] = x(dt, Et, jt))) return !0;
                                  }
                      return !1;
                  };
        }
        function Ei(x) {
            return 1 < x.length
                ? function (z, S, q) {
                      for (var U = x.length; U--; ) if (!x[U](z, S, q)) return !1;
                      return !0;
                  }
                : x[0];
        }
        function bi(x, z, S, q, U) {
            for (var ot, rt = [], ut = 0, dt = x.length, Et = z != null; ut < dt; ut++) (ot = x[ut]) && ((S && !S(ot, q, U)) || (rt.push(ot), Et && z.push(ut)));
            return rt;
        }
        function zi(x) {
            for (
                var z,
                    S,
                    q,
                    U = x.length,
                    ot = w.relative[x[0].type],
                    rt = ot || w.relative[" "],
                    ut = ot ? 1 : 0,
                    dt = wi(
                        function (Mt) {
                            return Mt === z;
                        },
                        rt,
                        !0
                    ),
                    Et = wi(
                        function (Mt) {
                            return -1 < we(z, Mt);
                        },
                        rt,
                        !0
                    ),
                    jt = [
                        function (Mt, Wt, ie) {
                            return (ie = (!ot && (ie || Wt !== M)) || ((z = Wt).nodeType ? dt : Et)(Mt, Wt, ie)), (z = null), ie;
                        },
                    ];
                ut < U;
                ut++
            )
                if ((S = w.relative[x[ut].type])) jt = [wi(Ei(jt), S)];
                else {
                    if ((S = w.filter[x[ut].type].apply(null, x[ut].matches))[pt]) {
                        for (q = ++ut; q < U && !w.relative[x[q].type]; q++);
                        return (function Mt(Wt, ie, kt, Xt, Ft, nn) {
                            return (
                                Xt && !Xt[pt] && (Xt = Mt(Xt)),
                                Ft && !Ft[pt] && (Ft = Mt(Ft, nn)),
                                pn(function (ge, Oe, ce, Yt) {
                                    var me,
                                        $e,
                                        wn,
                                        ui = [],
                                        di = [],
                                        Ri = Oe.length,
                                        Wi =
                                            ge ||
                                            (function (os, Fi, Ui) {
                                                for (var Di = 0, rs = Fi.length; Di < rs; Di++) Rt(os, Fi[Di], Ui);
                                                return Ui;
                                            })(ie || "*", ce.nodeType ? [ce] : ce, []),
                                        xi = !Wt || (!ge && ie) ? Wi : bi(Wi, ui, Wt, ce, Yt),
                                        je = kt ? (Ft || (ge ? Wt : Ri || Xt) ? [] : Oe) : xi;
                                    if ((kt && kt(xi, je, ce, Yt), Xt)) for (me = bi(je, di), Xt(me, [], ce, Yt), $e = me.length; $e--; ) (wn = me[$e]) && (je[di[$e]] = !(xi[di[$e]] = wn));
                                    if (ge) {
                                        if (Ft || Wt) {
                                            if (Ft) {
                                                for (me = [], $e = je.length; $e--; ) (wn = je[$e]) && me.push((xi[$e] = wn));
                                                Ft(null, (je = []), me, Yt);
                                            }
                                            for ($e = je.length; $e--; ) (wn = je[$e]) && -1 < (me = Ft ? we(ge, wn) : ui[$e]) && (ge[me] = !(Oe[me] = wn));
                                        }
                                    } else (je = bi(je === Oe ? je.splice(Ri, je.length) : je)), Ft ? Ft(null, Oe, je, Yt) : Nt.apply(Oe, je);
                                })
                            );
                        })(1 < ut && Ei(jt), 1 < ut && yi(x.slice(0, ut - 1).concat({ value: x[ut - 2].type === " " ? "*" : "" })).replace(gi, "$1"), S, ut < q && zi(x.slice(ut, q)), q < U && zi((x = x.slice(q))), q < U && yi(x));
                    }
                    jt.push(S);
                }
            return Ei(jt);
        }
        return (
            (Hi.prototype = w.filters = w.pseudos),
            (w.setFilters = new Hi()),
            (P = Rt.tokenize = function (x, z) {
                var S,
                    q,
                    U,
                    ot,
                    rt,
                    ut,
                    dt,
                    Et = Xn[x + " "];
                if (Et) return z ? 0 : Et.slice(0);
                for (rt = x, ut = [], dt = w.preFilter; rt; ) {
                    for (ot in ((S && !(q = Qi.exec(rt))) || (q && (rt = rt.slice(q[0].length) || rt), ut.push((U = []))),
                    (S = !1),
                    (q = Pi.exec(rt)) && ((S = q.shift()), U.push({ value: S, type: q[0].replace(gi, " ") }), (rt = rt.slice(S.length))),
                    w.filter))
                        !(q = mi[ot].exec(rt)) || (dt[ot] && !(q = dt[ot](q))) || ((S = q.shift()), U.push({ value: S, type: ot, matches: q }), (rt = rt.slice(S.length)));
                    if (!S) break;
                }
                return z ? rt.length : rt ? Rt.error(x) : Xn(x, ut).slice(0);
            }),
            (N = Rt.compile = function (x, z) {
                var S,
                    q,
                    U,
                    ot,
                    rt,
                    ut,
                    dt = [],
                    Et = [],
                    jt = Tn[x + " "];
                if (!jt) {
                    for (S = (z = z || P(x)).length; S--; ) ((jt = zi(z[S]))[pt] ? dt : Et).push(jt);
                    (jt = Tn(
                        x,
                        ((ot = 0 < (U = dt).length),
                        (rt = 0 < (q = Et).length),
                        (ut = function (Mt, Wt, ie, kt, Xt) {
                            var Ft,
                                nn,
                                ge,
                                Oe = 0,
                                ce = "0",
                                Yt = Mt && [],
                                me = [],
                                $e = M,
                                wn = Mt || (rt && w.find.TAG("*", Xt)),
                                ui = (Se += $e == null ? 1 : Math.random() || 0.1),
                                di = wn.length;
                            for (Xt && (M = Wt == st || Wt || Xt); ce !== di && (Ft = wn[ce]) != null; ce++) {
                                if (rt && Ft) {
                                    for (nn = 0, Wt || Ft.ownerDocument == st || (nt(Ft), (ie = !Bt)); (ge = q[nn++]); )
                                        if (ge(Ft, Wt || st, ie)) {
                                            kt.push(Ft);
                                            break;
                                        }
                                    Xt && (Se = ui);
                                }
                                ot && ((Ft = !ge && Ft) && Oe--, Mt && Yt.push(Ft));
                            }
                            if (((Oe += ce), ot && ce !== Oe)) {
                                for (nn = 0; (ge = U[nn++]); ) ge(Yt, me, Wt, ie);
                                if (Mt) {
                                    if (0 < Oe) for (; ce--; ) Yt[ce] || me[ce] || (me[ce] = On.call(kt));
                                    me = bi(me);
                                }
                                Nt.apply(kt, me), Xt && !Mt && 0 < me.length && 1 < Oe + U.length && Rt.uniqueSort(kt);
                            }
                            return Xt && ((Se = ui), (M = $e)), Yt;
                        }),
                        ot ? pn(ut) : ut)
                    )).selector = x;
                }
                return jt;
            }),
            (R = Rt.select = function (x, z, S, q) {
                var U,
                    ot,
                    rt,
                    ut,
                    dt,
                    Et = typeof x == "function" && x,
                    jt = !q && P((x = Et.selector || x));
                if (((S = S || []), jt.length === 1)) {
                    if (2 < (ot = jt[0] = jt[0].slice(0)).length && (rt = ot[0]).type === "ID" && z.nodeType === 9 && Bt && w.relative[ot[1].type]) {
                        if (!(z = (w.find.ID(rt.matches[0].replace(Sn, n), z) || [])[0])) return S;
                        Et && (z = z.parentNode), (x = x.slice(ot.shift().value.length));
                    }
                    for (U = mi.needsContext.test(x) ? 0 : ot.length; U-- && ((rt = ot[U]), !w.relative[(ut = rt.type)]); )
                        if ((dt = w.find[ut]) && (q = dt(rt.matches[0].replace(Sn, n), ($i.test(ot[0].type) && Ai(z.parentNode)) || z))) {
                            if ((ot.splice(U, 1), !(x = q.length && yi(ot)))) return Nt.apply(S, q), S;
                            break;
                        }
                }
                return (Et || N(x, jt))(q, z, !Bt, S, !z || ($i.test(x) && Ai(z.parentNode)) || z), S;
            }),
            (g.sortStable = pt.split("").sort(fe).join("") === pt),
            (g.detectDuplicates = !!V),
            nt(),
            (g.sortDetached = hn(function (x) {
                return 1 & x.compareDocumentPosition(st.createElement("fieldset"));
            })),
            hn(function (x) {
                return (x.innerHTML = "<a href='#'></a>"), x.firstChild.getAttribute("href") === "#";
            }) ||
                ki("type|href|height|width", function (x, z, S) {
                    if (!S) return x.getAttribute(z, z.toLowerCase() === "type" ? 1 : 2);
                }),
            (g.attributes &&
                hn(function (x) {
                    return (x.innerHTML = "<input/>"), x.firstChild.setAttribute("value", ""), x.firstChild.getAttribute("value") === "";
                })) ||
                ki("value", function (x, z, S) {
                    if (!S && x.nodeName.toLowerCase() === "input") return x.defaultValue;
                }),
            hn(function (x) {
                return x.getAttribute("disabled") == null;
            }) ||
                ki(Kt, function (x, z, S) {
                    if (!S) return x[z] === !0 ? z.toLowerCase() : (z = x.getAttributeNode(z)) && z.specified ? z.value : null;
                }),
            Rt
        );
    })(mt);
    (c.find = xe), (c.expr = xe.selectors), (c.expr[":"] = c.expr.pseudos), (c.uniqueSort = c.unique = xe.uniqueSort), (c.text = xe.getText), (c.isXMLDoc = xe.isXML), (c.contains = xe.contains), (c.escapeSelector = xe.escape);
    function pe(t, n, o) {
        for (var a = [], g = o !== void 0; (t = t[n]) && t.nodeType !== 9; )
            if (t.nodeType === 1) {
                if (g && c(t).is(o)) break;
                a.push(t);
            }
        return a;
    }
    function Vn(t, n) {
        for (var o = []; t; t = t.nextSibling) t.nodeType === 1 && t !== n && o.push(t);
        return o;
    }
    var Qe = c.expr.match.needsContext;
    function _e(t, n) {
        return t.nodeName && t.nodeName.toLowerCase() === n.toLowerCase();
    }
    var qn = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function In(t, n, o) {
        return yt(n)
            ? c.grep(t, function (a, g) {
                  return !!n.call(a, g, a) !== o;
              })
            : n.nodeType
            ? c.grep(t, function (a) {
                  return (a === n) !== o;
              })
            : typeof n != "string"
            ? c.grep(t, function (a) {
                  return -1 < bn.call(n, a) !== o;
              })
            : c.filter(n, t, o);
    }
    (c.filter = function (t, n, o) {
        var a = n[0];
        return (
            o && (t = ":not(" + t + ")"),
            n.length === 1 && a.nodeType === 1
                ? c.find.matchesSelector(a, t)
                    ? [a]
                    : []
                : c.find.matches(
                      t,
                      c.grep(n, function (g) {
                          return g.nodeType === 1;
                      })
                  )
        );
    }),
        c.fn.extend({
            find: function (t) {
                var n,
                    o,
                    a = this.length,
                    g = this;
                if (typeof t != "string")
                    return this.pushStack(
                        c(t).filter(function () {
                            for (n = 0; n < a; n++) if (c.contains(g[n], this)) return !0;
                        })
                    );
                for (o = this.pushStack([]), n = 0; n < a; n++) c.find(t, g[n], o);
                return 1 < a ? c.uniqueSort(o) : o;
            },
            filter: function (t) {
                return this.pushStack(In(this, t || [], !1));
            },
            not: function (t) {
                return this.pushStack(In(this, t || [], !0));
            },
            is: function (t) {
                return !!In(this, typeof t == "string" && Qe.test(t) ? c(t) : t || [], !1).length;
            },
        });
    var Qn = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (c.fn.init = function (t, n, o) {
        if (!t) return this;
        if (((o = o || ni), typeof t != "string")) return t.nodeType ? ((this[0] = t), (this.length = 1), this) : yt(t) ? (o.ready !== void 0 ? o.ready(t) : t(c)) : c.makeArray(t, this);
        if (!(a = t[0] === "<" && t[t.length - 1] === ">" && 3 <= t.length ? [null, t, null] : Qn.exec(t)) || (!a[1] && n)) return (!n || n.jquery ? n || o : this.constructor(n)).find(t);
        if (a[1]) {
            if (((n = n instanceof c ? n[0] : n), c.merge(this, c.parseHTML(a[1], n && n.nodeType ? n.ownerDocument || n : xt, !0)), qn.test(a[1]) && c.isPlainObject(n))) for (var a in n) yt(this[a]) ? this[a](n[a]) : this.attr(a, n[a]);
            return this;
        }
        return (t = xt.getElementById(a[2])) && ((this[0] = t), (this.length = 1)), this;
    }).prototype = c.fn;
    var ni = c(xt),
        We = /^(?:parents|prev(?:Until|All))/,
        pi = { children: !0, contents: !0, next: !0, prev: !0 };
    function ii(t, n) {
        for (; (t = t[n]) && t.nodeType !== 1; );
        return t;
    }
    c.fn.extend({
        has: function (t) {
            var n = c(t, this),
                o = n.length;
            return this.filter(function () {
                for (var a = 0; a < o; a++) if (c.contains(this, n[a])) return !0;
            });
        },
        closest: function (t, n) {
            var o,
                a = 0,
                g = this.length,
                w = [],
                C = typeof t != "string" && c(t);
            if (!Qe.test(t)) {
                for (; a < g; a++)
                    for (o = this[a]; o && o !== n; o = o.parentNode)
                        if (o.nodeType < 11 && (C ? -1 < C.index(o) : o.nodeType === 1 && c.find.matchesSelector(o, t))) {
                            w.push(o);
                            break;
                        }
            }
            return this.pushStack(1 < w.length ? c.uniqueSort(w) : w);
        },
        index: function (t) {
            return t ? (typeof t == "string" ? bn.call(c(t), this[0]) : bn.call(this, t.jquery ? t[0] : t)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        },
        add: function (t, n) {
            return this.pushStack(c.uniqueSort(c.merge(this.get(), c(t, n))));
        },
        addBack: function (t) {
            return this.add(t == null ? this.prevObject : this.prevObject.filter(t));
        },
    }),
        c.each(
            {
                parent: function (t) {
                    return (t = t.parentNode), t && t.nodeType !== 11 ? t : null;
                },
                parents: function (t) {
                    return pe(t, "parentNode");
                },
                parentsUntil: function (t, n, o) {
                    return pe(t, "parentNode", o);
                },
                next: function (t) {
                    return ii(t, "nextSibling");
                },
                prev: function (t) {
                    return ii(t, "previousSibling");
                },
                nextAll: function (t) {
                    return pe(t, "nextSibling");
                },
                prevAll: function (t) {
                    return pe(t, "previousSibling");
                },
                nextUntil: function (t, n, o) {
                    return pe(t, "nextSibling", o);
                },
                prevUntil: function (t, n, o) {
                    return pe(t, "previousSibling", o);
                },
                siblings: function (t) {
                    return Vn((t.parentNode || {}).firstChild, t);
                },
                children: function (t) {
                    return Vn(t.firstChild);
                },
                contents: function (t) {
                    return t.contentDocument != null && jn(t.contentDocument) ? t.contentDocument : (_e(t, "template") && (t = t.content || t), c.merge([], t.childNodes));
                },
            },
            function (t, n) {
                c.fn[t] = function (o, a) {
                    var g = c.map(this, n, o);
                    return (a = t.slice(-5) !== "Until" ? o : a) && typeof a == "string" && (g = c.filter(a, g)), 1 < this.length && (pi[t] || c.uniqueSort(g), We.test(t) && g.reverse()), this.pushStack(g);
                };
            }
        );
    var Fe = /[^\x20\t\r\n\f]+/g;
    function Ue(t) {
        return t;
    }
    function Pe(t) {
        throw t;
    }
    function Be(t, n, o, a) {
        var g;
        try {
            t && yt((g = t.promise)) ? g.call(t).done(n).fail(o) : t && yt((g = t.then)) ? g.call(t, n, o) : n.apply(void 0, [t].slice(a));
        } catch (w) {
            o.apply(void 0, [w]);
        }
    }
    (c.Callbacks = function (t) {
        var n;
        t =
            typeof t == "string"
                ? ((n = {}),
                  c.each(t.match(Fe) || [], function (M, B) {
                      n[B] = !0;
                  }),
                  n)
                : c.extend({}, t);
        function o() {
            for (C = C || t.once, w = a = !0; P.length; N = -1) for (g = P.shift(); ++N < E.length; ) E[N].apply(g[0], g[1]) === !1 && t.stopOnFalse && ((N = E.length), (g = !1));
            t.memory || (g = !1), (a = !1), C && (E = g ? [] : "");
        }
        var a,
            g,
            w,
            C,
            E = [],
            P = [],
            N = -1,
            R = {
                add: function () {
                    return (
                        E &&
                            (g && !a && ((N = E.length - 1), P.push(g)),
                            (function M(B) {
                                c.each(B, function (V, nt) {
                                    yt(nt) ? (t.unique && R.has(nt)) || E.push(nt) : nt && nt.length && fn(nt) !== "string" && M(nt);
                                });
                            })(arguments),
                            g && !a && o()),
                        this
                    );
                },
                remove: function () {
                    return (
                        c.each(arguments, function (M, B) {
                            for (var V; -1 < (V = c.inArray(B, E, V)); ) E.splice(V, 1), V <= N && N--;
                        }),
                        this
                    );
                },
                has: function (M) {
                    return M ? -1 < c.inArray(M, E) : 0 < E.length;
                },
                empty: function () {
                    return (E = E && []), this;
                },
                disable: function () {
                    return (C = P = []), (E = g = ""), this;
                },
                disabled: function () {
                    return !E;
                },
                lock: function () {
                    return (C = P = []), g || a || (E = g = ""), this;
                },
                locked: function () {
                    return !!C;
                },
                fireWith: function (M, B) {
                    return C || ((B = [M, (B = B || []).slice ? B.slice() : B]), P.push(B), a || o()), this;
                },
                fire: function () {
                    return R.fireWith(this, arguments), this;
                },
                fired: function () {
                    return !!w;
                },
            };
        return R;
    }),
        c.extend({
            Deferred: function (t) {
                var n = [
                        ["notify", "progress", c.Callbacks("memory"), c.Callbacks("memory"), 2],
                        ["resolve", "done", c.Callbacks("once memory"), c.Callbacks("once memory"), 0, "resolved"],
                        ["reject", "fail", c.Callbacks("once memory"), c.Callbacks("once memory"), 1, "rejected"],
                    ],
                    o = "pending",
                    a = {
                        state: function () {
                            return o;
                        },
                        always: function () {
                            return g.done(arguments).fail(arguments), this;
                        },
                        catch: function (w) {
                            return a.then(null, w);
                        },
                        pipe: function () {
                            var w = arguments;
                            return c
                                .Deferred(function (C) {
                                    c.each(n, function (E, P) {
                                        var N = yt(w[P[4]]) && w[P[4]];
                                        g[P[1]](function () {
                                            var R = N && N.apply(this, arguments);
                                            R && yt(R.promise) ? R.promise().progress(C.notify).done(C.resolve).fail(C.reject) : C[P[0] + "With"](this, N ? [R] : arguments);
                                        });
                                    }),
                                        (w = null);
                                })
                                .promise();
                        },
                        then: function (w, C, E) {
                            var P = 0;
                            function N(R, M, B, V) {
                                return function () {
                                    function nt() {
                                        var Lt, Ee;
                                        if (!(R < P)) {
                                            if ((Lt = B.apply(st, bt)) === M.promise()) throw new TypeError("Thenable self-resolution");
                                            (Ee = Lt && (_typeof(Lt) == "object" || typeof Lt == "function") && Lt.then),
                                                yt(Ee)
                                                    ? V
                                                        ? Ee.call(Lt, N(P, M, Ue, V), N(P, M, Pe, V))
                                                        : (P++, Ee.call(Lt, N(P, M, Ue, V), N(P, M, Pe, V), N(P, M, Ue, M.notifyWith)))
                                                    : (B !== Ue && ((st = void 0), (bt = [Lt])), (V || M.resolveWith)(st, bt));
                                        }
                                    }
                                    var st = this,
                                        bt = arguments,
                                        Bt = V
                                            ? nt
                                            : function () {
                                                  try {
                                                      nt();
                                                  } catch (Lt) {
                                                      c.Deferred.exceptionHook && c.Deferred.exceptionHook(Lt, Bt.stackTrace), P <= R + 1 && (B !== Pe && ((st = void 0), (bt = [Lt])), M.rejectWith(st, bt));
                                                  }
                                              };
                                    R ? Bt() : (c.Deferred.getStackHook && (Bt.stackTrace = c.Deferred.getStackHook()), mt.setTimeout(Bt));
                                };
                            }
                            return c
                                .Deferred(function (R) {
                                    n[0][3].add(N(0, R, yt(E) ? E : Ue, R.notifyWith)), n[1][3].add(N(0, R, yt(w) ? w : Ue)), n[2][3].add(N(0, R, yt(C) ? C : Pe));
                                })
                                .promise();
                        },
                        promise: function (w) {
                            return w != null ? c.extend(w, a) : a;
                        },
                    },
                    g = {};
                return (
                    c.each(n, function (w, C) {
                        var E = C[2],
                            P = C[5];
                        (a[C[1]] = E.add),
                            P &&
                                E.add(
                                    function () {
                                        o = P;
                                    },
                                    n[3 - w][2].disable,
                                    n[3 - w][3].disable,
                                    n[0][2].lock,
                                    n[0][3].lock
                                ),
                            E.add(C[3].fire),
                            (g[C[0]] = function () {
                                return g[C[0] + "With"](this === g ? void 0 : this, arguments), this;
                            }),
                            (g[C[0] + "With"] = E.fireWith);
                    }),
                    a.promise(g),
                    t && t.call(g, g),
                    g
                );
            },
            when: function (t) {
                function n(E) {
                    return function (P) {
                        (g[E] = this), (w[E] = 1 < arguments.length ? be.call(arguments) : P), --o || C.resolveWith(g, w);
                    };
                }
                var o = arguments.length,
                    a = o,
                    g = Array(a),
                    w = be.call(arguments),
                    C = c.Deferred();
                if (o <= 1 && (Be(t, C.done(n(a)).resolve, C.reject, !o), C.state() === "pending" || yt(w[a] && w[a].then))) return C.then();
                for (; a--; ) Be(w[a], n(a), C.reject);
                return C.promise();
            },
        });
    var Ze = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    (c.Deferred.exceptionHook = function (t, n) {
        mt.console && mt.console.warn && t && Ze.test(t.name) && mt.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n);
    }),
        (c.readyException = function (t) {
            mt.setTimeout(function () {
                throw t;
            });
        });
    var ye = c.Deferred();
    function on() {
        xt.removeEventListener("DOMContentLoaded", on), mt.removeEventListener("load", on), c.ready();
    }
    (c.fn.ready = function (t) {
        return (
            ye.then(t).catch(function (n) {
                c.readyException(n);
            }),
            this
        );
    }),
        c.extend({
            isReady: !1,
            readyWait: 1,
            ready: function (t) {
                (t === !0 ? --c.readyWait : c.isReady) || ((c.isReady = !0) !== t && 0 < --c.readyWait) || ye.resolveWith(xt, [c]);
            },
        }),
        (c.ready.then = ye.then),
        xt.readyState === "complete" || (xt.readyState !== "loading" && !xt.documentElement.doScroll) ? mt.setTimeout(c.ready) : (xt.addEventListener("DOMContentLoaded", on), mt.addEventListener("load", on));
    function Ke(t, n, o, a, g, w, C) {
        var E = 0,
            P = t.length,
            N = o == null;
        if (fn(o) === "object") for (E in ((g = !0), o)) Ke(t, n, E, o[E], !0, w, C);
        else if (
            a !== void 0 &&
            ((g = !0),
            yt(a) || (C = !0),
            (n = N
                ? C
                    ? (n.call(t, a), null)
                    : ((N = n),
                      function (R, M, B) {
                          return N.call(c(R), B);
                      })
                : n))
        )
            for (; E < P; E++) n(t[E], o, C ? a : a.call(t[E], E, n(t[E], o)));
        return g ? t : N ? n.call(t) : P ? n(t[0], o) : w;
    }
    var Ne = /^-ms-/,
        Vt = /-([a-z])/g;
    function Zn(t, n) {
        return n.toUpperCase();
    }
    function te(t) {
        return t.replace(Ne, "ms-").replace(Vt, Zn);
    }
    function xn(t) {
        return t.nodeType === 1 || t.nodeType === 9 || !+t.nodeType;
    }
    function he() {
        this.expando = c.expando + he.uid++;
    }
    (he.uid = 1),
        (he.prototype = {
            cache: function (t) {
                var n = t[this.expando];
                return n || ((n = {}), xn(t) && (t.nodeType ? (t[this.expando] = n) : Object.defineProperty(t, this.expando, { value: n, configurable: !0 }))), n;
            },
            set: function (t, n, o) {
                var a,
                    g = this.cache(t);
                if (typeof n == "string") g[te(n)] = o;
                else for (a in n) g[te(a)] = n[a];
                return g;
            },
            get: function (t, n) {
                return n === void 0 ? this.cache(t) : t[this.expando] && t[this.expando][te(n)];
            },
            access: function (t, n, o) {
                return n === void 0 || (n && typeof n == "string" && o === void 0) ? this.get(t, n) : (this.set(t, n, o), o !== void 0 ? o : n);
            },
            remove: function (t, n) {
                var o,
                    a = t[this.expando];
                if (a !== void 0) {
                    if (n !== void 0) for (o = (n = Array.isArray(n) ? n.map(te) : ((n = te(n)) in a) ? [n] : n.match(Fe) || []).length; o--; ) delete a[n[o]];
                    (n !== void 0 && !c.isEmptyObject(a)) || (t.nodeType ? (t[this.expando] = void 0) : delete t[this.expando]);
                }
            },
            hasData: function (t) {
                return (t = t[this.expando]), t !== void 0 && !c.isEmptyObject(t);
            },
        });
    var gt = new he(),
        oe = new he(),
        si = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        G = /[A-Z]/g;
    function Me(t, n, o) {
        var a, g;
        if (o === void 0 && t.nodeType === 1)
            if (((a = "data-" + n.replace(G, "-$&").toLowerCase()), typeof (o = t.getAttribute(a)) == "string")) {
                try {
                    o = (g = o) === "true" || (g !== "false" && (g === "null" ? null : g === +g + "" ? +g : si.test(g) ? JSON.parse(g) : g));
                } catch {}
                oe.set(t, n, o);
            } else o = void 0;
        return o;
    }
    c.extend({
        hasData: function (t) {
            return oe.hasData(t) || gt.hasData(t);
        },
        data: function (t, n, o) {
            return oe.access(t, n, o);
        },
        removeData: function (t, n) {
            oe.remove(t, n);
        },
        _data: function (t, n, o) {
            return gt.access(t, n, o);
        },
        _removeData: function (t, n) {
            gt.remove(t, n);
        },
    }),
        c.fn.extend({
            data: function (t, n) {
                var o,
                    a,
                    g,
                    w = this[0],
                    C = w && w.attributes;
                if (t !== void 0)
                    return _typeof(t) == "object"
                        ? this.each(function () {
                              oe.set(this, t);
                          })
                        : Ke(
                              this,
                              function (E) {
                                  var P;
                                  return w && E === void 0
                                      ? (P = oe.get(w, t)) !== void 0 || (P = Me(w, t)) !== void 0
                                          ? P
                                          : void 0
                                      : void this.each(function () {
                                            oe.set(this, t, E);
                                        });
                              },
                              null,
                              n,
                              1 < arguments.length,
                              null,
                              !0
                          );
                if (this.length && ((g = oe.get(w)), w.nodeType === 1 && !gt.get(w, "hasDataAttrs"))) {
                    for (o = C.length; o--; ) C[o] && (a = C[o].name).indexOf("data-") === 0 && ((a = te(a.slice(5))), Me(w, a, g[a]));
                    gt.set(w, "hasDataAttrs", !0);
                }
                return g;
            },
            removeData: function (t) {
                return this.each(function () {
                    oe.remove(this, t);
                });
            },
        }),
        c.extend({
            queue: function (t, n, o) {
                var a;
                if (t) return (a = gt.get(t, (n = (n || "fx") + "queue"))), o && (!a || Array.isArray(o) ? (a = gt.access(t, n, c.makeArray(o))) : a.push(o)), a || [];
            },
            dequeue: function (t, n) {
                var o = c.queue(t, (n = n || "fx")),
                    a = o.length,
                    g = o.shift(),
                    w = c._queueHooks(t, n);
                g === "inprogress" && ((g = o.shift()), a--),
                    g &&
                        (n === "fx" && o.unshift("inprogress"),
                        delete w.stop,
                        g.call(
                            t,
                            function () {
                                c.dequeue(t, n);
                            },
                            w
                        )),
                    !a && w && w.empty.fire();
            },
            _queueHooks: function (t, n) {
                var o = n + "queueHooks";
                return (
                    gt.get(t, o) ||
                    gt.access(t, o, {
                        empty: c.Callbacks("once memory").add(function () {
                            gt.remove(t, [n + "queue", o]);
                        }),
                    })
                );
            },
        }),
        c.fn.extend({
            queue: function (t, n) {
                var o = 2;
                return (
                    typeof t != "string" && ((n = t), (t = "fx"), o--),
                    arguments.length < o
                        ? c.queue(this[0], t)
                        : n === void 0
                        ? this
                        : this.each(function () {
                              var a = c.queue(this, t, n);
                              c._queueHooks(this, t), t === "fx" && a[0] !== "inprogress" && c.dequeue(this, t);
                          })
                );
            },
            dequeue: function (t) {
                return this.each(function () {
                    c.dequeue(this, t);
                });
            },
            clearQueue: function (t) {
                return this.queue(t || "fx", []);
            },
            promise: function (t, n) {
                function o() {
                    --g || w.resolveWith(C, [C]);
                }
                var a,
                    g = 1,
                    w = c.Deferred(),
                    C = this,
                    E = this.length;
                for (typeof t != "string" && ((n = t), (t = void 0)), t = t || "fx"; E--; ) (a = gt.get(C[E], t + "queueHooks")) && a.empty && (g++, a.empty.add(o));
                return o(), w.promise(n);
            },
        });
    var qe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        Qt = new RegExp("^(?:([+-])=|)(" + qe + ")([a-z%]*)$", "i"),
        Xe = ["Top", "Right", "Bottom", "Left"],
        rn = xt.documentElement,
        gn = function (t) {
            return c.contains(t.ownerDocument, t);
        },
        oi = { composed: !0 };
    rn.getRootNode &&
        (gn = function (t) {
            return c.contains(t.ownerDocument, t) || t.getRootNode(oi) === t.ownerDocument;
        });
    function kn(t, n) {
        return (t = n || t).style.display === "none" || (t.style.display === "" && gn(t) && c.css(t, "display") === "none");
    }
    function Hn(t, n, o, a) {
        var g,
            w,
            C = 20,
            E = a
                ? function () {
                      return a.cur();
                  }
                : function () {
                      return c.css(t, n, "");
                  },
            P = E(),
            N = (o && o[3]) || (c.cssNumber[n] ? "" : "px"),
            R = t.nodeType && (c.cssNumber[n] || (N !== "px" && +P)) && Qt.exec(c.css(t, n));
        if (R && R[3] !== N) {
            for (N = N || R[3], R = +(P /= 2) || 1; C--; ) c.style(t, n, R + N), (1 - w) * (1 - (w = E() / P || 0.5)) <= 0 && (C = 0), (R /= w);
            c.style(t, n, (R *= 2) + N), (o = o || []);
        }
        return o && ((R = +R || +P || 0), (g = o[1] ? R + (o[1] + 1) * o[2] : +o[2]), a && ((a.unit = N), (a.start = R), (a.end = g))), g;
    }
    var Rn = {};
    function an(t, n) {
        for (var o, a, g, w, C, E, P = [], N = 0, R = t.length; N < R; N++)
            (a = t[N]).style &&
                ((o = a.style.display),
                n
                    ? (o === "none" && ((P[N] = gt.get(a, "display") || null), P[N] || (a.style.display = "")),
                      a.style.display === "" &&
                          kn(a) &&
                          (P[N] =
                              ((E = w = g = void 0),
                              (w = a.ownerDocument),
                              (C = a.nodeName),
                              (E = Rn[C]) || ((g = w.body.appendChild(w.createElement(C))), (E = c.css(g, "display")), g.parentNode.removeChild(g), (Rn[C] = E = E === "none" ? "block" : E)))))
                    : o !== "none" && ((P[N] = "none"), gt.set(a, "display", o)));
        for (N = 0; N < R; N++) P[N] != null && (t[N].style.display = P[N]);
        return t;
    }
    c.fn.extend({
        show: function () {
            return an(this, !0);
        },
        hide: function () {
            return an(this);
        },
        toggle: function (t) {
            return typeof t == "boolean"
                ? t
                    ? this.show()
                    : this.hide()
                : this.each(function () {
                      kn(this) ? c(this).show() : c(this).hide();
                  });
        },
    });
    var An = /^(?:checkbox|radio)$/i,
        _n = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        hi = /^$|^module$|\/(?:java|ecma)script/i,
        Jt = xt.createDocumentFragment().appendChild(xt.createElement("div"));
    (xe = xt.createElement("input")).setAttribute("type", "radio"),
        xe.setAttribute("checked", "checked"),
        xe.setAttribute("name", "t"),
        Jt.appendChild(xe),
        (St.checkClone = Jt.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (Jt.innerHTML = "<textarea>x</textarea>"),
        (St.noCloneChecked = !!Jt.cloneNode(!0).lastChild.defaultValue),
        (Jt.innerHTML = "<option></option>"),
        (St.option = !!Jt.lastChild);
    var ke = { thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };
    function re(t, n) {
        var o = t.getElementsByTagName !== void 0 ? t.getElementsByTagName(n || "*") : t.querySelectorAll !== void 0 ? t.querySelectorAll(n || "*") : [];
        return n === void 0 || (n && _e(t, n)) ? c.merge([t], o) : o;
    }
    function Wn(t, n) {
        for (var o = 0, a = t.length; o < a; o++) gt.set(t[o], "globalEval", !n || gt.get(n[o], "globalEval"));
    }
    (ke.tbody = ke.tfoot = ke.colgroup = ke.caption = ke.thead), (ke.th = ke.td), St.option || (ke.optgroup = ke.option = [1, "<select multiple='multiple'>", "</select>"]);
    var ln = /<|&#?\w+;/;
    function Cn(t, n, o, a, g) {
        for (var w, C, E, P, N, R = n.createDocumentFragment(), M = [], B = 0, V = t.length; B < V; B++)
            if ((w = t[B]) || w === 0)
                if (fn(w) === "object") c.merge(M, w.nodeType ? [w] : w);
                else if (ln.test(w)) {
                    for (C = C || R.appendChild(n.createElement("div")), E = (_n.exec(w) || ["", ""])[1].toLowerCase(), E = ke[E] || ke._default, C.innerHTML = E[1] + c.htmlPrefilter(w) + E[2], N = E[0]; N--; ) C = C.lastChild;
                    c.merge(M, C.childNodes), ((C = R.firstChild).textContent = "");
                } else M.push(n.createTextNode(w));
        for (R.textContent = "", B = 0; (w = M[B++]); )
            if (a && -1 < c.inArray(w, a)) g && g.push(w);
            else if (((P = gn(w)), (C = re(R.appendChild(w), "script")), P && Wn(C), o)) for (N = 0; (w = C[N++]); ) hi.test(w.type || "") && o.push(w);
        return R;
    }
    var cn = /^key/,
        Fn = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        En = /^([^.]*)(?:\.(.+)|)/;
    function Ge() {
        return !0;
    }
    function K() {
        return !1;
    }
    function i(t, n) {
        return (
            (t ===
                (function () {
                    try {
                        return xt.activeElement;
                    } catch {}
                })()) ==
            (n === "focus")
        );
    }
    function h(t, n, o, a, g, w) {
        var C, E;
        if (_typeof(n) == "object") {
            for (E in (typeof o != "string" && ((a = a || o), (o = void 0)), n)) h(t, E, o, a, n[E], w);
            return t;
        }
        if ((a == null && g == null ? ((g = o), (a = o = void 0)) : g == null && (typeof o == "string" ? ((g = a), (a = void 0)) : ((g = a), (a = o), (o = void 0))), g === !1)) g = K;
        else if (!g) return t;
        return (
            w === 1 &&
                ((C = g),
                ((g = function (P) {
                    return c().off(P), C.apply(this, arguments);
                }).guid = C.guid || (C.guid = c.guid++))),
            t.each(function () {
                c.event.add(this, n, g, a, o);
            })
        );
    }
    function m(t, n, o) {
        o
            ? (gt.set(t, n, !1),
              c.event.add(t, n, {
                  namespace: !1,
                  handler: function (a) {
                      var g,
                          w,
                          C = gt.get(this, n);
                      if (1 & a.isTrigger && this[n]) {
                          if (C.length) (c.event.special[n] || {}).delegateType && a.stopPropagation();
                          else if (((C = be.call(arguments)), gt.set(this, n, C), (g = o(this, n)), this[n](), C !== (w = gt.get(this, n)) || g ? gt.set(this, n, !1) : (w = {}), C !== w))
                              return a.stopImmediatePropagation(), a.preventDefault(), w.value;
                      } else C.length && (gt.set(this, n, { value: c.event.trigger(c.extend(C[0], c.Event.prototype), C.slice(1), this) }), a.stopImmediatePropagation());
                  },
              }))
            : gt.get(t, n) === void 0 && c.event.add(t, n, Ge);
    }
    (c.event = {
        global: {},
        add: function (t, n, o, a, g) {
            var w,
                C,
                E,
                P,
                N,
                R,
                M,
                B,
                V,
                nt = gt.get(t);
            if (xn(t))
                for (
                    o.handler && ((o = (w = o).handler), (g = w.selector)),
                        g && c.find.matchesSelector(rn, g),
                        o.guid || (o.guid = c.guid++),
                        (E = nt.events) || (E = nt.events = Object.create(null)),
                        (C = nt.handle) ||
                            (C = nt.handle = function (st) {
                                return c !== void 0 && c.event.triggered !== st.type ? c.event.dispatch.apply(t, arguments) : void 0;
                            }),
                        P = (n = (n || "").match(Fe) || [""]).length;
                    P--;

                )
                    (M = V = (N = En.exec(n[P]) || [])[1]),
                        (B = (N[2] || "").split(".").sort()),
                        M &&
                            ((R = c.event.special[M] || {}),
                            (M = (g ? R.delegateType : R.bindType) || M),
                            (R = c.event.special[M] || {}),
                            (N = c.extend({ type: M, origType: V, data: a, handler: o, guid: o.guid, selector: g, needsContext: g && c.expr.match.needsContext.test(g), namespace: B.join(".") }, w)),
                            (V = E[M]) || (((V = E[M] = []).delegateCount = 0), (R.setup && R.setup.call(t, a, B, C) !== !1) || (t.addEventListener && t.addEventListener(M, C))),
                            R.add && (R.add.call(t, N), N.handler.guid || (N.handler.guid = o.guid)),
                            g ? V.splice(V.delegateCount++, 0, N) : V.push(N),
                            (c.event.global[M] = !0));
        },
        remove: function (t, n, o, a, g) {
            var w,
                C,
                E,
                P,
                N,
                R,
                M,
                B,
                V,
                nt,
                st,
                bt = gt.hasData(t) && gt.get(t);
            if (bt && (P = bt.events)) {
                for (N = (n = (n || "").match(Fe) || [""]).length; N--; )
                    if (((V = st = (E = En.exec(n[N]) || [])[1]), (nt = (E[2] || "").split(".").sort()), V)) {
                        for (M = c.event.special[V] || {}, B = P[(V = (a ? M.delegateType : M.bindType) || V)] || [], E = E[2] && new RegExp("(^|\\.)" + nt.join("\\.(?:.*\\.|)") + "(\\.|$)"), C = w = B.length; w--; )
                            (R = B[w]),
                                (!g && st !== R.origType) ||
                                    (o && o.guid !== R.guid) ||
                                    (E && !E.test(R.namespace)) ||
                                    (a && a !== R.selector && (a !== "**" || !R.selector)) ||
                                    (B.splice(w, 1), R.selector && B.delegateCount--, M.remove && M.remove.call(t, R));
                        C && !B.length && ((M.teardown && M.teardown.call(t, nt, bt.handle) !== !1) || c.removeEvent(t, V, bt.handle), delete P[V]);
                    } else for (V in P) c.event.remove(t, V + n[N], o, a, !0);
                c.isEmptyObject(P) && gt.remove(t, "handle events");
            }
        },
        dispatch: function (t) {
            var n,
                o,
                a,
                g,
                w,
                C = new Array(arguments.length),
                E = c.event.fix(t),
                P = (gt.get(this, "events") || Object.create(null))[E.type] || [],
                t = c.event.special[E.type] || {};
            for (C[0] = E, n = 1; n < arguments.length; n++) C[n] = arguments[n];
            if (((E.delegateTarget = this), !t.preDispatch || t.preDispatch.call(this, E) !== !1)) {
                for (w = c.event.handlers.call(this, E, P), n = 0; (a = w[n++]) && !E.isPropagationStopped(); )
                    for (E.currentTarget = a.elem, o = 0; (g = a.handlers[o++]) && !E.isImmediatePropagationStopped(); )
                        (E.rnamespace && g.namespace !== !1 && !E.rnamespace.test(g.namespace)) ||
                            ((E.handleObj = g), (E.data = g.data), (g = ((c.event.special[g.origType] || {}).handle || g.handler).apply(a.elem, C)) !== void 0 && (E.result = g) === !1 && (E.preventDefault(), E.stopPropagation()));
                return t.postDispatch && t.postDispatch.call(this, E), E.result;
            }
        },
        handlers: function (t, n) {
            var o,
                a,
                g,
                w,
                C,
                E = [],
                P = n.delegateCount,
                N = t.target;
            if (P && N.nodeType && !(t.type === "click" && 1 <= t.button)) {
                for (; N !== this; N = N.parentNode || this)
                    if (N.nodeType === 1 && (t.type !== "click" || N.disabled !== !0)) {
                        for (w = [], C = {}, o = 0; o < P; o++) C[(g = (a = n[o]).selector + " ")] === void 0 && (C[g] = a.needsContext ? -1 < c(g, this).index(N) : c.find(g, this, null, [N]).length), C[g] && w.push(a);
                        w.length && E.push({ elem: N, handlers: w });
                    }
            }
            return (N = this), P < n.length && E.push({ elem: N, handlers: n.slice(P) }), E;
        },
        addProp: function (t, n) {
            Object.defineProperty(c.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: yt(n)
                    ? function () {
                          if (this.originalEvent) return n(this.originalEvent);
                      }
                    : function () {
                          if (this.originalEvent) return this.originalEvent[t];
                      },
                set: function (o) {
                    Object.defineProperty(this, t, { enumerable: !0, configurable: !0, writable: !0, value: o });
                },
            });
        },
        fix: function (t) {
            return t[c.expando] ? t : new c.Event(t);
        },
        special: {
            load: { noBubble: !0 },
            click: {
                setup: function (t) {
                    return (t = this || t), An.test(t.type) && t.click && _e(t, "input") && m(t, "click", Ge), !1;
                },
                trigger: function (t) {
                    return (t = this || t), An.test(t.type) && t.click && _e(t, "input") && m(t, "click"), !0;
                },
                _default: function (t) {
                    return (t = t.target), (An.test(t.type) && t.click && _e(t, "input") && gt.get(t, "click")) || _e(t, "a");
                },
            },
            beforeunload: {
                postDispatch: function (t) {
                    t.result !== void 0 && t.originalEvent && (t.originalEvent.returnValue = t.result);
                },
            },
        },
    }),
        (c.removeEvent = function (t, n, o) {
            t.removeEventListener && t.removeEventListener(n, o);
        }),
        (c.Event = function (t, n) {
            if (!(this instanceof c.Event)) return new c.Event(t, n);
            t && t.type
                ? ((this.originalEvent = t),
                  (this.type = t.type),
                  (this.isDefaultPrevented = t.defaultPrevented || (t.defaultPrevented === void 0 && t.returnValue === !1) ? Ge : K),
                  (this.target = t.target && t.target.nodeType === 3 ? t.target.parentNode : t.target),
                  (this.currentTarget = t.currentTarget),
                  (this.relatedTarget = t.relatedTarget))
                : (this.type = t),
                n && c.extend(this, n),
                (this.timeStamp = (t && t.timeStamp) || Date.now()),
                (this[c.expando] = !0);
        }),
        (c.Event.prototype = {
            constructor: c.Event,
            isDefaultPrevented: K,
            isPropagationStopped: K,
            isImmediatePropagationStopped: K,
            isSimulated: !1,
            preventDefault: function () {
                var t = this.originalEvent;
                (this.isDefaultPrevented = Ge), t && !this.isSimulated && t.preventDefault();
            },
            stopPropagation: function () {
                var t = this.originalEvent;
                (this.isPropagationStopped = Ge), t && !this.isSimulated && t.stopPropagation();
            },
            stopImmediatePropagation: function () {
                var t = this.originalEvent;
                (this.isImmediatePropagationStopped = Ge), t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation();
            },
        }),
        c.each(
            {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: function (t) {
                    var n = t.button;
                    return t.which == null && cn.test(t.type) ? (t.charCode != null ? t.charCode : t.keyCode) : !t.which && n !== void 0 && Fn.test(t.type) ? (1 & n ? 1 : 2 & n ? 3 : 4 & n ? 2 : 0) : t.which;
                },
            },
            c.event.addProp
        ),
        c.each({ focus: "focusin", blur: "focusout" }, function (t, n) {
            c.event.special[t] = {
                setup: function () {
                    return m(this, t, i), !1;
                },
                trigger: function () {
                    return m(this, t), !0;
                },
                delegateType: n,
            };
        }),
        c.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (t, n) {
            c.event.special[t] = {
                delegateType: n,
                bindType: n,
                handle: function (o) {
                    var a,
                        g = o.relatedTarget,
                        w = o.handleObj;
                    return (g && (g === this || c.contains(this, g))) || ((o.type = w.origType), (a = w.handler.apply(this, arguments)), (o.type = n)), a;
                },
            };
        }),
        c.fn.extend({
            on: function (t, n, o, a) {
                return h(this, t, n, o, a);
            },
            one: function (t, n, o, a) {
                return h(this, t, n, o, a, 1);
            },
            off: function (t, n, o) {
                var a, g;
                if (t && t.preventDefault && t.handleObj) return (a = t.handleObj), c(t.delegateTarget).off(a.namespace ? a.origType + "." + a.namespace : a.origType, a.selector, a.handler), this;
                if (_typeof(t) != "object")
                    return (
                        (n !== !1 && typeof n != "function") || ((o = n), (n = void 0)),
                        o === !1 && (o = K),
                        this.each(function () {
                            c.event.remove(this, t, o, n);
                        })
                    );
                for (g in t) this.off(g, n, t[g]);
                return this;
            },
        });
    var e = /<script|<style|<link/i,
        r = /checked\s*(?:[^=]|=\s*.checked.)/i,
        p = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function u(t, n) {
        return (_e(t, "table") && _e(n.nodeType !== 11 ? n : n.firstChild, "tr") && c(t).children("tbody")[0]) || t;
    }
    function D(t) {
        return (t.type = (t.getAttribute("type") !== null) + "/" + t.type), t;
    }
    function j(t) {
        return (t.type || "").slice(0, 5) === "true/" ? (t.type = t.type.slice(5)) : t.removeAttribute("type"), t;
    }
    function A(t, n) {
        var o, a, g, w;
        if (n.nodeType === 1) {
            if (gt.hasData(t) && (w = gt.get(t).events)) for (g in (gt.remove(n, "handle events"), w)) for (o = 0, a = w[g].length; o < a; o++) c.event.add(n, g, w[g][o]);
            oe.hasData(t) && ((t = oe.access(t)), (t = c.extend({}, t)), oe.set(n, t));
        }
    }
    function W(t, n, o, a) {
        n = Ln(n);
        var g,
            w,
            C,
            E,
            P,
            N,
            R = 0,
            M = t.length,
            B = M - 1,
            V = n[0],
            nt = yt(V);
        if (nt || (1 < M && typeof V == "string" && !St.checkClone && r.test(V)))
            return t.each(function (st) {
                var bt = t.eq(st);
                nt && (n[0] = V.call(this, st, bt.html())), W(bt, n, o, a);
            });
        if (M && ((w = (g = Cn(n, t[0].ownerDocument, !1, t, a)).firstChild), g.childNodes.length === 1 && (g = w), w || a)) {
            for (E = (C = c.map(re(g, "script"), D)).length; R < M; R++) (P = g), R !== B && ((P = c.clone(P, !0, !0)), E && c.merge(C, re(P, "script"))), o.call(t[R], P, R);
            if (E)
                for (N = C[C.length - 1].ownerDocument, c.map(C, j), R = 0; R < E; R++)
                    (P = C[R]),
                        hi.test(P.type || "") &&
                            !gt.access(P, "globalEval") &&
                            c.contains(N, P) &&
                            (P.src && (P.type || "").toLowerCase() !== "module" ? c._evalUrl && !P.noModule && c._evalUrl(P.src, { nonce: P.nonce || P.getAttribute("nonce") }, N) : Yn(P.textContent.replace(p, ""), P, N));
        }
        return t;
    }
    function F(t, n, o) {
        for (var a, g = n ? c.filter(n, t) : t, w = 0; (a = g[w]) != null; w++) o || a.nodeType !== 1 || c.cleanData(re(a)), a.parentNode && (o && gn(a) && Wn(re(a, "script")), a.parentNode.removeChild(a));
        return t;
    }
    c.extend({
        htmlPrefilter: function (t) {
            return t;
        },
        clone: function (t, n, o) {
            var a,
                g,
                w,
                C,
                E,
                P,
                N,
                R = t.cloneNode(!0),
                M = gn(t);
            if (!(St.noCloneChecked || (t.nodeType !== 1 && t.nodeType !== 11) || c.isXMLDoc(t)))
                for (C = re(R), a = 0, g = (w = re(t)).length; a < g; a++)
                    (E = w[a]), (N = (P = C[a]).nodeName.toLowerCase()) === "input" && An.test(E.type) ? (P.checked = E.checked) : (N !== "input" && N !== "textarea") || (P.defaultValue = E.defaultValue);
            if (n)
                if (o) for (w = w || re(t), C = C || re(R), a = 0, g = w.length; a < g; a++) A(w[a], C[a]);
                else A(t, R);
            return 0 < (C = re(R, "script")).length && Wn(C, !M && re(t, "script")), R;
        },
        cleanData: function (t) {
            for (var n, o, a, g = c.event.special, w = 0; (o = t[w]) !== void 0; w++)
                if (xn(o)) {
                    if ((n = o[gt.expando])) {
                        if (n.events) for (a in n.events) g[a] ? c.event.remove(o, a) : c.removeEvent(o, a, n.handle);
                        o[gt.expando] = void 0;
                    }
                    o[oe.expando] && (o[oe.expando] = void 0);
                }
        },
    }),
        c.fn.extend({
            detach: function (t) {
                return F(this, t, !0);
            },
            remove: function (t) {
                return F(this, t);
            },
            text: function (t) {
                return Ke(
                    this,
                    function (n) {
                        return n === void 0
                            ? c.text(this)
                            : this.empty().each(function () {
                                  (this.nodeType !== 1 && this.nodeType !== 11 && this.nodeType !== 9) || (this.textContent = n);
                              });
                    },
                    null,
                    t,
                    arguments.length
                );
            },
            append: function () {
                return W(this, arguments, function (t) {
                    (this.nodeType !== 1 && this.nodeType !== 11 && this.nodeType !== 9) || u(this, t).appendChild(t);
                });
            },
            prepend: function () {
                return W(this, arguments, function (t) {
                    var n;
                    (this.nodeType !== 1 && this.nodeType !== 11 && this.nodeType !== 9) || (n = u(this, t)).insertBefore(t, n.firstChild);
                });
            },
            before: function () {
                return W(this, arguments, function (t) {
                    this.parentNode && this.parentNode.insertBefore(t, this);
                });
            },
            after: function () {
                return W(this, arguments, function (t) {
                    this.parentNode && this.parentNode.insertBefore(t, this.nextSibling);
                });
            },
            empty: function () {
                for (var t, n = 0; (t = this[n]) != null; n++) t.nodeType === 1 && (c.cleanData(re(t, !1)), (t.textContent = ""));
                return this;
            },
            clone: function (t, n) {
                return (
                    (t = t != null && t),
                    (n = n ?? t),
                    this.map(function () {
                        return c.clone(this, t, n);
                    })
                );
            },
            html: function (t) {
                return Ke(
                    this,
                    function (n) {
                        var o = this[0] || {},
                            a = 0,
                            g = this.length;
                        if (n === void 0 && o.nodeType === 1) return o.innerHTML;
                        if (typeof n == "string" && !e.test(n) && !ke[(_n.exec(n) || ["", ""])[1].toLowerCase()]) {
                            n = c.htmlPrefilter(n);
                            try {
                                for (; a < g; a++) (o = this[a] || {}).nodeType === 1 && (c.cleanData(re(o, !1)), (o.innerHTML = n));
                                o = 0;
                            } catch {}
                        }
                        o && this.empty().append(n);
                    },
                    null,
                    t,
                    arguments.length
                );
            },
            replaceWith: function () {
                var t = [];
                return W(
                    this,
                    arguments,
                    function (n) {
                        var o = this.parentNode;
                        c.inArray(this, t) < 0 && (c.cleanData(re(this)), o && o.replaceChild(n, this));
                    },
                    t
                );
            },
        }),
        c.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (t, n) {
            c.fn[t] = function (o) {
                for (var a, g = [], w = c(o), C = w.length - 1, E = 0; E <= C; E++) (a = E === C ? this : this.clone(!0)), c(w[E])[n](a), sn.apply(g, a.get());
                return this.pushStack(g);
            };
        });
    function Q(t, n, o) {
        var a,
            g = {};
        for (a in n) (g[a] = t.style[a]), (t.style[a] = n[a]);
        for (a in ((o = o.call(t)), n)) t.style[a] = g[a];
        return o;
    }
    var J,
        wt,
        zt,
        X,
        tt,
        it,
        lt,
        ht,
        _t = new RegExp("^(" + qe + ")(?!px)[a-z%]+$", "i"),
        et = function (t) {
            var n = t.ownerDocument.defaultView;
            return (n = !n || !n.opener ? mt : n).getComputedStyle(t);
        },
        y = new RegExp(Xe.join("|"), "i");
    function _(t, n, o) {
        var a,
            g,
            w = t.style;
        return (
            (o = o || et(t)) &&
                ((g = o.getPropertyValue(n) || o[n]) !== "" || gn(t) || (g = c.style(t, n)),
                !St.pixelBoxStyles() && _t.test(g) && y.test(n) && ((a = w.width), (t = w.minWidth), (n = w.maxWidth), (w.minWidth = w.maxWidth = w.width = g), (g = o.width), (w.width = a), (w.minWidth = t), (w.maxWidth = n))),
            g !== void 0 ? g + "" : g
        );
    }
    function v(t, n) {
        return {
            get: function () {
                if (!t()) return (this.get = n).apply(this, arguments);
                delete this.get;
            },
        };
    }
    function d() {
        var t;
        ht &&
            ((lt.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
            (ht.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
            rn.appendChild(lt).appendChild(ht),
            (t = mt.getComputedStyle(ht)),
            (J = t.top !== "1%"),
            (it = l(t.marginLeft) === 12),
            (ht.style.right = "60%"),
            (X = l(t.right) === 36),
            (wt = l(t.width) === 36),
            (ht.style.position = "absolute"),
            (zt = l(ht.offsetWidth / 3) === 12),
            rn.removeChild(lt),
            (ht = null));
    }
    function l(t) {
        return Math.round(parseFloat(t));
    }
    (lt = xt.createElement("div")),
        (ht = xt.createElement("div")).style &&
            ((ht.style.backgroundClip = "content-box"),
            (ht.cloneNode(!0).style.backgroundClip = ""),
            (St.clearCloneStyle = ht.style.backgroundClip === "content-box"),
            c.extend(St, {
                boxSizingReliable: function () {
                    return d(), wt;
                },
                pixelBoxStyles: function () {
                    return d(), X;
                },
                pixelPosition: function () {
                    return d(), J;
                },
                reliableMarginLeft: function () {
                    return d(), it;
                },
                scrollboxSize: function () {
                    return d(), zt;
                },
                reliableTrDimensions: function () {
                    var t, n, o;
                    return (
                        tt == null &&
                            ((t = xt.createElement("table")),
                            (o = xt.createElement("tr")),
                            (n = xt.createElement("div")),
                            (t.style.cssText = "position:absolute;left:-11111px"),
                            (o.style.height = "1px"),
                            (n.style.height = "9px"),
                            rn.appendChild(t).appendChild(o).appendChild(n),
                            (o = mt.getComputedStyle(o)),
                            (tt = 3 < parseInt(o.height)),
                            rn.removeChild(t)),
                        tt
                    );
                },
            }));
    var s = ["Webkit", "Moz", "ms"],
        f = xt.createElement("div").style,
        b = {};
    function k(t) {
        return (
            c.cssProps[t] ||
            b[t] ||
            (t in f
                ? t
                : (b[t] =
                      (function (n) {
                          for (var o = n[0].toUpperCase() + n.slice(1), a = s.length; a--; ) if ((n = s[a] + o) in f) return n;
                      })(t) || t))
        );
    }
    var T = /^(none|table(?!-c[ea]).+)/,
        O = /^--/,
        L = { position: "absolute", visibility: "hidden", display: "block" },
        I = { letterSpacing: "0", fontWeight: "400" };
    function Z(t, n, o) {
        var a = Qt.exec(n);
        return a ? Math.max(0, a[2] - (o || 0)) + (a[3] || "px") : n;
    }
    function Y(t, n, o, a, g, w) {
        var C = n === "width" ? 1 : 0,
            E = 0,
            P = 0;
        if (o === (a ? "border" : "content")) return 0;
        for (; C < 4; C += 2)
            o === "margin" && (P += c.css(t, o + Xe[C], !0, g)),
                a
                    ? (o === "content" && (P -= c.css(t, "padding" + Xe[C], !0, g)), o !== "margin" && (P -= c.css(t, "border" + Xe[C] + "Width", !0, g)))
                    : ((P += c.css(t, "padding" + Xe[C], !0, g)), o !== "padding" ? (P += c.css(t, "border" + Xe[C] + "Width", !0, g)) : (E += c.css(t, "border" + Xe[C] + "Width", !0, g)));
        return !a && 0 <= w && (P += Math.max(0, Math.ceil(t["offset" + n[0].toUpperCase() + n.slice(1)] - w - P - E - 0.5)) || 0), P;
    }
    function at(t, n, o) {
        var a = et(t),
            g = (!St.boxSizingReliable() || o) && c.css(t, "boxSizing", !1, a) === "border-box",
            w = g,
            C = _(t, n, a),
            E = "offset" + n[0].toUpperCase() + n.slice(1);
        if (_t.test(C)) {
            if (!o) return C;
            C = "auto";
        }
        return (
            ((!St.boxSizingReliable() && g) || (!St.reliableTrDimensions() && _e(t, "tr")) || C === "auto" || (!parseFloat(C) && c.css(t, "display", !1, a) === "inline")) &&
                t.getClientRects().length &&
                ((g = c.css(t, "boxSizing", !1, a) === "border-box"), (w = E in t) && (C = t[E])),
            (C = parseFloat(C) || 0) + Y(t, n, o || (g ? "border" : "content"), w, a, C) + "px"
        );
    }
    function ft(t, n, o, a, g) {
        return new ft.prototype.init(t, n, o, a, g);
    }
    c.extend({
        cssHooks: {
            opacity: {
                get: function (t, n) {
                    if (n) return (t = _(t, "opacity")), t === "" ? "1" : t;
                },
            },
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
        },
        cssProps: {},
        style: function (t, n, o, a) {
            if (t && t.nodeType !== 3 && t.nodeType !== 8 && t.style) {
                var g,
                    w,
                    C,
                    E = te(n),
                    P = O.test(n),
                    N = t.style;
                if ((P || (n = k(E)), (C = c.cssHooks[n] || c.cssHooks[E]), o === void 0)) return C && "get" in C && (g = C.get(t, !1, a)) !== void 0 ? g : N[n];
                (w = _typeof(o)) === "string" && (g = Qt.exec(o)) && g[1] && ((o = Hn(t, n, g)), (w = "number")),
                    o != null &&
                        o == o &&
                        (w !== "number" || P || (o += (g && g[3]) || (c.cssNumber[E] ? "" : "px")),
                        St.clearCloneStyle || o !== "" || n.indexOf("background") !== 0 || (N[n] = "inherit"),
                        (C && "set" in C && (o = C.set(t, o, a)) === void 0) || (P ? N.setProperty(n, o) : (N[n] = o)));
            }
        },
        css: function (t, n, o, a) {
            var g,
                w = te(n);
            return (
                O.test(n) || (n = k(w)),
                (g = (g = (w = c.cssHooks[n] || c.cssHooks[w]) && "get" in w ? w.get(t, !0, o) : g) === void 0 ? _(t, n, a) : g) === "normal" && n in I && (g = I[n]),
                o === "" || o ? ((n = parseFloat(g)), o === !0 || isFinite(n) ? n || 0 : g) : g
            );
        },
    }),
        c.each(["height", "width"], function (t, n) {
            c.cssHooks[n] = {
                get: function (o, a, g) {
                    if (a)
                        return !T.test(c.css(o, "display")) || (o.getClientRects().length && o.getBoundingClientRect().width)
                            ? at(o, n, g)
                            : Q(o, L, function () {
                                  return at(o, n, g);
                              });
                },
                set: function (o, a, g) {
                    var w,
                        C = et(o),
                        E = !St.scrollboxSize() && C.position === "absolute",
                        P = (E || g) && c.css(o, "boxSizing", !1, C) === "border-box",
                        g = g ? Y(o, n, g, P, C) : 0;
                    return (
                        P && E && (g -= Math.ceil(o["offset" + n[0].toUpperCase() + n.slice(1)] - parseFloat(C[n]) - Y(o, n, "border", !1, C) - 0.5)),
                        g && (w = Qt.exec(a)) && (w[3] || "px") !== "px" && ((o.style[n] = a), (a = c.css(o, n))),
                        Z(0, a, g)
                    );
                },
            };
        }),
        (c.cssHooks.marginLeft = v(St.reliableMarginLeft, function (t, n) {
            if (n)
                return (
                    (parseFloat(_(t, "marginLeft")) ||
                        t.getBoundingClientRect().left -
                            Q(t, { marginLeft: 0 }, function () {
                                return t.getBoundingClientRect().left;
                            })) + "px"
                );
        })),
        c.each({ margin: "", padding: "", border: "Width" }, function (t, n) {
            (c.cssHooks[t + n] = {
                expand: function (o) {
                    for (var a = 0, g = {}, w = typeof o == "string" ? o.split(" ") : [o]; a < 4; a++) g[t + Xe[a] + n] = w[a] || w[a - 2] || w[0];
                    return g;
                },
            }),
                t !== "margin" && (c.cssHooks[t + n].set = Z);
        }),
        c.fn.extend({
            css: function (t, n) {
                return Ke(
                    this,
                    function (o, a, g) {
                        var w,
                            C,
                            E = {},
                            P = 0;
                        if (Array.isArray(a)) {
                            for (w = et(o), C = a.length; P < C; P++) E[a[P]] = c.css(o, a[P], !1, w);
                            return E;
                        }
                        return g !== void 0 ? c.style(o, a, g) : c.css(o, a);
                    },
                    t,
                    n,
                    1 < arguments.length
                );
            },
        }),
        (((c.Tween = ft).prototype = {
            constructor: ft,
            init: function (t, n, o, a, g, w) {
                (this.elem = t), (this.prop = o), (this.easing = g || c.easing._default), (this.options = n), (this.start = this.now = this.cur()), (this.end = a), (this.unit = w || (c.cssNumber[o] ? "" : "px"));
            },
            cur: function () {
                var t = ft.propHooks[this.prop];
                return (t && t.get ? t : ft.propHooks._default).get(this);
            },
            run: function (t) {
                var n,
                    o = ft.propHooks[this.prop];
                return (
                    this.options.duration ? (this.pos = n = c.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration)) : (this.pos = n = t),
                    (this.now = (this.end - this.start) * n + this.start),
                    this.options.step && this.options.step.call(this.elem, this.now, this),
                    (o && o.set ? o : ft.propHooks._default).set(this),
                    this
                );
            },
        }).init.prototype = ft.prototype),
        ((ft.propHooks = {
            _default: {
                get: function (t) {
                    return t.elem.nodeType !== 1 || (t.elem[t.prop] != null && t.elem.style[t.prop] == null) ? t.elem[t.prop] : (t = c.css(t.elem, t.prop, "")) && t !== "auto" ? t : 0;
                },
                set: function (t) {
                    c.fx.step[t.prop] ? c.fx.step[t.prop](t) : t.elem.nodeType !== 1 || (!c.cssHooks[t.prop] && t.elem.style[k(t.prop)] == null) ? (t.elem[t.prop] = t.now) : c.style(t.elem, t.prop, t.now + t.unit);
                },
            },
        }).scrollTop = ft.propHooks.scrollLeft = {
            set: function (t) {
                t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now);
            },
        }),
        (c.easing = {
            linear: function (t) {
                return t;
            },
            swing: function (t) {
                return 0.5 - Math.cos(t * Math.PI) / 2;
            },
            _default: "swing",
        }),
        (c.fx = ft.prototype.init),
        (c.fx.step = {});
    var ct,
        Pt,
        ee = /^(?:toggle|show|hide)$/,
        ne = /queueHooks$/;
    function mn() {
        Pt && (xt.hidden === !1 && mt.requestAnimationFrame ? mt.requestAnimationFrame(mn) : mt.setTimeout(mn, c.fx.interval), c.fx.tick());
    }
    function zn() {
        return (
            mt.setTimeout(function () {
                ct = void 0;
            }),
            (ct = Date.now())
        );
    }
    function Dn(t, n) {
        var o,
            a = 0,
            g = { height: t };
        for (n = n ? 1 : 0; a < 4; a += 2 - n) g["margin" + (o = Xe[a])] = g["padding" + o] = t;
        return n && (g.opacity = g.width = t), g;
    }
    function Kn(t, n, o) {
        for (var a, g = (Ae.tweeners[n] || []).concat(Ae.tweeners["*"]), w = 0, C = g.length; w < C; w++) if ((a = g[w].call(o, n, t))) return a;
    }
    function Ae(t, n, o) {
        var a,
            g,
            w = 0,
            C = Ae.prefilters.length,
            E = c.Deferred().always(function () {
                delete P.elem;
            }),
            P = function () {
                if (g) return !1;
                for (var M = ct || zn(), M = Math.max(0, N.startTime + N.duration - M), B = 1 - (M / N.duration || 0), V = 0, nt = N.tweens.length; V < nt; V++) N.tweens[V].run(B);
                return E.notifyWith(t, [N, B, M]), B < 1 && nt ? M : (nt || E.notifyWith(t, [N, 1, 0]), E.resolveWith(t, [N]), !1);
            },
            N = E.promise({
                elem: t,
                props: c.extend({}, n),
                opts: c.extend(!0, { specialEasing: {}, easing: c.easing._default }, o),
                originalProperties: n,
                originalOptions: o,
                startTime: ct || zn(),
                duration: o.duration,
                tweens: [],
                createTween: function (M, B) {
                    return (M = c.Tween(t, N.opts, M, B, N.opts.specialEasing[M] || N.opts.easing)), N.tweens.push(M), M;
                },
                stop: function (M) {
                    var B = 0,
                        V = M ? N.tweens.length : 0;
                    if (g) return this;
                    for (g = !0; B < V; B++) N.tweens[B].run(1);
                    return M ? (E.notifyWith(t, [N, 1, 0]), E.resolveWith(t, [N, M])) : E.rejectWith(t, [N, M]), this;
                },
            }),
            R = N.props;
        for (
            (function (M, B) {
                var V, nt, st, bt, Bt;
                for (V in M)
                    if (((st = B[(nt = te(V))]), (bt = M[V]), Array.isArray(bt) && ((st = bt[1]), (bt = M[V] = bt[0])), V !== nt && ((M[nt] = bt), delete M[V]), (Bt = c.cssHooks[nt]) && ("expand" in Bt)))
                        for (V in ((bt = Bt.expand(bt)), delete M[nt], bt)) (V in M) || ((M[V] = bt[V]), (B[V] = st));
                    else B[nt] = st;
            })(R, N.opts.specialEasing);
            w < C;
            w++
        )
            if ((a = Ae.prefilters[w].call(N, t, R, N.opts))) return yt(a.stop) && (c._queueHooks(N.elem, N.opts.queue).stop = a.stop.bind(a)), a;
        return (
            c.map(R, Kn, N),
            yt(N.opts.start) && N.opts.start.call(t, N),
            N.progress(N.opts.progress).done(N.opts.done, N.opts.complete).fail(N.opts.fail).always(N.opts.always),
            c.fx.timer(c.extend(P, { elem: t, anim: N, queue: N.opts.queue })),
            N
        );
    }
    (c.Animation = c.extend(Ae, {
        tweeners: {
            "*": [
                function (t, n) {
                    var o = this.createTween(t, n);
                    return Hn(o.elem, t, Qt.exec(n), o), o;
                },
            ],
        },
        tweener: function (t, n) {
            for (var o, a = 0, g = (t = yt(t) ? ((n = t), ["*"]) : t.match(Fe)).length; a < g; a++) (o = t[a]), (Ae.tweeners[o] = Ae.tweeners[o] || []), Ae.tweeners[o].unshift(n);
        },
        prefilters: [
            function (t, n, o) {
                var a,
                    g,
                    w,
                    C,
                    E,
                    P,
                    N,
                    R = "width" in n || "height" in n,
                    M = this,
                    B = {},
                    V = t.style,
                    nt = t.nodeType && kn(t),
                    st = gt.get(t, "fxshow");
                for (a in (o.queue ||
                    ((C = c._queueHooks(t, "fx")).unqueued == null &&
                        ((C.unqueued = 0),
                        (E = C.empty.fire),
                        (C.empty.fire = function () {
                            C.unqueued || E();
                        })),
                    C.unqueued++,
                    M.always(function () {
                        M.always(function () {
                            C.unqueued--, c.queue(t, "fx").length || C.empty.fire();
                        });
                    })),
                n))
                    if (((g = n[a]), ee.test(g))) {
                        if ((delete n[a], (w = w || g === "toggle"), g === (nt ? "hide" : "show"))) {
                            if (g !== "show" || !st || st[a] === void 0) continue;
                            nt = !0;
                        }
                        B[a] = (st && st[a]) || c.style(t, a);
                    }
                if ((P = !c.isEmptyObject(n)) || !c.isEmptyObject(B))
                    for (a in (R &&
                        t.nodeType === 1 &&
                        ((o.overflow = [V.overflow, V.overflowX, V.overflowY]),
                        (N = st && st.display) == null && (N = gt.get(t, "display")),
                        (R = c.css(t, "display")) === "none" && (N ? (R = N) : (an([t], !0), (N = t.style.display || N), (R = c.css(t, "display")), an([t]))),
                        (R === "inline" || (R === "inline-block" && N != null)) &&
                            c.css(t, "float") === "none" &&
                            (P ||
                                (M.done(function () {
                                    V.display = N;
                                }),
                                N == null && ((R = V.display), (N = R === "none" ? "" : R))),
                            (V.display = "inline-block"))),
                    o.overflow &&
                        ((V.overflow = "hidden"),
                        M.always(function () {
                            (V.overflow = o.overflow[0]), (V.overflowX = o.overflow[1]), (V.overflowY = o.overflow[2]);
                        })),
                    (P = !1),
                    B))
                        P ||
                            (st ? "hidden" in st && (nt = st.hidden) : (st = gt.access(t, "fxshow", { display: N })),
                            w && (st.hidden = !nt),
                            nt && an([t], !0),
                            M.done(function () {
                                for (a in (nt || an([t]), gt.remove(t, "fxshow"), B)) c.style(t, a, B[a]);
                            })),
                            (P = Kn(nt ? st[a] : 0, a, M)),
                            a in st || ((st[a] = P.start), nt && ((P.end = P.start), (P.start = 0)));
            },
        ],
        prefilter: function (t, n) {
            n ? Ae.prefilters.unshift(t) : Ae.prefilters.push(t);
        },
    })),
        (c.speed = function (t, n, o) {
            var a = t && _typeof(t) == "object" ? c.extend({}, t) : { complete: o || (!o && n) || (yt(t) && t), duration: t, easing: (o && n) || (n && !yt(n) && n) };
            return (
                c.fx.off ? (a.duration = 0) : typeof a.duration != "number" && (a.duration in c.fx.speeds ? (a.duration = c.fx.speeds[a.duration]) : (a.duration = c.fx.speeds._default)),
                (a.queue != null && a.queue !== !0) || (a.queue = "fx"),
                (a.old = a.complete),
                (a.complete = function () {
                    yt(a.old) && a.old.call(this), a.queue && c.dequeue(this, a.queue);
                }),
                a
            );
        }),
        c.fn.extend({
            fadeTo: function (t, n, o, a) {
                return this.filter(kn).css("opacity", 0).show().end().animate({ opacity: n }, t, o, a);
            },
            animate: function (t, n, o, a) {
                var g = c.isEmptyObject(t),
                    w = c.speed(n, o, a),
                    a = function () {
                        var C = Ae(this, c.extend({}, t), w);
                        (g || gt.get(this, "finish")) && C.stop(!0);
                    };
                return (a.finish = a), g || w.queue === !1 ? this.each(a) : this.queue(w.queue, a);
            },
            stop: function (t, n, o) {
                function a(g) {
                    var w = g.stop;
                    delete g.stop, w(o);
                }
                return (
                    typeof t != "string" && ((o = n), (n = t), (t = void 0)),
                    n && this.queue(t || "fx", []),
                    this.each(function () {
                        var g = !0,
                            w = t != null && t + "queueHooks",
                            C = c.timers,
                            E = gt.get(this);
                        if (w) E[w] && E[w].stop && a(E[w]);
                        else for (w in E) E[w] && E[w].stop && ne.test(w) && a(E[w]);
                        for (w = C.length; w--; ) C[w].elem !== this || (t != null && C[w].queue !== t) || (C[w].anim.stop(o), (g = !1), C.splice(w, 1));
                        (!g && o) || c.dequeue(this, t);
                    })
                );
            },
            finish: function (t) {
                return (
                    t !== !1 && (t = t || "fx"),
                    this.each(function () {
                        var n,
                            o = gt.get(this),
                            a = o[t + "queue"],
                            g = o[t + "queueHooks"],
                            w = c.timers,
                            C = a ? a.length : 0;
                        for (o.finish = !0, c.queue(this, t, []), g && g.stop && g.stop.call(this, !0), n = w.length; n--; ) w[n].elem === this && w[n].queue === t && (w[n].anim.stop(!0), w.splice(n, 1));
                        for (n = 0; n < C; n++) a[n] && a[n].finish && a[n].finish.call(this);
                        delete o.finish;
                    })
                );
            },
        }),
        c.each(["toggle", "show", "hide"], function (t, n) {
            var o = c.fn[n];
            c.fn[n] = function (a, g, w) {
                return a == null || typeof a == "boolean" ? o.apply(this, arguments) : this.animate(Dn(n, !0), a, g, w);
            };
        }),
        c.each({ slideDown: Dn("show"), slideUp: Dn("hide"), slideToggle: Dn("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (t, n) {
            c.fn[t] = function (o, a, g) {
                return this.animate(n, o, a, g);
            };
        }),
        (c.timers = []),
        (c.fx.tick = function () {
            var t,
                n = 0,
                o = c.timers;
            for (ct = Date.now(); n < o.length; n++) (t = o[n])() || o[n] !== t || o.splice(n--, 1);
            o.length || c.fx.stop(), (ct = void 0);
        }),
        (c.fx.timer = function (t) {
            c.timers.push(t), c.fx.start();
        }),
        (c.fx.interval = 13),
        (c.fx.start = function () {
            Pt || ((Pt = !0), mn());
        }),
        (c.fx.stop = function () {
            Pt = null;
        }),
        (c.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
        (c.fn.delay = function (t, n) {
            return (
                (t = (c.fx && c.fx.speeds[t]) || t),
                this.queue((n = n || "fx"), function (o, a) {
                    var g = mt.setTimeout(o, t);
                    a.stop = function () {
                        mt.clearTimeout(g);
                    };
                })
            );
        }),
        (Jt = xt.createElement("input")),
        (qe = xt.createElement("select").appendChild(xt.createElement("option"))),
        (Jt.type = "checkbox"),
        (St.checkOn = Jt.value !== ""),
        (St.optSelected = qe.selected),
        ((Jt = xt.createElement("input")).value = "t"),
        (Jt.type = "radio"),
        (St.radioValue = Jt.value === "t");
    var Jn,
        Je = c.expr.attrHandle;
    c.fn.extend({
        attr: function (t, n) {
            return Ke(this, c.attr, t, n, 1 < arguments.length);
        },
        removeAttr: function (t) {
            return this.each(function () {
                c.removeAttr(this, t);
            });
        },
    }),
        c.extend({
            attr: function (t, n, o) {
                var a,
                    g,
                    w = t.nodeType;
                if (w !== 3 && w !== 8 && w !== 2)
                    return t.getAttribute === void 0
                        ? c.prop(t, n, o)
                        : ((w === 1 && c.isXMLDoc(t)) || (g = c.attrHooks[n.toLowerCase()] || (c.expr.match.bool.test(n) ? Jn : void 0)),
                          o !== void 0
                              ? o === null
                                  ? void c.removeAttr(t, n)
                                  : g && "set" in g && (a = g.set(t, o, n)) !== void 0
                                  ? a
                                  : (t.setAttribute(n, o + ""), o)
                              : !(g && "get" in g && (a = g.get(t, n)) !== null) && (a = c.find.attr(t, n)) == null
                              ? void 0
                              : a);
            },
            attrHooks: {
                type: {
                    set: function (t, n) {
                        if (!St.radioValue && n === "radio" && _e(t, "input")) {
                            var o = t.value;
                            return t.setAttribute("type", n), o && (t.value = o), n;
                        }
                    },
                },
            },
            removeAttr: function (t, n) {
                var o,
                    a = 0,
                    g = n && n.match(Fe);
                if (g && t.nodeType === 1) for (; (o = g[a++]); ) t.removeAttribute(o);
            },
        }),
        (Jn = {
            set: function (t, n, o) {
                return n === !1 ? c.removeAttr(t, o) : t.setAttribute(o, o), o;
            },
        }),
        c.each(c.expr.match.bool.source.match(/\w+/g), function (t, n) {
            var o = Je[n] || c.find.attr;
            Je[n] = function (a, g, w) {
                var C,
                    E,
                    P = g.toLowerCase();
                return w || ((E = Je[P]), (Je[P] = C), (C = o(a, g, w) != null ? P : null), (Je[P] = E)), C;
            };
        });
    var Ie = /^(?:input|select|textarea|button)$/i,
        Ce = /^(?:a|area)$/i;
    function H(t) {
        return (t.match(Fe) || []).join(" ");
    }
    function At(t) {
        return (t.getAttribute && t.getAttribute("class")) || "";
    }
    function Dt(t) {
        return Array.isArray(t) ? t : (typeof t == "string" && t.match(Fe)) || [];
    }
    c.fn.extend({
        prop: function (t, n) {
            return Ke(this, c.prop, t, n, 1 < arguments.length);
        },
        removeProp: function (t) {
            return this.each(function () {
                delete this[c.propFix[t] || t];
            });
        },
    }),
        c.extend({
            prop: function (t, n, o) {
                var a,
                    g,
                    w = t.nodeType;
                if (w !== 3 && w !== 8 && w !== 2)
                    return (
                        (w === 1 && c.isXMLDoc(t)) || ((n = c.propFix[n] || n), (g = c.propHooks[n])),
                        o !== void 0 ? (g && "set" in g && (a = g.set(t, o, n)) !== void 0 ? a : (t[n] = o)) : g && "get" in g && (a = g.get(t, n)) !== null ? a : t[n]
                    );
            },
            propHooks: {
                tabIndex: {
                    get: function (t) {
                        var n = c.find.attr(t, "tabindex");
                        return n ? parseInt(n, 10) : Ie.test(t.nodeName) || (Ce.test(t.nodeName) && t.href) ? 0 : -1;
                    },
                },
            },
            propFix: { for: "htmlFor", class: "className" },
        }),
        St.optSelected ||
            (c.propHooks.selected = {
                get: function (t) {
                    return (t = t.parentNode), t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function (t) {
                    (t = t.parentNode), t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                },
            }),
        c.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
            c.propFix[this.toLowerCase()] = this;
        }),
        c.fn.extend({
            addClass: function (t) {
                var n,
                    o,
                    a,
                    g,
                    w,
                    C,
                    E = 0;
                if (yt(t))
                    return this.each(function (P) {
                        c(this).addClass(t.call(this, P, At(this)));
                    });
                if ((n = Dt(t)).length) {
                    for (; (o = this[E++]); )
                        if (((C = At(o)), (a = o.nodeType === 1 && " " + H(C) + " "))) {
                            for (w = 0; (g = n[w++]); ) a.indexOf(" " + g + " ") < 0 && (a += g + " ");
                            C !== (C = H(a)) && o.setAttribute("class", C);
                        }
                }
                return this;
            },
            removeClass: function (t) {
                var n,
                    o,
                    a,
                    g,
                    w,
                    C,
                    E = 0;
                if (yt(t))
                    return this.each(function (P) {
                        c(this).removeClass(t.call(this, P, At(this)));
                    });
                if (!arguments.length) return this.attr("class", "");
                if ((n = Dt(t)).length) {
                    for (; (o = this[E++]); )
                        if (((C = At(o)), (a = o.nodeType === 1 && " " + H(C) + " "))) {
                            for (w = 0; (g = n[w++]); ) for (; -1 < a.indexOf(" " + g + " "); ) a = a.replace(" " + g + " ", " ");
                            C !== (C = H(a)) && o.setAttribute("class", C);
                        }
                }
                return this;
            },
            toggleClass: function (t, n) {
                var o = _typeof(t),
                    a = o === "string" || Array.isArray(t);
                return typeof n == "boolean" && a
                    ? n
                        ? this.addClass(t)
                        : this.removeClass(t)
                    : yt(t)
                    ? this.each(function (g) {
                          c(this).toggleClass(t.call(this, g, At(this), n), n);
                      })
                    : this.each(function () {
                          var g, w, C, E;
                          if (a) for (w = 0, C = c(this), E = Dt(t); (g = E[w++]); ) C.hasClass(g) ? C.removeClass(g) : C.addClass(g);
                          else (t !== void 0 && o !== "boolean") || ((g = At(this)) && gt.set(this, "__className__", g), this.setAttribute && this.setAttribute("class", (!g && t !== !1 && gt.get(this, "__className__")) || ""));
                      });
            },
            hasClass: function (t) {
                for (var n, o = 0, a = " " + t + " "; (n = this[o++]); ) if (n.nodeType === 1 && -1 < (" " + H(At(n)) + " ").indexOf(a)) return !0;
                return !1;
            },
        });
    var Ct = /\r/g;
    c.fn.extend({
        val: function (t) {
            var n,
                o,
                a,
                g = this[0];
            return arguments.length
                ? ((a = yt(t)),
                  this.each(function (w) {
                      this.nodeType === 1 &&
                          ((w = a ? t.call(this, w, c(this).val()) : t) == null
                              ? (w = "")
                              : typeof w == "number"
                              ? (w += "")
                              : Array.isArray(w) &&
                                (w = c.map(w, function (C) {
                                    return C == null ? "" : C + "";
                                })),
                          ((n = c.valHooks[this.type] || c.valHooks[this.nodeName.toLowerCase()]) && "set" in n && n.set(this, w, "value") !== void 0) || (this.value = w));
                  }))
                : g
                ? (n = c.valHooks[g.type] || c.valHooks[g.nodeName.toLowerCase()]) && "get" in n && (o = n.get(g, "value")) !== void 0
                    ? o
                    : typeof (o = g.value) == "string"
                    ? o.replace(Ct, "")
                    : o ?? ""
                : void 0;
        },
    }),
        c.extend({
            valHooks: {
                option: {
                    get: function (t) {
                        var n = c.find.attr(t, "value");
                        return n ?? H(c.text(t));
                    },
                },
                select: {
                    get: function (t) {
                        for (var n, o = t.options, a = t.selectedIndex, g = t.type === "select-one", w = g ? null : [], C = g ? a + 1 : o.length, E = a < 0 ? C : g ? a : 0; E < C; E++)
                            if (((n = o[E]).selected || E === a) && !n.disabled && (!n.parentNode.disabled || !_e(n.parentNode, "optgroup"))) {
                                if (((n = c(n).val()), g)) return n;
                                w.push(n);
                            }
                        return w;
                    },
                    set: function (t, n) {
                        for (var o, a, g = t.options, w = c.makeArray(n), C = g.length; C--; ) ((a = g[C]).selected = -1 < c.inArray(c.valHooks.option.get(a), w)) && (o = !0);
                        return o || (t.selectedIndex = -1), w;
                    },
                },
            },
        }),
        c.each(["radio", "checkbox"], function () {
            (c.valHooks[this] = {
                set: function (t, n) {
                    if (Array.isArray(n)) return (t.checked = -1 < c.inArray(c(t).val(), n));
                },
            }),
                St.checkOn ||
                    (c.valHooks[this].get = function (t) {
                        return t.getAttribute("value") === null ? "on" : t.value;
                    });
        }),
        (St.focusin = "onfocusin" in mt);
    function It(t) {
        t.stopPropagation();
    }
    var Gt = /^(?:focusinfocus|focusoutblur)$/;
    c.extend(c.event, {
        trigger: function (t, n, o, a) {
            var g,
                w,
                C,
                E,
                P,
                N,
                R,
                M = [o || xt],
                B = ue.call(t, "type") ? t.type : t,
                V = ue.call(t, "namespace") ? t.namespace.split(".") : [],
                nt = (R = w = o = o || xt);
            if (
                o.nodeType !== 3 &&
                o.nodeType !== 8 &&
                !Gt.test(B + c.event.triggered) &&
                (-1 < B.indexOf(".") && ((B = (V = B.split(".")).shift()), V.sort()),
                (E = B.indexOf(":") < 0 && "on" + B),
                ((t = t[c.expando] ? t : new c.Event(B, _typeof(t) == "object" && t)).isTrigger = a ? 2 : 3),
                (t.namespace = V.join(".")),
                (t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + V.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                (t.result = void 0),
                t.target || (t.target = o),
                (n = n == null ? [t] : c.makeArray(n, [t])),
                (N = c.event.special[B] || {}),
                a || !N.trigger || N.trigger.apply(o, n) !== !1)
            ) {
                if (!a && !N.noBubble && !Le(o)) {
                    for (C = N.delegateType || B, Gt.test(C + B) || (nt = nt.parentNode); nt; nt = nt.parentNode) M.push(nt), (w = nt);
                    w === (o.ownerDocument || xt) && M.push(w.defaultView || w.parentWindow || mt);
                }
                for (g = 0; (nt = M[g++]) && !t.isPropagationStopped(); )
                    (R = nt),
                        (t.type = 1 < g ? C : N.bindType || B),
                        (P = (gt.get(nt, "events") || Object.create(null))[t.type] && gt.get(nt, "handle")) && P.apply(nt, n),
                        (P = E && nt[E]) && P.apply && xn(nt) && ((t.result = P.apply(nt, n)), t.result === !1 && t.preventDefault());
                return (
                    (t.type = B),
                    a ||
                        t.isDefaultPrevented() ||
                        (N._default && N._default.apply(M.pop(), n) !== !1) ||
                        !xn(o) ||
                        (E &&
                            yt(o[B]) &&
                            !Le(o) &&
                            ((w = o[E]) && (o[E] = null),
                            (c.event.triggered = B),
                            t.isPropagationStopped() && R.addEventListener(B, It),
                            o[B](),
                            t.isPropagationStopped() && R.removeEventListener(B, It),
                            (c.event.triggered = void 0),
                            w && (o[E] = w))),
                    t.result
                );
            }
        },
        simulate: function (t, n, o) {
            (t = c.extend(new c.Event(), o, { type: t, isSimulated: !0 })), c.event.trigger(t, null, n);
        },
    }),
        c.fn.extend({
            trigger: function (t, n) {
                return this.each(function () {
                    c.event.trigger(t, n, this);
                });
            },
            triggerHandler: function (t, n) {
                var o = this[0];
                if (o) return c.event.trigger(t, n, o, !0);
            },
        }),
        St.focusin ||
            c.each({ focus: "focusin", blur: "focusout" }, function (t, n) {
                function o(a) {
                    c.event.simulate(n, a.target, c.event.fix(a));
                }
                c.event.special[n] = {
                    setup: function () {
                        var a = this.ownerDocument || this.document || this,
                            g = gt.access(a, n);
                        g || a.addEventListener(t, o, !0), gt.access(a, n, (g || 0) + 1);
                    },
                    teardown: function () {
                        var a = this.ownerDocument || this.document || this,
                            g = gt.access(a, n) - 1;
                        g ? gt.access(a, n, g) : (a.removeEventListener(t, o, !0), gt.remove(a, n));
                    },
                };
            });
    var He = mt.location,
        Un = { guid: Date.now() },
        ri = /\?/;
    c.parseXML = function (t) {
        var n;
        if (!t || typeof t != "string") return null;
        try {
            n = new mt.DOMParser().parseFromString(t, "text/xml");
        } catch {
            n = void 0;
        }
        return (n && !n.getElementsByTagName("parsererror").length) || c.error("Invalid XML: " + t), n;
    };
    var _i = /\[\]$/,
        Bn = /\r?\n/g,
        ai = /^(?:submit|button|image|reset|file)$/i,
        Ot = /^(?:input|select|textarea|keygen)/i;
    (c.param = function (t, n) {
        function o(w, C) {
            (C = yt(C) ? C() : C), (g[g.length] = encodeURIComponent(w) + "=" + encodeURIComponent(C ?? ""));
        }
        var a,
            g = [];
        if (t == null) return "";
        if (Array.isArray(t) || (t.jquery && !c.isPlainObject(t)))
            c.each(t, function () {
                o(this.name, this.value);
            });
        else
            for (a in t)
                (function w(C, E, P, N) {
                    if (Array.isArray(E))
                        c.each(E, function (M, B) {
                            P || _i.test(C) ? N(C, B) : w(C + "[" + (_typeof(B) == "object" && B != null ? M : "") + "]", B, P, N);
                        });
                    else if (P || fn(E) !== "object") N(C, E);
                    else for (var R in E) w(C + "[" + R + "]", E[R], P, N);
                })(a, t[a], n, o);
        return g.join("&");
    }),
        c.fn.extend({
            serialize: function () {
                return c.param(this.serializeArray());
            },
            serializeArray: function () {
                return this.map(function () {
                    var t = c.prop(this, "elements");
                    return t ? c.makeArray(t) : this;
                })
                    .filter(function () {
                        var t = this.type;
                        return this.name && !c(this).is(":disabled") && Ot.test(this.nodeName) && !ai.test(t) && (this.checked || !An.test(t));
                    })
                    .map(function (t, n) {
                        var o = c(this).val();
                        return o == null
                            ? null
                            : Array.isArray(o)
                            ? c.map(o, function (a) {
                                  return {
                                      name: n.name,
                                      value: a.replace(
                                          Bn,
                                          `\r
`
                                      ),
                                  };
                              })
                            : {
                                  name: n.name,
                                  value: o.replace(
                                      Bn,
                                      `\r
`
                                  ),
                              };
                    })
                    .get();
            },
        });
    var vt = /%20/g,
        qt = /#.*$/,
        Ut = /([?&])_=[^&]*/,
        ae = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Zt = /^(?:GET|HEAD)$/,
        Te = /^\/\//,
        un = {},
        Re = {},
        vn = "*/".concat("*"),
        le = xt.createElement("a");
    function Oi(t) {
        return function (n, o) {
            typeof n != "string" && ((o = n), (n = "*"));
            var a,
                g = 0,
                w = n.toLowerCase().match(Fe) || [];
            if (yt(o)) for (; (a = w[g++]); ) a[0] === "+" ? ((a = a.slice(1) || "*"), (t[a] = t[a] || []).unshift(o)) : (t[a] = t[a] || []).push(o);
        };
    }
    function ji(t, n, o, a) {
        var g = {},
            w = t === Re;
        function C(E) {
            var P;
            return (
                (g[E] = !0),
                c.each(t[E] || [], function (N, R) {
                    return (R = R(n, o, a)), typeof R != "string" || w || g[R] ? (w ? !(P = R) : void 0) : (n.dataTypes.unshift(R), C(R), !1);
                }),
                P
            );
        }
        return C(n.dataTypes[0]) || (!g["*"] && C("*"));
    }
    function Ci(t, n) {
        var o,
            a,
            g = c.ajaxSettings.flatOptions || {};
        for (o in n) n[o] !== void 0 && ((g[o] ? t : (a = a || {}))[o] = n[o]);
        return a && c.extend(!0, t, a), t;
    }
    (le.href = He.href),
        c.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: He.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(He.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: { "*": vn, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": c.parseXML },
                flatOptions: { url: !0, context: !0 },
            },
            ajaxSetup: function (t, n) {
                return n ? Ci(Ci(t, c.ajaxSettings), n) : Ci(c.ajaxSettings, t);
            },
            ajaxPrefilter: Oi(un),
            ajaxTransport: Oi(Re),
            ajax: function (t, n) {
                _typeof(t) == "object" && ((n = t), (t = void 0));
                var o,
                    a,
                    g,
                    w,
                    C,
                    E,
                    P,
                    N,
                    R,
                    M = c.ajaxSetup({}, (n = n || {})),
                    B = M.context || M,
                    V = M.context && (B.nodeType || B.jquery) ? c(B) : c.event,
                    nt = c.Deferred(),
                    st = c.Callbacks("once memory"),
                    bt = M.statusCode || {},
                    Bt = {},
                    Lt = {},
                    Ee = "canceled",
                    $t = {
                        readyState: 0,
                        getResponseHeader: function (pt) {
                            var Ht;
                            if (E) {
                                if (!w) for (w = {}; (Ht = ae.exec(g)); ) w[Ht[1].toLowerCase() + " "] = (w[Ht[1].toLowerCase() + " "] || []).concat(Ht[2]);
                                Ht = w[pt.toLowerCase() + " "];
                            }
                            return Ht == null ? null : Ht.join(", ");
                        },
                        getAllResponseHeaders: function () {
                            return E ? g : null;
                        },
                        setRequestHeader: function (pt, Ht) {
                            return E == null && ((pt = Lt[pt.toLowerCase()] = Lt[pt.toLowerCase()] || pt), (Bt[pt] = Ht)), this;
                        },
                        overrideMimeType: function (pt) {
                            return E == null && (M.mimeType = pt), this;
                        },
                        statusCode: function (pt) {
                            if (pt)
                                if (E) $t.always(pt[$t.status]);
                                else for (var Ht in pt) bt[Ht] = [bt[Ht], pt[Ht]];
                            return this;
                        },
                        abort: function (pt) {
                            return (pt = pt || Ee), o && o.abort(pt), yn(0, pt), this;
                        },
                    };
                if (
                    (nt.promise($t),
                    (M.url = ((t || M.url || He.href) + "").replace(Te, He.protocol + "//")),
                    (M.type = n.method || n.type || M.method || M.type),
                    (M.dataTypes = (M.dataType || "*").toLowerCase().match(Fe) || [""]),
                    M.crossDomain == null)
                ) {
                    R = xt.createElement("a");
                    try {
                        (R.href = M.url), (R.href = R.href), (M.crossDomain = le.protocol + "//" + le.host != R.protocol + "//" + R.host);
                    } catch {
                        M.crossDomain = !0;
                    }
                }
                if ((M.data && M.processData && typeof M.data != "string" && (M.data = c.param(M.data, M.traditional)), ji(un, M, n, $t), E)) return $t;
                for (N in ((P = c.event && M.global) && c.active++ == 0 && c.event.trigger("ajaxStart"),
                (M.type = M.type.toUpperCase()),
                (M.hasContent = !Zt.test(M.type)),
                (a = M.url.replace(qt, "")),
                M.hasContent
                    ? M.data && M.processData && (M.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (M.data = M.data.replace(vt, "+"))
                    : ((R = M.url.slice(a.length)),
                      M.data && (M.processData || typeof M.data == "string") && ((a += (ri.test(a) ? "&" : "?") + M.data), delete M.data),
                      M.cache === !1 && ((a = a.replace(Ut, "$1")), (R = (ri.test(a) ? "&" : "?") + "_=" + Un.guid++ + R)),
                      (M.url = a + R)),
                M.ifModified && (c.lastModified[a] && $t.setRequestHeader("If-Modified-Since", c.lastModified[a]), c.etag[a] && $t.setRequestHeader("If-None-Match", c.etag[a])),
                ((M.data && M.hasContent && M.contentType !== !1) || n.contentType) && $t.setRequestHeader("Content-Type", M.contentType),
                $t.setRequestHeader("Accept", M.dataTypes[0] && M.accepts[M.dataTypes[0]] ? M.accepts[M.dataTypes[0]] + (M.dataTypes[0] !== "*" ? ", " + vn + "; q=0.01" : "") : M.accepts["*"]),
                M.headers))
                    $t.setRequestHeader(N, M.headers[N]);
                if (M.beforeSend && (M.beforeSend.call(B, $t, M) === !1 || E)) return $t.abort();
                if (((Ee = "abort"), st.add(M.complete), $t.done(M.success), $t.fail(M.error), (o = ji(Re, M, n, $t)))) {
                    if ((($t.readyState = 1), P && V.trigger("ajaxSend", [$t, M]), E)) return $t;
                    M.async &&
                        0 < M.timeout &&
                        (C = mt.setTimeout(function () {
                            $t.abort("timeout");
                        }, M.timeout));
                    try {
                        (E = !1), o.send(Bt, yn);
                    } catch (pt) {
                        if (E) throw pt;
                        yn(-1, pt);
                    }
                } else yn(-1, "No Transport");
                function yn(pt, Ht, Se, dn) {
                    var ti,
                        Xn,
                        Tn,
                        ze = Ht;
                    E ||
                        ((E = !0),
                        C && mt.clearTimeout(C),
                        (o = void 0),
                        (g = dn || ""),
                        ($t.readyState = 0 < pt ? 4 : 0),
                        (dn = (200 <= pt && pt < 300) || pt === 304),
                        Se &&
                            (Tn = (function (fe, tn, Ye) {
                                for (var On, De, Nt, de, we = fe.contents, Kt = fe.dataTypes; Kt[0] === "*"; ) Kt.shift(), On === void 0 && (On = fe.mimeType || tn.getResponseHeader("Content-Type"));
                                if (On) {
                                    for (De in we)
                                        if (we[De] && we[De].test(On)) {
                                            Kt.unshift(De);
                                            break;
                                        }
                                }
                                if (Kt[0] in Ye) Nt = Kt[0];
                                else {
                                    for (De in Ye) {
                                        if (!Kt[0] || fe.converters[De + " " + Kt[0]]) {
                                            Nt = De;
                                            break;
                                        }
                                        de = de || De;
                                    }
                                    Nt = Nt || de;
                                }
                                if (Nt) return Nt !== Kt[0] && Kt.unshift(Nt), Ye[Nt];
                            })(M, $t, Se)),
                        !dn && -1 < c.inArray("script", M.dataTypes) && (M.converters["text script"] = function () {}),
                        (Tn = (function (fe, tn, Ye, On) {
                            var De,
                                Nt,
                                de,
                                we,
                                Kt,
                                Tt = {},
                                en = fe.dataTypes.slice();
                            if (en[1]) for (de in fe.converters) Tt[de.toLowerCase()] = fe.converters[de];
                            for (Nt = en.shift(); Nt; )
                                if ((fe.responseFields[Nt] && (Ye[fe.responseFields[Nt]] = tn), !Kt && On && fe.dataFilter && (tn = fe.dataFilter(tn, fe.dataType)), (Kt = Nt), (Nt = en.shift()))) {
                                    if (Nt === "*") Nt = Kt;
                                    else if (Kt !== "*" && Kt !== Nt) {
                                        if (!(de = Tt[Kt + " " + Nt] || Tt["* " + Nt])) {
                                            for (De in Tt)
                                                if ((we = De.split(" "))[1] === Nt && (de = Tt[Kt + " " + we[0]] || Tt["* " + we[0]])) {
                                                    de === !0 ? (de = Tt[De]) : Tt[De] !== !0 && ((Nt = we[0]), en.unshift(we[1]));
                                                    break;
                                                }
                                        }
                                        if (de !== !0)
                                            if (de && fe.throws) tn = de(tn);
                                            else
                                                try {
                                                    tn = de(tn);
                                                } catch (fi) {
                                                    return { state: "parsererror", error: de ? fi : "No conversion from " + Kt + " to " + Nt };
                                                }
                                    }
                                }
                            return { state: "success", data: tn };
                        })(M, Tn, $t, dn)),
                        dn
                            ? (M.ifModified && ((Se = $t.getResponseHeader("Last-Modified")) && (c.lastModified[a] = Se), (Se = $t.getResponseHeader("etag")) && (c.etag[a] = Se)),
                              pt === 204 || M.type === "HEAD" ? (ze = "nocontent") : pt === 304 ? (ze = "notmodified") : ((ze = Tn.state), (ti = Tn.data), (dn = !(Xn = Tn.error))))
                            : ((Xn = ze), (!pt && ze) || ((ze = "error"), pt < 0 && (pt = 0))),
                        ($t.status = pt),
                        ($t.statusText = (Ht || ze) + ""),
                        dn ? nt.resolveWith(B, [ti, ze, $t]) : nt.rejectWith(B, [$t, ze, Xn]),
                        $t.statusCode(bt),
                        (bt = void 0),
                        P && V.trigger(dn ? "ajaxSuccess" : "ajaxError", [$t, M, dn ? ti : Xn]),
                        st.fireWith(B, [$t, ze]),
                        P && (V.trigger("ajaxComplete", [$t, M]), --c.active || c.event.trigger("ajaxStop")));
                }
                return $t;
            },
            getJSON: function (t, n, o) {
                return c.get(t, n, o, "json");
            },
            getScript: function (t, n) {
                return c.get(t, void 0, n, "script");
            },
        }),
        c.each(["get", "post"], function (t, n) {
            c[n] = function (o, a, g, w) {
                return yt(a) && ((w = w || g), (g = a), (a = void 0)), c.ajax(c.extend({ url: o, type: n, dataType: w, data: a, success: g }, c.isPlainObject(o) && o));
            };
        }),
        c.ajaxPrefilter(function (t) {
            for (var n in t.headers) n.toLowerCase() === "content-type" && (t.contentType = t.headers[n] || "");
        }),
        (c._evalUrl = function (t, n, o) {
            return c.ajax({
                url: t,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function () {} },
                dataFilter: function (a) {
                    c.globalEval(a, n, o);
                },
            });
        }),
        c.fn.extend({
            wrapAll: function (t) {
                return (
                    this[0] &&
                        (yt(t) && (t = t.call(this[0])),
                        (t = c(t, this[0].ownerDocument).eq(0).clone(!0)),
                        this[0].parentNode && t.insertBefore(this[0]),
                        t
                            .map(function () {
                                for (var n = this; n.firstElementChild; ) n = n.firstElementChild;
                                return n;
                            })
                            .append(this)),
                    this
                );
            },
            wrapInner: function (t) {
                return yt(t)
                    ? this.each(function (n) {
                          c(this).wrapInner(t.call(this, n));
                      })
                    : this.each(function () {
                          var n = c(this),
                              o = n.contents();
                          o.length ? o.wrapAll(t) : n.append(t);
                      });
            },
            wrap: function (t) {
                var n = yt(t);
                return this.each(function (o) {
                    c(this).wrapAll(n ? t.call(this, o) : t);
                });
            },
            unwrap: function (t) {
                return (
                    this.parent(t)
                        .not("body")
                        .each(function () {
                            c(this).replaceWith(this.childNodes);
                        }),
                    this
                );
            },
        }),
        (c.expr.pseudos.hidden = function (t) {
            return !c.expr.pseudos.visible(t);
        }),
        (c.expr.pseudos.visible = function (t) {
            return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
        }),
        (c.ajaxSettings.xhr = function () {
            try {
                return new mt.XMLHttpRequest();
            } catch {}
        });
    var Bi = { 0: 200, 1223: 204 },
        li = c.ajaxSettings.xhr();
    (St.cors = !!li && "withCredentials" in li),
        (St.ajax = li = !!li),
        c.ajaxTransport(function (t) {
            var n, o;
            if (St.cors || (li && !t.crossDomain))
                return {
                    send: function (a, g) {
                        var w,
                            C = t.xhr();
                        if ((C.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)) for (w in t.xhrFields) C[w] = t.xhrFields[w];
                        for (w in (t.mimeType && C.overrideMimeType && C.overrideMimeType(t.mimeType), t.crossDomain || a["X-Requested-With"] || (a["X-Requested-With"] = "XMLHttpRequest"), a)) C.setRequestHeader(w, a[w]);
                        (n = function (E) {
                            return function () {
                                n &&
                                    ((n = o = C.onload = C.onerror = C.onabort = C.ontimeout = C.onreadystatechange = null),
                                    E === "abort"
                                        ? C.abort()
                                        : E === "error"
                                        ? typeof C.status != "number"
                                            ? g(0, "error")
                                            : g(C.status, C.statusText)
                                        : g(Bi[C.status] || C.status, C.statusText, (C.responseType || "text") !== "text" || typeof C.responseText != "string" ? { binary: C.response } : { text: C.responseText }, C.getAllResponseHeaders()));
                            };
                        }),
                            (C.onload = n()),
                            (o = C.onerror = C.ontimeout = n("error")),
                            C.onabort !== void 0
                                ? (C.onabort = o)
                                : (C.onreadystatechange = function () {
                                      C.readyState === 4 &&
                                          mt.setTimeout(function () {
                                              n && o();
                                          });
                                  }),
                            (n = n("abort"));
                        try {
                            C.send((t.hasContent && t.data) || null);
                        } catch (E) {
                            if (n) throw E;
                        }
                    },
                    abort: function () {
                        n && n();
                    },
                };
        }),
        c.ajaxPrefilter(function (t) {
            t.crossDomain && (t.contents.script = !1);
        }),
        c.ajaxSetup({
            accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
            contents: { script: /\b(?:java|ecma)script\b/ },
            converters: {
                "text script": function (t) {
                    return c.globalEval(t), t;
                },
            },
        }),
        c.ajaxPrefilter("script", function (t) {
            t.cache === void 0 && (t.cache = !1), t.crossDomain && (t.type = "GET");
        }),
        c.ajaxTransport("script", function (t) {
            var n, o;
            if (t.crossDomain || t.scriptAttrs)
                return {
                    send: function (a, g) {
                        (n = c("<script>")
                            .attr(t.scriptAttrs || {})
                            .prop({ charset: t.scriptCharset, src: t.url })
                            .on(
                                "load error",
                                (o = function (w) {
                                    n.remove(), (o = null), w && g(w.type === "error" ? 404 : 200, w.type);
                                })
                            )),
                            xt.head.appendChild(n[0]);
                    },
                    abort: function () {
                        o && o();
                    },
                };
        });
    var Li = [],
        Ti = /(=)\?(?=&|$)|\?\?/;
    c.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function () {
            var t = Li.pop() || c.expando + "_" + Un.guid++;
            return (this[t] = !0), t;
        },
    }),
        c.ajaxPrefilter("json jsonp", function (t, n, o) {
            var a,
                g,
                w,
                C = t.jsonp !== !1 && (Ti.test(t.url) ? "url" : typeof t.data == "string" && (t.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && Ti.test(t.data) && "data");
            if (C || t.dataTypes[0] === "jsonp")
                return (
                    (a = t.jsonpCallback = yt(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                    C ? (t[C] = t[C].replace(Ti, "$1" + a)) : t.jsonp !== !1 && (t.url += (ri.test(t.url) ? "&" : "?") + t.jsonp + "=" + a),
                    (t.converters["script json"] = function () {
                        return w || c.error(a + " was not called"), w[0];
                    }),
                    (t.dataTypes[0] = "json"),
                    (g = mt[a]),
                    (mt[a] = function () {
                        w = arguments;
                    }),
                    o.always(function () {
                        g === void 0 ? c(mt).removeProp(a) : (mt[a] = g), t[a] && ((t.jsonpCallback = n.jsonpCallback), Li.push(a)), w && yt(g) && g(w[0]), (w = g = void 0);
                    }),
                    "script"
                );
        }),
        (St.createHTMLDocument = (((Jt = xt.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), Jt.childNodes.length === 2)),
        (c.parseHTML = function (t, n, o) {
            return typeof t != "string"
                ? []
                : (typeof n == "boolean" && ((o = n), (n = !1)),
                  n || (St.createHTMLDocument ? (((a = (n = xt.implementation.createHTMLDocument("")).createElement("base")).href = xt.location.href), n.head.appendChild(a)) : (n = xt)),
                  (a = !o && []),
                  (o = qn.exec(t)) ? [n.createElement(o[1])] : ((o = Cn([t], n, a)), a && a.length && c(a).remove(), c.merge([], o.childNodes)));
            var a;
        }),
        (c.fn.load = function (t, n, o) {
            var a,
                g,
                w,
                C = this,
                E = t.indexOf(" ");
            return (
                -1 < E && ((a = H(t.slice(E))), (t = t.slice(0, E))),
                yt(n) ? ((o = n), (n = void 0)) : n && _typeof(n) == "object" && (g = "POST"),
                0 < C.length &&
                    c
                        .ajax({ url: t, type: g || "GET", dataType: "html", data: n })
                        .done(function (P) {
                            (w = arguments), C.html(a ? c("<div>").append(c.parseHTML(P)).find(a) : P);
                        })
                        .always(
                            o &&
                                function (P, N) {
                                    C.each(function () {
                                        o.apply(this, w || [P.responseText, N, P]);
                                    });
                                }
                        ),
                this
            );
        }),
        (c.expr.pseudos.animated = function (t) {
            return c.grep(c.timers, function (n) {
                return t === n.elem;
            }).length;
        }),
        (c.offset = {
            setOffset: function (t, n, o) {
                var a,
                    g,
                    w,
                    C,
                    E = c.css(t, "position"),
                    P = c(t),
                    N = {};
                E === "static" && (t.style.position = "relative"),
                    (w = P.offset()),
                    (a = c.css(t, "top")),
                    (C = c.css(t, "left")),
                    (C = (E === "absolute" || E === "fixed") && -1 < (a + C).indexOf("auto") ? ((g = (E = P.position()).top), E.left) : ((g = parseFloat(a) || 0), parseFloat(C) || 0)),
                    (n = yt(n) ? n.call(t, o, c.extend({}, w)) : n).top != null && (N.top = n.top - w.top + g),
                    n.left != null && (N.left = n.left - w.left + C),
                    "using" in n ? n.using.call(t, N) : (typeof N.top == "number" && (N.top += "px"), typeof N.left == "number" && (N.left += "px"), P.css(N));
            },
        }),
        c.fn.extend({
            offset: function (t) {
                if (arguments.length)
                    return t === void 0
                        ? this
                        : this.each(function (a) {
                              c.offset.setOffset(this, t, a);
                          });
                var n,
                    o = this[0];
                return o ? (o.getClientRects().length ? ((n = o.getBoundingClientRect()), (o = o.ownerDocument.defaultView), { top: n.top + o.pageYOffset, left: n.left + o.pageXOffset }) : { top: 0, left: 0 }) : void 0;
            },
            position: function () {
                if (this[0]) {
                    var t,
                        n,
                        o,
                        a = this[0],
                        g = { top: 0, left: 0 };
                    if (c.css(a, "position") === "fixed") n = a.getBoundingClientRect();
                    else {
                        for (n = this.offset(), o = a.ownerDocument, t = a.offsetParent || o.documentElement; t && (t === o.body || t === o.documentElement) && c.css(t, "position") === "static"; ) t = t.parentNode;
                        t && t !== a && t.nodeType === 1 && (((g = c(t).offset()).top += c.css(t, "borderTopWidth", !0)), (g.left += c.css(t, "borderLeftWidth", !0)));
                    }
                    return { top: n.top - g.top - c.css(a, "marginTop", !0), left: n.left - g.left - c.css(a, "marginLeft", !0) };
                }
            },
            offsetParent: function () {
                return this.map(function () {
                    for (var t = this.offsetParent; t && c.css(t, "position") === "static"; ) t = t.offsetParent;
                    return t || rn;
                });
            },
        }),
        c.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (t, n) {
            var o = n === "pageYOffset";
            c.fn[t] = function (a) {
                return Ke(
                    this,
                    function (g, w, C) {
                        var E;
                        return Le(g) ? (E = g) : g.nodeType === 9 && (E = g.defaultView), C === void 0 ? (E ? E[n] : g[w]) : void (E ? E.scrollTo(o ? E.pageXOffset : C, o ? C : E.pageYOffset) : (g[w] = C));
                    },
                    t,
                    a,
                    arguments.length
                );
            };
        }),
        c.each(["top", "left"], function (t, n) {
            c.cssHooks[n] = v(St.pixelPosition, function (o, a) {
                if (a) return (a = _(o, n)), _t.test(a) ? c(o).position()[n] + "px" : a;
            });
        }),
        c.each({ Height: "height", Width: "width" }, function (t, n) {
            c.each({ padding: "inner" + t, content: n, "": "outer" + t }, function (o, a) {
                c.fn[a] = function (g, w) {
                    var C = arguments.length && (o || typeof g != "boolean"),
                        E = o || (g === !0 || w === !0 ? "margin" : "border");
                    return Ke(
                        this,
                        function (P, N, R) {
                            var M;
                            return Le(P)
                                ? a.indexOf("outer") === 0
                                    ? P["inner" + t]
                                    : P.document.documentElement["client" + t]
                                : P.nodeType === 9
                                ? ((M = P.documentElement), Math.max(P.body["scroll" + t], M["scroll" + t], P.body["offset" + t], M["offset" + t], M["client" + t]))
                                : R === void 0
                                ? c.css(P, N, E)
                                : c.style(P, N, R, E);
                        },
                        n,
                        C ? g : void 0,
                        C
                    );
                };
            });
        }),
        c.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (t, n) {
            c.fn[n] = function (o) {
                return this.on(n, o);
            };
        }),
        c.fn.extend({
            bind: function (t, n, o) {
                return this.on(t, null, n, o);
            },
            unbind: function (t, n) {
                return this.off(t, null, n);
            },
            delegate: function (t, n, o, a) {
                return this.on(n, t, o, a);
            },
            undelegate: function (t, n, o) {
                return arguments.length === 1 ? this.off(t, "**") : this.off(n, t || "**", o);
            },
            hover: function (t, n) {
                return this.mouseenter(t).mouseleave(n || t);
            },
        }),
        c.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (t, n) {
            c.fn[n] = function (o, a) {
                return 0 < arguments.length ? this.on(n, null, o, a) : this.trigger(n);
            };
        });
    var Xi = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    (c.proxy = function (t, n) {
        var o, a;
        if ((typeof n == "string" && ((a = t[n]), (n = t), (t = a)), yt(t)))
            return (
                (o = be.call(arguments, 2)),
                ((a = function () {
                    return t.apply(n || this, o.concat(be.call(arguments)));
                }).guid = t.guid = t.guid || c.guid++),
                a
            );
    }),
        (c.holdReady = function (t) {
            t ? c.readyWait++ : c.ready(!0);
        }),
        (c.isArray = Array.isArray),
        (c.parseJSON = JSON.parse),
        (c.nodeName = _e),
        (c.isFunction = yt),
        (c.isWindow = Le),
        (c.camelCase = te),
        (c.type = fn),
        (c.now = Date.now),
        (c.isNumeric = function (t) {
            var n = c.type(t);
            return (n === "number" || n === "string") && !isNaN(t - parseFloat(t));
        }),
        (c.trim = function (t) {
            return t == null ? "" : (t + "").replace(Xi, "");
        }),
        typeof define == "function" &&
            define.amd &&
            define("jquery", [], function () {
                return c;
            });
    var Gi = mt.jQuery,
        Yi = mt.$;
    return (
        (c.noConflict = function (t) {
            return mt.$ === c && (mt.$ = Yi), t && mt.jQuery === c && (mt.jQuery = Gi), c;
        }),
        se === void 0 && (mt.jQuery = mt.$ = c),
        c
    );
}),
    (theme.jQuery = $),
    (function (mt) {
        var se,
            Le,
            ve,
            jn,
            be,
            Ln,
            sn,
            bn,
            Ve,
            Pn,
            ue,
            ei,
            $n,
            St,
            yt,
            xt,
            Nn,
            Yn,
            fn,
            Jt,
            c,
            Mn,
            xe,
            pe,
            Vn,
            Qe,
            _e,
            qn,
            In,
            Qn,
            ni,
            We,
            pi,
            ii,
            Fe,
            Ue,
            Pe,
            Be,
            Ze,
            ye,
            on,
            Ke,
            Ne,
            Vt,
            Zn,
            te,
            xn,
            he,
            gt,
            oe,
            si,
            G,
            Me,
            qe,
            Qt,
            mt = (jQuery = mt);
        function Xe() {
            Le(se.lazySizes), se.removeEventListener("lazyunveilread", Xe, !0);
        }
        function rn() {
            jn(ve.lazySizes), ve.removeEventListener("lazyunveilread", rn, !0);
        }
        function gn() {
            Ln(be.lazySizes), be.removeEventListener("lazyunveilread", gn, !0);
        }
        function oi() {
            bn(sn.lazySizes), sn.removeEventListener("lazyunveilread", oi, !0);
        }
        function kn() {
            Pn(Ve.lazySizes), Ve.removeEventListener("lazyunveilread", kn, !0);
        }
        function Hn(i) {
            return yt.call(i) == "[object Function]";
        }
        function Rn(i) {
            return typeof i == "string";
        }
        function an() {}
        function An(i) {
            return !i || i == "loaded" || i == "complete" || i == "uninitialized";
        }
        function _n() {
            var i = xt.shift();
            (Nn = 1),
                i
                    ? i.t
                        ? $n(function () {
                              (i.t == "c" ? Qe.injectCss : Qe.injectJs)(i.s, 0, i.a, i.x, i.e, 1);
                          }, 0)
                        : (i(), _n())
                    : (Nn = 0);
        }
        function hi(i, h, m, e, r) {
            return (
                (Nn = 0),
                (h = h || "j"),
                Rn(i)
                    ? ((u = h == "c" ? c : Jt),
                      (D = i),
                      (j = h),
                      (h = this.i++),
                      (m = m),
                      (e = e),
                      (r = (r = r) || Qe.errorTimeout),
                      (A = ue.createElement(u)),
                      (F = W = 0),
                      (Q = { t: j, s: D, e: m, a: e, x: r }),
                      pe[D] === 1 && ((F = 1), (pe[D] = [])),
                      u == "object" ? (A.data = D) : ((A.src = D), (A.type = u)),
                      (A.width = A.height = "0"),
                      (A.onerror = A.onload = A.onreadystatechange = function () {
                          p.call(this, F);
                      }),
                      xt.splice(h, 0, Q),
                      u != "img" && (F || pe[D] === 2 ? (fn.insertBefore(A, Yn ? null : St), $n(p, r)) : pe[D].push(A)))
                    : (xt.splice(this.i++, 0, i), xt.length == 1 && _n()),
                this
            );
            function p(J) {
                if (!W && An(A.readyState) && ((Q.r = W = 1), Nn || _n(), (A.onload = A.onreadystatechange = null), J))
                    for (var wt in (u != "img" &&
                        $n(function () {
                            fn.removeChild(A);
                        }, 50),
                    pe[D]))
                        pe[D].hasOwnProperty(wt) && pe[D][wt].onload();
            }
            var u, D, j, A, W, F, Q;
        }
        function ke() {
            var i = Qe;
            return (i.loader = { load: hi, i: 0 }), i;
        }
        function re(i, h) {
            var m = !1,
                e = i.charAt(0).toUpperCase() + i.slice(1);
            return (
                We.each((i + " " + Fe.join(e + " ") + e).split(" "), function (r, p) {
                    if (ii[p] !== pi) return (m = !h || p), !1;
                }),
                m
            );
        }
        function Wn(i) {
            return re(i, !0);
        }
        function ln(i) {
            (this._core = i),
                (this._call = null),
                (this._time = 0),
                (this._timeout = 0),
                (this._paused = !0),
                (this._handlers = {
                    "changed.owl.carousel": ye.proxy(function (h) {
                        h.namespace && h.property.name === "settings" ? (this._core.settings.autoplay ? this.play() : this.stop()) : h.namespace && h.property.name === "position" && this._paused && (this._time = 0);
                    }, this),
                    "initialized.owl.carousel": ye.proxy(function (h) {
                        h.namespace && this._core.settings.autoplay && this.play();
                    }, this),
                    "play.owl.autoplay": ye.proxy(function (h, m, e) {
                        h.namespace && this.play(m, e);
                    }, this),
                    "stop.owl.autoplay": ye.proxy(function (h) {
                        h.namespace && this.stop();
                    }, this),
                    "mouseover.owl.autoplay": ye.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
                    }, this),
                    "mouseleave.owl.autoplay": ye.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play();
                    }, this),
                    "touchstart.owl.core": ye.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
                    }, this),
                    "touchend.owl.core": ye.proxy(function () {
                        this._core.settings.autoplayHoverPause && this.play();
                    }, this),
                }),
                this._core.$element.on(this._handlers),
                (this._core.options = ye.extend({}, ln.Defaults, this._core.options));
        }
        function Cn(i) {
            (this.core = i),
                (this.core.options = Ne.extend({}, Cn.Defaults, this.core.options)),
                (this.swapping = !0),
                (this.previous = void 0),
                (this.next = void 0),
                (this.handlers = {
                    "change.owl.carousel": Ne.proxy(function (h) {
                        h.namespace && h.property.name == "position" && ((this.previous = this.core.current()), (this.next = h.property.value));
                    }, this),
                    "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": Ne.proxy(function (h) {
                        h.namespace && (this.swapping = h.type == "translated");
                    }, this),
                    "translate.owl.carousel": Ne.proxy(function (h) {
                        h.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap();
                    }, this),
                }),
                this.core.$element.on(this.handlers);
        }
        function cn(i) {
            (this._core = i),
                (this._videos = {}),
                (this._playing = null),
                (this._handlers = {
                    "initialized.owl.carousel": Vt.proxy(function (h) {
                        h.namespace && this._core.register({ type: "state", name: "playing", tags: ["interacting"] });
                    }, this),
                    "resize.owl.carousel": Vt.proxy(function (h) {
                        h.namespace && this._core.settings.video && this.isInFullScreen() && h.preventDefault();
                    }, this),
                    "refreshed.owl.carousel": Vt.proxy(function (h) {
                        h.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove();
                    }, this),
                    "changed.owl.carousel": Vt.proxy(function (h) {
                        h.namespace && h.property.name === "position" && this._playing && this.stop();
                    }, this),
                    "prepared.owl.carousel": Vt.proxy(function (h) {
                        var m;
                        !h.namespace || ((m = Vt(h.content).find(".owl-video")).length && (m.css("display", "none"), this.fetch(m, Vt(h.content))));
                    }, this),
                }),
                (this._core.options = Vt.extend({}, cn.Defaults, this._core.options)),
                this._core.$element.on(this._handlers),
                this._core.$element.on(
                    "click.owl.video",
                    ".owl-video-play-icon",
                    Vt.proxy(function (h) {
                        this.play(h);
                    }, this)
                );
        }
        function Fn(i) {
            (this._core = i),
                (this._previousHeight = null),
                (this._handlers = {
                    "initialized.owl.carousel refreshed.owl.carousel": te.proxy(function (m) {
                        m.namespace && this._core.settings.autoHeight && this.update();
                    }, this),
                    "changed.owl.carousel": te.proxy(function (m) {
                        m.namespace && this._core.settings.autoHeight && m.property.name === "position" && this.update();
                    }, this),
                    "loaded.owl.lazy": te.proxy(function (m) {
                        m.namespace && this._core.settings.autoHeight && m.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update();
                    }, this),
                }),
                (this._core.options = te.extend({}, Fn.Defaults, this._core.options)),
                this._core.$element.on(this._handlers),
                (this._intervalId = null);
            var h = this;
            te(xn).on("load", function () {
                h._core.settings.autoHeight && h.update();
            }),
                te(xn).resize(function () {
                    h._core.settings.autoHeight &&
                        (h._intervalId != null && clearTimeout(h._intervalId),
                        (h._intervalId = setTimeout(function () {
                            h.update();
                        }, 250)));
                });
        }
        function En(i) {
            (this._core = i),
                (this._loaded = []),
                (this._handlers = {
                    "initialized.owl.carousel change.owl.carousel resized.owl.carousel": he.proxy(function (h) {
                        if (h.namespace && this._core.settings && this._core.settings.lazyLoad && ((h.property && h.property.name == "position") || h.type == "initialized")) {
                            var m = this._core.settings,
                                e = (m.center && Math.ceil(m.items / 2)) || m.items,
                                r = (m.center && -1 * e) || 0,
                                p = (h.property && h.property.value !== void 0 ? h.property.value : this._core.current()) + r,
                                u = this._core.clones().length,
                                D = he.proxy(function (j, A) {
                                    this.load(A);
                                }, this);
                            for (0 < m.lazyLoadEager && ((e += m.lazyLoadEager), m.loop && ((p -= m.lazyLoadEager), e++)); r++ < e; )
                                this.load(u / 2 + this._core.relative(p)), u && he.each(this._core.clones(this._core.relative(p)), D), p++;
                        }
                    }, this),
                }),
                (this._core.options = he.extend({}, En.Defaults, this._core.options)),
                this._core.$element.on(this._handlers);
        }
        function Ge(i) {
            (this._core = i),
                (this._interval = null),
                (this._visible = null),
                (this._handlers = {
                    "initialized.owl.carousel": oe.proxy(function (h) {
                        h.namespace && this._core.settings.autoRefresh && this.watch();
                    }, this),
                }),
                (this._core.options = oe.extend({}, Ge.Defaults, this._core.options)),
                this._core.$element.on(this._handlers);
        }
        function K(i, h) {
            (this.settings = null),
                (this.options = G.extend({}, K.Defaults, h)),
                (this.$element = G(i)),
                (this._handlers = {}),
                (this._plugins = {}),
                (this._supress = {}),
                (this._current = null),
                (this._speed = null),
                (this._coordinates = []),
                (this._breakpoint = null),
                (this._width = null),
                (this._items = []),
                (this._clones = []),
                (this._mergers = []),
                (this._widths = []),
                (this._invalidated = {}),
                (this._pipe = []),
                (this._drag = { time: null, target: null, pointer: null, stage: { start: null, current: null }, direction: null }),
                (this._states = { current: {}, tags: { initializing: ["busy"], animating: ["busy"], dragging: ["interacting"] } }),
                G.each(
                    ["onResize", "onThrottledResize"],
                    G.proxy(function (m, e) {
                        this._handlers[e] = G.proxy(this[e], this);
                    }, this)
                ),
                G.each(
                    K.Plugins,
                    G.proxy(function (m, e) {
                        this._plugins[m.charAt(0).toLowerCase() + m.slice(1)] = new e(this);
                    }, this)
                ),
                G.each(
                    K.Workers,
                    G.proxy(function (m, e) {
                        this._pipe.push({ filter: e.filter, run: G.proxy(e.run, this) });
                    }, this)
                ),
                this.setup(),
                this.initialize();
        }
        (Pe = window),
            (Ue = (function (i, h) {
                "use strict";
                if (h.getElementsByClassName) {
                    var m,
                        e,
                        r = h.documentElement,
                        p = i.Date,
                        u = i.HTMLPictureElement,
                        D = "addEventListener",
                        j = "getAttribute",
                        A = i[D],
                        W = i.setTimeout,
                        F = i.requestAnimationFrame || W,
                        Q = i.requestIdleCallback,
                        J = /^picture$/i,
                        wt = ["load", "error", "lazyincluded", "_lazyloaded"],
                        zt = {},
                        X = Array.prototype.forEach,
                        tt = function (O, L) {
                            return zt[L] || (zt[L] = new RegExp("(\\s|^)" + L + "(\\s|$)")), zt[L].test(O[j]("class") || "") && zt[L];
                        },
                        it = function (O, L) {
                            tt(O, L) || O.setAttribute("class", (O[j]("class") || "").trim() + " " + L);
                        },
                        lt = function (O, L) {
                            var I;
                            (I = tt(O, L)) && O.setAttribute("class", (O[j]("class") || "").replace(I, " "));
                        },
                        ht = function T(O, L, I) {
                            var Z = I ? D : "removeEventListener";
                            I && T(O, L),
                                wt.forEach(function (Y) {
                                    O[Z](Y, L);
                                });
                        },
                        _t = function (O, L, I, Z, Y) {
                            var at = h.createEvent("CustomEvent");
                            return I || (I = {}), (I.instance = m), at.initCustomEvent(L, !Z, !Y, I), O.dispatchEvent(at), at;
                        },
                        et = function (O, L) {
                            var I;
                            !u && (I = i.picturefill || e.pf) ? I({ reevaluate: !0, elements: [O] }) : L && L.src && (O.src = L.src);
                        },
                        y = function (O, L) {
                            return (getComputedStyle(O, null) || {})[L];
                        },
                        _ = function (O, L, I) {
                            for (I = I || O.offsetWidth; I < e.minSize && L && !O._lazysizesWidth; ) (I = L.offsetWidth), (L = L.parentNode);
                            return I;
                        },
                        v = (function () {
                            var T,
                                O,
                                L = [],
                                I = [],
                                Z = L,
                                Y = function () {
                                    var ct = Z;
                                    for (Z = L.length ? I : L, T = !0, O = !1; ct.length; ) ct.shift()();
                                    T = !1;
                                },
                                at = function (ct, Pt) {
                                    T && !Pt ? ct.apply(this, arguments) : (Z.push(ct), O || ((O = !0), (h.hidden ? W : F)(Y)));
                                };
                            return (at._lsFlush = Y), at;
                        })(),
                        d = function (O, L) {
                            return L
                                ? function () {
                                      v(O);
                                  }
                                : function () {
                                      var I = this,
                                          Z = arguments;
                                      v(function () {
                                          O.apply(I, Z);
                                      });
                                  };
                        },
                        l = function (O) {
                            var L,
                                I = 0,
                                Z = 125,
                                Y = e.ricTimeout,
                                at = function () {
                                    (L = !1), (I = p.now()), O();
                                },
                                ft =
                                    Q && e.ricTimeout
                                        ? function () {
                                              Q(at, { timeout: Y }), Y !== e.ricTimeout && (Y = e.ricTimeout);
                                          }
                                        : d(function () {
                                              W(at);
                                          }, !0);
                            return function (ct) {
                                var Pt;
                                (ct = ct === !0) && (Y = 33), L || ((L = !0), (Pt = Z - (p.now() - I)), 0 > Pt && (Pt = 0), ct || (9 > Pt && Q) ? ft() : W(ft, Pt));
                            };
                        },
                        s = function (O) {
                            var L,
                                I,
                                Z = 99,
                                Y = function () {
                                    (L = null), O();
                                },
                                at = function ft() {
                                    var ct = p.now() - I;
                                    Z > ct ? W(ft, Z - ct) : (Q || Y)(Y);
                                };
                            return function () {
                                (I = p.now()), L || (L = W(at, Z));
                            };
                        };
                    (function () {
                        var T,
                            O = {
                                lazyClass: "lazyload",
                                loadedClass: "lazyloaded",
                                loadingClass: "lazyloading",
                                preloadClass: "lazypreload",
                                errorClass: "lazyerror",
                                autosizesClass: "lazyautosizes",
                                srcAttr: "data-src",
                                srcsetAttr: "data-srcset",
                                sizesAttr: "data-sizes",
                                minSize: 40,
                                customMedia: {},
                                init: !0,
                                expFactor: 1.5,
                                hFac: 0.8,
                                loadMode: 2,
                                loadHidden: !0,
                                ricTimeout: 300,
                            };
                        e = i.lazySizesConfig || i.lazysizesConfig || {};
                        for (T in O) T in e || (e[T] = O[T]);
                        (i.lazySizesConfig = e),
                            W(function () {
                                e.init && k();
                            });
                    })();
                    var f = (function () {
                            var T,
                                O,
                                L,
                                I,
                                Z,
                                Y,
                                at,
                                ft,
                                ct,
                                Pt,
                                ee,
                                ne,
                                mn,
                                zn,
                                Dn = /^img$/i,
                                Kn = /^iframe$/i,
                                Ae = "onscroll" in i && !/glebot/.test(navigator.userAgent),
                                Jn = 0,
                                Je = 0,
                                Ie = 0,
                                Ce = -1,
                                H = function Ot(vt) {
                                    Ie--, vt && vt.target && ht(vt.target, Ot), (!vt || 0 > Ie || !vt.target) && (Ie = 0);
                                },
                                At = function (vt, qt) {
                                    var Ut,
                                        ae = vt,
                                        Zt = y(h.body, "visibility") == "hidden" || y(vt, "visibility") != "hidden";
                                    for (ft -= qt, ee += qt, ct -= qt, Pt += qt; Zt && (ae = ae.offsetParent) && ae != h.body && ae != r; )
                                        (Zt = (y(ae, "opacity") || 1) > 0), Zt && y(ae, "overflow") != "visible" && ((Ut = ae.getBoundingClientRect()), (Zt = Pt > Ut.left && ct < Ut.right && ee > Ut.top - 1 && ft < Ut.bottom + 1));
                                    return Zt;
                                },
                                Dt = function () {
                                    var vt,
                                        qt,
                                        Ut,
                                        ae,
                                        Zt,
                                        Te,
                                        un,
                                        Re,
                                        vn,
                                        le = m.elements;
                                    if ((I = e.loadMode) && 8 > Ie && (vt = le.length)) {
                                        for (
                                            qt = 0,
                                                Ce++,
                                                mn == null && (("expand" in e) || (e.expand = r.clientHeight > 500 && r.clientWidth > 500 ? 500 : 370), (ne = e.expand), (mn = ne * e.expFactor)),
                                                mn > Je && 1 > Ie && Ce > 2 && I > 2 && !h.hidden ? ((Je = mn), (Ce = 0)) : (Je = I > 1 && Ce > 1 && 6 > Ie ? ne : Jn);
                                            vt > qt;
                                            qt++
                                        )
                                            if (le[qt] && !le[qt]._lazyRace)
                                                if (Ae)
                                                    if (
                                                        (((Re = le[qt][j]("data-expand")) && (Te = 1 * Re)) || (Te = Je),
                                                        vn !== Te && ((Y = innerWidth + Te * zn), (at = innerHeight + Te), (un = -1 * Te), (vn = Te)),
                                                        (Ut = le[qt].getBoundingClientRect()),
                                                        (ee = Ut.bottom) >= un &&
                                                            (ft = Ut.top) <= at &&
                                                            (Pt = Ut.right) >= un * zn &&
                                                            (ct = Ut.left) <= Y &&
                                                            (ee || Pt || ct || ft) &&
                                                            (e.loadHidden || y(le[qt], "visibility") != "hidden") &&
                                                            ((O && 3 > Ie && !Re && (3 > I || 4 > Ce)) || At(le[qt], Te)))
                                                    ) {
                                                        if ((Bn(le[qt]), (Zt = !0), Ie > 9)) break;
                                                    } else
                                                        !Zt && O && !ae && 4 > Ie && 4 > Ce && I > 2 && (T[0] || e.preloadAfterLoad) && (T[0] || (!Re && (ee || Pt || ct || ft || le[qt][j](e.sizesAttr) != "auto"))) && (ae = T[0] || le[qt]);
                                                else Bn(le[qt]);
                                        ae && !Zt && Bn(ae);
                                    }
                                },
                                Ct = l(Dt),
                                It = function (vt) {
                                    it(vt.target, e.loadedClass), lt(vt.target, e.loadingClass), ht(vt.target, He), _t(vt.target, "lazyloaded");
                                },
                                Gt = d(It),
                                He = function (vt) {
                                    Gt({ target: vt.target });
                                },
                                Un = function (vt, qt) {
                                    try {
                                        vt.contentWindow.location.replace(qt);
                                    } catch {
                                        vt.src = qt;
                                    }
                                },
                                ri = function (vt) {
                                    var qt,
                                        Ut = vt[j](e.srcsetAttr);
                                    (qt = e.customMedia[vt[j]("data-media") || vt[j]("media")]) && vt.setAttribute("media", qt), Ut && vt.setAttribute("srcset", Ut);
                                },
                                _i = d(function (Ot, vt, qt, Ut, ae) {
                                    var Zt, Te, un, Re, vn, le;
                                    (vn = _t(Ot, "lazybeforeunveil", vt)).defaultPrevented ||
                                        (Ut && (qt ? it(Ot, e.autosizesClass) : Ot.setAttribute("sizes", Ut)),
                                        (Te = Ot[j](e.srcsetAttr)),
                                        (Zt = Ot[j](e.srcAttr)),
                                        ae && ((un = Ot.parentNode), (Re = un && J.test(un.nodeName || ""))),
                                        (le = vt.firesLoad || ("src" in Ot && (Te || Zt || Re))),
                                        (vn = { target: Ot }),
                                        le && (ht(Ot, H, !0), clearTimeout(L), (L = W(H, 2500)), it(Ot, e.loadingClass), ht(Ot, He, !0)),
                                        Re && X.call(un.getElementsByTagName("source"), ri),
                                        Te ? Ot.setAttribute("srcset", Te) : Zt && !Re && (Kn.test(Ot.nodeName) ? Un(Ot, Zt) : (Ot.src = Zt)),
                                        ae && (Te || Re) && et(Ot, { src: Zt })),
                                        Ot._lazyRace && delete Ot._lazyRace,
                                        lt(Ot, e.lazyClass),
                                        v(function () {
                                            (!le || (Ot.complete && Ot.naturalWidth > 1)) && (le ? H(vn) : Ie--, It(vn));
                                        }, !0);
                                }),
                                Bn = function (vt) {
                                    var qt,
                                        Ut = Dn.test(vt.nodeName),
                                        ae = Ut && (vt[j](e.sizesAttr) || vt[j]("sizes")),
                                        Zt = ae == "auto";
                                    ((!Zt && O) || !Ut || (!vt[j]("src") && !vt.srcset) || vt.complete || tt(vt, e.errorClass) || !tt(vt, e.lazyClass)) &&
                                        ((qt = _t(vt, "lazyunveilread").detail), Zt && b.updateElem(vt, !0, vt.offsetWidth), (vt._lazyRace = !0), Ie++, _i(vt, qt, Zt, ae, Ut));
                                },
                                ai = function Ot() {
                                    if (!O) {
                                        if (p.now() - Z < 999) return void W(Ot, 999);
                                        var vt = s(function () {
                                            (e.loadMode = 3), Ct();
                                        });
                                        (O = !0),
                                            (e.loadMode = 3),
                                            Ct(),
                                            A(
                                                "scroll",
                                                function () {
                                                    e.loadMode == 3 && (e.loadMode = 2), vt();
                                                },
                                                !0
                                            );
                                    }
                                };
                            return {
                                _: function () {
                                    (Z = p.now()),
                                        (m.elements = h.getElementsByClassName(e.lazyClass)),
                                        (T = h.getElementsByClassName(e.lazyClass + " " + e.preloadClass)),
                                        (zn = e.hFac),
                                        A("scroll", Ct, !0),
                                        A("resize", Ct, !0),
                                        i.MutationObserver ? new MutationObserver(Ct).observe(r, { childList: !0, subtree: !0, attributes: !0 }) : (r[D]("DOMNodeInserted", Ct, !0), r[D]("DOMAttrModified", Ct, !0), setInterval(Ct, 999)),
                                        A("hashchange", Ct, !0),
                                        ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (vt) {
                                            h[D](vt, Ct, !0);
                                        }),
                                        /d$|^c/.test(h.readyState) ? ai() : (A("load", ai), h[D]("DOMContentLoaded", Ct), W(ai, 2e4)),
                                        m.elements.length ? (Dt(), v._lsFlush()) : Ct();
                                },
                                checkElems: Ct,
                                unveil: Bn,
                            };
                        })(),
                        b = (function () {
                            var T,
                                O = d(function (Y, at, ft, ct) {
                                    var Pt, ee, ne;
                                    if (((Y._lazysizesWidth = ct), (ct += "px"), Y.setAttribute("sizes", ct), J.test(at.nodeName || "")))
                                        for (Pt = at.getElementsByTagName("source"), ee = 0, ne = Pt.length; ne > ee; ee++) Pt[ee].setAttribute("sizes", ct);
                                    ft.detail.dataAttr || et(Y, ft.detail);
                                }),
                                L = function (at, ft, ct) {
                                    var Pt,
                                        ee = at.parentNode;
                                    ee && ((ct = _(at, ee, ct)), (Pt = _t(at, "lazybeforesizes", { width: ct, dataAttr: !!ft })), Pt.defaultPrevented || ((ct = Pt.detail.width), ct && ct !== at._lazysizesWidth && O(at, ee, Pt, ct)));
                                },
                                I = function () {
                                    var at,
                                        ft = T.length;
                                    if (ft) for (at = 0; ft > at; at++) L(T[at]);
                                },
                                Z = s(I);
                            return {
                                _: function () {
                                    (T = h.getElementsByClassName(e.autosizesClass)), A("resize", Z);
                                },
                                checkElems: Z,
                                updateElem: L,
                            };
                        })(),
                        k = function T() {
                            T.i || ((T.i = !0), b._(), f._());
                        };
                    return (m = { cfg: e, autoSizer: b, loader: f, init: k, uP: et, aC: it, rC: lt, hC: tt, fire: _t, gW: _, rAF: v });
                }
            })(Pe, Pe.document)),
            (Pe.lazySizes = Ue),
            (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports && (module.exports = Ue),
            (se = window),
            (Le = (Le = function (i, h, m) {
                "use strict";
                function e(v, d, l) {
                    var s,
                        f,
                        b,
                        k = 0,
                        T = 0,
                        O = l;
                    if (v) {
                        if (d.ratio === "container") {
                            for (k = O.scrollWidth, T = O.scrollHeight; !((k && T) || O === h); ) (k = (O = O.parentNode).scrollWidth), (T = O.scrollHeight);
                            k && T && (d.ratio = T / k);
                        }
                        (s = v),
                            (f = d),
                            ((b = []).srcset = []),
                            f.absUrl && (X.setAttribute("href", s), (s = X.href)),
                            (s = ((f.prefix || "") + s + (f.postfix || "")).replace(J, function (L, I) {
                                return j[_typeof(f[I])] ? f[I] : L;
                            })),
                            f.widths.forEach(function (L) {
                                var I = f.widthmap[L] || L,
                                    I = { u: s.replace(F, I).replace(Q, f.ratio ? Math.round(L * f.ratio) : ""), w: L };
                                b.push(I), b.srcset.push((I.c = I.u + " " + L + "w"));
                            }),
                            ((v = b).isPicture = d.isPicture),
                            it && l.nodeName.toUpperCase() == "IMG" ? l.removeAttribute(u.srcsetAttr) : l.setAttribute(u.srcsetAttr, v.srcset.join(", ")),
                            Object.defineProperty(l, "_lazyrias", { value: v, writable: !0 });
                    }
                }
                function r(v, d) {
                    return (
                        (d = (function (l, s) {
                            var f,
                                b = i.getComputedStyle(l),
                                k = l.parentNode,
                                T = { isPicture: !(!k || !W.test(k.nodeName || "")) },
                                O = function (L, I) {
                                    var Z,
                                        Y = l.getAttribute("data-" + L);
                                    if ((Y || ((Z = b.getPropertyValue("--ls-" + L)) && (Y = Z.trim())), Y)) {
                                        if (Y == "true") Y = !0;
                                        else if (Y == "false") Y = !1;
                                        else if (A.test(Y)) Y = parseFloat(Y);
                                        else if (typeof D[L] == "function") Y = D[L](l, Y);
                                        else if (wt.test(Y))
                                            try {
                                                Y = JSON.parse(Y);
                                            } catch {}
                                        T[L] = Y;
                                    } else L in D && typeof D[L] != "function" ? (T[L] = D[L]) : I && typeof D[L] == "function" && (T[L] = D[L](l, Y));
                                };
                            for (f in D) O(f);
                            return (
                                s.replace(J, function (L, I) {
                                    I in T || O(I, !0);
                                }),
                                T
                            );
                        })(v, d)),
                        D.modifyOptions.call(v, { target: v, details: d, detail: d }),
                        m.fire(v, "lazyriasmodifyoptions", d),
                        d
                    );
                }
                function p(v) {
                    return v.getAttribute(v.getAttribute("data-srcattr") || D.srcAttr) || v.getAttribute(u.srcsetAttr) || v.getAttribute(u.srcAttr) || v.getAttribute("data-pfsrcset") || "";
                }
                var u,
                    D,
                    j = { string: 1, number: 1 },
                    A = /^\-*\+*\d+\.*\d*$/,
                    W = /^picture$/i,
                    F = /\s*\{\s*width\s*\}\s*/i,
                    Q = /\s*\{\s*height\s*\}\s*/i,
                    J = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
                    wt = /^\[.*\]|\{.*\}$/,
                    zt = /^(?:auto|\d+(px)?)$/,
                    X = h.createElement("a"),
                    tt = h.createElement("img"),
                    it = "srcset" in tt && !("sizes" in tt),
                    lt = !!i.HTMLPictureElement && !it;
                (function () {
                    var v,
                        d = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: function () {}, widthmap: {}, ratio: !1 };
                    for (v in ((u = (m && m.cfg) || i.lazySizesConfig) || ((u = {}), (i.lazySizesConfig = u)),
                    u.supportsType ||
                        (u.supportsType = function (l) {
                            return !l;
                        }),
                    u.rias || (u.rias = {}),
                    "widths" in (D = u.rias) ||
                        ((D.widths = []),
                        (function (l) {
                            for (var s, f = 0; !s || s < 3e3; ) 30 < (f += 5) && (f += 1), l.push((s = 36 * f));
                        })(D.widths)),
                    d))
                        v in D || (D[v] = d[v]);
                })(),
                    addEventListener(
                        "lazybeforesizes",
                        function (v) {
                            if (v.detail.instance == m) {
                                var d,
                                    l,
                                    s,
                                    f,
                                    b,
                                    k,
                                    T,
                                    O,
                                    L,
                                    I = v.target;
                                if (v.detail.dataAttr && !v.defaultPrevented && !D.disabled && (T = I.getAttribute(u.sizesAttr) || I.getAttribute("sizes")) && zt.test(T)) {
                                    if (((d = r(I, (v = p(I)))), (O = F.test(d.prefix) || F.test(d.postfix)), d.isPicture && (l = I.parentNode)))
                                        for (f = 0, b = (s = l.getElementsByTagName("source")).length; f < b; f++) (O || F.test((k = p(s[f])))) && (e(k, d, s[f]), (L = !0));
                                    O || F.test(v) ? (e(v, d, I), (L = !0)) : L && (((v = []).srcset = []), (v.isPicture = !0), Object.defineProperty(I, "_lazyrias", { value: v, writable: !0 })),
                                        L && (lt ? I.removeAttribute(u.srcAttr) : T != "auto" && ((T = { width: parseInt(T, 10) }), _t({ target: I, detail: T })));
                                }
                            }
                        },
                        !0
                    );
                var ht,
                    _t =
                        ((ht = function (v) {
                            if (v.detail.instance == m) {
                                var d,
                                    l = v.target;
                                return !it && (i.respimage || i.picturefill || lazySizesConfig.pf)
                                    ? void h.removeEventListener("lazybeforesizes", ht)
                                    : void (
                                          ("_lazyrias" in l || (v.detail.dataAttr && y(l, !0))) &&
                                          (d = _(l, v.detail.width)) &&
                                          d.u &&
                                          l._lazyrias.cur != d.u &&
                                          ((l._lazyrias.cur = d.u),
                                          (d.cached = !0),
                                          m.rAF(function () {
                                              l.setAttribute(u.srcAttr, d.u), l.setAttribute("src", d.u);
                                          }))
                                      );
                            }
                        }),
                        lt ? (ht = function () {}) : addEventListener("lazybeforesizes", ht),
                        ht);
                function et(v, d) {
                    return v.w - d.w;
                }
                function y(v, d) {
                    var l;
                    return (
                        !v._lazyrias &&
                            m.pWS &&
                            (l = m.pWS(v.getAttribute(u.srcsetAttr || ""))).length &&
                            (Object.defineProperty(v, "_lazyrias", { value: l, writable: !0 }), d && v.parentNode && (l.isPicture = v.parentNode.nodeName.toUpperCase() == "PICTURE")),
                        v._lazyrias
                    );
                }
                function _(v, d) {
                    var l,
                        s,
                        f,
                        b,
                        k,
                        T = v._lazyrias;
                    if (T.isPicture && i.matchMedia) {
                        for (s = 0, f = (l = v.parentNode.getElementsByTagName("source")).length; s < f; s++)
                            if (y(l[s]) && !l[s].getAttribute("type") && (!(b = l[s].getAttribute("media")) || (matchMedia(b) || {}).matches)) {
                                T = l[s]._lazyrias;
                                break;
                            }
                    }
                    return (
                        (!T.w || T.w < d) &&
                            ((T.w = d),
                            (T.d = ((v = v), (k = i.devicePixelRatio || 1), (v = m.getX && m.getX(v)), Math.min(v || k, 2.4, k))),
                            (k = (function (O) {
                                for (var L, I, Z = O.length, Y = O[Z - 1], at = 0; at < Z; at++)
                                    if ((((Y = O[at]).d = Y.w / O.w), Y.d >= O.d)) {
                                        !Y.cached && (L = O[at - 1]) && L.d > O.d - 0.13 * Math.pow(O.d, 2.2) && ((I = Math.pow(L.d - 0.6, 1.6)), L.cached && (L.d += 0.15 * I), L.d + (Y.d - O.d) * I > O.d && (Y = L));
                                        break;
                                    }
                                return Y;
                            })(T.sort(et)))),
                        k
                    );
                }
            }).bind(null, se, se.document)),
            (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports ? Le(require("lazysizes")) : se.lazySizes ? Xe() : se.addEventListener("lazyunveilread", Xe, !0),
            (function (i, h) {
                "use strict";
                var m, e, r, p, u, D, j, A, W, F;
                function Q(X, tt, it, lt, ht) {
                    var _t,
                        et = X[ht];
                    et && ((_t = et.index), D[ht](et, tt, it), (et.dirty && _t == et.index) || (et.cSrcset.join(", "), X.setAttribute(lt, et.cSrcset.join(", ")), (et.dirty = !0)));
                }
                function J(X, tt) {
                    return X.w - tt.w;
                }
                function wt(X, tt) {
                    var it = { srcset: X.getAttribute(lazySizes.cfg.srcsetAttr) || "" },
                        lt = p(it.srcset);
                    return (
                        Object.defineProperty(X, tt, { value: it, writable: !0 }),
                        (it.cands = lt),
                        (it.index = 0),
                        (it.dirty = !1),
                        lt[0] && lt[0].w ? (lt.sort(J), (it.cSrcset = [lt[it.index].c])) : ((it.cSrcset = it.srcset ? [it.srcset] : []), (it.cands = [])),
                        it
                    );
                }
                function zt(X, tt, it, lt, ht, _t, et, y) {
                    W.push({ c: tt, u: it, w: +(y == "w" ? et : lt) });
                }
                i.addEventListener &&
                    ((e = /^picture$/i),
                    (r = h.documentElement),
                    (F = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g),
                    (p = function (X) {
                        return (W = []), X.replace(F, zt), W;
                    }),
                    (u = function (X, tt) {
                        var it, lt, ht, _t;
                        if (!X[tt] && ((_t = X.parentNode || {}), (X[tt] = wt(X, tt)), (X[tt].isImg = !0), e.test(_t.nodeName || "")))
                            for (X[tt].picture = !0, lt = 0, ht = (it = _t.getElementsByTagName("source")).length; lt < ht; lt++) wt(it[lt], tt).isImg = !1;
                        return X[tt];
                    }),
                    (D = {
                        _lazyOptimumx: function (X, tt, it) {
                            for (var lt, ht, _t, et, y, _ = 0; _ < X.cands.length; _++)
                                if ((((lt = X.cands[_]).d = (lt.w || 1) / tt), !(X.index >= _))) {
                                    if (
                                        !(
                                            lt.d <= it ||
                                            ((ht = X.cands[_ - 1]),
                                            (_t = lt.d),
                                            (et = it),
                                            (y = void 0),
                                            !ht || !ht.d || (!(ht.d >= et) && ((y = Math.pow(ht.d - (0.7 < et ? 0.6 : 0.4), 1.6) || 0.1) < 0.1 ? (y = 0.1) : 3 < y && (y = 3), ht.d + (_t - et) * y < et)))
                                        )
                                    )
                                        break;
                                    X.cSrcset.push(lt.c), (X.index = _);
                                }
                        },
                    }),
                    (j = function (X, tt, it, lt, ht) {
                        var _t,
                            et,
                            y,
                            _,
                            v = X[ht];
                        if (((v.width = tt), v.picture && (et = X.parentNode))) for (_ = 0, y = (_t = et.getElementsByTagName("source")).length; _ < y; _++) Q(_t[_], tt, it, lt, ht);
                        Q(X, tt, it, lt, ht);
                    }),
                    (A = function (X) {
                        var tt = X.getAttribute("data-optimumx") || X.getAttribute("data-maxdpr");
                        return (tt = (tt = !tt && m.constrainPixelDensity ? "auto" : tt) && (tt == "auto" ? m.getOptimumX(X) : parseFloat(tt, 10)));
                    }),
                    (h = function X() {
                        i.lazySizes && !i.lazySizes.getOptimumX && ((lazySizes.getX = A), (lazySizes.pWS = p), r.removeEventListener("lazybeforeunveil", X));
                    }),
                    r.addEventListener("lazybeforeunveil", h),
                    setTimeout(h),
                    (m = (i.lazySizes && lazySizes.cfg) || i.lazySizesConfig) || (i.lazySizesConfig = m = {}),
                    typeof m.getOptimumX != "function" &&
                        (m.getOptimumX = function () {
                            var X = i.devicePixelRatio || 1;
                            return 2.6 < X ? (X *= 0.6) : 1.9 < X ? (X *= 0.8) : (X -= 0.01), Math.min(Math.round(100 * X) / 100, 2);
                        }),
                    i.devicePixelRatio &&
                        addEventListener("lazybeforesizes", function (X) {
                            var tt,
                                it,
                                lt,
                                ht = X.target,
                                _t = X.detail,
                                et = _t.dataAttr;
                            X.defaultPrevented ||
                                !(tt = A(ht)) ||
                                tt >= devicePixelRatio ||
                                (!et || !ht._lazyOptimumx || _t.reloaded || (m.unloadedClass && lazySizes.hC(ht, m.unloadedClass)) || (ht._lazyOptimumx = null),
                                (X = u(ht, "_lazyOptimumx")),
                                (it = _t.width) &&
                                    (X.width || 0) < it &&
                                    ((lt = et ? lazySizes.cfg.srcsetAttr : "srcset"),
                                    lazySizes.rAF(function () {
                                        j(ht, it, tt, lt, "_lazyOptimumx");
                                    })));
                        }));
            })(window, document),
            (ve = window),
            (jn = (jn = function (i, h, m) {
                "use strict";
                var e, r;
                "srcset" in h.createElement("img") &&
                    ((e = /^img$/i),
                    h.addEventListener(
                        "lazybeforeunveil",
                        function (p) {
                            var u;
                            p.detail.instance == m &&
                                ((u = p.target),
                                !e.test(u.nodeName) || ((p = u.getAttribute("src")) && ((u.style.backgroundSize = "100% 100%"), (u.style.backgroundImage = "url(" + p + ")"), u.removeAttribute("src"), u.addEventListener("load", r))));
                        },
                        !(r = function (p) {
                            (p.target.style.backgroundSize = ""), (p.target.style.backgroundImage = ""), p.target.removeEventListener(p.type, r);
                        })
                    ));
            }).bind(null, ve, ve.document)),
            (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports ? jn(require("lazysizes")) : ve.lazySizes ? rn() : ve.addEventListener("lazyunveilread", rn, !0),
            (be = window),
            (Ln = (Ln = function (i, h, m) {
                "use strict";
                var e, r, p, u, D;
                i.addEventListener &&
                    ((e = /\s+(\d+)(w|h)\s+(\d+)(w|h)/),
                    (r = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/),
                    (p = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/),
                    (u = /^picture$/i),
                    (m.parentFit = D = {
                        getParent: function (j, A) {
                            var W = j,
                                F = j.parentNode;
                            return (
                                (A && A != "prev") || !F || !u.test(F.nodeName || "") || (F = F.parentNode),
                                (W = A != "self" ? (A == "prev" ? j.previousElementSibling : (A && (F.closest || i.jQuery) && (F.closest ? F.closest(A) : jQuery(F).closest(A)[0])) || F) : W)
                            );
                        },
                        getFit: function (j) {
                            var A,
                                W,
                                F = getComputedStyle(j, null) || {},
                                Q = F.content || F.fontFamily,
                                J = { fit: j._lazysizesParentFit || j.getAttribute("data-parent-fit") };
                            return (
                                !J.fit && Q && (A = Q.match(r)) && (J.fit = A[1]),
                                J.fit ? (!(W = j._lazysizesParentContainer || j.getAttribute("data-parent-container")) && Q && (A = Q.match(p)) && (W = A[1]), (J.parent = D.getParent(j, W))) : (J.fit = F.objectFit),
                                J
                            );
                        },
                        getImageRatio: function (j) {
                            for (var A, W, F, Q = j.parentNode, J = Q && u.test(Q.nodeName || "") ? Q.querySelectorAll("source, img") : [j], wt = 0; wt < J.length; wt++)
                                if (
                                    ((A = (j = J[wt]).getAttribute(lazySizesConfig.srcsetAttr) || j.getAttribute("srcset") || j.getAttribute("data-pfsrcset") || j.getAttribute("data-risrcset") || ""),
                                    (W = j._lsMedia || j.getAttribute("media")),
                                    (W = lazySizesConfig.customMedia[j.getAttribute("data-media") || W] || W),
                                    A && (!W || ((i.matchMedia && matchMedia(W)) || {}).matches))
                                ) {
                                    !(F = parseFloat(j.getAttribute("data-aspectratio"))) && A.match(e) && (F = RegExp.$2 == "w" ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1);
                                    break;
                                }
                            return F;
                        },
                        calculateSize: function (j, A) {
                            var W,
                                F,
                                Q = this.getFit(j),
                                J = Q.fit,
                                Q = Q.parent;
                            return J == "width" || ((J == "contain" || J == "cover") && (F = this.getImageRatio(j)))
                                ? (Q ? (A = Q.clientWidth) : (Q = j), (j = A), J == "width" ? (j = A) : 40 < (Q = Q.clientHeight) && (W = A / Q) && ((J == "cover" && W < F) || (J == "contain" && F < W)) && (j = A * (F / W)), j)
                                : A;
                        },
                    }),
                    h.addEventListener("lazybeforesizes", function (j) {
                        var A;
                        j.defaultPrevented || j.detail.instance != m || ((A = j.target), (j.detail.width = D.calculateSize(A, j.detail.width)));
                    }));
            }).bind(null, be, be.document)),
            (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports ? Ln(require("lazysizes")) : be.lazySizes ? gn() : be.addEventListener("lazyunveilread", gn, !0),
            (sn = window),
            (bn = (bn = function (i, h, m) {
                "use strict";
                var e,
                    r,
                    p,
                    u,
                    D,
                    j,
                    A,
                    W,
                    F,
                    Q,
                    J = (m && m.cfg) || i.lazySizesConfig,
                    wt = h.createElement("img"),
                    zt = "sizes" in wt && "srcset" in wt,
                    X = /\s+\d+h/g,
                    wt =
                        ((r = /\s+(\d+)(w|h)\s+(\d+)(w|h)/),
                        (p = Array.prototype.forEach),
                        function (y) {
                            function _(s) {
                                var f,
                                    b = s.getAttribute(lazySizesConfig.srcsetAttr);
                                b && (!(f = b.match(r)) || ((f = f[2] == "w" ? f[1] / f[3] : f[3] / f[1]) && s.setAttribute("data-aspectratio", f)), s.setAttribute(lazySizesConfig.srcsetAttr, b.replace(X, "")));
                            }
                            function v(s) {
                                var f = s.target.parentNode;
                                f && f.nodeName == "PICTURE" && p.call(f.getElementsByTagName("source"), _), _(s.target);
                            }
                            function d() {
                                l.currentSrc && h.removeEventListener("lazybeforeunveil", v);
                            }
                            var l = h.createElement("img");
                            y[1] && (h.addEventListener("lazybeforeunveil", v), (l.onload = d), (l.onerror = d), (l.srcset = "data:,a 1w 1h"), l.complete && d());
                        });
                if (
                    (J || (i.lazySizesConfig = J = {}),
                    J.supportsType ||
                        (J.supportsType = function (y) {
                            return !y;
                        }),
                    !i.picturefill && !J.pf)
                ) {
                    if (i.HTMLPictureElement && zt) return h.msElementsFromPoint && wt(navigator.userAgent.match(/Edge\/(\d+)/)), void (J.pf = function () {});
                    (J.pf = function (y) {
                        var _, v;
                        if (!i.picturefill) for (_ = 0, v = y.elements.length; _ < v; _++) e(y.elements[_]);
                    }),
                        (W = /^\s*\d+\.*\d*px\s*$/),
                        (j = /(([^,\s].[^\s]+)\s+(\d+)w)/g),
                        (A = /\s/),
                        (Q = function (y) {
                            return i.matchMedia
                                ? (Q = function (_) {
                                      return !_ || (matchMedia(_) || {}).matches;
                                  })(y)
                                : !y;
                        }),
                        (_t.parse = F = function (y) {
                            return (D = []), (y = y.trim()).replace(X, "").replace(j, et), D.length || !y || A.test(y) || D.push({ c: y, u: y, w: 99 }), D;
                        }),
                        (e = _t),
                        J.loadedClass &&
                            J.loadingClass &&
                            ((u = []),
                            ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function (y) {
                                u.push(y + J.loadedClass), u.push(y + J.loadingClass);
                            }),
                            J.pf({ elements: h.querySelectorAll(u.join(", ")) }));
                }
                function tt(y, _) {
                    return y.w - _.w;
                }
                function it() {
                    function y() {
                        for (var d = 0, l = v.length; d < l; d++) e(v[d]);
                    }
                    var _, v;
                    it.init ||
                        ((it.init = !0),
                        addEventListener(
                            "resize",
                            ((v = h.getElementsByClassName("lazymatchmedia")),
                            function () {
                                clearTimeout(_), (_ = setTimeout(y, 66));
                            })
                        ));
                }
                function lt(y, _) {
                    var v,
                        d = y.getAttribute("srcset") || y.getAttribute(J.srcsetAttr);
                    !d && _ && (d = y._lazypolyfill ? y._lazypolyfill._set : y.getAttribute(J.srcAttr) || y.getAttribute("src")),
                        (y._lazypolyfill && y._lazypolyfill._set == d) ||
                            ((v = F(d || "")),
                            _ && y.parentNode && ((v.isPicture = y.parentNode.nodeName.toUpperCase() == "PICTURE"), v.isPicture && i.matchMedia && (m.aC(y, "lazymatchmedia"), it())),
                            (v._set = d),
                            Object.defineProperty(y, "_lazypolyfill", { value: v, writable: !0 }));
                }
                function ht(y) {
                    var _,
                        v,
                        d,
                        l,
                        s,
                        f,
                        b,
                        k,
                        T = y;
                    if ((lt(T, !0), (l = T._lazypolyfill).isPicture)) {
                        for (v = 0, d = (_ = y.parentNode.getElementsByTagName("source")).length; v < d; v++)
                            if (J.supportsType(_[v].getAttribute("type"), y) && Q(_[v].getAttribute("media"))) {
                                (T = _[v]), lt(T), (l = T._lazypolyfill);
                                break;
                            }
                    }
                    return (
                        1 < l.length
                            ? ((f = T.getAttribute("sizes") || ""),
                              (f = (W.test(f) && parseInt(f, 10)) || m.gW(y, y.parentNode)),
                              (l.d = ((b = y), (k = i.devicePixelRatio || 1), (b = m.getX && m.getX(b)), Math.min(b || k, 2.5, k))),
                              !l.src || !l.w || l.w < f
                                  ? ((l.w = f),
                                    (s = (function (O) {
                                        for (var L, I, Z = O.length, Y = O[Z - 1], at = 0; at < Z; at++)
                                            if ((((Y = O[at]).d = Y.w / O.w), Y.d >= O.d)) {
                                                !Y.cached && (L = O[at - 1]) && L.d > O.d - 0.13 * Math.pow(O.d, 2.2) && ((I = Math.pow(L.d - 0.6, 1.6)), L.cached && (L.d += 0.15 * I), L.d + (Y.d - O.d) * I > O.d && (Y = L));
                                                break;
                                            }
                                        return Y;
                                    })(l.sort(tt))),
                                    (l.src = s))
                                  : (s = l.src))
                            : (s = l[0]),
                        s
                    );
                }
                function _t(y) {
                    var _;
                    (zt && y.parentNode && y.parentNode.nodeName.toUpperCase() != "PICTURE") ||
                        ((_ = ht(y)) && _.u && y._lazypolyfill.cur != _.u && ((y._lazypolyfill.cur = _.u), (_.cached = !0), y.setAttribute(J.srcAttr, _.u), y.setAttribute("src", _.u)));
                }
                function et(y, _, v, d) {
                    D.push({ c: _, u: v, w: +d });
                }
            }).bind(null, sn, sn.document)),
            (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports
                ? bn(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes"))
                : sn.lazySizes
                ? oi()
                : sn.addEventListener("lazyunveilread", oi, !0),
            (Ve = window),
            (Pn = (Pn = function (i, h, m) {
                "use strict";
                var e, r, p, u, D, j;
                i.addEventListener &&
                    ((e = /\s+/g),
                    (r = /\s*\|\s+|\s+\|\s*/g),
                    (p = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/),
                    (u = /\(|\)|'/),
                    (D = { contain: 1, cover: 1 }),
                    (j = function (A) {
                        var W, F;
                        A.target._lazybgset &&
                            ((F = (W = A.target)._lazybgset),
                            (A = W.currentSrc || W.src) && (F.style.backgroundImage = "url(" + (u.test(A) ? JSON.stringify(A) : A) + ")"),
                            W._lazybgsetLoading && (m.fire(F, "_lazyloaded", {}, !1, !0), delete W._lazybgsetLoading));
                    }),
                    addEventListener("lazybeforeunveil", function (A) {
                        var W, F, Q, J, wt, zt, X;
                        !A.defaultPrevented &&
                            (zt = A.target.getAttribute("data-bgset")) &&
                            ((X = A.target),
                            ((W = h.createElement("img")).alt = ""),
                            (W._lazybgsetLoading = !0),
                            (A.detail.firesLoad = !0),
                            (F = zt),
                            (Q = X),
                            (A = W),
                            (J = h.createElement("picture")),
                            (wt = Q.getAttribute(lazySizesConfig.sizesAttr)),
                            (zt = Q.getAttribute("data-ratio")),
                            (X = Q.getAttribute("data-optimumx")),
                            Q._lazybgset && Q._lazybgset.parentNode == Q && Q.removeChild(Q._lazybgset),
                            Object.defineProperty(A, "_lazybgset", { value: Q, writable: !0 }),
                            Object.defineProperty(Q, "_lazybgset", { value: J, writable: !0 }),
                            (F = F.replace(e, " ").split(r)),
                            (J.style.display = "none"),
                            (A.className = lazySizesConfig.lazyClass),
                            F.length != 1 || wt || (wt = "auto"),
                            F.forEach(function (tt) {
                                var it = h.createElement("source");
                                wt && wt != "auto" && it.setAttribute("sizes", wt),
                                    tt.match(p) && (it.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1), RegExp.$2 && it.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)),
                                    J.appendChild(it);
                            }),
                            wt && (A.setAttribute(lazySizesConfig.sizesAttr, wt), Q.removeAttribute(lazySizesConfig.sizesAttr), Q.removeAttribute("sizes")),
                            X && A.setAttribute("data-optimumx", X),
                            zt && A.setAttribute("data-ratio", zt),
                            J.appendChild(A),
                            Q.appendChild(J),
                            setTimeout(function () {
                                m.loader.unveil(W),
                                    m.rAF(function () {
                                        m.fire(W, "_lazyloaded", {}, !0, !0), W.complete && j({ target: W });
                                    });
                            }));
                    }),
                    h.addEventListener("load", j, !0),
                    i.addEventListener(
                        "lazybeforesizes",
                        function (A) {
                            var W, F, Q;
                            A.detail.instance == m &&
                                A.target._lazybgset &&
                                A.detail.dataAttr &&
                                ((Q = A.target._lazybgset),
                                (F = Q),
                                (Q = (getComputedStyle(F) || { getPropertyValue: function () {} }).getPropertyValue("background-size")),
                                (W = Q = !D[Q] && D[F.style.backgroundSize] ? F.style.backgroundSize : Q),
                                D[W] &&
                                    ((A.target._lazysizesParentFit = W),
                                    m.rAF(function () {
                                        A.target.setAttribute("data-parent-fit", W), A.target._lazysizesParentFit && delete A.target._lazysizesParentFit;
                                    })));
                        },
                        !0
                    ),
                    h.documentElement.addEventListener("lazybeforesizes", function (A) {
                        var W;
                        !A.defaultPrevented &&
                            A.target._lazybgset &&
                            A.detail.instance == m &&
                            (A.detail.width = ((W = A.target._lazybgset), (A = m.gW(W, W.parentNode)), (!W._lazysizesWidth || A > W._lazysizesWidth) && (W._lazysizesWidth = A), W._lazysizesWidth));
                    }));
            }).bind(null, Ve, Ve.document)),
            (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports ? Pn(require("lazysizes")) : Ve.lazySizes ? kn() : Ve.addEventListener("lazyunveilread", kn, !0),
            document.addEventListener("lazyloaded", function (i) {
                i.target.parentElement.className = i.target.parentElement.className.replace("lazyload--placeholder", "");
            }),
            (function (i) {
                "use strict";
                typeof exports != "undefined" ? (module.exports = i(require("jquery"))) : i(jQuery);
            })(function (i) {
                "use strict";
                var h,
                    m = window.Slick || {};
                (h = 0),
                    ((m = function (e, r) {
                        var p = this;
                        (p.defaults = {
                            accessibility: !0,
                            adaptiveHeight: !1,
                            appendArrows: i(e),
                            appendDots: i(e),
                            arrows: !0,
                            asNavFor: null,
                            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="' + theme.strings.previous + '" tabindex="0" role="button">' + theme.strings.previous + "</button>",
                            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="' + theme.strings.next + '" tabindex="0" role="button">' + theme.strings.next + "</button>",
                            autoplay: !1,
                            autoplaySpeed: 3e3,
                            centerMode: !1,
                            centerPadding: "50px",
                            cssEase: "ease",
                            customPaging: function (u, D) {
                                return i('<button type="button" data-role="none" role="button" tabindex="0" />').text(D + 1);
                            },
                            dots: !1,
                            dotsClass: "slick-dots",
                            draggable: !0,
                            easing: "linear",
                            edgeFriction: 0.35,
                            fade: !1,
                            focusOnSelect: !1,
                            infinite: !0,
                            initialSlide: 0,
                            lazyLoad: "ondemand",
                            mobileFirst: !1,
                            pauseOnHover: !0,
                            pauseOnFocus: !0,
                            pauseOnDotsHover: !1,
                            respondTo: "window",
                            responsive: null,
                            rows: 1,
                            rtl: !1,
                            slide: "",
                            slidesPerRow: 1,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 500,
                            swipe: !0,
                            swipeToSlide: !1,
                            touchMove: !0,
                            touchThreshold: 5,
                            useCSS: !0,
                            useTransform: !0,
                            variableWidth: !1,
                            vertical: !1,
                            verticalSwiping: !1,
                            waitForAnimate: !0,
                            zIndex: 1e3,
                        }),
                            (p.initials = {
                                animating: !1,
                                dragging: !1,
                                autoPlayTimer: null,
                                currentDirection: 0,
                                currentLeft: null,
                                currentSlide: 0,
                                direction: 1,
                                $dots: null,
                                listWidth: null,
                                listHeight: null,
                                loadIndex: 0,
                                $nextArrow: null,
                                $prevArrow: null,
                                slideCount: null,
                                slideWidth: null,
                                $slideTrack: null,
                                $slides: null,
                                sliding: !1,
                                slideOffset: 0,
                                swipeLeft: null,
                                $list: null,
                                touchObject: {},
                                transformsEnabled: !1,
                                unslicked: !1,
                            }),
                            i.extend(p, p.initials),
                            (p.activeBreakpoint = null),
                            (p.animType = null),
                            (p.animProp = null),
                            (p.breakpoints = []),
                            (p.breakpointSettings = []),
                            (p.cssTransitions = !1),
                            (p.focussed = !1),
                            (p.interrupted = !1),
                            (p.hidden = "hidden"),
                            (p.paused = !0),
                            (p.positionProp = null),
                            (p.respondTo = null),
                            (p.rowCount = 1),
                            (p.shouldClick = !0),
                            (p.$slider = i(e)),
                            (p.$slidesCache = null),
                            (p.transformType = null),
                            (p.transitionType = null),
                            (p.visibilityChange = "visibilitychange"),
                            (p.windowWidth = 0),
                            (p.windowTimer = null),
                            (e = i(e).data("slick") || {}),
                            (p.options = i.extend({}, p.defaults, r, e)),
                            (p.currentSlide = p.options.initialSlide),
                            (p.originalSettings = p.options),
                            document.mozHidden !== void 0
                                ? ((p.hidden = "mozHidden"), (p.visibilityChange = "mozvisibilitychange"))
                                : document.webkitHidden !== void 0 && ((p.hidden = "webkitHidden"), (p.visibilityChange = "webkitvisibilitychange")),
                            (p.autoPlay = i.proxy(p.autoPlay, p)),
                            (p.autoPlayClear = i.proxy(p.autoPlayClear, p)),
                            (p.autoPlayIterator = i.proxy(p.autoPlayIterator, p)),
                            (p.changeSlide = i.proxy(p.changeSlide, p)),
                            (p.clickHandler = i.proxy(p.clickHandler, p)),
                            (p.selectHandler = i.proxy(p.selectHandler, p)),
                            (p.setPosition = i.proxy(p.setPosition, p)),
                            (p.swipeHandler = i.proxy(p.swipeHandler, p)),
                            (p.dragHandler = i.proxy(p.dragHandler, p)),
                            (p.keyHandler = i.proxy(p.keyHandler, p)),
                            (p.instanceUid = h++),
                            (p.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                            p.registerBreakpoints(),
                            p.init(!0);
                    }).prototype.activateADA = function () {
                        this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
                    }),
                    (m.prototype.addSlide = m.prototype.slickAdd = function (e, r, p) {
                        var u = this;
                        if (typeof r == "boolean") (p = r), (r = null);
                        else if (r < 0 || r >= u.slideCount) return !1;
                        u.unload(),
                            typeof r == "number"
                                ? r === 0 && u.$slides.length === 0
                                    ? i(e).appendTo(u.$slideTrack)
                                    : p
                                    ? i(e).insertBefore(u.$slides.eq(r))
                                    : i(e).insertAfter(u.$slides.eq(r))
                                : p === !0
                                ? i(e).prependTo(u.$slideTrack)
                                : i(e).appendTo(u.$slideTrack),
                            (u.$slides = u.$slideTrack.children(this.options.slide)),
                            u.$slideTrack.children(this.options.slide).detach(),
                            u.$slideTrack.append(u.$slides),
                            u.$slides.each(function (D, j) {
                                i(j).attr("data-slick-index", D);
                            }),
                            (u.$slidesCache = u.$slides),
                            u.reinit();
                    }),
                    (m.prototype.animateHeight = function () {
                        var e,
                            r = this;
                        r.options.slidesToShow === 1 && r.options.adaptiveHeight === !0 && r.options.vertical === !1 && ((e = r.$slides.eq(r.currentSlide).outerHeight(!0)), r.$list.animate({ height: e }, r.options.speed));
                    }),
                    (m.prototype.animateSlide = function (e, r) {
                        var p = {},
                            u = this;
                        u.animateHeight(),
                            u.options.rtl === !0 && u.options.vertical === !1 && (e = -e),
                            u.transformsEnabled === !1
                                ? u.options.vertical === !1
                                    ? u.$slideTrack.animate({ left: e }, u.options.speed, u.options.easing, r)
                                    : u.$slideTrack.animate({ top: e }, u.options.speed, u.options.easing, r)
                                : u.cssTransitions === !1
                                ? (u.options.rtl === !0 && (u.currentLeft = -u.currentLeft),
                                  i({ animStart: u.currentLeft }).animate(
                                      { animStart: e },
                                      {
                                          duration: u.options.speed,
                                          easing: u.options.easing,
                                          step: function (D) {
                                              (D = Math.ceil(D)), u.options.vertical === !1 ? (p[u.animType] = "translate(" + D + "px, 0px)") : (p[u.animType] = "translate(0px," + D + "px)"), u.$slideTrack.css(p);
                                          },
                                          complete: function () {
                                              r && r.call();
                                          },
                                      }
                                  ))
                                : (u.applyTransition(),
                                  (e = Math.ceil(e)),
                                  u.options.vertical === !1 ? (p[u.animType] = "translate3d(" + e + "px, 0px, 0px)") : (p[u.animType] = "translate3d(0px," + e + "px, 0px)"),
                                  u.$slideTrack.css(p),
                                  r &&
                                      setTimeout(function () {
                                          u.disableTransition(), r.call();
                                      }, u.options.speed));
                    }),
                    (m.prototype.getNavTarget = function () {
                        var e = this.options.asNavFor;
                        return (e = e && e !== null ? i(e).not(this.$slider) : e);
                    }),
                    (m.prototype.asNavFor = function (e) {
                        var r = this.getNavTarget();
                        r !== null &&
                            _typeof(r) == "object" &&
                            r.each(function () {
                                var p = i(this).slick("getSlick");
                                p.unslicked || p.slideHandler(e, !0);
                            });
                    }),
                    (m.prototype.applyTransition = function (e) {
                        var r = this,
                            p = {};
                        r.options.fade === !1 ? (p[r.transitionType] = r.transformType + " " + r.options.speed + "ms " + r.options.cssEase) : (p[r.transitionType] = "opacity " + r.options.speed + "ms " + r.options.cssEase),
                            (r.options.fade === !1 ? r.$slideTrack : r.$slides.eq(e)).css(p);
                    }),
                    (m.prototype.autoPlay = function () {
                        var e = this;
                        e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed));
                    }),
                    (m.prototype.autoPlayClear = function () {
                        this.autoPlayTimer && clearInterval(this.autoPlayTimer);
                    }),
                    (m.prototype.autoPlayIterator = function () {
                        var e = this,
                            r = e.currentSlide + e.options.slidesToScroll;
                        e.paused ||
                            e.interrupted ||
                            e.focussed ||
                            (e.options.infinite === !1 &&
                                (e.direction === 1 && e.currentSlide + 1 === e.slideCount - 1 ? (e.direction = 0) : e.direction === 0 && ((r = e.currentSlide - e.options.slidesToScroll), e.currentSlide - 1 == 0 && (e.direction = 1))),
                            e.slideHandler(r));
                    }),
                    (m.prototype.buildArrows = function () {
                        var e = this;
                        e.options.arrows === !0 &&
                            ((e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow")),
                            (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")),
                            e.slideCount > e.options.slidesToShow
                                ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                                  e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                                  e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
                                  e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
                                  e.options.infinite !== !0 && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                                : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
                    }),
                    (m.prototype.buildDots = function () {
                        var e,
                            r,
                            p = this;
                        if (p.options.dots === !0 && p.slideCount > p.options.slidesToShow) {
                            for (p.$slider.addClass("slick-dotted"), r = i("<ul />").addClass(p.options.dotsClass), e = 0; e <= p.getDotCount(); e += 1) r.append(i("<li />").append(p.options.customPaging.call(this, p, e)));
                            (p.$dots = r.appendTo(p.options.appendDots)), p.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
                        }
                    }),
                    (m.prototype.buildOut = function () {
                        var e = this;
                        (e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                            (e.slideCount = e.$slides.length),
                            e.$slides.each(function (r, p) {
                                i(p)
                                    .attr("data-slick-index", r)
                                    .data("originalStyling", i(p).attr("style") || "");
                            }),
                            e.$slider.addClass("slick-slider"),
                            (e.$slideTrack =
                                e.slideCount === 0
                                    ? i('<div class="slick-track" aria-label="'.concat(theme.strings.imageSlider || "", '"/>')).appendTo(e.$slider)
                                    : e.$slides.wrapAll('<div class="slick-track" aria-label="'.concat(theme.strings.imageSlider || "", '"/>')).parent()),
                            (e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent()),
                            e.$slideTrack.css("opacity", 0),
                            (e.options.centerMode !== !0 && e.options.swipeToSlide !== !0) || (e.options.slidesToScroll = 1),
                            i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
                            e.setupInfinite(),
                            e.buildArrows(),
                            e.buildDots(),
                            e.updateDots(),
                            e.setSlideClasses(typeof e.currentSlide == "number" ? e.currentSlide : 0),
                            e.options.draggable === !0 && e.$list.addClass("draggable");
                    }),
                    (m.prototype.buildRows = function () {
                        var e,
                            r,
                            p,
                            u = this,
                            D = document.createDocumentFragment(),
                            j = u.$slider.children();
                        if (1 < u.options.rows) {
                            for (p = u.options.slidesPerRow * u.options.rows, r = Math.ceil(j.length / p), e = 0; e < r; e++) {
                                for (var A = document.createElement("div"), W = 0; W < u.options.rows; W++) {
                                    for (var F = document.createElement("div"), Q = 0; Q < u.options.slidesPerRow; Q++) {
                                        var J = e * p + (W * u.options.slidesPerRow + Q);
                                        j.get(J) && F.appendChild(j.get(J));
                                    }
                                    A.appendChild(F);
                                }
                                D.appendChild(A);
                            }
                            u.$slider.empty().append(D),
                                u.$slider
                                    .children()
                                    .children()
                                    .children()
                                    .css({ width: 100 / u.options.slidesPerRow + "%", display: "inline-block" });
                        }
                    }),
                    (m.prototype.checkResponsive = function (e, r) {
                        var p,
                            u,
                            D,
                            j = this,
                            A = !1,
                            W = j.$slider.width(),
                            F = window.innerWidth || i(window).width();
                        if ((j.respondTo === "window" ? (D = F) : j.respondTo === "slider" ? (D = W) : j.respondTo === "min" && (D = Math.min(F, W)), j.options.responsive && j.options.responsive.length && j.options.responsive !== null)) {
                            for (p in ((u = null), j.breakpoints)) j.breakpoints.hasOwnProperty(p) && (j.originalSettings.mobileFirst === !1 ? D < j.breakpoints[p] && (u = j.breakpoints[p]) : D > j.breakpoints[p] && (u = j.breakpoints[p]));
                            u !== null
                                ? (j.activeBreakpoint !== null && u === j.activeBreakpoint && !r) ||
                                  ((j.activeBreakpoint = u),
                                  j.breakpointSettings[u] === "unslick" ? j.unslick(u) : ((j.options = i.extend({}, j.originalSettings, j.breakpointSettings[u])), e === !0 && (j.currentSlide = j.options.initialSlide), j.refresh(e)),
                                  (A = u))
                                : j.activeBreakpoint !== null && ((j.activeBreakpoint = null), (j.options = j.originalSettings), e === !0 && (j.currentSlide = j.options.initialSlide), j.refresh(e), (A = u)),
                                e || A === !1 || j.$slider.trigger("breakpoint", [j, A]);
                        }
                    }),
                    (m.prototype.changeSlide = function (e, r) {
                        var p,
                            u = this,
                            D = i(e.currentTarget);
                        switch ((D.is("a") && e.preventDefault(), D.is("li") || (D = D.closest("li")), (p = u.slideCount % u.options.slidesToScroll != 0 ? 0 : (u.slideCount - u.currentSlide) % u.options.slidesToScroll), e.data.message)) {
                            case "previous":
                                (j = p == 0 ? u.options.slidesToScroll : u.options.slidesToShow - p), u.slideCount > u.options.slidesToShow && u.slideHandler(u.currentSlide - j, !1, r);
                                break;
                            case "next":
                                (j = p == 0 ? u.options.slidesToScroll : p), u.slideCount > u.options.slidesToShow && u.slideHandler(u.currentSlide + j, !1, r);
                                break;
                            case "index":
                                var j = e.data.index === 0 ? 0 : e.data.index || D.index() * u.options.slidesToScroll;
                                u.slideHandler(u.checkNavigable(j), !1, r), D.children().trigger("focus");
                                break;
                            default:
                                return;
                        }
                    }),
                    (m.prototype.checkNavigable = function (e) {
                        var r = this.getNavigableIndexes(),
                            p = 0;
                        if (e > r[r.length - 1]) e = r[r.length - 1];
                        else
                            for (var u in r) {
                                if (e < r[u]) {
                                    e = p;
                                    break;
                                }
                                p = r[u];
                            }
                        return e;
                    }),
                    (m.prototype.cleanUpEvents = function () {
                        var e = this;
                        e.options.dots && e.$dots !== null && i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
                            e.$slider.off("focus.slick blur.slick"),
                            e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
                            e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
                            e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
                            e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
                            e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
                            e.$list.off("click.slick", e.clickHandler),
                            i(document).off(e.visibilityChange, e.visibility),
                            e.cleanUpSlideEvents(),
                            e.options.accessibility === !0 && e.$list.off("keydown.slick", e.keyHandler),
                            e.options.focusOnSelect === !0 && i(e.$slideTrack).children().off("click.slick", e.selectHandler),
                            i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
                            i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
                            i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
                            i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition),
                            i(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition);
                    }),
                    (m.prototype.cleanUpSlideEvents = function () {
                        var e = this;
                        e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
                    }),
                    (m.prototype.cleanUpRows = function () {
                        var e;
                        1 < this.options.rows && ((e = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(e));
                    }),
                    (m.prototype.clickHandler = function (e) {
                        this.shouldClick === !1 && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault());
                    }),
                    (m.prototype.destroy = function (e) {
                        var r = this;
                        r.autoPlayClear(),
                            (r.touchObject = {}),
                            r.cleanUpEvents(),
                            i(".slick-cloned", r.$slider).detach(),
                            r.$dots && r.$dots.remove(),
                            r.$prevArrow &&
                                r.$prevArrow.length &&
                                (r.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), r.htmlExpr.test(r.options.prevArrow) && r.$prevArrow.remove()),
                            r.$nextArrow &&
                                r.$nextArrow.length &&
                                (r.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), r.htmlExpr.test(r.options.nextArrow) && r.$nextArrow.remove()),
                            r.$slides &&
                                (r.$slides
                                    .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                                    .removeAttr("aria-hidden")
                                    .removeAttr("data-slick-index")
                                    .each(function () {
                                        i(this).attr("style", i(this).data("originalStyling"));
                                    }),
                                r.$slideTrack.children(this.options.slide).detach(),
                                r.$slideTrack.detach(),
                                r.$list.detach(),
                                r.$slider.append(r.$slides)),
                            r.cleanUpRows(),
                            r.$slider.removeClass("slick-slider"),
                            r.$slider.removeClass("slick-initialized"),
                            r.$slider.removeClass("slick-dotted"),
                            (r.unslicked = !0),
                            e || r.$slider.trigger("destroy", [r]);
                    }),
                    (m.prototype.disableTransition = function (e) {
                        var r = {};
                        (r[this.transitionType] = ""), (this.options.fade === !1 ? this.$slideTrack : this.$slides.eq(e)).css(r);
                    }),
                    (m.prototype.fadeSlide = function (e, r) {
                        var p = this;
                        p.cssTransitions === !1
                            ? (p.$slides.eq(e).css({ zIndex: p.options.zIndex }), p.$slides.eq(e).animate({ opacity: 1 }, p.options.speed, p.options.easing, r))
                            : (p.applyTransition(e),
                              p.$slides.eq(e).css({ opacity: 1, zIndex: p.options.zIndex }),
                              r &&
                                  setTimeout(function () {
                                      p.disableTransition(e), r.call();
                                  }, p.options.speed));
                    }),
                    (m.prototype.fadeSlideOut = function (e) {
                        var r = this;
                        r.cssTransitions === !1
                            ? r.$slides.eq(e).animate({ opacity: 0, zIndex: r.options.zIndex - 2 }, r.options.speed, r.options.easing)
                            : (r.applyTransition(e), r.$slides.eq(e).css({ opacity: 0, zIndex: r.options.zIndex - 2 }));
                    }),
                    (m.prototype.filterSlides = m.prototype.slickFilter = function (e) {
                        var r = this;
                        e !== null && ((r.$slidesCache = r.$slides), r.unload(), r.$slideTrack.children(this.options.slide).detach(), r.$slidesCache.filter(e).appendTo(r.$slideTrack), r.reinit());
                    }),
                    (m.prototype.focusHandler = function () {
                        var e = this;
                        e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function (r) {
                            var p = i(this);
                            setTimeout(function () {
                                e.options.pauseOnFocus && ((e.focussed = p.is(":focus")), e.autoPlay());
                            }, 0);
                        });
                    }),
                    (m.prototype.getCurrent = m.prototype.slickCurrentSlide = function () {
                        return this.currentSlide;
                    }),
                    (m.prototype.getDotCount = function () {
                        var e = this,
                            r = 0,
                            p = 0,
                            u = 0;
                        if (e.options.infinite === !0) for (; r < e.slideCount; ) ++u, (r = p + e.options.slidesToScroll), (p += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                        else if (e.options.centerMode === !0) u = e.slideCount;
                        else if (e.options.asNavFor) for (; r < e.slideCount; ) ++u, (r = p + e.options.slidesToScroll), (p += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                        else u = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
                        return u - 1;
                    }),
                    (m.prototype.getLeft = function (e) {
                        var r,
                            p = this,
                            u = 0;
                        return (
                            (p.slideOffset = 0),
                            (r = p.$slides.first().outerHeight(!0)),
                            p.options.infinite === !0
                                ? (p.slideCount > p.options.slidesToShow && ((p.slideOffset = p.slideWidth * p.options.slidesToShow * -1), (u = r * p.options.slidesToShow * -1)),
                                  p.slideCount % p.options.slidesToScroll != 0 &&
                                      e + p.options.slidesToScroll > p.slideCount &&
                                      p.slideCount > p.options.slidesToShow &&
                                      (u =
                                          e > p.slideCount
                                              ? ((p.slideOffset = (p.options.slidesToShow - (e - p.slideCount)) * p.slideWidth * -1), (p.options.slidesToShow - (e - p.slideCount)) * r * -1)
                                              : ((p.slideOffset = (p.slideCount % p.options.slidesToScroll) * p.slideWidth * -1), (p.slideCount % p.options.slidesToScroll) * r * -1)))
                                : e + p.options.slidesToShow > p.slideCount && ((p.slideOffset = (e + p.options.slidesToShow - p.slideCount) * p.slideWidth), (u = (e + p.options.slidesToShow - p.slideCount) * r)),
                            p.slideCount <= p.options.slidesToShow && (u = p.slideOffset = 0),
                            p.options.centerMode === !0 && p.options.infinite === !0
                                ? (p.slideOffset += p.slideWidth * Math.floor(p.options.slidesToShow / 2) - p.slideWidth)
                                : p.options.centerMode === !0 && ((p.slideOffset = 0), (p.slideOffset += p.slideWidth * Math.floor(p.options.slidesToShow / 2))),
                            (r = p.options.vertical === !1 ? e * p.slideWidth * -1 + p.slideOffset : e * r * -1 + u),
                            p.options.variableWidth === !0 &&
                                ((u = p.slideCount <= p.options.slidesToShow || p.options.infinite === !1 ? p.$slideTrack.children(".slick-slide").eq(e) : p.$slideTrack.children(".slick-slide").eq(e + p.options.slidesToShow)),
                                (r = p.options.rtl === !0 ? (u[0] ? -1 * (p.$slideTrack.width() - u[0].offsetLeft - u.width()) : 0) : u[0] ? -1 * u[0].offsetLeft : 0),
                                p.options.centerMode === !0 &&
                                    ((u = p.slideCount <= p.options.slidesToShow || p.options.infinite === !1 ? p.$slideTrack.children(".slick-slide").eq(e) : p.$slideTrack.children(".slick-slide").eq(e + p.options.slidesToShow + 1)),
                                    (r = p.options.rtl === !0 ? (u[0] ? -1 * (p.$slideTrack.width() - u[0].offsetLeft - u.width()) : 0) : u[0] ? -1 * u[0].offsetLeft : 0),
                                    (r += (p.$list.width() - u.outerWidth()) / 2))),
                            r
                        );
                    }),
                    (m.prototype.getOption = m.prototype.slickGetOption = function (e) {
                        return this.options[e];
                    }),
                    (m.prototype.getNavigableIndexes = function () {
                        for (var e = this, r = 0, p = 0, u = [], D = e.options.infinite === !1 ? e.slideCount : ((r = -1 * e.options.slidesToScroll), (p = -1 * e.options.slidesToScroll), 2 * e.slideCount); r < D; )
                            u.push(r), (r = p + e.options.slidesToScroll), (p += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                        return u;
                    }),
                    (m.prototype.getSlick = function () {
                        return this;
                    }),
                    (m.prototype.getSlideCount = function () {
                        var e,
                            r = this,
                            p = r.options.centerMode === !0 ? r.slideWidth * Math.floor(r.options.slidesToShow / 2) : 0;
                        return r.options.swipeToSlide === !0
                            ? (r.$slideTrack.find(".slick-slide").each(function (u, D) {
                                  return D.offsetLeft - p + i(D).outerWidth() / 2 > -1 * r.swipeLeft ? ((e = D), !1) : void 0;
                              }),
                              Math.abs(i(e).attr("data-slick-index") - r.currentSlide) || 1)
                            : r.options.slidesToScroll;
                    }),
                    (m.prototype.goTo = m.prototype.slickGoTo = function (e, r) {
                        this.changeSlide({ data: { message: "index", index: parseInt(e) } }, r);
                    }),
                    (m.prototype.init = function (e) {
                        var r = this;
                        i(r.$slider).hasClass("slick-initialized") ||
                            (i(r.$slider).addClass("slick-initialized"),
                            r.buildRows(),
                            r.buildOut(),
                            r.setProps(),
                            r.startLoad(),
                            r.loadSlider(),
                            r.initializeEvents(),
                            r.updateArrows(),
                            r.updateDots(),
                            r.checkResponsive(!0),
                            r.focusHandler()),
                            e && r.$slider.trigger("init", [r]),
                            r.options.accessibility === !0 && r.initADA(),
                            r.options.autoplay && ((r.paused = !1), r.autoPlay());
                    }),
                    (m.prototype.initADA = function () {
                        var e = this;
                        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }),
                            e.$slideTrack.attr("role", "listbox"),
                            e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (r) {
                                i(this).attr({ role: "option" });
                            }),
                            e.$dots !== null &&
                                e.$dots
                                    .attr("aria-hidden", "true")
                                    .find("li")
                                    .each(function (r) {
                                        i(this).attr({ role: "presentation", "aria-selected": "false", "aria-controls": "navigation" + e.instanceUid + r, id: "slick-slide" + e.instanceUid + r });
                                    })
                                    .first()
                                    .attr("aria-selected", "true")
                                    .end()
                                    .find("button")
                                    .attr("role", "button")
                                    .end()
                                    .closest("div")
                                    .attr("role", "toolbar"),
                            e.activateADA();
                    }),
                    (m.prototype.initArrowEvents = function () {
                        var e = this;
                        e.options.arrows === !0 &&
                            e.slideCount > e.options.slidesToShow &&
                            (e.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, e.changeSlide));
                    }),
                    (m.prototype.initDotEvents = function () {
                        var e = this;
                        e.options.dots === !0 && e.slideCount > e.options.slidesToShow && i("li", e.$dots).on("click.slick", { message: "index" }, e.changeSlide),
                            e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
                    }),
                    (m.prototype.initSlideEvents = function () {
                        var e = this;
                        e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
                    }),
                    (m.prototype.initializeEvents = function () {
                        var e = this;
                        e.initArrowEvents(),
                            e.initDotEvents(),
                            e.initSlideEvents(),
                            e.$list.on("touchstart.slick mousedown.slick", { action: "start" }, e.swipeHandler),
                            e.$list.on("touchmove.slick mousemove.slick", { action: "move" }, e.swipeHandler),
                            e.$list.on("touchend.slick mouseup.slick", { action: "end" }, e.swipeHandler),
                            e.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, e.swipeHandler),
                            e.$list.on("click.slick", e.clickHandler),
                            i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
                            e.options.accessibility === !0 && e.$list.on("keydown.slick", e.keyHandler),
                            e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
                            i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)),
                            i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)),
                            i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
                            i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
                            i(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition);
                    }),
                    (m.prototype.initUI = function () {
                        var e = this;
                        e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), e.options.dots === !0 && e.slideCount > e.options.slidesToShow && e.$dots.show();
                    }),
                    (m.prototype.keyHandler = function (e) {
                        var r = this;
                        e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                            (e.keyCode === 37 && r.options.accessibility === !0
                                ? r.changeSlide({ data: { message: r.options.rtl === !0 ? "next" : "previous" } })
                                : e.keyCode === 39 && r.options.accessibility === !0 && r.changeSlide({ data: { message: r.options.rtl === !0 ? "previous" : "next" } }));
                    }),
                    (m.prototype.lazyLoad = function () {
                        function e(D) {
                            i("img[data-lazy]", D).each(function () {
                                var j = i(this),
                                    A = i(this).attr("data-lazy"),
                                    W = document.createElement("img");
                                (W.onload = function () {
                                    j.animate({ opacity: 0 }, 100, function () {
                                        j.attr("src", A).animate({ opacity: 1 }, 200, function () {
                                            j.removeAttr("data-lazy").removeClass("slick-loading");
                                        }),
                                            u.$slider.trigger("lazyLoaded", [u, j, A]);
                                    });
                                }),
                                    (W.onerror = function () {
                                        j.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), u.$slider.trigger("lazyLoadError", [u, j, A]);
                                    }),
                                    (W.src = A);
                            });
                        }
                        var r,
                            p,
                            u = this;
                        u.options.centerMode === !0
                            ? (p =
                                  u.options.infinite === !0
                                      ? (r = u.currentSlide + (u.options.slidesToShow / 2 + 1)) + u.options.slidesToShow + 2
                                      : ((r = Math.max(0, u.currentSlide - (u.options.slidesToShow / 2 + 1))), u.options.slidesToShow / 2 + 1 + 2 + u.currentSlide))
                            : ((r = u.options.infinite ? u.options.slidesToShow + u.currentSlide : u.currentSlide), (p = Math.ceil(r + u.options.slidesToShow)), u.options.fade === !0 && (0 < r && r--, p <= u.slideCount && p++)),
                            e(u.$slider.find(".slick-slide").slice(r, p)),
                            u.slideCount <= u.options.slidesToShow
                                ? e(u.$slider.find(".slick-slide"))
                                : u.currentSlide >= u.slideCount - u.options.slidesToShow
                                ? e(u.$slider.find(".slick-cloned").slice(0, u.options.slidesToShow))
                                : u.currentSlide === 0 && e(u.$slider.find(".slick-cloned").slice(-1 * u.options.slidesToShow));
                    }),
                    (m.prototype.loadSlider = function () {
                        var e = this;
                        e.setPosition(), e.$slideTrack.css({ opacity: 1 }), e.$slider.removeClass("slick-loading"), e.initUI(), e.options.lazyLoad === "progressive" && e.progressiveLazyLoad();
                    }),
                    (m.prototype.next = m.prototype.slickNext = function () {
                        this.changeSlide({ data: { message: "next" } });
                    }),
                    (m.prototype.orientationChange = function () {
                        this.checkResponsive(), this.setPosition();
                    }),
                    (m.prototype.pause = m.prototype.slickPause = function () {
                        this.autoPlayClear(), (this.paused = !0);
                    }),
                    (m.prototype.play = m.prototype.slickPlay = function () {
                        var e = this;
                        e.autoPlay(), (e.options.autoplay = !0), (e.paused = !1), (e.focussed = !1), (e.interrupted = !1);
                    }),
                    (m.prototype.postSlide = function (e) {
                        var r = this;
                        r.unslicked || (r.$slider.trigger("afterChange", [r, e]), (r.animating = !1), r.setPosition(), (r.swipeLeft = null), r.options.autoplay && r.autoPlay(), r.options.accessibility === !0 && r.initADA());
                    }),
                    (m.prototype.prev = m.prototype.slickPrev = function () {
                        this.changeSlide({ data: { message: "previous" } });
                    }),
                    (m.prototype.preventDefault = function (e) {
                        e.preventDefault();
                    }),
                    (m.prototype.progressiveLazyLoad = function (e) {
                        e = e || 1;
                        var r,
                            p,
                            u = this,
                            D = i("img[data-lazy]", u.$slider);
                        D.length
                            ? ((r = D.first()),
                              (p = r.attr("data-lazy")),
                              ((D = document.createElement("img")).onload = function () {
                                  r.attr("src", p).removeAttr("data-lazy").removeClass("slick-loading"), u.options.adaptiveHeight === !0 && u.setPosition(), u.$slider.trigger("lazyLoaded", [u, r, p]), u.progressiveLazyLoad();
                              }),
                              (D.onerror = function () {
                                  e < 3
                                      ? setTimeout(function () {
                                            u.progressiveLazyLoad(e + 1);
                                        }, 500)
                                      : (r.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), u.$slider.trigger("lazyLoadError", [u, r, p]), u.progressiveLazyLoad());
                              }),
                              (D.src = p))
                            : u.$slider.trigger("allImagesLoaded", [u]);
                    }),
                    (m.prototype.refresh = function (e) {
                        var r = this,
                            p = r.slideCount - r.options.slidesToShow;
                        !r.options.infinite && r.currentSlide > p && (r.currentSlide = p),
                            r.slideCount <= r.options.slidesToShow && (r.currentSlide = 0),
                            (p = r.currentSlide),
                            r.destroy(!0),
                            i.extend(r, r.initials, { currentSlide: p }),
                            r.init(),
                            e || r.changeSlide({ data: { message: "index", index: p } }, !1);
                    }),
                    (m.prototype.registerBreakpoints = function () {
                        var e,
                            r,
                            p,
                            u = this,
                            D = u.options.responsive || null;
                        if (i.type(D) === "array" && D.length) {
                            for (e in ((u.respondTo = u.options.respondTo || "window"), D))
                                if (((p = u.breakpoints.length - 1), (r = D[e].breakpoint), D.hasOwnProperty(e))) {
                                    for (; 0 <= p; ) u.breakpoints[p] && u.breakpoints[p] === r && u.breakpoints.splice(p, 1), p--;
                                    u.breakpoints.push(r), (u.breakpointSettings[r] = D[e].settings);
                                }
                            u.breakpoints.sort(function (j, A) {
                                return u.options.mobileFirst ? j - A : A - j;
                            });
                        }
                    }),
                    (m.prototype.reinit = function () {
                        var e = this;
                        (e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide")),
                            (e.slideCount = e.$slides.length),
                            e.currentSlide >= e.slideCount && e.currentSlide !== 0 && (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
                            e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
                            e.registerBreakpoints(),
                            e.setProps(),
                            e.setupInfinite(),
                            e.buildArrows(),
                            e.updateArrows(),
                            e.initArrowEvents(),
                            e.buildDots(),
                            e.updateDots(),
                            e.initDotEvents(),
                            e.cleanUpSlideEvents(),
                            e.initSlideEvents(),
                            e.checkResponsive(!1, !0),
                            e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
                            e.setSlideClasses(typeof e.currentSlide == "number" ? e.currentSlide : 0),
                            e.setPosition(),
                            e.focusHandler(),
                            (e.paused = !e.options.autoplay),
                            e.autoPlay(),
                            e.$slider.trigger("reInit", [e]);
                    }),
                    (m.prototype.resize = function () {
                        var e = this;
                        i(window).width() !== e.windowWidth &&
                            (clearTimeout(e.windowDelay),
                            (e.windowDelay = window.setTimeout(function () {
                                (e.windowWidth = i(window).width()), e.checkResponsive(), e.unslicked || e.setPosition();
                            }, 50)));
                    }),
                    (m.prototype.removeSlide = m.prototype.slickRemove = function (e, r, p) {
                        var u = this;
                        return (
                            (e = typeof e == "boolean" ? ((r = e) === !0 ? 0 : u.slideCount - 1) : r === !0 ? --e : e),
                            !(u.slideCount < 1 || e < 0 || e > u.slideCount - 1) &&
                                (u.unload(),
                                (p === !0 ? u.$slideTrack.children() : u.$slideTrack.children(this.options.slide).eq(e)).remove(),
                                (u.$slides = u.$slideTrack.children(this.options.slide)),
                                u.$slideTrack.children(this.options.slide).detach(),
                                u.$slideTrack.append(u.$slides),
                                (u.$slidesCache = u.$slides),
                                void u.reinit())
                        );
                    }),
                    (m.prototype.setCSS = function (e) {
                        var r,
                            p,
                            u = this,
                            D = {};
                        u.options.rtl === !0 && (e = -e),
                            (r = u.positionProp == "left" ? Math.ceil(e) + "px" : "0px"),
                            (p = u.positionProp == "top" ? Math.ceil(e) + "px" : "0px"),
                            (D[u.positionProp] = e),
                            u.transformsEnabled === !1 || (!(D = {}) === u.cssTransitions ? (D[u.animType] = "translate(" + r + ", " + p + ")") : (D[u.animType] = "translate3d(" + r + ", " + p + ", 0px)")),
                            u.$slideTrack.css(D);
                    }),
                    (m.prototype.setDimensions = function () {
                        var e = this;
                        e.options.vertical === !1
                            ? e.options.centerMode === !0 && e.$list.css({ padding: "0px " + e.options.centerPadding })
                            : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), e.options.centerMode === !0 && e.$list.css({ padding: e.options.centerPadding + " 0px" })),
                            (e.listWidth = e.$list.width()),
                            (e.listHeight = e.$list.height()),
                            e.options.vertical === !1 && e.options.variableWidth === !1
                                ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length)))
                                : e.options.variableWidth === !0
                                ? e.$slideTrack.width(5e3 * e.slideCount)
                                : ((e.slideWidth = Math.ceil(e.listWidth)), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
                        var r = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
                        e.options.variableWidth === !1 && e.$slideTrack.children(".slick-slide").width(e.slideWidth - r);
                    }),
                    (m.prototype.setFade = function () {
                        var e,
                            r = this;
                        r.$slides.each(function (p, u) {
                            (e = r.slideWidth * p * -1),
                                r.options.rtl === !0
                                    ? i(u).css({ position: "relative", right: e, top: 0, zIndex: r.options.zIndex - 2, opacity: 0 })
                                    : i(u).css({ position: "relative", left: e, top: 0, zIndex: r.options.zIndex - 2, opacity: 0 });
                        }),
                            r.$slides.eq(r.currentSlide).css({ zIndex: r.options.zIndex - 1, opacity: 1 });
                    }),
                    (m.prototype.setHeight = function () {
                        var e,
                            r = this;
                        r.options.slidesToShow === 1 && r.options.adaptiveHeight === !0 && r.options.vertical === !1 && ((e = r.$slides.eq(r.currentSlide).outerHeight(!0)), r.$list.css("height", e));
                    }),
                    (m.prototype.setOption = m.prototype.slickSetOption = function () {
                        var e,
                            r,
                            p,
                            u,
                            D,
                            j = this,
                            A = !1;
                        if (
                            (i.type(arguments[0]) === "object"
                                ? ((p = arguments[0]), (A = arguments[1]), (D = "multiple"))
                                : i.type(arguments[0]) === "string" &&
                                  ((p = arguments[0]), (u = arguments[1]), (A = arguments[2]), arguments[0] === "responsive" && i.type(arguments[1]) === "array" ? (D = "responsive") : arguments[1] !== void 0 && (D = "single")),
                            D === "single")
                        )
                            j.options[p] = u;
                        else if (D === "multiple")
                            i.each(p, function (W, F) {
                                j.options[W] = F;
                            });
                        else if (D === "responsive")
                            for (r in u)
                                if (i.type(j.options.responsive) !== "array") j.options.responsive = [u[r]];
                                else {
                                    for (e = j.options.responsive.length - 1; 0 <= e; ) j.options.responsive[e].breakpoint === u[r].breakpoint && j.options.responsive.splice(e, 1), e--;
                                    j.options.responsive.push(u[r]);
                                }
                        A && (j.unload(), j.reinit());
                    }),
                    (m.prototype.setPosition = function () {
                        var e = this;
                        e.setDimensions(), e.setHeight(), e.options.fade === !1 ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e]);
                    }),
                    (m.prototype.setProps = function () {
                        var e = this,
                            r = document.body.style;
                        (e.positionProp = e.options.vertical === !0 ? "top" : "left"),
                            e.positionProp === "top" ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
                            (r.WebkitTransition === void 0 && r.MozTransition === void 0 && r.msTransition === void 0) || e.options.useCSS !== !0 || (e.cssTransitions = !0),
                            e.options.fade && (typeof e.options.zIndex == "number" ? e.options.zIndex < 3 && (e.options.zIndex = 3) : (e.options.zIndex = e.defaults.zIndex)),
                            r.OTransform !== void 0 &&
                                ((e.animType = "OTransform"), (e.transformType = "-o-transform"), (e.transitionType = "OTransition"), r.perspectiveProperty === void 0 && r.webkitPerspective === void 0 && (e.animType = !1)),
                            r.MozTransform !== void 0 &&
                                ((e.animType = "MozTransform"), (e.transformType = "-moz-transform"), (e.transitionType = "MozTransition"), r.perspectiveProperty === void 0 && r.MozPerspective === void 0 && (e.animType = !1)),
                            r.webkitTransform !== void 0 &&
                                ((e.animType = "webkitTransform"), (e.transformType = "-webkit-transform"), (e.transitionType = "webkitTransition"), r.perspectiveProperty === void 0 && r.webkitPerspective === void 0 && (e.animType = !1)),
                            r.msTransform !== void 0 && ((e.animType = "msTransform"), (e.transformType = "-ms-transform"), (e.transitionType = "msTransition"), r.msTransform === void 0 && (e.animType = !1)),
                            r.transform !== void 0 && e.animType !== !1 && ((e.animType = "transform"), (e.transformType = "transform"), (e.transitionType = "transition")),
                            (e.transformsEnabled = e.options.useTransform && e.animType !== null && e.animType !== !1);
                    }),
                    (m.prototype.setSlideClasses = function (e) {
                        var r,
                            p,
                            u = this,
                            D = u.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true");
                        u.$slides.eq(e).addClass("slick-current"),
                            u.options.centerMode === !0
                                ? ((p = Math.floor(u.options.slidesToShow / 2)),
                                  u.options.infinite === !0 &&
                                      (p <= e && e <= u.slideCount - 1 - p
                                          ? u.$slides
                                                .slice(e - p, e + p + 1)
                                                .addClass("slick-active")
                                                .attr("aria-hidden", "false")
                                          : ((r = u.options.slidesToShow + e),
                                            D.slice(r - p + 1, r + p + 2)
                                                .addClass("slick-active")
                                                .attr("aria-hidden", "false")),
                                      e === 0 ? D.eq(D.length - 1 - u.options.slidesToShow).addClass("slick-center") : e === u.slideCount - 1 && D.eq(u.options.slidesToShow).addClass("slick-center")),
                                  u.$slides.eq(e).addClass("slick-center"))
                                : 0 <= e && e <= u.slideCount - u.options.slidesToShow
                                ? u.$slides
                                      .slice(e, e + u.options.slidesToShow)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")
                                : D.length <= u.options.slidesToShow
                                ? D.addClass("slick-active").attr("aria-hidden", "false")
                                : ((p = u.slideCount % u.options.slidesToShow),
                                  (r = u.options.infinite === !0 ? u.options.slidesToShow + e : e),
                                  (u.options.slidesToShow == u.options.slidesToScroll && u.slideCount - e < u.options.slidesToShow ? D.slice(r - (u.options.slidesToShow - p), r + p) : D.slice(r, r + u.options.slidesToShow))
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")),
                            u.options.lazyLoad === "ondemand" && u.lazyLoad();
                    }),
                    (m.prototype.setupInfinite = function () {
                        var e,
                            r,
                            p,
                            u = this;
                        if ((u.options.fade === !0 && (u.options.centerMode = !1), u.options.infinite === !0 && u.options.fade === !1 && ((r = null), u.slideCount > u.options.slidesToShow))) {
                            for (p = u.options.centerMode === !0 ? u.options.slidesToShow + 1 : u.options.slidesToShow, e = u.slideCount; e > u.slideCount - p; --e)
                                i(u.$slides[(r = e - 1)])
                                    .clone(!0)
                                    .attr("id", "")
                                    .attr("data-slick-index", r - u.slideCount)
                                    .prependTo(u.$slideTrack)
                                    .addClass("slick-cloned");
                            for (e = 0; e < p; e += 1)
                                i(u.$slides[(r = e)])
                                    .clone(!0)
                                    .attr("id", "")
                                    .attr("data-slick-index", r + u.slideCount)
                                    .appendTo(u.$slideTrack)
                                    .addClass("slick-cloned");
                            u.$slideTrack
                                .find(".slick-cloned")
                                .find("[id]")
                                .each(function () {
                                    i(this).attr("id", "");
                                });
                        }
                    }),
                    (m.prototype.interrupt = function (e) {
                        e || this.autoPlay(), (this.interrupted = e);
                    }),
                    (m.prototype.selectHandler = function (e) {
                        var r = this,
                            e = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
                            e = (e = parseInt(e.attr("data-slick-index"))) || 0;
                        return r.slideCount <= r.options.slidesToShow ? (r.setSlideClasses(e), void r.asNavFor(e)) : void r.slideHandler(e);
                    }),
                    (m.prototype.slideHandler = function (e, r, p) {
                        var u,
                            D,
                            j,
                            A = this;
                        return (
                            (r = r || !1),
                            (A.animating === !0 && A.options.waitForAnimate === !0) || (A.options.fade === !0 && A.currentSlide === e) || A.slideCount <= A.options.slidesToShow
                                ? void 0
                                : (r === !1 && A.asNavFor(e),
                                  (j = A.getLeft((u = e))),
                                  (r = A.getLeft(A.currentSlide)),
                                  (A.currentLeft = A.swipeLeft === null ? r : A.swipeLeft),
                                  (A.options.infinite === !1 && A.options.centerMode === !1 && (e < 0 || e > A.getDotCount() * A.options.slidesToScroll)) ||
                                  (A.options.infinite === !1 && A.options.centerMode === !0 && (e < 0 || e > A.slideCount - A.options.slidesToScroll))
                                      ? void (
                                            A.options.fade === !1 &&
                                            ((u = A.currentSlide),
                                            p !== !0
                                                ? A.animateSlide(r, function () {
                                                      A.postSlide(u);
                                                  })
                                                : A.postSlide(u))
                                        )
                                      : (A.options.autoplay && clearInterval(A.autoPlayTimer),
                                        (D =
                                            u < 0
                                                ? A.slideCount % A.options.slidesToScroll != 0
                                                    ? A.slideCount - (A.slideCount % A.options.slidesToScroll)
                                                    : A.slideCount + u
                                                : u >= A.slideCount
                                                ? A.slideCount % A.options.slidesToScroll != 0
                                                    ? 0
                                                    : u - A.slideCount
                                                : u),
                                        (A.animating = !0),
                                        A.$slider.trigger("beforeChange", [A, A.currentSlide, D]),
                                        (e = A.currentSlide),
                                        (A.currentSlide = D),
                                        A.setSlideClasses(A.currentSlide),
                                        A.options.asNavFor && (r = (r = A.getNavTarget()).slick("getSlick")).slideCount <= r.options.slidesToShow && r.setSlideClasses(A.currentSlide),
                                        A.updateDots(),
                                        A.updateArrows(),
                                        A.options.fade === !0
                                            ? (p !== !0
                                                  ? (A.fadeSlideOut(e),
                                                    A.fadeSlide(D, function () {
                                                        A.postSlide(D);
                                                    }))
                                                  : A.postSlide(D),
                                              void A.animateHeight())
                                            : void (p !== !0
                                                  ? A.animateSlide(j, function () {
                                                        A.postSlide(D);
                                                    })
                                                  : A.postSlide(D))))
                        );
                    }),
                    (m.prototype.startLoad = function () {
                        var e = this;
                        e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()),
                            e.options.dots === !0 && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
                            e.$slider.addClass("slick-loading");
                    }),
                    (m.prototype.swipeDirection = function () {
                        var e = this,
                            r = e.touchObject.startX - e.touchObject.curX,
                            p = e.touchObject.startY - e.touchObject.curY,
                            r = Math.atan2(p, r),
                            r = Math.round((180 * r) / Math.PI);
                        return ((r = r < 0 ? 360 - Math.abs(r) : r) <= 45 && 0 <= r) || (r <= 360 && 315 <= r)
                            ? e.options.rtl === !1
                                ? "left"
                                : "right"
                            : 135 <= r && r <= 225
                            ? e.options.rtl === !1
                                ? "right"
                                : "left"
                            : e.options.verticalSwiping === !0
                            ? 35 <= r && r <= 135
                                ? "down"
                                : "up"
                            : "vertical";
                    }),
                    (m.prototype.swipeEnd = function (e) {
                        var r,
                            p,
                            u = this;
                        if (((u.dragging = !1), (u.interrupted = !1), (u.shouldClick = !(10 < u.touchObject.swipeLength)), u.touchObject.curX === void 0)) return !1;
                        if ((u.touchObject.edgeHit === !0 && u.$slider.trigger("edge", [u, u.swipeDirection()]), u.touchObject.swipeLength >= u.touchObject.minSwipe)) {
                            switch ((p = u.swipeDirection())) {
                                case "left":
                                case "down":
                                    (r = u.options.swipeToSlide ? u.checkNavigable(u.currentSlide + u.getSlideCount()) : u.currentSlide + u.getSlideCount()), (u.currentDirection = 0);
                                    break;
                                case "right":
                                case "up":
                                    (r = u.options.swipeToSlide ? u.checkNavigable(u.currentSlide - u.getSlideCount()) : u.currentSlide - u.getSlideCount()), (u.currentDirection = 1);
                            }
                            p != "vertical" && (u.slideHandler(r), (u.touchObject = {}), u.$slider.trigger("swipe", [u, p]));
                        } else u.touchObject.startX !== u.touchObject.curX && (u.slideHandler(u.currentSlide), (u.touchObject = {}));
                    }),
                    (m.prototype.swipeHandler = function (e) {
                        var r = this;
                        if (!(r.options.swipe === !1 || ("ontouchend" in document && r.options.swipe === !1) || (r.options.draggable === !1 && e.type.indexOf("mouse") !== -1)))
                            switch (
                                ((r.touchObject.fingerCount = e.originalEvent && e.originalEvent.touches !== void 0 ? e.originalEvent.touches.length : 1),
                                (r.touchObject.minSwipe = r.listWidth / r.options.touchThreshold),
                                r.options.verticalSwiping === !0 && (r.touchObject.minSwipe = r.listHeight / r.options.touchThreshold),
                                e.data.action)
                            ) {
                                case "start":
                                    r.swipeStart(e);
                                    break;
                                case "move":
                                    r.swipeMove(e);
                                    break;
                                case "end":
                                    r.swipeEnd(e);
                            }
                    }),
                    (m.prototype.swipeMove = function (e) {
                        var r,
                            p,
                            u = this,
                            D = e.originalEvent !== void 0 ? e.originalEvent.touches : null;
                        return (
                            !(!u.dragging || (D && D.length !== 1)) &&
                            ((r = u.getLeft(u.currentSlide)),
                            (u.touchObject.curX = D !== void 0 ? D[0].pageX : e.clientX),
                            (u.touchObject.curY = D !== void 0 ? D[0].pageY : e.clientY),
                            (u.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(u.touchObject.curX - u.touchObject.startX, 2)))),
                            u.options.verticalSwiping === !0 && (u.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(u.touchObject.curY - u.touchObject.startY, 2)))),
                            (p = u.swipeDirection()) !== "vertical"
                                ? (e.originalEvent !== void 0 && 4 < u.touchObject.swipeLength && e.preventDefault(),
                                  (D = (u.options.rtl === !1 ? 1 : -1) * (u.touchObject.curX > u.touchObject.startX ? 1 : -1)),
                                  u.options.verticalSwiping === !0 && (D = u.touchObject.curY > u.touchObject.startY ? 1 : -1),
                                  (e = u.touchObject.swipeLength),
                                  (u.touchObject.edgeHit = !1) === u.options.infinite &&
                                      ((u.currentSlide === 0 && p === "right") || (u.currentSlide >= u.getDotCount() && p === "left")) &&
                                      ((e = u.touchObject.swipeLength * u.options.edgeFriction), (u.touchObject.edgeHit = !0)),
                                  u.options.vertical === !1 ? (u.swipeLeft = r + e * D) : (u.swipeLeft = r + e * (u.$list.height() / u.listWidth) * D),
                                  u.options.verticalSwiping === !0 && (u.swipeLeft = r + e * D),
                                  u.options.fade !== !0 && u.options.touchMove !== !1 && (u.animating === !0 ? ((u.swipeLeft = null), !1) : void u.setCSS(u.swipeLeft)))
                                : void 0)
                        );
                    }),
                    (m.prototype.swipeStart = function (e) {
                        var r,
                            p = this;
                        return (
                            (p.interrupted = !0),
                            p.touchObject.fingerCount !== 1 || p.slideCount <= p.options.slidesToShow
                                ? !(p.touchObject = {})
                                : (e.originalEvent !== void 0 && e.originalEvent.touches !== void 0 && (r = e.originalEvent.touches[0]),
                                  (p.touchObject.startX = p.touchObject.curX = r !== void 0 ? r.pageX : e.clientX),
                                  (p.touchObject.startY = p.touchObject.curY = r !== void 0 ? r.pageY : e.clientY),
                                  void (p.dragging = !0))
                        );
                    }),
                    (m.prototype.unfilterSlides = m.prototype.slickUnfilter = function () {
                        var e = this;
                        e.$slidesCache !== null && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit());
                    }),
                    (m.prototype.unload = function () {
                        var e = this;
                        i(".slick-cloned", e.$slider).remove(),
                            e.$dots && e.$dots.remove(),
                            e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
                            e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
                            e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
                    }),
                    (m.prototype.unslick = function (e) {
                        this.$slider.trigger("unslick", [this, e]), this.destroy();
                    }),
                    (m.prototype.updateArrows = function () {
                        var e = this;
                        Math.floor(e.options.slidesToShow / 2),
                            e.options.arrows === !0 &&
                                e.slideCount > e.options.slidesToShow &&
                                !e.options.infinite &&
                                (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                                e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                                e.currentSlide === 0
                                    ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                                    : ((e.currentSlide >= e.slideCount - e.options.slidesToShow && e.options.centerMode === !1) || (e.currentSlide >= e.slideCount - 1 && e.options.centerMode === !0)) &&
                                      (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
                    }),
                    (m.prototype.updateDots = function () {
                        var e = this;
                        e.$dots !== null &&
                            (e.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
                            e.$dots
                                .find("li")
                                .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
                                .addClass("slick-active")
                                .attr("aria-hidden", "false"));
                    }),
                    (m.prototype.visibility = function () {
                        this.options.autoplay && (document[this.hidden] ? (this.interrupted = !0) : (this.interrupted = !1));
                    }),
                    (i.fn.slick = function () {
                        for (var e, r = this, p = arguments[0], u = Array.prototype.slice.call(arguments, 1), D = r.length, j = 0; j < D; j++)
                            if ((_typeof(p) == "object" || p === void 0 ? (r[j].slick = new m(r[j], p)) : (e = r[j].slick[p].apply(r[j].slick, u)), e !== void 0)) return e;
                        return r;
                    });
            }),
            (jQuery.cookie = function (i, h, m) {
                if (h === void 0) {
                    var e = null;
                    if (document.cookie && document.cookie != "")
                        for (var r = document.cookie.split(";"), p = 0; p < r.length; p++) {
                            var u = jQuery.trim(r[p]);
                            if (u.substring(0, i.length + 1) == i + "=") {
                                e = decodeURIComponent(u.substring(i.length + 1));
                                break;
                            }
                        }
                    return e;
                }
                (m = m || {}), h === null && ((h = ""), (m.expires = -1));
                var D = "";
                m.expires &&
                    (typeof m.expires == "number" || m.expires.toUTCString) &&
                    (typeof m.expires == "number" ? (A = new Date()).setTime(A.getTime() + 24 * m.expires * 60 * 60 * 1e3) : (A = m.expires), (D = "; expires=" + A.toUTCString()));
                var j = m.path ? "; path=" + m.path : "",
                    A = m.domain ? "; domain=" + m.domain : "",
                    m = m.secure ? "; secure" : "";
                document.cookie = [i, "=", encodeURIComponent(h), D, j, A, m].join("");
            }),
            (window.Modernizr = (function (i, h, m) {
                function e(et) {
                    F.cssText = et;
                }
                function r(et, y) {
                    return _typeof(et) === y;
                }
                function p(et, y) {
                    for (var _ in et) if (((_ = et[_]), !~("" + _).indexOf("-") && F[_] !== m)) return y != "pfx" || _;
                    return !1;
                }
                function u(et, y, _) {
                    var v = et.charAt(0).toUpperCase() + et.slice(1),
                        d = (et + " " + wt.join(v + " ") + v).split(" ");
                    return r(y, "string") || r(y, "undefined")
                        ? p(d, y)
                        : (function (l, s, f) {
                              for (var b in l) {
                                  var k = s[l[b]];
                                  if (k !== m) return f === !1 ? l[b] : r(k, "function") ? k.bind(f || s) : k;
                              }
                              return !1;
                          })((d = (et + " " + zt.join(v + " ") + v).split(" ")), y, _);
                }
                var D,
                    j,
                    A = {},
                    W = h.documentElement,
                    F = h.createElement("modernizr").style,
                    Q = h.createElement("input"),
                    J = "Webkit Moz O ms",
                    wt = J.split(" "),
                    zt = J.toLowerCase().split(" "),
                    X = {},
                    tt = {},
                    it = [],
                    lt = it.slice,
                    ht = {}.hasOwnProperty,
                    _t =
                        r(ht, "undefined") || r(ht.call, "undefined")
                            ? function (et, y) {
                                  return y in et && r(et.constructor.prototype[y], "undefined");
                              }
                            : function (et, y) {
                                  return ht.call(et, y);
                              };
                for (j in (Function.prototype.bind ||
                    (Function.prototype.bind = function (et) {
                        var y = this;
                        if (typeof y != "function") throw new TypeError();
                        var _ = lt.call(arguments, 1);
                        return function v() {
                            if (this instanceof v) {
                                var d = function () {};
                                d.prototype = y.prototype;
                                var l = new d(),
                                    d = y.apply(l, _.concat(lt.call(arguments)));
                                return Object(d) === d ? d : l;
                            }
                            return y.apply(et, _.concat(lt.call(arguments)));
                        };
                    }),
                (X.csstransitions = function () {
                    return u("transition");
                }),
                X))
                    _t(X, j) && ((D = j.toLowerCase()), (A[D] = X[j]()), it.push((A[D] ? "" : "no-") + D));
                return (
                    A.input ||
                        (A.input = (function (et) {
                            for (var y = 0, _ = et.length; y < _; y++) tt[et[y]] = et[y] in Q;
                            return tt.list && (tt.list = !!h.createElement("datalist") && !!i.HTMLDataListElement), tt;
                        })("autocomplete autofocus list placeholder max min multiple pattern required step".split(" "))),
                    (A.addTest = function (et, y) {
                        if (_typeof(et) == "object") for (var _ in et) _t(et, _) && A.addTest(_, et[_]);
                        else {
                            if (((et = et.toLowerCase()), A[et] !== m)) return A;
                            (y = typeof y == "function" ? y() : y), typeof enableClasses != "undefined" && enableClasses && (W.className += " " + (y ? "" : "no-") + et), (A[et] = y);
                        }
                        return A;
                    }),
                    e(""),
                    (Q = null),
                    (A._version = "2.6.2"),
                    (A._domPrefixes = zt),
                    (A._cssomPrefixes = wt),
                    (A.testProp = function (et) {
                        return p([et]);
                    }),
                    (A.testAllProps = u),
                    A
                );
            })(this, this.document)),
            (Ze = this),
            (ue = document),
            (Be = ue.documentElement),
            ($n = Ze.setTimeout),
            (St = ue.getElementsByTagName("script")[0]),
            (yt = {}.toString),
            (xt = []),
            (Nn = 0),
            (Pe = "MozAppearance" in Be.style),
            (Yn = Pe && !!ue.createRange().compareNode),
            (fn = Yn ? Be : St.parentNode),
            (Be = Ze.opera && yt.call(Ze.opera) == "[object Opera]"),
            (Be = !!ue.attachEvent && !Be),
            (Jt = Pe ? "object" : Be ? "script" : "img"),
            (c = Be ? "script" : Jt),
            (Mn =
                Array.isArray ||
                function (i) {
                    return yt.call(i) == "[object Array]";
                }),
            (xe = []),
            (pe = {}),
            (Vn = {
                timeout: function (i, h) {
                    return h.length && (i.timeout = h[0]), i;
                },
            }),
            ((Qe = function (i) {
                function h(u, D, j, A, W) {
                    var F = (function (J) {
                            for (var wt, zt, J = J.split("!"), X = xe.length, tt = J.pop(), it = J.length, tt = { url: tt, origUrl: tt, prefixes: J }, lt = 0; lt < it; lt++)
                                (zt = J[lt].split("=")), (wt = Vn[zt.shift()]) && (tt = wt(tt, zt));
                            for (lt = 0; lt < X; lt++) tt = xe[lt](tt);
                            return tt;
                        })(u),
                        Q = F.autoCallback;
                    F.url.split(".").pop().split("?").shift(),
                        F.bypass ||
                            ((D = D && (Hn(D) ? D : D[u] || D[A] || D[u.split("/").pop().split("?")[0]])),
                            F.instead
                                ? F.instead(u, D, j, A, W)
                                : (pe[F.url] ? (F.noexec = !0) : (pe[F.url] = 1),
                                  j.load(F.url, F.forceCSS || (!F.forceJS && F.url.split(".").pop().split("?").shift() == "css") ? "c" : void 0, F.noexec, F.attrs, F.timeout),
                                  (Hn(D) || Hn(Q)) &&
                                      j.load(function () {
                                          ke(), D && D(F.origUrl, W, A), Q && Q(F.origUrl, W, A), (pe[F.url] = 2);
                                      })));
                }
                function m(u, D) {
                    function j(X, tt) {
                        if (X) {
                            if (Rn(X))
                                h(
                                    X,
                                    (J = tt
                                        ? J
                                        : function () {
                                              var it = [].slice.call(arguments);
                                              wt.apply(this, it), zt();
                                          }),
                                    D,
                                    0,
                                    F
                                );
                            else if (Object(X) === X)
                                for (W in ((A = (function () {
                                    var it,
                                        lt = 0;
                                    for (it in X) X.hasOwnProperty(it) && lt++;
                                    return lt;
                                })()),
                                X))
                                    X.hasOwnProperty(W) &&
                                        (tt ||
                                            --A ||
                                            (Hn(J)
                                                ? (J = function () {
                                                      var it = [].slice.call(arguments);
                                                      wt.apply(this, it), zt();
                                                  })
                                                : (J[W] = (function (it) {
                                                      return function () {
                                                          var lt = [].slice.call(arguments);
                                                          it && it.apply(this, lt), zt();
                                                      };
                                                  })(wt[W]))),
                                        h(X[W], J, D, W, F));
                        } else tt || zt();
                    }
                    var A,
                        W,
                        F = !!u.test,
                        Q = u.load || u.both,
                        J = u.callback || an,
                        wt = J,
                        zt = u.complete || an;
                    j(F ? u.yep : u.nope, !!Q), Q && j(Q);
                }
                var e,
                    r,
                    p = this.yepnope.loader;
                if (Rn(i)) h(i, 0, p, 0);
                else if (Mn(i)) for (e = 0; e < i.length; e++) Rn((r = i[e])) ? h(r, 0, p, 0) : Mn(r) ? Qe(r) : Object(r) === r && m(r, p);
                else Object(i) === i && m(i, p);
            }).addPrefix = function (i, h) {
                Vn[i] = h;
            }),
            (Qe.addFilter = function (i) {
                xe.push(i);
            }),
            (Qe.errorTimeout = 1e4),
            ue.readyState == null &&
                ue.addEventListener &&
                ((ue.readyState = "loading"),
                ue.addEventListener(
                    "DOMContentLoaded",
                    (ei = function () {
                        ue.removeEventListener("DOMContentLoaded", ei, 0), (ue.readyState = "complete");
                    }),
                    0
                )),
            (Ze.yepnope = ke()),
            (Ze.yepnope.executeStack = _n),
            (Ze.yepnope.injectJs = function (i, h, m, e, r, p) {
                var u,
                    D,
                    j = ue.createElement("script"),
                    e = e || Qe.errorTimeout;
                for (D in ((j.src = i), m)) j.setAttribute(D, m[D]);
                (h = p ? _n : h || an),
                    (j.onreadystatechange = j.onload = function () {
                        !u && An(j.readyState) && ((u = 1), h(), (j.onload = j.onreadystatechange = null));
                    }),
                    $n(function () {
                        u || h((u = 1));
                    }, e),
                    r ? j.onload() : St.parentNode.insertBefore(j, St);
            }),
            (Ze.yepnope.injectCss = function (i, h, m, e, r, p) {
                var u,
                    h = p ? _n : h || an;
                for (u in (((e = ue.createElement("link")).href = i), (e.rel = "stylesheet"), (e.type = "text/css"), m)) e.setAttribute(u, m[u]);
                r || (St.parentNode.insertBefore(e, St), $n(h, 0));
            }),
            (Modernizr.load = function () {
                yepnope.apply(window, [].slice.call(arguments, 0));
            }),
            (qn = mt.event),
            (In = window.innerWidth),
            (Qn = qn.special.debouncedresize = {
                setup: function () {
                    mt(this).on("resize", Qn.handler);
                },
                teardown: function () {
                    mt(this).off("resize", Qn.handler);
                },
                handler: function (i, h) {
                    function m() {
                        (i.type = "debouncedresize"), qn.dispatch.apply(e, r), In !== window.innerWidth && ((i.type = "debouncedresizewidth"), qn.dispatch.apply(e, r), (In = window.innerWidth));
                    }
                    var e = this,
                        r = arguments;
                    _e && clearTimeout(_e), h ? m() : (_e = setTimeout(m, Qn.threshold));
                },
                threshold: 150,
            }),
            (function () {
                for (
                    var i = [
                            {
                                base: "A",
                                letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F",
                            },
                            { base: "AA", letters: "\uA732" },
                            { base: "AE", letters: "\xC6\u01FC\u01E2" },
                            { base: "AO", letters: "\uA734" },
                            { base: "AU", letters: "\uA736" },
                            { base: "AV", letters: "\uA738\uA73A" },
                            { base: "AY", letters: "\uA73C" },
                            { base: "B", letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181" },
                            { base: "C", letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E" },
                            { base: "D", letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0" },
                            { base: "DZ", letters: "\u01F1\u01C4" },
                            { base: "Dz", letters: "\u01F2\u01C5" },
                            { base: "E", letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E" },
                            { base: "F", letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B" },
                            { base: "G", letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E" },
                            { base: "H", letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D" },
                            { base: "I", letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197" },
                            { base: "J", letters: "J\u24BF\uFF2A\u0134\u0248" },
                            { base: "K", letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2" },
                            { base: "L", letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780" },
                            { base: "LJ", letters: "\u01C7" },
                            { base: "Lj", letters: "\u01C8" },
                            { base: "M", letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C" },
                            { base: "N", letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4" },
                            { base: "NJ", letters: "\u01CA" },
                            { base: "Nj", letters: "\u01CB" },
                            {
                                base: "O",
                                letters:
                                    "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C",
                            },
                            { base: "OI", letters: "\u01A2" },
                            { base: "OO", letters: "\uA74E" },
                            { base: "OU", letters: "\u0222" },
                            { base: "OE", letters: "\x8C\u0152" },
                            { base: "oe", letters: "\x9C\u0153" },
                            { base: "P", letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754" },
                            { base: "Q", letters: "Q\u24C6\uFF31\uA756\uA758\u024A" },
                            { base: "R", letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782" },
                            { base: "S", letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784" },
                            { base: "T", letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786" },
                            { base: "TZ", letters: "\uA728" },
                            {
                                base: "U",
                                letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244",
                            },
                            { base: "V", letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245" },
                            { base: "VY", letters: "\uA760" },
                            { base: "W", letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72" },
                            { base: "X", letters: "X\u24CD\uFF38\u1E8A\u1E8C" },
                            { base: "Y", letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE" },
                            { base: "Z", letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762" },
                            {
                                base: "a",
                                letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250",
                            },
                            { base: "aa", letters: "\uA733" },
                            { base: "ae", letters: "\xE6\u01FD\u01E3" },
                            { base: "ao", letters: "\uA735" },
                            { base: "au", letters: "\uA737" },
                            { base: "av", letters: "\uA739\uA73B" },
                            { base: "ay", letters: "\uA73D" },
                            { base: "b", letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253" },
                            { base: "c", letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184" },
                            { base: "d", letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A" },
                            { base: "dz", letters: "\u01F3\u01C6" },
                            { base: "e", letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD" },
                            { base: "f", letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C" },
                            { base: "g", letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F" },
                            { base: "h", letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265" },
                            { base: "hv", letters: "\u0195" },
                            { base: "i", letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131" },
                            { base: "j", letters: "j\u24D9\uFF4A\u0135\u01F0\u0249" },
                            { base: "k", letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3" },
                            { base: "l", letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747" },
                            { base: "lj", letters: "\u01C9" },
                            { base: "m", letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F" },
                            { base: "n", letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5" },
                            { base: "nj", letters: "\u01CC" },
                            {
                                base: "o",
                                letters:
                                    "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275",
                            },
                            { base: "oi", letters: "\u01A3" },
                            { base: "ou", letters: "\u0223" },
                            { base: "oo", letters: "\uA74F" },
                            { base: "p", letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755" },
                            { base: "q", letters: "q\u24E0\uFF51\u024B\uA757\uA759" },
                            { base: "r", letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783" },
                            { base: "s", letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B" },
                            { base: "t", letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787" },
                            { base: "tz", letters: "\uA729" },
                            {
                                base: "u",
                                letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289",
                            },
                            { base: "v", letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C" },
                            { base: "vy", letters: "\uA761" },
                            { base: "w", letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73" },
                            { base: "x", letters: "x\u24E7\uFF58\u1E8B\u1E8D" },
                            { base: "y", letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF" },
                            { base: "z", letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763" },
                        ],
                        h = {},
                        m = 0;
                    m < i.length;
                    m++
                )
                    for (var e = i[m].letters, r = 0; r < e.length; r++) h[e[r]] = i[m].base;
                window.removeDiacritics = function (p) {
                    return typeof p != "string"
                        ? (console.warn("Invalid parameter passed to window.removeDiacritics (".concat(_typeof(p), ")"), p), p)
                        : p.replace(/[^\u0000-\u007E]/g, function (u) {
                              return h[u] || u;
                          });
                };
            })(),
            (ni = function (i) {
                var h,
                    m,
                    e,
                    r,
                    p,
                    u,
                    D,
                    j,
                    A,
                    W,
                    F,
                    Q,
                    J,
                    wt,
                    zt,
                    X,
                    X =
                        (((h = i && i.fn && i.fn.select2 && i.fn.select2.amd ? i.fn.select2.amd : h) && h.requirejs) ||
                            (h ? (e = h) : (h = {}),
                            (A = {}),
                            (W = {}),
                            (F = {}),
                            (Q = {}),
                            (J = Object.prototype.hasOwnProperty),
                            (wt = [].slice),
                            (zt = /\.js$/),
                            (D = function (y, _) {
                                var v,
                                    d,
                                    l = _t(y),
                                    s = l[0],
                                    _ = _[1];
                                return (
                                    (y = l[1]),
                                    s && (v = ht((s = it(s, _)))),
                                    s
                                        ? (y =
                                              v && v.normalize
                                                  ? v.normalize(
                                                        y,
                                                        ((d = _),
                                                        function (f) {
                                                            return it(f, d);
                                                        })
                                                    )
                                                  : it(y, _))
                                        : ((s = (l = _t((y = it(y, _))))[0]), (y = l[1]), s && (v = ht(s))),
                                    { f: s ? s + "!" + y : y, n: y, pr: s, p: v }
                                );
                            }),
                            (j = {
                                require: function (y) {
                                    return lt(y);
                                },
                                exports: function (y) {
                                    var _ = A[y];
                                    return _ !== void 0 ? _ : (A[y] = {});
                                },
                                module: function (y) {
                                    return {
                                        id: y,
                                        uri: "",
                                        exports: A[y],
                                        config:
                                            ((_ = y),
                                            function () {
                                                return (F && F.config && F.config[_]) || {};
                                            }),
                                    };
                                    var _;
                                },
                            }),
                            (p = function (y, _, v, d) {
                                var l,
                                    s,
                                    f,
                                    b,
                                    k,
                                    T = [],
                                    O = _typeof(v),
                                    L = et((d = d || y));
                                if (O == "undefined" || O == "function") {
                                    for (_ = !_.length && v.length ? ["require", "exports", "module"] : _, b = 0; b < _.length; b += 1)
                                        if ((s = (f = D(_[b], L)).f) === "require") T[b] = j.require(y);
                                        else if (s === "exports") (T[b] = j.exports(y)), (k = !0);
                                        else if (s === "module") l = T[b] = j.module(y);
                                        else if (tt(A, s) || tt(W, s) || tt(Q, s)) T[b] = ht(s);
                                        else {
                                            if (!f.p) throw new Error(y + " missing " + s);
                                            f.p.load(
                                                f.n,
                                                lt(d, !0),
                                                (function (I) {
                                                    return function (Z) {
                                                        A[I] = Z;
                                                    };
                                                })(s),
                                                {}
                                            ),
                                                (T[b] = A[s]);
                                        }
                                    (O = v ? v.apply(A[y], T) : void 0), y && (l && l.exports !== r && l.exports !== A[y] ? (A[y] = l.exports) : (O === r && k) || (A[y] = O));
                                } else y && (A[y] = v);
                            }),
                            (m = e = u = function (y, _, v, d, l) {
                                if (typeof y == "string") return j[y] ? j[y](_) : ht(D(y, et(_)).f);
                                if (!y.splice) {
                                    if (((F = y).deps && u(F.deps, F.callback), !_)) return;
                                    _.splice ? ((y = _), (_ = v), (v = null)) : (y = r);
                                }
                                return (
                                    (_ = _ || function () {}),
                                    typeof v == "function" && ((v = d), (d = l)),
                                    d
                                        ? p(r, y, _, v)
                                        : setTimeout(function () {
                                              p(r, y, _, v);
                                          }, 4),
                                    u
                                );
                            }),
                            (u.config = function (y) {
                                return u(y);
                            }),
                            (m._defined = A),
                            ((X = function (y, _, v) {
                                if (typeof y != "string") throw new Error("See almond README: incorrect module build, no module name");
                                _.splice || ((v = _), (_ = [])), tt(A, y) || tt(W, y) || (W[y] = [y, _, v]);
                            }).amd = { jQuery: !0 }),
                            (h.requirejs = m),
                            (h.require = e),
                            (h.define = X)),
                        h.define("almond", function () {}),
                        h.define("jquery", [], function () {
                            var y = i || mt;
                            return (
                                y == null && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."),
                                y
                            );
                        }),
                        h.define("select2/utils", ["jquery"], function (y) {
                            var _ = {};
                            function v(s) {
                                var f,
                                    b = s.prototype,
                                    k = [];
                                for (f in b) typeof b[f] == "function" && f !== "constructor" && k.push(f);
                                return k;
                            }
                            function d() {
                                this.listeners = {};
                            }
                            (_.Extend = function (s, f) {
                                var b,
                                    k = {}.hasOwnProperty;
                                function T() {
                                    this.constructor = s;
                                }
                                for (b in f) k.call(f, b) && (s[b] = f[b]);
                                return (T.prototype = f.prototype), (s.prototype = new T()), (s.__super__ = f.prototype), s;
                            }),
                                (_.Decorate = function (s, f) {
                                    var b = v(f),
                                        k = v(s);
                                    function T() {
                                        var Y = Array.prototype.unshift,
                                            at = f.prototype.constructor.length,
                                            ft = s.prototype.constructor;
                                        0 < at && (Y.call(arguments, s.prototype.constructor), (ft = f.prototype.constructor)), ft.apply(this, arguments);
                                    }
                                    (f.displayName = s.displayName),
                                        (T.prototype = new (function () {
                                            this.constructor = T;
                                        })());
                                    for (var O = 0; O < k.length; O++) {
                                        var L = k[O];
                                        T.prototype[L] = s.prototype[L];
                                    }
                                    for (var I = 0; I < b.length; I++) {
                                        var Z = b[I];
                                        T.prototype[Z] = (function (Y) {
                                            var at = function () {};
                                            Y in T.prototype && (at = T.prototype[Y]);
                                            var ft = f.prototype[Y];
                                            return function () {
                                                return Array.prototype.unshift.call(arguments, at), ft.apply(this, arguments);
                                            };
                                        })(Z);
                                    }
                                    return T;
                                }),
                                (d.prototype.on = function (s, f) {
                                    (this.listeners = this.listeners || {}), s in this.listeners ? this.listeners[s].push(f) : (this.listeners[s] = [f]);
                                }),
                                (d.prototype.trigger = function (s) {
                                    var f = Array.prototype.slice,
                                        b = f.call(arguments, 1);
                                    (this.listeners = this.listeners || {}),
                                        (b = b ?? []).length === 0 && b.push({}),
                                        (b[0]._type = s) in this.listeners && this.invoke(this.listeners[s], f.call(arguments, 1)),
                                        "*" in this.listeners && this.invoke(this.listeners["*"], arguments);
                                }),
                                (d.prototype.invoke = function (s, f) {
                                    for (var b = 0, k = s.length; b < k; b++) s[b].apply(this, f);
                                }),
                                (_.Observable = d),
                                (_.generateChars = function (s) {
                                    for (var f = "", b = 0; b < s; b++) f += Math.floor(36 * Math.random()).toString(36);
                                    return f;
                                }),
                                (_.bind = function (s, f) {
                                    return function () {
                                        s.apply(f, arguments);
                                    };
                                }),
                                (_._convertData = function (s) {
                                    for (var f in s) {
                                        var b = f.split("-"),
                                            k = s;
                                        if (b.length !== 1) {
                                            for (var T = 0; T < b.length; T++) {
                                                var O = b[T];
                                                (O = O.substring(0, 1).toLowerCase() + O.substring(1)) in k || (k[O] = {}), T == b.length - 1 && (k[O] = s[f]), (k = k[O]);
                                            }
                                            delete s[f];
                                        }
                                    }
                                    return s;
                                }),
                                (_.hasScroll = function (s, f) {
                                    var b = y(f),
                                        k = f.style.overflowX,
                                        T = f.style.overflowY;
                                    return (k !== T || (T !== "hidden" && T !== "visible")) && (k === "scroll" || T === "scroll" || b.innerHeight() < f.scrollHeight || b.innerWidth() < f.scrollWidth);
                                }),
                                (_.escapeMarkup = function (s) {
                                    var f = { "\\": "&#92;", "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#47;" };
                                    return typeof s != "string"
                                        ? s
                                        : String(s).replace(/[&<>"'\/\\]/g, function (b) {
                                              return f[b];
                                          });
                                }),
                                (_.appendMany = function (s, f) {
                                    var b;
                                    y.fn.jquery.substr(0, 3) === "1.7" &&
                                        ((b = y()),
                                        y.map(f, function (k) {
                                            b = b.add(k);
                                        }),
                                        (f = b)),
                                        s.append(f);
                                }),
                                (_.__cache = {});
                            var l = 0;
                            return (
                                (_.GetUniqueElementId = function (s) {
                                    var f = s.getAttribute("data-select2-id");
                                    return f == null && (s.id ? ((f = s.id), s.setAttribute("data-select2-id", f)) : (s.setAttribute("data-select2-id", ++l), (f = l.toString()))), f;
                                }),
                                (_.StoreData = function (s, f, b) {
                                    (s = _.GetUniqueElementId(s)), _.__cache[s] || (_.__cache[s] = {}), (_.__cache[s][f] = b);
                                }),
                                (_.GetData = function (s, f) {
                                    var b = _.GetUniqueElementId(s);
                                    return f ? (_.__cache[b] && _.__cache[b][f] != null ? _.__cache[b][f] : y(s).data(f)) : _.__cache[b];
                                }),
                                (_.RemoveData = function (s) {
                                    var f = _.GetUniqueElementId(s);
                                    _.__cache[f] != null && delete _.__cache[f], s.removeAttribute("data-select2-id");
                                }),
                                _
                            );
                        }),
                        h.define("select2/results", ["jquery", "./utils"], function (y, _) {
                            function v(d, l, s) {
                                (this.$element = d), (this.data = s), (this.options = l), v.__super__.constructor.call(this);
                            }
                            return (
                                _.Extend(v, _.Observable),
                                (v.prototype.render = function () {
                                    var d = y('<ul class="select2-results__options" role="listbox"></ul>');
                                    return this.options.get("multiple") && d.attr("aria-multiselectable", "true"), (this.$results = d);
                                }),
                                (v.prototype.clear = function () {
                                    this.$results.empty();
                                }),
                                (v.prototype.displayMessage = function (d) {
                                    var l = this.options.get("escapeMarkup");
                                    this.clear(), this.hideLoading();
                                    var s = y('<li role="alert" aria-live="assertive" class="select2-results__option"></li>'),
                                        f = this.options.get("translations").get(d.message);
                                    s.append(l(f(d.args))), (s[0].className += " select2-results__message"), this.$results.append(s);
                                }),
                                (v.prototype.hideMessages = function () {
                                    this.$results.find(".select2-results__message").remove();
                                }),
                                (v.prototype.append = function (d) {
                                    this.hideLoading();
                                    var l = [];
                                    if (d.results != null && d.results.length !== 0) {
                                        d.results = this.sort(d.results);
                                        for (var s = 0; s < d.results.length; s++) {
                                            var f = d.results[s],
                                                f = this.option(f);
                                            l.push(f);
                                        }
                                        this.$results.append(l);
                                    } else this.$results.children().length === 0 && this.trigger("results:message", { message: "noResults" });
                                }),
                                (v.prototype.position = function (d, l) {
                                    l.find(".select2-results").append(d);
                                }),
                                (v.prototype.sort = function (d) {
                                    return this.options.get("sorter")(d);
                                }),
                                (v.prototype.highlightFirstItem = function () {
                                    var d = this.$results.find(".select2-results__option[aria-selected]"),
                                        l = d.filter("[aria-selected=true]");
                                    (0 < l.length ? l : d).first().trigger("mouseenter"), this.ensureHighlightVisible();
                                }),
                                (v.prototype.setClasses = function () {
                                    var d = this;
                                    this.data.current(function (l) {
                                        var s = y.map(l, function (f) {
                                            return f.id.toString();
                                        });
                                        d.$results.find(".select2-results__option[aria-selected]").each(function () {
                                            var f = y(this),
                                                b = _.GetData(this, "data"),
                                                k = "" + b.id;
                                            (b.element != null && b.element.selected) || (b.element == null && -1 < y.inArray(k, s)) ? f.attr("aria-selected", "true") : f.attr("aria-selected", "false");
                                        });
                                    });
                                }),
                                (v.prototype.showLoading = function (d) {
                                    this.hideLoading(), (d = { disabled: !0, loading: !0, text: this.options.get("translations").get("searching")(d) }), (d = this.option(d)), (d.className += " loading-results"), this.$results.prepend(d);
                                }),
                                (v.prototype.hideLoading = function () {
                                    this.$results.find(".loading-results").remove();
                                }),
                                (v.prototype.option = function (d) {
                                    var l = document.createElement("li");
                                    l.className = "select2-results__option";
                                    var s,
                                        f = { role: "option", "aria-selected": "false" },
                                        b = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;
                                    for (s in (((d.element != null && b.call(d.element, ":disabled")) || (d.element == null && d.disabled)) && (delete f["aria-selected"], (f["aria-disabled"] = "true")),
                                    d.id == null && delete f["aria-selected"],
                                    d._resultId != null && (l.id = d._resultId),
                                    d.title && (l.title = d.title),
                                    d.children && ((f.role = "group"), (f["aria-label"] = d.text), delete f["aria-selected"]),
                                    f)) {
                                        var k = f[s];
                                        l.setAttribute(s, k);
                                    }
                                    if (d.children) {
                                        var T = y(l),
                                            O = document.createElement("strong");
                                        (O.className = "select2-results__group"), y(O), this.template(d, O);
                                        for (var L = [], I = 0; I < d.children.length; I++) {
                                            var Z = d.children[I],
                                                Z = this.option(Z);
                                            L.push(Z);
                                        }
                                        (b = y("<ul></ul>", { class: "select2-results__options select2-results__options--nested" })), b.append(L), T.append(O), T.append(b);
                                    } else this.template(d, l);
                                    return _.StoreData(l, "data", d), l;
                                }),
                                (v.prototype.bind = function (d, l) {
                                    var s = this,
                                        f = d.id + "-results";
                                    this.$results.attr("id", f),
                                        d.on("results:all", function (b) {
                                            s.clear(), s.append(b.data), d.isOpen() && (s.setClasses(), s.highlightFirstItem());
                                        }),
                                        d.on("results:append", function (b) {
                                            s.append(b.data), d.isOpen() && s.setClasses();
                                        }),
                                        d.on("query", function (b) {
                                            s.hideMessages(), s.showLoading(b);
                                        }),
                                        d.on("select", function () {
                                            d.isOpen() && (s.setClasses(), s.options.get("scrollAfterSelect") && s.highlightFirstItem());
                                        }),
                                        d.on("unselect", function () {
                                            d.isOpen() && (s.setClasses(), s.options.get("scrollAfterSelect") && s.highlightFirstItem());
                                        }),
                                        d.on("open", function () {
                                            s.$results.attr("aria-expanded", "true"), s.$results.attr("aria-hidden", "false"), s.setClasses(), s.ensureHighlightVisible();
                                        }),
                                        d.on("close", function () {
                                            s.$results.attr("aria-expanded", "false"), s.$results.attr("aria-hidden", "true"), s.$results.removeAttr("aria-activedescendant");
                                        }),
                                        d.on("results:toggle", function () {
                                            var b = s.getHighlightedResults();
                                            b.length !== 0 && b.trigger("mouseup");
                                        }),
                                        d.on("results:select", function () {
                                            var b,
                                                k = s.getHighlightedResults();
                                            k.length !== 0 && ((b = _.GetData(k[0], "data")), k.attr("aria-selected") == "true" ? s.trigger("close", {}) : s.trigger("select", { data: b }));
                                        }),
                                        d.on("results:previous", function () {
                                            var b,
                                                k = s.getHighlightedResults(),
                                                T = s.$results.find("[aria-selected]"),
                                                O = T.index(k);
                                            O <= 0 ||
                                                ((b = O - 1),
                                                k.length === 0 && (b = 0),
                                                (O = T.eq(b)).trigger("mouseenter"),
                                                (k = s.$results.offset().top),
                                                (T = O.offset().top),
                                                (O = s.$results.scrollTop() + (T - k)),
                                                b === 0 ? s.$results.scrollTop(0) : T - k < 0 && s.$results.scrollTop(O));
                                        }),
                                        d.on("results:next", function () {
                                            var b,
                                                k = s.getHighlightedResults(),
                                                T = s.$results.find("[aria-selected]"),
                                                O = T.index(k) + 1;
                                            O >= T.length ||
                                                ((b = T.eq(O)).trigger("mouseenter"),
                                                (k = s.$results.offset().top + s.$results.outerHeight(!1)),
                                                (T = b.offset().top + b.outerHeight(!1)),
                                                (b = s.$results.scrollTop() + T - k),
                                                O === 0 ? s.$results.scrollTop(0) : k < T && s.$results.scrollTop(b));
                                        }),
                                        d.on("results:focus", function (b) {
                                            b.element.addClass("select2-results__option--highlighted");
                                        }),
                                        d.on("results:message", function (b) {
                                            s.displayMessage(b);
                                        }),
                                        y.fn.mousewheel &&
                                            this.$results.on("mousewheel", function (b) {
                                                var k = s.$results.scrollTop(),
                                                    T = s.$results.get(0).scrollHeight - k + b.deltaY,
                                                    k = 0 < b.deltaY && k - b.deltaY <= 0,
                                                    T = b.deltaY < 0 && T <= s.$results.height();
                                                k
                                                    ? (s.$results.scrollTop(0), b.preventDefault(), b.stopPropagation())
                                                    : T && (s.$results.scrollTop(s.$results.get(0).scrollHeight - s.$results.height()), b.preventDefault(), b.stopPropagation());
                                            }),
                                        this.$results.on("mouseup", ".select2-results__option[aria-selected]", function (b) {
                                            var k = y(this),
                                                T = _.GetData(this, "data");
                                            k.attr("aria-selected") !== "true" ? s.trigger("select", { originalEvent: b, data: T }) : s.options.get("multiple") ? s.trigger("unselect", { originalEvent: b, data: T }) : s.trigger("close", {});
                                        }),
                                        this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function (b) {
                                            var k = _.GetData(this, "data");
                                            s.getHighlightedResults().removeClass("select2-results__option--highlighted"), s.trigger("results:focus", { data: k, element: y(this) });
                                        });
                                }),
                                (v.prototype.getHighlightedResults = function () {
                                    return this.$results.find(".select2-results__option--highlighted");
                                }),
                                (v.prototype.destroy = function () {
                                    this.$results.remove();
                                }),
                                (v.prototype.ensureHighlightVisible = function () {
                                    var d,
                                        l,
                                        s,
                                        f,
                                        b = this.getHighlightedResults();
                                    b.length !== 0 &&
                                        ((d = this.$results.find("[aria-selected]").index(b)),
                                        (f = this.$results.offset().top),
                                        (l = b.offset().top),
                                        (s = this.$results.scrollTop() + (l - f)),
                                        (f = l - f),
                                        (s -= 2 * b.outerHeight(!1)),
                                        d <= 2 ? this.$results.scrollTop(0) : (f > this.$results.outerHeight() || f < 0) && this.$results.scrollTop(s));
                                }),
                                (v.prototype.template = function (d, l) {
                                    var s = this.options.get("templateResult"),
                                        f = this.options.get("escapeMarkup"),
                                        d = s(d, l);
                                    d == null ? (l.style.display = "none") : typeof d == "string" ? (l.innerHTML = f(d)) : y(l).append(d);
                                }),
                                v
                            );
                        }),
                        h.define("select2/keys", [], function () {
                            return { BACKSPACE: 8, TAB: 9, ENTER: 13, SHIFT: 16, CTRL: 17, ALT: 18, ESC: 27, SPACE: 32, PAGE_UP: 33, PAGE_DOWN: 34, END: 35, HOME: 36, LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40, DELETE: 46 };
                        }),
                        h.define("select2/selection/base", ["jquery", "../utils", "../keys"], function (y, _, v) {
                            function d(l, s) {
                                (this.$element = l), (this.options = s), d.__super__.constructor.call(this);
                            }
                            return (
                                _.Extend(d, _.Observable),
                                (d.prototype.render = function () {
                                    var l = y('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
                                    return (
                                        (this._tabindex = 0),
                                        _.GetData(this.$element[0], "old-tabindex") != null
                                            ? (this._tabindex = _.GetData(this.$element[0], "old-tabindex"))
                                            : this.$element.attr("tabindex") != null && (this._tabindex = this.$element.attr("tabindex")),
                                        l.attr("title", this.$element.attr("title")),
                                        l.attr("tabindex", this._tabindex),
                                        l.attr("aria-disabled", "false"),
                                        (this.$selection = l)
                                    );
                                }),
                                (d.prototype.bind = function (l, s) {
                                    var f = this,
                                        b = l.id + "-results";
                                    (this.container = l),
                                        this.$selection.on("focus", function (k) {
                                            f.trigger("focus", k);
                                        }),
                                        this.$selection.on("blur", function (k) {
                                            f._handleBlur(k);
                                        }),
                                        this.$selection.on("keydown", function (k) {
                                            f.trigger("keypress", k), k.which === v.SPACE && k.preventDefault();
                                        }),
                                        l.on("results:focus", function (k) {
                                            f.$selection.attr("aria-activedescendant", k.data._resultId);
                                        }),
                                        l.on("selection:update", function (k) {
                                            f.update(k.data);
                                        }),
                                        l.on("open", function () {
                                            f.$selection.attr("aria-expanded", "true"), f.$selection.attr("aria-owns", b), f._attachCloseHandler(l);
                                        }),
                                        l.on("close", function () {
                                            f.$selection.attr("aria-expanded", "false"), f.$selection.removeAttr("aria-activedescendant"), f.$selection.removeAttr("aria-owns"), f.$selection.trigger("focus"), f._detachCloseHandler(l);
                                        }),
                                        l.on("enable", function () {
                                            f.$selection.attr("tabindex", f._tabindex), f.$selection.attr("aria-disabled", "false");
                                        }),
                                        l.on("disable", function () {
                                            f.$selection.attr("tabindex", "-1"), f.$selection.attr("aria-disabled", "true");
                                        });
                                }),
                                (d.prototype._handleBlur = function (l) {
                                    var s = this;
                                    window.setTimeout(function () {
                                        document.activeElement == s.$selection[0] || y.contains(s.$selection[0], document.activeElement) || s.trigger("blur", l);
                                    }, 1);
                                }),
                                (d.prototype._attachCloseHandler = function (l) {
                                    y(document.body).on("mousedown.select2." + l.id, function (s) {
                                        var f = y(s.target).closest(".select2");
                                        y(".select2.select2-container--open").each(function () {
                                            this != f[0] && _.GetData(this, "element").select2("close");
                                        });
                                    });
                                }),
                                (d.prototype._detachCloseHandler = function (l) {
                                    y(document.body).off("mousedown.select2." + l.id);
                                }),
                                (d.prototype.position = function (l, s) {
                                    s.find(".selection").append(l);
                                }),
                                (d.prototype.destroy = function () {
                                    this._detachCloseHandler(this.container);
                                }),
                                (d.prototype.update = function (l) {
                                    throw new Error("The `update` method must be defined in child classes.");
                                }),
                                d
                            );
                        }),
                        h.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function (y, _, v, d) {
                            function l() {
                                l.__super__.constructor.apply(this, arguments);
                            }
                            return (
                                v.Extend(l, _),
                                (l.prototype.render = function () {
                                    var s = l.__super__.render.call(this);
                                    return s.addClass("select2-selection--single"), s.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), s;
                                }),
                                (l.prototype.bind = function (s, f) {
                                    var b = this;
                                    l.__super__.bind.apply(this, arguments);
                                    var k = s.id + "-container";
                                    this.$selection.find(".select2-selection__rendered").attr("id", k).attr("role", "textbox").attr("aria-readonly", "true"),
                                        this.$selection.attr("aria-labelledby", k),
                                        this.$selection.on("mousedown", function (T) {
                                            T.which === 1 && b.trigger("toggle", { originalEvent: T });
                                        }),
                                        this.$selection.on("focus", function (T) {}),
                                        this.$selection.on("blur", function (T) {}),
                                        s.on("focus", function (T) {
                                            s.isOpen() || b.$selection.trigger("focus");
                                        });
                                }),
                                (l.prototype.clear = function () {
                                    var s = this.$selection.find(".select2-selection__rendered");
                                    s.empty(), s.removeAttr("title");
                                }),
                                (l.prototype.display = function (s, f) {
                                    var b = this.options.get("templateSelection");
                                    return this.options.get("escapeMarkup")(b(s, f));
                                }),
                                (l.prototype.selectionContainer = function () {
                                    return y("<span></span>");
                                }),
                                (l.prototype.update = function (s) {
                                    var f, b;
                                    s.length !== 0
                                        ? ((b = s[0]), (f = this.$selection.find(".select2-selection__rendered")), (s = this.display(b, f)), f.empty().append(s), (b = b.title || b.text) ? f.attr("title", b) : f.removeAttr("title"))
                                        : this.clear();
                                }),
                                l
                            );
                        }),
                        h.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function (y, _, v) {
                            function d(l, s) {
                                d.__super__.constructor.apply(this, arguments);
                            }
                            return (
                                v.Extend(d, _),
                                (d.prototype.render = function () {
                                    var l = d.__super__.render.call(this);
                                    return l.addClass("select2-selection--multiple"), l.html('<ul class="select2-selection__rendered"></ul>'), l;
                                }),
                                (d.prototype.bind = function (l, s) {
                                    var f = this;
                                    d.__super__.bind.apply(this, arguments),
                                        this.$selection.on("click", function (b) {
                                            f.trigger("toggle", { originalEvent: b });
                                        }),
                                        this.$selection.on("click", ".select2-selection__choice__remove", function (b) {
                                            var k;
                                            f.options.get("disabled") || ((k = y(this).parent()), (k = v.GetData(k[0], "data")), f.trigger("unselect", { originalEvent: b, data: k }));
                                        });
                                }),
                                (d.prototype.clear = function () {
                                    var l = this.$selection.find(".select2-selection__rendered");
                                    l.empty(), l.removeAttr("title");
                                }),
                                (d.prototype.display = function (l, s) {
                                    var f = this.options.get("templateSelection");
                                    return this.options.get("escapeMarkup")(f(l, s));
                                }),
                                (d.prototype.selectionContainer = function () {
                                    return y('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>');
                                }),
                                (d.prototype.update = function (l) {
                                    if ((this.clear(), l.length !== 0)) {
                                        for (var s = [], f = 0; f < l.length; f++) {
                                            var b = l[f],
                                                k = this.selectionContainer(),
                                                T = this.display(b, k);
                                            k.append(T), (T = b.title || b.text), T && k.attr("title", T), v.StoreData(k[0], "data", b), s.push(k);
                                        }
                                        var O = this.$selection.find(".select2-selection__rendered");
                                        v.appendMany(O, s);
                                    }
                                }),
                                d
                            );
                        }),
                        h.define("select2/selection/placeholder", ["../utils"], function (y) {
                            function _(v, d, l) {
                                (this.placeholder = this.normalizePlaceholder(l.get("placeholder"))), v.call(this, d, l);
                            }
                            return (
                                (_.prototype.normalizePlaceholder = function (v, d) {
                                    return (d = typeof d == "string" ? { id: "", text: d } : d);
                                }),
                                (_.prototype.createPlaceholder = function (v, d) {
                                    var l = this.selectionContainer();
                                    return l.html(this.display(d)), l.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), l;
                                }),
                                (_.prototype.update = function (v, d) {
                                    var l = d.length == 1 && d[0].id != this.placeholder.id;
                                    if (1 < d.length || l) return v.call(this, d);
                                    this.clear(), (d = this.createPlaceholder(this.placeholder)), this.$selection.find(".select2-selection__rendered").append(d);
                                }),
                                _
                            );
                        }),
                        h.define("select2/selection/allowClear", ["jquery", "../keys", "../utils"], function (y, _, v) {
                            function d() {}
                            return (
                                (d.prototype.bind = function (l, s, f) {
                                    var b = this;
                                    l.call(this, s, f),
                                        this.placeholder == null &&
                                            this.options.get("debug") &&
                                            window.console &&
                                            console.error &&
                                            console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."),
                                        this.$selection.on("mousedown", ".select2-selection__clear", function (k) {
                                            b._handleClear(k);
                                        }),
                                        s.on("keypress", function (k) {
                                            b._handleKeyboardClear(k, s);
                                        });
                                }),
                                (d.prototype._handleClear = function (l, s) {
                                    if (!this.options.get("disabled")) {
                                        var f = this.$selection.find(".select2-selection__clear");
                                        if (f.length !== 0) {
                                            s.stopPropagation();
                                            var b = v.GetData(f[0], "data"),
                                                k = this.$element.val();
                                            this.$element.val(this.placeholder.id);
                                            var T = { data: b };
                                            if ((this.trigger("clear", T), T.prevented)) this.$element.val(k);
                                            else {
                                                for (var O = 0; O < b.length; O++) if (((T = { data: b[O] }), this.trigger("unselect", T), T.prevented)) return void this.$element.val(k);
                                                this.$element.trigger("change"), this.trigger("toggle", {});
                                            }
                                        }
                                    }
                                }),
                                (d.prototype._handleKeyboardClear = function (l, s, f) {
                                    f.isOpen() || (s.which != _.DELETE && s.which != _.BACKSPACE) || this._handleClear(s);
                                }),
                                (d.prototype.update = function (l, s) {
                                    l.call(this, s),
                                        0 < this.$selection.find(".select2-selection__placeholder").length ||
                                            s.length === 0 ||
                                            ((l = this.options.get("translations").get("removeAllItems")),
                                            (l = y('<span class="select2-selection__clear" title="' + l() + '">&times;</span>')),
                                            v.StoreData(l[0], "data", s),
                                            this.$selection.find(".select2-selection__rendered").prepend(l));
                                }),
                                d
                            );
                        }),
                        h.define("select2/selection/search", ["jquery", "../utils", "../keys"], function (y, _, v) {
                            function d(l, s, f) {
                                l.call(this, s, f);
                            }
                            return (
                                (d.prototype.render = function (l) {
                                    var s = y(
                                        '<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>'
                                    );
                                    return (this.$searchContainer = s), (this.$search = s.find("input")), (l = l.call(this)), this._transferTabIndex(), l;
                                }),
                                (d.prototype.bind = function (l, s, f) {
                                    var b = this,
                                        k = s.id + "-results";
                                    l.call(this, s, f),
                                        s.on("open", function () {
                                            b.$search.attr("aria-controls", k), b.$search.trigger("focus");
                                        }),
                                        s.on("close", function () {
                                            b.$search.val(""), b.$search.removeAttr("aria-controls"), b.$search.removeAttr("aria-activedescendant"), b.$search.trigger("focus");
                                        }),
                                        s.on("enable", function () {
                                            b.$search.prop("disabled", !1), b._transferTabIndex();
                                        }),
                                        s.on("disable", function () {
                                            b.$search.prop("disabled", !0);
                                        }),
                                        s.on("focus", function (O) {
                                            b.$search.trigger("focus");
                                        }),
                                        s.on("results:focus", function (O) {
                                            O.data._resultId ? b.$search.attr("aria-activedescendant", O.data._resultId) : b.$search.removeAttr("aria-activedescendant");
                                        }),
                                        this.$selection.on("focusin", ".select2-search--inline", function (O) {
                                            b.trigger("focus", O);
                                        }),
                                        this.$selection.on("focusout", ".select2-search--inline", function (O) {
                                            b._handleBlur(O);
                                        }),
                                        this.$selection.on("keydown", ".select2-search--inline", function (O) {
                                            var L;
                                            O.stopPropagation(),
                                                b.trigger("keypress", O),
                                                (b._keyUpPrevented = O.isDefaultPrevented()),
                                                O.which === v.BACKSPACE &&
                                                    b.$search.val() === "" &&
                                                    0 < (L = b.$searchContainer.prev(".select2-selection__choice")).length &&
                                                    ((L = _.GetData(L[0], "data")), b.searchRemoveChoice(L), O.preventDefault());
                                        }),
                                        this.$selection.on("click", ".select2-search--inline", function (O) {
                                            b.$search.val() && O.stopPropagation();
                                        });
                                    var s = document.documentMode,
                                        T = s && s <= 11;
                                    this.$selection.on("input.searchcheck", ".select2-search--inline", function (O) {
                                        T ? b.$selection.off("input.search input.searchcheck") : b.$selection.off("keyup.search");
                                    }),
                                        this.$selection.on("keyup.search input.search", ".select2-search--inline", function (O) {
                                            var L;
                                            T && O.type === "input" ? b.$selection.off("input.search input.searchcheck") : (L = O.which) != v.SHIFT && L != v.CTRL && L != v.ALT && L != v.TAB && b.handleSearch(O);
                                        });
                                }),
                                (d.prototype._transferTabIndex = function (l) {
                                    this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1");
                                }),
                                (d.prototype.createPlaceholder = function (l, s) {
                                    this.$search.attr("placeholder", s.text);
                                }),
                                (d.prototype.update = function (l, s) {
                                    var f = this.$search[0] == document.activeElement;
                                    this.$search.attr("placeholder", ""), l.call(this, s), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), f && this.$search.trigger("focus");
                                }),
                                (d.prototype.handleSearch = function () {
                                    var l;
                                    this.resizeSearch(), this._keyUpPrevented || ((l = this.$search.val()), this.trigger("query", { term: l })), (this._keyUpPrevented = !1);
                                }),
                                (d.prototype.searchRemoveChoice = function (l, s) {
                                    this.trigger("unselect", { data: s }), this.$search.val(s.text), this.handleSearch();
                                }),
                                (d.prototype.resizeSearch = function () {
                                    this.$search.css("width", "25px");
                                    var l = "",
                                        l = this.$search.attr("placeholder") !== "" ? this.$selection.find(".select2-selection__rendered").width() : 0.75 * (this.$search.val().length + 1) + "em";
                                    this.$search.css("width", l);
                                }),
                                d
                            );
                        }),
                        h.define("select2/selection/eventRelay", ["jquery"], function (y) {
                            function _() {}
                            return (
                                (_.prototype.bind = function (v, d, l) {
                                    var s = this,
                                        f = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting", "clear", "clearing"],
                                        b = ["opening", "closing", "selecting", "unselecting", "clearing"];
                                    v.call(this, d, l),
                                        d.on("*", function (k, T) {
                                            var O;
                                            y.inArray(k, f) !== -1 && ((O = y.Event("select2:" + k, { params: (T = T || {}) })), s.$element.trigger(O), y.inArray(k, b) !== -1 && (T.prevented = O.isDefaultPrevented()));
                                        });
                                }),
                                _
                            );
                        }),
                        h.define("select2/translation", ["jquery", "require"], function (y, _) {
                            function v(d) {
                                this.dict = d || {};
                            }
                            return (
                                (v.prototype.all = function () {
                                    return this.dict;
                                }),
                                (v.prototype.get = function (d) {
                                    return this.dict[d];
                                }),
                                (v.prototype.extend = function (d) {
                                    this.dict = y.extend({}, d.all(), this.dict);
                                }),
                                (v._cache = {}),
                                (v.loadPath = function (d) {
                                    var l;
                                    return d in v._cache || ((l = _(d)), (v._cache[d] = l)), new v(v._cache[d]);
                                }),
                                v
                            );
                        }),
                        h.define("select2/diacritics", [], function () {
                            return {
                                "\u24B6": "A",
                                Ａ: "A",
                                À: "A",
                                Á: "A",
                                Â: "A",
                                Ầ: "A",
                                Ấ: "A",
                                Ẫ: "A",
                                Ẩ: "A",
                                Ã: "A",
                                Ā: "A",
                                Ă: "A",
                                Ằ: "A",
                                Ắ: "A",
                                Ẵ: "A",
                                Ẳ: "A",
                                Ȧ: "A",
                                Ǡ: "A",
                                Ä: "A",
                                Ǟ: "A",
                                Ả: "A",
                                Å: "A",
                                Ǻ: "A",
                                Ǎ: "A",
                                Ȁ: "A",
                                Ȃ: "A",
                                Ạ: "A",
                                Ậ: "A",
                                Ặ: "A",
                                Ḁ: "A",
                                Ą: "A",
                                Ⱥ: "A",
                                Ɐ: "A",
                                Ꜳ: "AA",
                                Æ: "AE",
                                Ǽ: "AE",
                                Ǣ: "AE",
                                Ꜵ: "AO",
                                Ꜷ: "AU",
                                Ꜹ: "AV",
                                Ꜻ: "AV",
                                Ꜽ: "AY",
                                "\u24B7": "B",
                                Ｂ: "B",
                                Ḃ: "B",
                                Ḅ: "B",
                                Ḇ: "B",
                                Ƀ: "B",
                                Ƃ: "B",
                                Ɓ: "B",
                                "\u24B8": "C",
                                Ｃ: "C",
                                Ć: "C",
                                Ĉ: "C",
                                Ċ: "C",
                                Č: "C",
                                Ç: "C",
                                Ḉ: "C",
                                Ƈ: "C",
                                Ȼ: "C",
                                Ꜿ: "C",
                                "\u24B9": "D",
                                Ｄ: "D",
                                Ḋ: "D",
                                Ď: "D",
                                Ḍ: "D",
                                Ḑ: "D",
                                Ḓ: "D",
                                Ḏ: "D",
                                Đ: "D",
                                Ƌ: "D",
                                Ɗ: "D",
                                Ɖ: "D",
                                Ꝺ: "D",
                                Ǳ: "DZ",
                                Ǆ: "DZ",
                                ǲ: "Dz",
                                ǅ: "Dz",
                                "\u24BA": "E",
                                Ｅ: "E",
                                È: "E",
                                É: "E",
                                Ê: "E",
                                Ề: "E",
                                Ế: "E",
                                Ễ: "E",
                                Ể: "E",
                                Ẽ: "E",
                                Ē: "E",
                                Ḕ: "E",
                                Ḗ: "E",
                                Ĕ: "E",
                                Ė: "E",
                                Ë: "E",
                                Ẻ: "E",
                                Ě: "E",
                                Ȅ: "E",
                                Ȇ: "E",
                                Ẹ: "E",
                                Ệ: "E",
                                Ȩ: "E",
                                Ḝ: "E",
                                Ę: "E",
                                Ḙ: "E",
                                Ḛ: "E",
                                Ɛ: "E",
                                Ǝ: "E",
                                "\u24BB": "F",
                                Ｆ: "F",
                                Ḟ: "F",
                                Ƒ: "F",
                                Ꝼ: "F",
                                "\u24BC": "G",
                                Ｇ: "G",
                                Ǵ: "G",
                                Ĝ: "G",
                                Ḡ: "G",
                                Ğ: "G",
                                Ġ: "G",
                                Ǧ: "G",
                                Ģ: "G",
                                Ǥ: "G",
                                Ɠ: "G",
                                Ꞡ: "G",
                                Ᵹ: "G",
                                Ꝿ: "G",
                                "\u24BD": "H",
                                Ｈ: "H",
                                Ĥ: "H",
                                Ḣ: "H",
                                Ḧ: "H",
                                Ȟ: "H",
                                Ḥ: "H",
                                Ḩ: "H",
                                Ḫ: "H",
                                Ħ: "H",
                                Ⱨ: "H",
                                Ⱶ: "H",
                                Ɥ: "H",
                                "\u24BE": "I",
                                Ｉ: "I",
                                Ì: "I",
                                Í: "I",
                                Î: "I",
                                Ĩ: "I",
                                Ī: "I",
                                Ĭ: "I",
                                İ: "I",
                                Ï: "I",
                                Ḯ: "I",
                                Ỉ: "I",
                                Ǐ: "I",
                                Ȉ: "I",
                                Ȋ: "I",
                                Ị: "I",
                                Į: "I",
                                Ḭ: "I",
                                Ɨ: "I",
                                "\u24BF": "J",
                                Ｊ: "J",
                                Ĵ: "J",
                                Ɉ: "J",
                                "\u24C0": "K",
                                Ｋ: "K",
                                Ḱ: "K",
                                Ǩ: "K",
                                Ḳ: "K",
                                Ķ: "K",
                                Ḵ: "K",
                                Ƙ: "K",
                                Ⱪ: "K",
                                Ꝁ: "K",
                                Ꝃ: "K",
                                Ꝅ: "K",
                                Ꞣ: "K",
                                "\u24C1": "L",
                                Ｌ: "L",
                                Ŀ: "L",
                                Ĺ: "L",
                                Ľ: "L",
                                Ḷ: "L",
                                Ḹ: "L",
                                Ļ: "L",
                                Ḽ: "L",
                                Ḻ: "L",
                                Ł: "L",
                                Ƚ: "L",
                                Ɫ: "L",
                                Ⱡ: "L",
                                Ꝉ: "L",
                                Ꝇ: "L",
                                Ꞁ: "L",
                                Ǉ: "LJ",
                                ǈ: "Lj",
                                "\u24C2": "M",
                                Ｍ: "M",
                                Ḿ: "M",
                                Ṁ: "M",
                                Ṃ: "M",
                                Ɱ: "M",
                                Ɯ: "M",
                                "\u24C3": "N",
                                Ｎ: "N",
                                Ǹ: "N",
                                Ń: "N",
                                Ñ: "N",
                                Ṅ: "N",
                                Ň: "N",
                                Ṇ: "N",
                                Ņ: "N",
                                Ṋ: "N",
                                Ṉ: "N",
                                Ƞ: "N",
                                Ɲ: "N",
                                Ꞑ: "N",
                                Ꞥ: "N",
                                Ǌ: "NJ",
                                ǋ: "Nj",
                                "\u24C4": "O",
                                Ｏ: "O",
                                Ò: "O",
                                Ó: "O",
                                Ô: "O",
                                Ồ: "O",
                                Ố: "O",
                                Ỗ: "O",
                                Ổ: "O",
                                Õ: "O",
                                Ṍ: "O",
                                Ȭ: "O",
                                Ṏ: "O",
                                Ō: "O",
                                Ṑ: "O",
                                Ṓ: "O",
                                Ŏ: "O",
                                Ȯ: "O",
                                Ȱ: "O",
                                Ö: "O",
                                Ȫ: "O",
                                Ỏ: "O",
                                Ő: "O",
                                Ǒ: "O",
                                Ȍ: "O",
                                Ȏ: "O",
                                Ơ: "O",
                                Ờ: "O",
                                Ớ: "O",
                                Ỡ: "O",
                                Ở: "O",
                                Ợ: "O",
                                Ọ: "O",
                                Ộ: "O",
                                Ǫ: "O",
                                Ǭ: "O",
                                Ø: "O",
                                Ǿ: "O",
                                Ɔ: "O",
                                Ɵ: "O",
                                Ꝋ: "O",
                                Ꝍ: "O",
                                Œ: "OE",
                                Ƣ: "OI",
                                Ꝏ: "OO",
                                Ȣ: "OU",
                                "\u24C5": "P",
                                Ｐ: "P",
                                Ṕ: "P",
                                Ṗ: "P",
                                Ƥ: "P",
                                Ᵽ: "P",
                                Ꝑ: "P",
                                Ꝓ: "P",
                                Ꝕ: "P",
                                "\u24C6": "Q",
                                Ｑ: "Q",
                                Ꝗ: "Q",
                                Ꝙ: "Q",
                                Ɋ: "Q",
                                "\u24C7": "R",
                                Ｒ: "R",
                                Ŕ: "R",
                                Ṙ: "R",
                                Ř: "R",
                                Ȑ: "R",
                                Ȓ: "R",
                                Ṛ: "R",
                                Ṝ: "R",
                                Ŗ: "R",
                                Ṟ: "R",
                                Ɍ: "R",
                                Ɽ: "R",
                                Ꝛ: "R",
                                Ꞧ: "R",
                                Ꞃ: "R",
                                "\u24C8": "S",
                                Ｓ: "S",
                                ẞ: "S",
                                Ś: "S",
                                Ṥ: "S",
                                Ŝ: "S",
                                Ṡ: "S",
                                Š: "S",
                                Ṧ: "S",
                                Ṣ: "S",
                                Ṩ: "S",
                                Ș: "S",
                                Ş: "S",
                                Ȿ: "S",
                                Ꞩ: "S",
                                Ꞅ: "S",
                                "\u24C9": "T",
                                Ｔ: "T",
                                Ṫ: "T",
                                Ť: "T",
                                Ṭ: "T",
                                Ț: "T",
                                Ţ: "T",
                                Ṱ: "T",
                                Ṯ: "T",
                                Ŧ: "T",
                                Ƭ: "T",
                                Ʈ: "T",
                                Ⱦ: "T",
                                Ꞇ: "T",
                                Ꜩ: "TZ",
                                "\u24CA": "U",
                                Ｕ: "U",
                                Ù: "U",
                                Ú: "U",
                                Û: "U",
                                Ũ: "U",
                                Ṹ: "U",
                                Ū: "U",
                                Ṻ: "U",
                                Ŭ: "U",
                                Ü: "U",
                                Ǜ: "U",
                                Ǘ: "U",
                                Ǖ: "U",
                                Ǚ: "U",
                                Ủ: "U",
                                Ů: "U",
                                Ű: "U",
                                Ǔ: "U",
                                Ȕ: "U",
                                Ȗ: "U",
                                Ư: "U",
                                Ừ: "U",
                                Ứ: "U",
                                Ữ: "U",
                                Ử: "U",
                                Ự: "U",
                                Ụ: "U",
                                Ṳ: "U",
                                Ų: "U",
                                Ṷ: "U",
                                Ṵ: "U",
                                Ʉ: "U",
                                "\u24CB": "V",
                                Ｖ: "V",
                                Ṽ: "V",
                                Ṿ: "V",
                                Ʋ: "V",
                                Ꝟ: "V",
                                Ʌ: "V",
                                Ꝡ: "VY",
                                "\u24CC": "W",
                                Ｗ: "W",
                                Ẁ: "W",
                                Ẃ: "W",
                                Ŵ: "W",
                                Ẇ: "W",
                                Ẅ: "W",
                                Ẉ: "W",
                                Ⱳ: "W",
                                "\u24CD": "X",
                                Ｘ: "X",
                                Ẋ: "X",
                                Ẍ: "X",
                                "\u24CE": "Y",
                                Ｙ: "Y",
                                Ỳ: "Y",
                                Ý: "Y",
                                Ŷ: "Y",
                                Ỹ: "Y",
                                Ȳ: "Y",
                                Ẏ: "Y",
                                Ÿ: "Y",
                                Ỷ: "Y",
                                Ỵ: "Y",
                                Ƴ: "Y",
                                Ɏ: "Y",
                                Ỿ: "Y",
                                "\u24CF": "Z",
                                Ｚ: "Z",
                                Ź: "Z",
                                Ẑ: "Z",
                                Ż: "Z",
                                Ž: "Z",
                                Ẓ: "Z",
                                Ẕ: "Z",
                                Ƶ: "Z",
                                Ȥ: "Z",
                                Ɀ: "Z",
                                Ⱬ: "Z",
                                Ꝣ: "Z",
                                "\u24D0": "a",
                                ａ: "a",
                                ẚ: "a",
                                à: "a",
                                á: "a",
                                â: "a",
                                ầ: "a",
                                ấ: "a",
                                ẫ: "a",
                                ẩ: "a",
                                ã: "a",
                                ā: "a",
                                ă: "a",
                                ằ: "a",
                                ắ: "a",
                                ẵ: "a",
                                ẳ: "a",
                                ȧ: "a",
                                ǡ: "a",
                                ä: "a",
                                ǟ: "a",
                                ả: "a",
                                å: "a",
                                ǻ: "a",
                                ǎ: "a",
                                ȁ: "a",
                                ȃ: "a",
                                ạ: "a",
                                ậ: "a",
                                ặ: "a",
                                ḁ: "a",
                                ą: "a",
                                ⱥ: "a",
                                ɐ: "a",
                                ꜳ: "aa",
                                æ: "ae",
                                ǽ: "ae",
                                ǣ: "ae",
                                ꜵ: "ao",
                                ꜷ: "au",
                                ꜹ: "av",
                                ꜻ: "av",
                                ꜽ: "ay",
                                "\u24D1": "b",
                                ｂ: "b",
                                ḃ: "b",
                                ḅ: "b",
                                ḇ: "b",
                                ƀ: "b",
                                ƃ: "b",
                                ɓ: "b",
                                "\u24D2": "c",
                                ｃ: "c",
                                ć: "c",
                                ĉ: "c",
                                ċ: "c",
                                č: "c",
                                ç: "c",
                                ḉ: "c",
                                ƈ: "c",
                                ȼ: "c",
                                ꜿ: "c",
                                ↄ: "c",
                                "\u24D3": "d",
                                ｄ: "d",
                                ḋ: "d",
                                ď: "d",
                                ḍ: "d",
                                ḑ: "d",
                                ḓ: "d",
                                ḏ: "d",
                                đ: "d",
                                ƌ: "d",
                                ɖ: "d",
                                ɗ: "d",
                                ꝺ: "d",
                                ǳ: "dz",
                                ǆ: "dz",
                                "\u24D4": "e",
                                ｅ: "e",
                                è: "e",
                                é: "e",
                                ê: "e",
                                ề: "e",
                                ế: "e",
                                ễ: "e",
                                ể: "e",
                                ẽ: "e",
                                ē: "e",
                                ḕ: "e",
                                ḗ: "e",
                                ĕ: "e",
                                ė: "e",
                                ë: "e",
                                ẻ: "e",
                                ě: "e",
                                ȅ: "e",
                                ȇ: "e",
                                ẹ: "e",
                                ệ: "e",
                                ȩ: "e",
                                ḝ: "e",
                                ę: "e",
                                ḙ: "e",
                                ḛ: "e",
                                ɇ: "e",
                                ɛ: "e",
                                ǝ: "e",
                                "\u24D5": "f",
                                ｆ: "f",
                                ḟ: "f",
                                ƒ: "f",
                                ꝼ: "f",
                                "\u24D6": "g",
                                ｇ: "g",
                                ǵ: "g",
                                ĝ: "g",
                                ḡ: "g",
                                ğ: "g",
                                ġ: "g",
                                ǧ: "g",
                                ģ: "g",
                                ǥ: "g",
                                ɠ: "g",
                                ꞡ: "g",
                                ᵹ: "g",
                                ꝿ: "g",
                                "\u24D7": "h",
                                ｈ: "h",
                                ĥ: "h",
                                ḣ: "h",
                                ḧ: "h",
                                ȟ: "h",
                                ḥ: "h",
                                ḩ: "h",
                                ḫ: "h",
                                ẖ: "h",
                                ħ: "h",
                                ⱨ: "h",
                                ⱶ: "h",
                                ɥ: "h",
                                ƕ: "hv",
                                "\u24D8": "i",
                                ｉ: "i",
                                ì: "i",
                                í: "i",
                                î: "i",
                                ĩ: "i",
                                ī: "i",
                                ĭ: "i",
                                ï: "i",
                                ḯ: "i",
                                ỉ: "i",
                                ǐ: "i",
                                ȉ: "i",
                                ȋ: "i",
                                ị: "i",
                                į: "i",
                                ḭ: "i",
                                ɨ: "i",
                                ı: "i",
                                "\u24D9": "j",
                                ｊ: "j",
                                ĵ: "j",
                                ǰ: "j",
                                ɉ: "j",
                                "\u24DA": "k",
                                ｋ: "k",
                                ḱ: "k",
                                ǩ: "k",
                                ḳ: "k",
                                ķ: "k",
                                ḵ: "k",
                                ƙ: "k",
                                ⱪ: "k",
                                ꝁ: "k",
                                ꝃ: "k",
                                ꝅ: "k",
                                ꞣ: "k",
                                "\u24DB": "l",
                                ｌ: "l",
                                ŀ: "l",
                                ĺ: "l",
                                ľ: "l",
                                ḷ: "l",
                                ḹ: "l",
                                ļ: "l",
                                ḽ: "l",
                                ḻ: "l",
                                ſ: "l",
                                ł: "l",
                                ƚ: "l",
                                ɫ: "l",
                                ⱡ: "l",
                                ꝉ: "l",
                                ꞁ: "l",
                                ꝇ: "l",
                                ǉ: "lj",
                                "\u24DC": "m",
                                ｍ: "m",
                                ḿ: "m",
                                ṁ: "m",
                                ṃ: "m",
                                ɱ: "m",
                                ɯ: "m",
                                "\u24DD": "n",
                                ｎ: "n",
                                ǹ: "n",
                                ń: "n",
                                ñ: "n",
                                ṅ: "n",
                                ň: "n",
                                ṇ: "n",
                                ņ: "n",
                                ṋ: "n",
                                ṉ: "n",
                                ƞ: "n",
                                ɲ: "n",
                                ŉ: "n",
                                ꞑ: "n",
                                ꞥ: "n",
                                ǌ: "nj",
                                "\u24DE": "o",
                                ｏ: "o",
                                ò: "o",
                                ó: "o",
                                ô: "o",
                                ồ: "o",
                                ố: "o",
                                ỗ: "o",
                                ổ: "o",
                                õ: "o",
                                ṍ: "o",
                                ȭ: "o",
                                ṏ: "o",
                                ō: "o",
                                ṑ: "o",
                                ṓ: "o",
                                ŏ: "o",
                                ȯ: "o",
                                ȱ: "o",
                                ö: "o",
                                ȫ: "o",
                                ỏ: "o",
                                ő: "o",
                                ǒ: "o",
                                ȍ: "o",
                                ȏ: "o",
                                ơ: "o",
                                ờ: "o",
                                ớ: "o",
                                ỡ: "o",
                                ở: "o",
                                ợ: "o",
                                ọ: "o",
                                ộ: "o",
                                ǫ: "o",
                                ǭ: "o",
                                ø: "o",
                                ǿ: "o",
                                ɔ: "o",
                                ꝋ: "o",
                                ꝍ: "o",
                                ɵ: "o",
                                œ: "oe",
                                ƣ: "oi",
                                ȣ: "ou",
                                ꝏ: "oo",
                                "\u24DF": "p",
                                ｐ: "p",
                                ṕ: "p",
                                ṗ: "p",
                                ƥ: "p",
                                ᵽ: "p",
                                ꝑ: "p",
                                ꝓ: "p",
                                ꝕ: "p",
                                "\u24E0": "q",
                                ｑ: "q",
                                ɋ: "q",
                                ꝗ: "q",
                                ꝙ: "q",
                                "\u24E1": "r",
                                ｒ: "r",
                                ŕ: "r",
                                ṙ: "r",
                                ř: "r",
                                ȑ: "r",
                                ȓ: "r",
                                ṛ: "r",
                                ṝ: "r",
                                ŗ: "r",
                                ṟ: "r",
                                ɍ: "r",
                                ɽ: "r",
                                ꝛ: "r",
                                ꞧ: "r",
                                ꞃ: "r",
                                "\u24E2": "s",
                                ｓ: "s",
                                ß: "s",
                                ś: "s",
                                ṥ: "s",
                                ŝ: "s",
                                ṡ: "s",
                                š: "s",
                                ṧ: "s",
                                ṣ: "s",
                                ṩ: "s",
                                ș: "s",
                                ş: "s",
                                ȿ: "s",
                                ꞩ: "s",
                                ꞅ: "s",
                                ẛ: "s",
                                "\u24E3": "t",
                                ｔ: "t",
                                ṫ: "t",
                                ẗ: "t",
                                ť: "t",
                                ṭ: "t",
                                ț: "t",
                                ţ: "t",
                                ṱ: "t",
                                ṯ: "t",
                                ŧ: "t",
                                ƭ: "t",
                                ʈ: "t",
                                ⱦ: "t",
                                ꞇ: "t",
                                ꜩ: "tz",
                                "\u24E4": "u",
                                ｕ: "u",
                                ù: "u",
                                ú: "u",
                                û: "u",
                                ũ: "u",
                                ṹ: "u",
                                ū: "u",
                                ṻ: "u",
                                ŭ: "u",
                                ü: "u",
                                ǜ: "u",
                                ǘ: "u",
                                ǖ: "u",
                                ǚ: "u",
                                ủ: "u",
                                ů: "u",
                                ű: "u",
                                ǔ: "u",
                                ȕ: "u",
                                ȗ: "u",
                                ư: "u",
                                ừ: "u",
                                ứ: "u",
                                ữ: "u",
                                ử: "u",
                                ự: "u",
                                ụ: "u",
                                ṳ: "u",
                                ų: "u",
                                ṷ: "u",
                                ṵ: "u",
                                ʉ: "u",
                                "\u24E5": "v",
                                ｖ: "v",
                                ṽ: "v",
                                ṿ: "v",
                                ʋ: "v",
                                ꝟ: "v",
                                ʌ: "v",
                                ꝡ: "vy",
                                "\u24E6": "w",
                                ｗ: "w",
                                ẁ: "w",
                                ẃ: "w",
                                ŵ: "w",
                                ẇ: "w",
                                ẅ: "w",
                                ẘ: "w",
                                ẉ: "w",
                                ⱳ: "w",
                                "\u24E7": "x",
                                ｘ: "x",
                                ẋ: "x",
                                ẍ: "x",
                                "\u24E8": "y",
                                ｙ: "y",
                                ỳ: "y",
                                ý: "y",
                                ŷ: "y",
                                ỹ: "y",
                                ȳ: "y",
                                ẏ: "y",
                                ÿ: "y",
                                ỷ: "y",
                                ẙ: "y",
                                ỵ: "y",
                                ƴ: "y",
                                ɏ: "y",
                                ỿ: "y",
                                "\u24E9": "z",
                                ｚ: "z",
                                ź: "z",
                                ẑ: "z",
                                ż: "z",
                                ž: "z",
                                ẓ: "z",
                                ẕ: "z",
                                ƶ: "z",
                                ȥ: "z",
                                ɀ: "z",
                                ⱬ: "z",
                                ꝣ: "z",
                                Ά: "\u0391",
                                Έ: "\u0395",
                                Ή: "\u0397",
                                Ί: "\u0399",
                                Ϊ: "\u0399",
                                Ό: "\u039F",
                                Ύ: "\u03A5",
                                Ϋ: "\u03A5",
                                Ώ: "\u03A9",
                                ά: "\u03B1",
                                έ: "\u03B5",
                                ή: "\u03B7",
                                ί: "\u03B9",
                                ϊ: "\u03B9",
                                ΐ: "\u03B9",
                                ό: "\u03BF",
                                ύ: "\u03C5",
                                ϋ: "\u03C5",
                                ΰ: "\u03C5",
                                ώ: "\u03C9",
                                ς: "\u03C3",
                                "\u2019": "'",
                            };
                        }),
                        h.define("select2/data/base", ["../utils"], function (y) {
                            function _(v, d) {
                                _.__super__.constructor.call(this);
                            }
                            return (
                                y.Extend(_, y.Observable),
                                (_.prototype.current = function (v) {
                                    throw new Error("The `current` method must be defined in child classes.");
                                }),
                                (_.prototype.query = function (v, d) {
                                    throw new Error("The `query` method must be defined in child classes.");
                                }),
                                (_.prototype.bind = function (v, d) {}),
                                (_.prototype.destroy = function () {}),
                                (_.prototype.generateResultId = function (v, d) {
                                    return (v = v.id + "-result-"), (v += y.generateChars(4)), d.id != null ? (v += "-" + d.id.toString()) : (v += "-" + y.generateChars(4)), v;
                                }),
                                _
                            );
                        }),
                        h.define("select2/data/select", ["./base", "../utils", "jquery"], function (y, _, v) {
                            function d(l, s) {
                                (this.$element = l), (this.options = s), d.__super__.constructor.call(this);
                            }
                            return (
                                _.Extend(d, y),
                                (d.prototype.current = function (l) {
                                    var s = [],
                                        f = this;
                                    this.$element.find(":selected").each(function () {
                                        var b = v(this),
                                            b = f.item(b);
                                        s.push(b);
                                    }),
                                        l(s);
                                }),
                                (d.prototype.select = function (l) {
                                    var s,
                                        f = this;
                                    if (((l.selected = !0), v(l.element).is("option"))) return (l.element.selected = !0), void this.$element.trigger("change");
                                    this.$element.prop("multiple")
                                        ? this.current(function (b) {
                                              var k = [];
                                              (l = [l]).push.apply(l, b);
                                              for (var T = 0; T < l.length; T++) {
                                                  var O = l[T].id;
                                                  v.inArray(O, k) === -1 && k.push(O);
                                              }
                                              f.$element.val(k), f.$element.trigger("change");
                                          })
                                        : ((s = l.id), this.$element.val(s), this.$element.trigger("change"));
                                }),
                                (d.prototype.unselect = function (l) {
                                    var s = this;
                                    if (this.$element.prop("multiple")) {
                                        if (((l.selected = !1), v(l.element).is("option"))) return (l.element.selected = !1), void this.$element.trigger("change");
                                        this.current(function (f) {
                                            for (var b = [], k = 0; k < f.length; k++) {
                                                var T = f[k].id;
                                                T !== l.id && v.inArray(T, b) === -1 && b.push(T);
                                            }
                                            s.$element.val(b), s.$element.trigger("change");
                                        });
                                    }
                                }),
                                (d.prototype.bind = function (l, s) {
                                    var f = this;
                                    (this.container = l).on("select", function (b) {
                                        f.select(b.data);
                                    }),
                                        l.on("unselect", function (b) {
                                            f.unselect(b.data);
                                        });
                                }),
                                (d.prototype.destroy = function () {
                                    this.$element.find("*").each(function () {
                                        _.RemoveData(this);
                                    });
                                }),
                                (d.prototype.query = function (l, s) {
                                    var f = [],
                                        b = this;
                                    this.$element.children().each(function () {
                                        var k = v(this);
                                        (k.is("option") || k.is("optgroup")) && ((k = b.item(k)), (k = b.matches(l, k)) !== null && f.push(k));
                                    }),
                                        s({ results: f });
                                }),
                                (d.prototype.addOptions = function (l) {
                                    _.appendMany(this.$element, l);
                                }),
                                (d.prototype.option = function (l) {
                                    var s;
                                    l.children ? ((s = document.createElement("optgroup")).label = l.text) : (s = document.createElement("option")).textContent !== void 0 ? (s.textContent = l.text) : (s.innerText = l.text),
                                        l.id !== void 0 && (s.value = l.id),
                                        l.disabled && (s.disabled = !0),
                                        l.selected && (s.selected = !0),
                                        l.title && (s.title = l.title);
                                    var f = v(s),
                                        l = this._normalizeItem(l);
                                    return (l.element = s), _.StoreData(s, "data", l), f;
                                }),
                                (d.prototype.item = function (l) {
                                    var s = {};
                                    if ((s = _.GetData(l[0], "data")) != null) return s;
                                    if (l.is("option")) s = { id: l.val(), text: l.text(), disabled: l.prop("disabled"), selected: l.prop("selected"), title: l.prop("title") };
                                    else if (l.is("optgroup")) {
                                        for (var s = { text: l.prop("label"), children: [], title: l.prop("title") }, f = l.children("option"), b = [], k = 0; k < f.length; k++) {
                                            var T = v(f[k]),
                                                T = this.item(T);
                                            b.push(T);
                                        }
                                        s.children = b;
                                    }
                                    return ((s = this._normalizeItem(s)).element = l[0]), _.StoreData(l[0], "data", s), s;
                                }),
                                (d.prototype._normalizeItem = function (l) {
                                    return (
                                        l !== Object(l) && (l = { id: l, text: l }),
                                        (l = v.extend({}, { text: "" }, l)).id != null && (l.id = l.id.toString()),
                                        l.text != null && (l.text = l.text.toString()),
                                        l._resultId == null && l.id && this.container != null && (l._resultId = this.generateResultId(this.container, l)),
                                        v.extend({}, { selected: !1, disabled: !1 }, l)
                                    );
                                }),
                                (d.prototype.matches = function (l, s) {
                                    return this.options.get("matcher")(l, s);
                                }),
                                d
                            );
                        }),
                        h.define("select2/data/array", ["./select", "../utils", "jquery"], function (y, _, v) {
                            function d(l, s) {
                                (this._dataToConvert = s.get("data") || []), d.__super__.constructor.call(this, l, s);
                            }
                            return (
                                _.Extend(d, y),
                                (d.prototype.bind = function (l, s) {
                                    d.__super__.bind.call(this, l, s), this.addOptions(this.convertToOptions(this._dataToConvert));
                                }),
                                (d.prototype.select = function (l) {
                                    var s = this.$element.find("option").filter(function (f, b) {
                                        return b.value == l.id.toString();
                                    });
                                    s.length === 0 && ((s = this.option(l)), this.addOptions(s)), d.__super__.select.call(this, l);
                                }),
                                (d.prototype.convertToOptions = function (l) {
                                    for (
                                        var s = this,
                                            f = this.$element.find("option"),
                                            b = f
                                                .map(function () {
                                                    return s.item(v(this)).id;
                                                })
                                                .get(),
                                            k = [],
                                            T = 0;
                                        T < l.length;
                                        T++
                                    ) {
                                        var O,
                                            L,
                                            I = this._normalizeItem(l[T]);
                                        0 <= v.inArray(I.id, b)
                                            ? ((O = f.filter(
                                                  (function (Z) {
                                                      return function () {
                                                          return v(this).val() == Z.id;
                                                      };
                                                  })(I)
                                              )),
                                              (L = this.item(O)),
                                              (L = v.extend(!0, {}, I, L)),
                                              (L = this.option(L)),
                                              O.replaceWith(L))
                                            : ((L = this.option(I)), I.children && ((I = this.convertToOptions(I.children)), _.appendMany(L, I)), k.push(L));
                                    }
                                    return k;
                                }),
                                d
                            );
                        }),
                        h.define("select2/data/ajax", ["./array", "../utils", "jquery"], function (y, _, v) {
                            function d(l, s) {
                                (this.ajaxOptions = this._applyDefaults(s.get("ajax"))), this.ajaxOptions.processResults != null && (this.processResults = this.ajaxOptions.processResults), d.__super__.constructor.call(this, l, s);
                            }
                            return (
                                _.Extend(d, y),
                                (d.prototype._applyDefaults = function (l) {
                                    var s = {
                                        data: function (f) {
                                            return v.extend({}, f, { q: f.term });
                                        },
                                        transport: function (f, b, k) {
                                            return (f = v.ajax(f)), f.then(b), f.fail(k), f;
                                        },
                                    };
                                    return v.extend({}, s, l, !0);
                                }),
                                (d.prototype.processResults = function (l) {
                                    return l;
                                }),
                                (d.prototype.query = function (l, s) {
                                    var f = this;
                                    this._request != null && (v.isFunction(this._request.abort) && this._request.abort(), (this._request = null));
                                    var b = v.extend({ type: "GET" }, this.ajaxOptions);
                                    function k() {
                                        var T = b.transport(
                                            b,
                                            function (O) {
                                                (O = f.processResults(O, l)),
                                                    f.options.get("debug") &&
                                                        window.console &&
                                                        console.error &&
                                                        ((O && O.results && v.isArray(O.results)) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")),
                                                    s(O);
                                            },
                                            function () {
                                                ("status" in T && (T.status === 0 || T.status === "0")) || f.trigger("results:message", { message: "errorLoading" });
                                            }
                                        );
                                        f._request = T;
                                    }
                                    typeof b.url == "function" && (b.url = b.url.call(this.$element, l)),
                                        typeof b.data == "function" && (b.data = b.data.call(this.$element, l)),
                                        this.ajaxOptions.delay && l.term != null ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), (this._queryTimeout = window.setTimeout(k, this.ajaxOptions.delay))) : k();
                                }),
                                d
                            );
                        }),
                        h.define("select2/data/tags", ["jquery"], function (y) {
                            function _(v, d, l) {
                                var s = l.get("tags"),
                                    f = l.get("createTag");
                                if ((f !== void 0 && (this.createTag = f), (f = l.get("insertTag")), f !== void 0 && (this.insertTag = f), v.call(this, d, l), y.isArray(s)))
                                    for (var b = 0; b < s.length; b++) {
                                        var k = s[b],
                                            k = this._normalizeItem(k),
                                            k = this.option(k);
                                        this.$element.append(k);
                                    }
                            }
                            return (
                                (_.prototype.query = function (v, d, l) {
                                    var s = this;
                                    this._removeOldTags(),
                                        d.term != null && d.page == null
                                            ? v.call(this, d, function f(b, k) {
                                                  for (var T = b.results, O = 0; O < T.length; O++) {
                                                      var L = T[O],
                                                          I = L.children != null && !f({ results: L.children }, !0);
                                                      if ((L.text || "").toUpperCase() === (d.term || "").toUpperCase() || I) return !k && ((b.data = T), void l(b));
                                                  }
                                                  if (k) return !0;
                                                  var Z,
                                                      Y = s.createTag(d);
                                                  Y != null && ((Z = s.option(Y)).attr("data-select2-tag", !0), s.addOptions([Z]), s.insertTag(T, Y)), (b.results = T), l(b);
                                              })
                                            : v.call(this, d, l);
                                }),
                                (_.prototype.createTag = function (v, d) {
                                    return (d = y.trim(d.term)), d === "" ? null : { id: d, text: d };
                                }),
                                (_.prototype.insertTag = function (v, d, l) {
                                    d.unshift(l);
                                }),
                                (_.prototype._removeOldTags = function (v) {
                                    this.$element.find("option[data-select2-tag]").each(function () {
                                        this.selected || y(this).remove();
                                    });
                                }),
                                _
                            );
                        }),
                        h.define("select2/data/tokenizer", ["jquery"], function (y) {
                            function _(v, d, l) {
                                var s = l.get("tokenizer");
                                s !== void 0 && (this.tokenizer = s), v.call(this, d, l);
                            }
                            return (
                                (_.prototype.bind = function (v, d, l) {
                                    v.call(this, d, l), (this.$search = d.dropdown.$search || d.selection.$search || l.find(".select2-search__field"));
                                }),
                                (_.prototype.query = function (v, d, l) {
                                    var s = this;
                                    d.term = d.term || "";
                                    var f = this.tokenizer(d, this.options, function (b) {
                                        var k = s._normalizeItem(b);
                                        s.$element.find("option").filter(function () {
                                            return y(this).val() === k.id;
                                        }).length || ((b = s.option(k)).attr("data-select2-tag", !0), s._removeOldTags(), s.addOptions([b])),
                                            s.trigger("select", { data: k });
                                    });
                                    f.term !== d.term && (this.$search.length && (this.$search.val(f.term), this.$search.trigger("focus")), (d.term = f.term)), v.call(this, d, l);
                                }),
                                (_.prototype.tokenizer = function (v, d, l, s) {
                                    for (
                                        var f = l.get("tokenSeparators") || [],
                                            b = d.term,
                                            k = 0,
                                            T =
                                                this.createTag ||
                                                function (L) {
                                                    return { id: L.term, text: L.term };
                                                };
                                        k < b.length;

                                    ) {
                                        var O = b[k];
                                        y.inArray(O, f) !== -1 ? ((O = b.substr(0, k)), (O = T(y.extend({}, d, { term: O }))) != null ? (s(O), (b = b.substr(k + 1) || ""), (k = 0)) : k++) : k++;
                                    }
                                    return { term: b };
                                }),
                                _
                            );
                        }),
                        h.define("select2/data/minimumInputLength", [], function () {
                            function y(_, v, d) {
                                (this.minimumInputLength = d.get("minimumInputLength")), _.call(this, v, d);
                            }
                            return (
                                (y.prototype.query = function (_, v, d) {
                                    (v.term = v.term || ""),
                                        v.term.length < this.minimumInputLength ? this.trigger("results:message", { message: "inputTooShort", args: { minimum: this.minimumInputLength, input: v.term, params: v } }) : _.call(this, v, d);
                                }),
                                y
                            );
                        }),
                        h.define("select2/data/maximumInputLength", [], function () {
                            function y(_, v, d) {
                                (this.maximumInputLength = d.get("maximumInputLength")), _.call(this, v, d);
                            }
                            return (
                                (y.prototype.query = function (_, v, d) {
                                    (v.term = v.term || ""),
                                        0 < this.maximumInputLength && v.term.length > this.maximumInputLength
                                            ? this.trigger("results:message", { message: "inputTooLong", args: { maximum: this.maximumInputLength, input: v.term, params: v } })
                                            : _.call(this, v, d);
                                }),
                                y
                            );
                        }),
                        h.define("select2/data/maximumSelectionLength", [], function () {
                            function y(_, v, d) {
                                (this.maximumSelectionLength = d.get("maximumSelectionLength")), _.call(this, v, d);
                            }
                            return (
                                (y.prototype.bind = function (_, v, d) {
                                    var l = this;
                                    _.call(this, v, d),
                                        v.on("select", function () {
                                            l._checkIfMaximumSelected();
                                        });
                                }),
                                (y.prototype.query = function (_, v, d) {
                                    var l = this;
                                    this._checkIfMaximumSelected(function () {
                                        _.call(l, v, d);
                                    });
                                }),
                                (y.prototype._checkIfMaximumSelected = function (_, v) {
                                    var d = this;
                                    this.current(function (l) {
                                        (l = l != null ? l.length : 0),
                                            0 < d.maximumSelectionLength && l >= d.maximumSelectionLength ? d.trigger("results:message", { message: "maximumSelected", args: { maximum: d.maximumSelectionLength } }) : v && v();
                                    });
                                }),
                                y
                            );
                        }),
                        h.define("select2/dropdown", ["jquery", "./utils"], function (y, _) {
                            function v(d, l) {
                                (this.$element = d), (this.options = l), v.__super__.constructor.call(this);
                            }
                            return (
                                _.Extend(v, _.Observable),
                                (v.prototype.render = function () {
                                    var d = y('<span class="select2-dropdown"><span class="select2-results"></span></span>');
                                    return d.attr("dir", this.options.get("dir")), (this.$dropdown = d);
                                }),
                                (v.prototype.bind = function () {}),
                                (v.prototype.position = function (d, l) {}),
                                (v.prototype.destroy = function () {
                                    this.$dropdown.remove();
                                }),
                                v
                            );
                        }),
                        h.define("select2/dropdown/search", ["jquery", "../utils"], function (y, _) {
                            function v() {}
                            return (
                                (v.prototype.render = function (d) {
                                    var l = d.call(this),
                                        d = y(
                                            '<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>'
                                        );
                                    return (this.$searchContainer = d), (this.$search = d.find("input")), l.prepend(d), l;
                                }),
                                (v.prototype.bind = function (d, l, s) {
                                    var f = this,
                                        b = l.id + "-results";
                                    d.call(this, l, s),
                                        this.$search.on("keydown", function (k) {
                                            f.trigger("keypress", k), (f._keyUpPrevented = k.isDefaultPrevented());
                                        }),
                                        this.$search.on("input", function (k) {
                                            y(this).off("keyup");
                                        }),
                                        this.$search.on("keyup input", function (k) {
                                            f.handleSearch(k);
                                        }),
                                        l.on("open", function () {
                                            f.$search.attr("tabindex", 0),
                                                f.$search.attr("aria-controls", b),
                                                f.$search.trigger("focus"),
                                                window.setTimeout(function () {
                                                    f.$search.trigger("focus");
                                                }, 0);
                                        }),
                                        l.on("close", function () {
                                            f.$search.attr("tabindex", -1), f.$search.removeAttr("aria-controls"), f.$search.removeAttr("aria-activedescendant"), f.$search.val(""), f.$search.trigger("blur");
                                        }),
                                        l.on("focus", function () {
                                            l.isOpen() || f.$search.trigger("focus");
                                        }),
                                        l.on("results:all", function (k) {
                                            (k.query.term != null && k.query.term !== "") || (f.showSearch(k) ? f.$searchContainer.removeClass("select2-search--hide") : f.$searchContainer.addClass("select2-search--hide"));
                                        }),
                                        l.on("results:focus", function (k) {
                                            k.data._resultId ? f.$search.attr("aria-activedescendant", k.data._resultId) : f.$search.removeAttr("aria-activedescendant");
                                        });
                                }),
                                (v.prototype.handleSearch = function (d) {
                                    var l;
                                    this._keyUpPrevented || ((l = this.$search.val()), this.trigger("query", { term: l })), (this._keyUpPrevented = !1);
                                }),
                                (v.prototype.showSearch = function (d, l) {
                                    return !0;
                                }),
                                v
                            );
                        }),
                        h.define("select2/dropdown/hidePlaceholder", [], function () {
                            function y(_, v, d, l) {
                                (this.placeholder = this.normalizePlaceholder(d.get("placeholder"))), _.call(this, v, d, l);
                            }
                            return (
                                (y.prototype.append = function (_, v) {
                                    (v.results = this.removePlaceholder(v.results)), _.call(this, v);
                                }),
                                (y.prototype.normalizePlaceholder = function (_, v) {
                                    return (v = typeof v == "string" ? { id: "", text: v } : v);
                                }),
                                (y.prototype.removePlaceholder = function (_, v) {
                                    for (var d = v.slice(0), l = v.length - 1; 0 <= l; l--) {
                                        var s = v[l];
                                        this.placeholder.id === s.id && d.splice(l, 1);
                                    }
                                    return d;
                                }),
                                y
                            );
                        }),
                        h.define("select2/dropdown/infiniteScroll", ["jquery"], function (y) {
                            function _(v, d, l, s) {
                                (this.lastParams = {}), v.call(this, d, l, s), (this.$loadingMore = this.createLoadingMore()), (this.loading = !1);
                            }
                            return (
                                (_.prototype.append = function (v, d) {
                                    this.$loadingMore.remove(), (this.loading = !1), v.call(this, d), this.showLoadingMore(d) && (this.$results.append(this.$loadingMore), this.loadMoreIfNeeded());
                                }),
                                (_.prototype.bind = function (v, d, l) {
                                    var s = this;
                                    v.call(this, d, l),
                                        d.on("query", function (f) {
                                            (s.lastParams = f), (s.loading = !0);
                                        }),
                                        d.on("query:append", function (f) {
                                            (s.lastParams = f), (s.loading = !0);
                                        }),
                                        this.$results.on("scroll", this.loadMoreIfNeeded.bind(this));
                                }),
                                (_.prototype.loadMoreIfNeeded = function () {
                                    var v = y.contains(document.documentElement, this.$loadingMore[0]);
                                    !this.loading && v && ((v = this.$results.offset().top + this.$results.outerHeight(!1)), this.$loadingMore.offset().top + this.$loadingMore.outerHeight(!1) <= v + 50 && this.loadMore());
                                }),
                                (_.prototype.loadMore = function () {
                                    this.loading = !0;
                                    var v = y.extend({}, { page: 1 }, this.lastParams);
                                    v.page++, this.trigger("query:append", v);
                                }),
                                (_.prototype.showLoadingMore = function (v, d) {
                                    return d.pagination && d.pagination.more;
                                }),
                                (_.prototype.createLoadingMore = function () {
                                    var v = y('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'),
                                        d = this.options.get("translations").get("loadingMore");
                                    return v.html(d(this.lastParams)), v;
                                }),
                                _
                            );
                        }),
                        h.define("select2/dropdown/attachBody", ["jquery", "../utils"], function (y, _) {
                            function v(d, l, s) {
                                (this.$dropdownParent = y(s.get("dropdownParent") || document.body)), d.call(this, l, s);
                            }
                            return (
                                (v.prototype.bind = function (d, l, s) {
                                    var f = this;
                                    d.call(this, l, s),
                                        l.on("open", function () {
                                            f._showDropdown(), f._attachPositioningHandler(l), f._bindContainerResultHandlers(l);
                                        }),
                                        l.on("close", function () {
                                            f._hideDropdown(), f._detachPositioningHandler(l);
                                        }),
                                        this.$dropdownContainer.on("mousedown", function (b) {
                                            b.stopPropagation();
                                        });
                                }),
                                (v.prototype.destroy = function (d) {
                                    d.call(this), this.$dropdownContainer.remove();
                                }),
                                (v.prototype.position = function (d, l, s) {
                                    l.attr("class", s.attr("class")), l.removeClass("select2"), l.addClass("select2-container--open"), l.css({ position: "absolute", top: -999999 }), (this.$container = s);
                                }),
                                (v.prototype.render = function (d) {
                                    var l = y("<span></span>"),
                                        d = d.call(this);
                                    return l.append(d), (this.$dropdownContainer = l);
                                }),
                                (v.prototype._hideDropdown = function (d) {
                                    this.$dropdownContainer.detach();
                                }),
                                (v.prototype._bindContainerResultHandlers = function (d, l) {
                                    var s;
                                    this._containerResultsHandlersBound ||
                                        ((s = this),
                                        l.on("results:all", function () {
                                            s._positionDropdown(), s._resizeDropdown();
                                        }),
                                        l.on("results:append", function () {
                                            s._positionDropdown(), s._resizeDropdown();
                                        }),
                                        l.on("results:message", function () {
                                            s._positionDropdown(), s._resizeDropdown();
                                        }),
                                        l.on("select", function () {
                                            s._positionDropdown(), s._resizeDropdown();
                                        }),
                                        l.on("unselect", function () {
                                            s._positionDropdown(), s._resizeDropdown();
                                        }),
                                        (this._containerResultsHandlersBound = !0));
                                }),
                                (v.prototype._attachPositioningHandler = function (d, l) {
                                    var s = this,
                                        f = "scroll.select2." + l.id,
                                        b = "resize.select2." + l.id,
                                        k = "orientationchange.select2." + l.id,
                                        l = this.$container.parents().filter(_.hasScroll);
                                    l.each(function () {
                                        _.StoreData(this, "select2-scroll-position", { x: y(this).scrollLeft(), y: y(this).scrollTop() });
                                    }),
                                        l.on(f, function (T) {
                                            var O = _.GetData(this, "select2-scroll-position");
                                            y(this).scrollTop(O.y);
                                        }),
                                        y(window).on(f + " " + b + " " + k, function (T) {
                                            s._positionDropdown(), s._resizeDropdown();
                                        });
                                }),
                                (v.prototype._detachPositioningHandler = function (d, l) {
                                    var s = "scroll.select2." + l.id,
                                        f = "resize.select2." + l.id,
                                        l = "orientationchange.select2." + l.id;
                                    this.$container.parents().filter(_.hasScroll).off(s), y(window).off(s + " " + f + " " + l);
                                }),
                                (v.prototype._positionDropdown = function () {
                                    var d = y(window),
                                        l = this.$dropdown.hasClass("select2-dropdown--above"),
                                        s = this.$dropdown.hasClass("select2-dropdown--below"),
                                        f = null,
                                        b = this.$container.offset();
                                    b.bottom = b.top + this.$container.outerHeight(!1);
                                    var k = { height: this.$container.outerHeight(!1) };
                                    (k.top = b.top), (k.bottom = b.top + k.height);
                                    var T = this.$dropdown.outerHeight(!1),
                                        O = d.scrollTop(),
                                        L = d.scrollTop() + d.height(),
                                        I = O < b.top - T,
                                        d = L > b.bottom + T,
                                        O = { left: b.left, top: k.bottom },
                                        L = this.$dropdownParent;
                                    L.css("position") === "static" && (L = L.offsetParent()),
                                        (b = { top: 0, left: 0 }),
                                        (y.contains(document.body, L[0]) || L[0].isConnected) && (b = L.offset()),
                                        (O.top -= b.top),
                                        (O.left -= b.left),
                                        l || s || (f = "below"),
                                        d || !I || l ? !I && d && l && (f = "below") : (f = "above"),
                                        (f == "above" || (l && f !== "below")) && (O.top = k.top - b.top - T),
                                        f != null &&
                                            (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + f),
                                            this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + f)),
                                        this.$dropdownContainer.css(O);
                                }),
                                (v.prototype._resizeDropdown = function () {
                                    var d = { width: this.$container.outerWidth(!1) + "px" };
                                    this.options.get("dropdownAutoWidth") && ((d.minWidth = d.width), (d.position = "relative"), (d.width = "auto")), this.$dropdown.css(d);
                                }),
                                (v.prototype._showDropdown = function (d) {
                                    this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown();
                                }),
                                v
                            );
                        }),
                        h.define("select2/dropdown/minimumResultsForSearch", [], function () {
                            function y(_, v, d, l) {
                                (this.minimumResultsForSearch = d.get("minimumResultsForSearch")), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), _.call(this, v, d, l);
                            }
                            return (
                                (y.prototype.showSearch = function (_, v) {
                                    return (
                                        !(
                                            (function d(l) {
                                                for (var s = 0, f = 0; f < l.length; f++) {
                                                    var b = l[f];
                                                    b.children ? (s += d(b.children)) : s++;
                                                }
                                                return s;
                                            })(v.data.results) < this.minimumResultsForSearch
                                        ) && _.call(this, v)
                                    );
                                }),
                                y
                            );
                        }),
                        h.define("select2/dropdown/selectOnClose", ["../utils"], function (y) {
                            function _() {}
                            return (
                                (_.prototype.bind = function (v, d, l) {
                                    var s = this;
                                    v.call(this, d, l),
                                        d.on("close", function (f) {
                                            s._handleSelectOnClose(f);
                                        });
                                }),
                                (_.prototype._handleSelectOnClose = function (v, d) {
                                    if (d && d.originalSelect2Event != null) {
                                        var l = d.originalSelect2Event;
                                        if (l._type === "select" || l._type === "unselect") return;
                                    }
                                    (l = this.getHighlightedResults()), l.length < 1 || ((l = y.GetData(l[0], "data")).element != null && l.element.selected) || (l.element == null && l.selected) || this.trigger("select", { data: l });
                                }),
                                _
                            );
                        }),
                        h.define("select2/dropdown/closeOnSelect", [], function () {
                            function y() {}
                            return (
                                (y.prototype.bind = function (_, v, d) {
                                    var l = this;
                                    _.call(this, v, d),
                                        v.on("select", function (s) {
                                            l._selectTriggered(s);
                                        }),
                                        v.on("unselect", function (s) {
                                            l._selectTriggered(s);
                                        });
                                }),
                                (y.prototype._selectTriggered = function (_, v) {
                                    var d = v.originalEvent;
                                    (d && (d.ctrlKey || d.metaKey)) || this.trigger("close", { originalEvent: d, originalSelect2Event: v });
                                }),
                                y
                            );
                        }),
                        h.define("select2/i18n/en", [], function () {
                            return {
                                errorLoading: function () {
                                    return "The results could not be loaded.";
                                },
                                inputTooLong: function (y) {
                                    var _ = y.input.length - y.maximum,
                                        y = "Please delete " + _ + " character";
                                    return _ != 1 && (y += "s"), y;
                                },
                                inputTooShort: function (y) {
                                    return "Please enter " + (y.minimum - y.input.length) + " or more characters";
                                },
                                loadingMore: function () {
                                    return "Loading more results\u2026";
                                },
                                maximumSelected: function (y) {
                                    var _ = "You can only select " + y.maximum + " item";
                                    return y.maximum != 1 && (_ += "s"), _;
                                },
                                noResults: function () {
                                    return "No results found";
                                },
                                searching: function () {
                                    return "Searching\u2026";
                                },
                                removeAllItems: function () {
                                    return "Remove all items";
                                },
                            };
                        }),
                        h.define(
                            "select2/defaults",
                            [
                                "jquery",
                                "require",
                                "./results",
                                "./selection/single",
                                "./selection/multiple",
                                "./selection/placeholder",
                                "./selection/allowClear",
                                "./selection/search",
                                "./selection/eventRelay",
                                "./utils",
                                "./translation",
                                "./diacritics",
                                "./data/select",
                                "./data/array",
                                "./data/ajax",
                                "./data/tags",
                                "./data/tokenizer",
                                "./data/minimumInputLength",
                                "./data/maximumInputLength",
                                "./data/maximumSelectionLength",
                                "./dropdown",
                                "./dropdown/search",
                                "./dropdown/hidePlaceholder",
                                "./dropdown/infiniteScroll",
                                "./dropdown/attachBody",
                                "./dropdown/minimumResultsForSearch",
                                "./dropdown/selectOnClose",
                                "./dropdown/closeOnSelect",
                                "./i18n/en",
                            ],
                            function (y, _, v, d, l, s, f, b, k, T, O, L, I, Z, Y, at, ft, ct, Pt, ee, ne, mn, zn, Dn, Kn, Ae, Jn, Je, Ie) {
                                function Ce() {
                                    this.reset();
                                }
                                return (
                                    (Ce.prototype.apply = function (H) {
                                        var At, Dt, Ct;
                                        (H = y.extend(!0, {}, this.defaults, H)).dataAdapter == null &&
                                            (H.ajax != null ? (H.dataAdapter = Y) : H.data != null ? (H.dataAdapter = Z) : (H.dataAdapter = I),
                                            0 < H.minimumInputLength && (H.dataAdapter = T.Decorate(H.dataAdapter, ct)),
                                            0 < H.maximumInputLength && (H.dataAdapter = T.Decorate(H.dataAdapter, Pt)),
                                            0 < H.maximumSelectionLength && (H.dataAdapter = T.Decorate(H.dataAdapter, ee)),
                                            H.tags && (H.dataAdapter = T.Decorate(H.dataAdapter, at)),
                                            (H.tokenSeparators == null && H.tokenizer == null) || (H.dataAdapter = T.Decorate(H.dataAdapter, ft)),
                                            H.query != null && ((At = _(H.amdBase + "compat/query")), (H.dataAdapter = T.Decorate(H.dataAdapter, At))),
                                            H.initSelection != null && ((Dt = _(H.amdBase + "compat/initSelection")), (H.dataAdapter = T.Decorate(H.dataAdapter, Dt)))),
                                            H.resultsAdapter == null &&
                                                ((H.resultsAdapter = v),
                                                H.ajax != null && (H.resultsAdapter = T.Decorate(H.resultsAdapter, Dn)),
                                                H.placeholder != null && (H.resultsAdapter = T.Decorate(H.resultsAdapter, zn)),
                                                H.selectOnClose && (H.resultsAdapter = T.Decorate(H.resultsAdapter, Jn))),
                                            H.dropdownAdapter == null &&
                                                (H.multiple ? (H.dropdownAdapter = ne) : ((Dt = T.Decorate(ne, mn)), (H.dropdownAdapter = Dt)),
                                                H.minimumResultsForSearch !== 0 && (H.dropdownAdapter = T.Decorate(H.dropdownAdapter, Ae)),
                                                H.closeOnSelect && (H.dropdownAdapter = T.Decorate(H.dropdownAdapter, Je)),
                                                (H.dropdownCssClass == null && H.dropdownCss == null && H.adaptDropdownCssClass == null) ||
                                                    ((Ct = _(H.amdBase + "compat/dropdownCss")), (H.dropdownAdapter = T.Decorate(H.dropdownAdapter, Ct))),
                                                (H.dropdownAdapter = T.Decorate(H.dropdownAdapter, Kn))),
                                            H.selectionAdapter == null &&
                                                (H.multiple ? (H.selectionAdapter = l) : (H.selectionAdapter = d),
                                                H.placeholder != null && (H.selectionAdapter = T.Decorate(H.selectionAdapter, s)),
                                                H.allowClear && (H.selectionAdapter = T.Decorate(H.selectionAdapter, f)),
                                                H.multiple && (H.selectionAdapter = T.Decorate(H.selectionAdapter, b)),
                                                (H.containerCssClass == null && H.containerCss == null && H.adaptContainerCssClass == null) ||
                                                    ((Ct = _(H.amdBase + "compat/containerCss")), (H.selectionAdapter = T.Decorate(H.selectionAdapter, Ct))),
                                                (H.selectionAdapter = T.Decorate(H.selectionAdapter, k))),
                                            (H.language = this._resolveLanguage(H.language)),
                                            H.language.push("en");
                                        for (var It = [], Gt = 0; Gt < H.language.length; Gt++) {
                                            var He = H.language[Gt];
                                            It.indexOf(He) === -1 && It.push(He);
                                        }
                                        return (H.language = It), (H.translations = this._processTranslations(H.language, H.debug)), H;
                                    }),
                                    (Ce.prototype.reset = function () {
                                        function H(At) {
                                            return At.replace(/[^\u0000-\u007E]/g, function (Dt) {
                                                return L[Dt] || Dt;
                                            });
                                        }
                                        this.defaults = {
                                            amdBase: "./",
                                            amdLanguageBase: "./i18n/",
                                            closeOnSelect: !0,
                                            debug: !1,
                                            dropdownAutoWidth: !1,
                                            escapeMarkup: T.escapeMarkup,
                                            language: {},
                                            matcher: function At(Dt, Ct) {
                                                if (y.trim(Dt.term) === "") return Ct;
                                                if (Ct.children && 0 < Ct.children.length) {
                                                    for (var It = y.extend(!0, {}, Ct), Gt = Ct.children.length - 1; 0 <= Gt; Gt--) At(Dt, Ct.children[Gt]) == null && It.children.splice(Gt, 1);
                                                    return 0 < It.children.length ? It : At(Dt, It);
                                                }
                                                var He = H(Ct.text).toUpperCase(),
                                                    Un = H(Dt.term).toUpperCase();
                                                return -1 < He.indexOf(Un) ? Ct : null;
                                            },
                                            minimumInputLength: 0,
                                            maximumInputLength: 0,
                                            maximumSelectionLength: 0,
                                            minimumResultsForSearch: 0,
                                            selectOnClose: !1,
                                            scrollAfterSelect: !1,
                                            sorter: function (At) {
                                                return At;
                                            },
                                            templateResult: function (At) {
                                                return At.text;
                                            },
                                            templateSelection: function (At) {
                                                return At.text;
                                            },
                                            theme: "default",
                                            width: "resolve",
                                        };
                                    }),
                                    (Ce.prototype.applyFromElement = function (H, At) {
                                        var Dt = H.language,
                                            Ct = this.defaults.language,
                                            It = At.prop("lang"),
                                            At = At.closest("[lang]").prop("lang"),
                                            At = Array.prototype.concat.call(this._resolveLanguage(It), this._resolveLanguage(Dt), this._resolveLanguage(Ct), this._resolveLanguage(At));
                                        return (H.language = At), H;
                                    }),
                                    (Ce.prototype._resolveLanguage = function (H) {
                                        if (!H) return [];
                                        if (y.isEmptyObject(H)) return [];
                                        if (y.isPlainObject(H)) return [H];
                                        for (var At, Dt = y.isArray(H) ? H : [H], Ct = [], It = 0; It < Dt.length; It++) Ct.push(Dt[It]), typeof Dt[It] == "string" && 0 < Dt[It].indexOf("-") && ((At = Dt[It].split("-")[0]), Ct.push(At));
                                        return Ct;
                                    }),
                                    (Ce.prototype._processTranslations = function (H, At) {
                                        for (var Dt = new O(), Ct = 0; Ct < H.length; Ct++) {
                                            var It = new O(),
                                                Gt = H[Ct];
                                            if (typeof Gt == "string")
                                                try {
                                                    It = O.loadPath(Gt);
                                                } catch {
                                                    try {
                                                        (Gt = this.defaults.amdLanguageBase + Gt), (It = O.loadPath(Gt));
                                                    } catch {
                                                        At && window.console && console.warn && console.warn('Select2: The language file for "' + Gt + '" could not be automatically loaded. A fallback will be used instead.');
                                                    }
                                                }
                                            else It = y.isPlainObject(Gt) ? new O(Gt) : Gt;
                                            Dt.extend(It);
                                        }
                                        return Dt;
                                    }),
                                    (Ce.prototype.set = function (H, At) {
                                        var Dt = {};
                                        (Dt[y.camelCase(H)] = At), (Dt = T._convertData(Dt)), y.extend(!0, this.defaults, Dt);
                                    }),
                                    new Ce()
                                );
                            }
                        ),
                        h.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function (y, _, v, d) {
                            function l(s, f) {
                                (this.options = s),
                                    f != null && this.fromElement(f),
                                    f != null && (this.options = v.applyFromElement(this.options, f)),
                                    (this.options = v.apply(this.options)),
                                    f && f.is("input") && ((f = y(this.get("amdBase") + "compat/inputData")), (this.options.dataAdapter = d.Decorate(this.options.dataAdapter, f)));
                            }
                            return (
                                (l.prototype.fromElement = function (s) {
                                    var f = ["select2"];
                                    this.options.multiple == null && (this.options.multiple = s.prop("multiple")),
                                        this.options.disabled == null && (this.options.disabled = s.prop("disabled")),
                                        this.options.dir == null && (s.prop("dir") ? (this.options.dir = s.prop("dir")) : s.closest("[dir]").prop("dir") ? (this.options.dir = s.closest("[dir]").prop("dir")) : (this.options.dir = "ltr")),
                                        s.prop("disabled", this.options.disabled),
                                        s.prop("multiple", this.options.multiple),
                                        d.GetData(s[0], "select2Tags") &&
                                            (this.options.debug &&
                                                window.console &&
                                                console.warn &&
                                                console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'),
                                            d.StoreData(s[0], "data", d.GetData(s[0], "select2Tags")),
                                            d.StoreData(s[0], "tags", !0)),
                                        d.GetData(s[0], "ajaxUrl") &&
                                            (this.options.debug &&
                                                window.console &&
                                                console.warn &&
                                                console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."),
                                            s.attr("ajax--url", d.GetData(s[0], "ajaxUrl")),
                                            d.StoreData(s[0], "ajax-Url", d.GetData(s[0], "ajaxUrl")));
                                    var b = {};
                                    function k(Y, at) {
                                        return at.toUpperCase();
                                    }
                                    for (var T = 0; T < s[0].attributes.length; T++) {
                                        var O,
                                            L = s[0].attributes[T].name;
                                        L.substr(0, "data-".length) == "data-" && ((O = L.substring("data-".length)), (L = d.GetData(s[0], O)), (b[O.replace(/-([a-z])/g, k)] = L));
                                    }
                                    _.fn.jquery && _.fn.jquery.substr(0, 2) == "1." && s[0].dataset && (b = _.extend(!0, {}, s[0].dataset, b));
                                    var I,
                                        Z = _.extend(!0, {}, d.GetData(s[0]), b);
                                    for (I in (Z = d._convertData(Z))) -1 < _.inArray(I, f) || (_.isPlainObject(this.options[I]) ? _.extend(this.options[I], Z[I]) : (this.options[I] = Z[I]));
                                    return this;
                                }),
                                (l.prototype.get = function (s) {
                                    return this.options[s];
                                }),
                                (l.prototype.set = function (s, f) {
                                    this.options[s] = f;
                                }),
                                l
                            );
                        }),
                        h.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function (y, _, v, d) {
                            function l(s, f) {
                                v.GetData(s[0], "select2") != null && v.GetData(s[0], "select2").destroy(), (this.$element = s), (this.id = this._generateId(s)), (this.options = new _((f = f || {}), s)), l.__super__.constructor.call(this);
                                var b = s.attr("tabindex") || 0;
                                v.StoreData(s[0], "old-tabindex", b),
                                    s.attr("tabindex", "-1"),
                                    (f = this.options.get("dataAdapter")),
                                    (this.dataAdapter = new f(s, this.options)),
                                    (b = this.render()),
                                    this._placeContainer(b),
                                    (f = this.options.get("selectionAdapter")),
                                    (this.selection = new f(s, this.options)),
                                    (this.$selection = this.selection.render()),
                                    this.selection.position(this.$selection, b),
                                    (f = this.options.get("dropdownAdapter")),
                                    (this.dropdown = new f(s, this.options)),
                                    (this.$dropdown = this.dropdown.render()),
                                    this.dropdown.position(this.$dropdown, b),
                                    (b = this.options.get("resultsAdapter")),
                                    (this.results = new b(s, this.options, this.dataAdapter)),
                                    (this.$results = this.results.render()),
                                    this.results.position(this.$results, this.$dropdown);
                                var k = this;
                                this._bindAdapters(),
                                    this._registerDomEvents(),
                                    this._registerDataEvents(),
                                    this._registerSelectionEvents(),
                                    this._registerDropdownEvents(),
                                    this._registerResultsEvents(),
                                    this._registerEvents(),
                                    this.dataAdapter.current(function (T) {
                                        k.trigger("selection:update", { data: T });
                                    }),
                                    s.addClass("select2-hidden-accessible"),
                                    s.attr("aria-hidden", "true"),
                                    this._syncAttributes(),
                                    v.StoreData(s[0], "select2", this),
                                    s.data("select2", this);
                            }
                            return (
                                v.Extend(l, v.Observable),
                                (l.prototype._generateId = function (s) {
                                    return "select2-" + (s.attr("id") != null ? s.attr("id") : s.attr("name") != null ? s.attr("name") + "-" + v.generateChars(2) : v.generateChars(4)).replace(/(:|\.|\[|\]|,)/g, "");
                                }),
                                (l.prototype._placeContainer = function (s) {
                                    s.insertAfter(this.$element);
                                    var f = this._resolveWidth(this.$element, this.options.get("width"));
                                    f != null && s.css("width", f);
                                }),
                                (l.prototype._resolveWidth = function (s, f) {
                                    var b = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
                                    if (f == "resolve") {
                                        var k = this._resolveWidth(s, "style");
                                        return k ?? this._resolveWidth(s, "element");
                                    }
                                    if (f == "element") return (k = s.outerWidth(!1)), k <= 0 ? "auto" : k + "px";
                                    if (f != "style") return f != "computedstyle" ? f : window.getComputedStyle(s[0]).width;
                                    if (((s = s.attr("style")), typeof s != "string")) return null;
                                    for (var T = s.split(";"), O = 0, L = T.length; O < L; O += 1) {
                                        var I = T[O].replace(/\s/g, "").match(b);
                                        if (I !== null && 1 <= I.length) return I[1];
                                    }
                                    return null;
                                }),
                                (l.prototype._bindAdapters = function () {
                                    this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container);
                                }),
                                (l.prototype._registerDomEvents = function () {
                                    var s = this;
                                    this.$element.on("change.select2", function () {
                                        s.dataAdapter.current(function (b) {
                                            s.trigger("selection:update", { data: b });
                                        });
                                    }),
                                        this.$element.on("focus.select2", function (b) {
                                            s.trigger("focus", b);
                                        }),
                                        (this._syncA = v.bind(this._syncAttributes, this)),
                                        (this._syncS = v.bind(this._syncSubtree, this)),
                                        this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);
                                    var f = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                                    f != null
                                        ? ((this._observer = new f(function (b) {
                                              y.each(b, s._syncA), y.each(b, s._syncS);
                                          })),
                                          this._observer.observe(this.$element[0], { attributes: !0, childList: !0, subtree: !1 }))
                                        : this.$element[0].addEventListener &&
                                          (this.$element[0].addEventListener("DOMAttrModified", s._syncA, !1),
                                          this.$element[0].addEventListener("DOMNodeInserted", s._syncS, !1),
                                          this.$element[0].addEventListener("DOMNodeRemoved", s._syncS, !1));
                                }),
                                (l.prototype._registerDataEvents = function () {
                                    var s = this;
                                    this.dataAdapter.on("*", function (f, b) {
                                        s.trigger(f, b);
                                    });
                                }),
                                (l.prototype._registerSelectionEvents = function () {
                                    var s = this,
                                        f = ["toggle", "focus"];
                                    this.selection.on("toggle", function () {
                                        s.toggleDropdown();
                                    }),
                                        this.selection.on("focus", function (b) {
                                            s.focus(b);
                                        }),
                                        this.selection.on("*", function (b, k) {
                                            y.inArray(b, f) === -1 && s.trigger(b, k);
                                        });
                                }),
                                (l.prototype._registerDropdownEvents = function () {
                                    var s = this;
                                    this.dropdown.on("*", function (f, b) {
                                        s.trigger(f, b);
                                    });
                                }),
                                (l.prototype._registerResultsEvents = function () {
                                    var s = this;
                                    this.results.on("*", function (f, b) {
                                        s.trigger(f, b);
                                    });
                                }),
                                (l.prototype._registerEvents = function () {
                                    var s = this;
                                    this.on("open", function () {
                                        s.$container.addClass("select2-container--open");
                                    }),
                                        this.on("close", function () {
                                            s.$container.removeClass("select2-container--open");
                                        }),
                                        this.on("enable", function () {
                                            s.$container.removeClass("select2-container--disabled");
                                        }),
                                        this.on("disable", function () {
                                            s.$container.addClass("select2-container--disabled");
                                        }),
                                        this.on("blur", function () {
                                            s.$container.removeClass("select2-container--focus");
                                        }),
                                        this.on("query", function (f) {
                                            s.isOpen() || s.trigger("open", {}),
                                                this.dataAdapter.query(f, function (b) {
                                                    s.trigger("results:all", { data: b, query: f });
                                                });
                                        }),
                                        this.on("query:append", function (f) {
                                            this.dataAdapter.query(f, function (b) {
                                                s.trigger("results:append", { data: b, query: f });
                                            });
                                        }),
                                        this.on("keypress", function (f) {
                                            var b = f.which;
                                            s.isOpen()
                                                ? b === d.ESC || b === d.TAB || (b === d.UP && f.altKey)
                                                    ? (s.close(), f.preventDefault())
                                                    : b === d.ENTER
                                                    ? (s.trigger("results:select", {}), f.preventDefault())
                                                    : b === d.SPACE && f.ctrlKey
                                                    ? (s.trigger("results:toggle", {}), f.preventDefault())
                                                    : b === d.UP
                                                    ? (s.trigger("results:previous", {}), f.preventDefault())
                                                    : b === d.DOWN && (s.trigger("results:next", {}), f.preventDefault())
                                                : (b === d.ENTER || b === d.SPACE || (b === d.DOWN && f.altKey)) && (s.open(), f.preventDefault());
                                        });
                                }),
                                (l.prototype._syncAttributes = function () {
                                    this.options.set("disabled", this.$element.prop("disabled")), this.options.get("disabled") ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {});
                                }),
                                (l.prototype._syncSubtree = function (s, f) {
                                    var b = !1,
                                        k = this;
                                    if (!s || !s.target || s.target.nodeName === "OPTION" || s.target.nodeName === "OPTGROUP") {
                                        if (f)
                                            if (f.addedNodes && 0 < f.addedNodes.length) for (var T = 0; T < f.addedNodes.length; T++) f.addedNodes[T].selected && (b = !0);
                                            else f.removedNodes && 0 < f.removedNodes.length && (b = !0);
                                        else b = !0;
                                        b &&
                                            this.dataAdapter.current(function (O) {
                                                k.trigger("selection:update", { data: O });
                                            });
                                    }
                                }),
                                (l.prototype.trigger = function (s, f) {
                                    var b = l.__super__.trigger,
                                        k = { open: "opening", close: "closing", select: "selecting", unselect: "unselecting", clear: "clearing" };
                                    if ((f === void 0 && (f = {}), s in k)) {
                                        var T = { prevented: !1, name: s, args: f };
                                        if ((b.call(this, k[s], T), T.prevented)) return void (f.prevented = !0);
                                    }
                                    b.call(this, s, f);
                                }),
                                (l.prototype.toggleDropdown = function () {
                                    this.options.get("disabled") || (this.isOpen() ? this.close() : this.open());
                                }),
                                (l.prototype.open = function () {
                                    this.isOpen() || this.trigger("query", {});
                                }),
                                (l.prototype.close = function () {
                                    this.isOpen() && this.trigger("close", {});
                                }),
                                (l.prototype.isOpen = function () {
                                    return this.$container.hasClass("select2-container--open");
                                }),
                                (l.prototype.hasFocus = function () {
                                    return this.$container.hasClass("select2-container--focus");
                                }),
                                (l.prototype.focus = function (s) {
                                    this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {}));
                                }),
                                (l.prototype.enable = function (s) {
                                    this.options.get("debug") &&
                                        window.console &&
                                        console.warn &&
                                        console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'),
                                        (s = !(s = s == null || s.length === 0 ? [!0] : s)[0]),
                                        this.$element.prop("disabled", s);
                                }),
                                (l.prototype.data = function () {
                                    this.options.get("debug") &&
                                        0 < arguments.length &&
                                        window.console &&
                                        console.warn &&
                                        console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
                                    var s = [];
                                    return (
                                        this.dataAdapter.current(function (f) {
                                            s = f;
                                        }),
                                        s
                                    );
                                }),
                                (l.prototype.val = function (s) {
                                    if (
                                        (this.options.get("debug") &&
                                            window.console &&
                                            console.warn &&
                                            console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'),
                                        s == null || s.length === 0)
                                    )
                                        return this.$element.val();
                                    (s = s[0]),
                                        y.isArray(s) &&
                                            (s = y.map(s, function (f) {
                                                return f.toString();
                                            })),
                                        this.$element.val(s).trigger("change");
                                }),
                                (l.prototype.destroy = function () {
                                    this.$container.remove(),
                                        this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA),
                                        this._observer != null
                                            ? (this._observer.disconnect(), (this._observer = null))
                                            : this.$element[0].removeEventListener &&
                                              (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1),
                                              this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1),
                                              this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)),
                                        (this._syncA = null),
                                        (this._syncS = null),
                                        this.$element.off(".select2"),
                                        this.$element.attr("tabindex", v.GetData(this.$element[0], "old-tabindex")),
                                        this.$element.removeClass("select2-hidden-accessible"),
                                        this.$element.attr("aria-hidden", "false"),
                                        v.RemoveData(this.$element[0]),
                                        this.$element.removeData("select2"),
                                        this.dataAdapter.destroy(),
                                        this.selection.destroy(),
                                        this.dropdown.destroy(),
                                        this.results.destroy(),
                                        (this.dataAdapter = null),
                                        (this.selection = null),
                                        (this.dropdown = null),
                                        (this.results = null);
                                }),
                                (l.prototype.render = function () {
                                    var s = y('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
                                    return s.attr("dir", this.options.get("dir")), (this.$container = s), this.$container.addClass("select2-container--" + this.options.get("theme")), v.StoreData(s[0], "element", this.$element), s;
                                }),
                                l
                            );
                        }),
                        h.define("select2/compat/utils", ["jquery"], function (y) {
                            return {
                                syncCssClasses: function (_, v, d) {
                                    var l,
                                        s,
                                        f = [];
                                    (l = y.trim(_.attr("class"))) &&
                                        y((l = "" + l).split(/\s+/)).each(function () {
                                            this.indexOf("select2-") === 0 && f.push(this);
                                        }),
                                        (l = y.trim(v.attr("class"))) &&
                                            y((l = "" + l).split(/\s+/)).each(function () {
                                                this.indexOf("select2-") !== 0 && (s = d(this)) != null && f.push(s);
                                            }),
                                        _.attr("class", f.join(" "));
                                },
                            };
                        }),
                        h.define("select2/compat/containerCss", ["jquery", "./utils"], function (y, _) {
                            function v(l) {
                                return null;
                            }
                            function d() {}
                            return (
                                (d.prototype.render = function (l) {
                                    var s = l.call(this),
                                        f = this.options.get("containerCssClass") || "";
                                    y.isFunction(f) && (f = f(this.$element));
                                    var b,
                                        k = this.options.get("adaptContainerCssClass");
                                    return (
                                        (k = k || v),
                                        f.indexOf(":all:") !== -1 &&
                                            ((f = f.replace(":all:", "")),
                                            (b = k),
                                            (k = function (T) {
                                                var O = b(T);
                                                return O != null ? O + " " + T : T;
                                            })),
                                        (l = this.options.get("containerCss") || {}),
                                        y.isFunction(l) && (l = l(this.$element)),
                                        _.syncCssClasses(s, this.$element, k),
                                        s.css(l),
                                        s.addClass(f),
                                        s
                                    );
                                }),
                                d
                            );
                        }),
                        h.define("select2/compat/dropdownCss", ["jquery", "./utils"], function (y, _) {
                            function v(l) {
                                return null;
                            }
                            function d() {}
                            return (
                                (d.prototype.render = function (l) {
                                    var s = l.call(this),
                                        f = this.options.get("dropdownCssClass") || "";
                                    y.isFunction(f) && (f = f(this.$element));
                                    var b,
                                        k = this.options.get("adaptDropdownCssClass");
                                    return (
                                        (k = k || v),
                                        f.indexOf(":all:") !== -1 &&
                                            ((f = f.replace(":all:", "")),
                                            (b = k),
                                            (k = function (T) {
                                                var O = b(T);
                                                return O != null ? O + " " + T : T;
                                            })),
                                        (l = this.options.get("dropdownCss") || {}),
                                        y.isFunction(l) && (l = l(this.$element)),
                                        _.syncCssClasses(s, this.$element, k),
                                        s.css(l),
                                        s.addClass(f),
                                        s
                                    );
                                }),
                                d
                            );
                        }),
                        h.define("select2/compat/initSelection", ["jquery"], function (y) {
                            function _(v, d, l) {
                                l.get("debug") &&
                                    window.console &&
                                    console.warn &&
                                    console.warn(
                                        "Select2: The `initSelection` option has been deprecated in favor of a custom data adapter that overrides the `current` method. This method is now called multiple times instead of a single time when the instance is initialized. Support will be removed for the `initSelection` option in future versions of Select2"
                                    ),
                                    (this.initSelection = l.get("initSelection")),
                                    (this._isInitialized = !1),
                                    v.call(this, d, l);
                            }
                            return (
                                (_.prototype.current = function (v, d) {
                                    var l = this;
                                    this._isInitialized
                                        ? v.call(this, d)
                                        : this.initSelection.call(null, this.$element, function (s) {
                                              (l._isInitialized = !0), y.isArray(s) || (s = [s]), d(s);
                                          });
                                }),
                                _
                            );
                        }),
                        h.define("select2/compat/inputData", ["jquery", "../utils"], function (y, _) {
                            function v(d, l, s) {
                                (this._currentData = []),
                                    (this._valueSeparator = s.get("valueSeparator") || ","),
                                    l.prop("type") === "hidden" &&
                                        s.get("debug") &&
                                        console &&
                                        console.warn &&
                                        console.warn("Select2: Using a hidden input with Select2 is no longer supported and may stop working in the future. It is recommended to use a `<select>` element instead."),
                                    d.call(this, l, s);
                            }
                            return (
                                (v.prototype.current = function (d, l) {
                                    for (var s = [], f = 0; f < this._currentData.length; f++) {
                                        var b = this._currentData[f];
                                        s.push.apply(
                                            s,
                                            (function k(T, O) {
                                                var L = [];
                                                return T.selected || y.inArray(T.id, O) !== -1 ? ((T.selected = !0), L.push(T)) : (T.selected = !1), T.children && L.push.apply(L, k(T.children, O)), L;
                                            })(b, this.$element.val().split(this._valueSeparator))
                                        );
                                    }
                                    l(s);
                                }),
                                (v.prototype.select = function (d, l) {
                                    var s;
                                    this.options.get("multiple")
                                        ? ((s = this.$element.val()), (s += this._valueSeparator + l.id), this.$element.val(s))
                                        : (this.current(function (f) {
                                              y.map(f, function (b) {
                                                  b.selected = !1;
                                              });
                                          }),
                                          this.$element.val(l.id)),
                                        this.$element.trigger("change");
                                }),
                                (v.prototype.unselect = function (d, l) {
                                    var s = this;
                                    (l.selected = !1),
                                        this.current(function (f) {
                                            for (var b = [], k = 0; k < f.length; k++) {
                                                var T = f[k];
                                                l.id != T.id && b.push(T.id);
                                            }
                                            s.$element.val(b.join(s._valueSeparator)), s.$element.trigger("change");
                                        });
                                }),
                                (v.prototype.query = function (d, l, s) {
                                    for (var f = [], b = 0; b < this._currentData.length; b++) {
                                        var k = this._currentData[b],
                                            k = this.matches(l, k);
                                        k !== null && f.push(k);
                                    }
                                    s({ results: f });
                                }),
                                (v.prototype.addOptions = function (d, l) {
                                    (l = y.map(l, function (s) {
                                        return _.GetData(s[0], "data");
                                    })),
                                        this._currentData.push.apply(this._currentData, l);
                                }),
                                v
                            );
                        }),
                        h.define("select2/compat/matcher", ["jquery"], function (y) {
                            return function (_) {
                                return function (v, d) {
                                    var l = y.extend(!0, {}, d);
                                    if (v.term == null || y.trim(v.term) === "") return l;
                                    if (d.children) {
                                        for (var s = d.children.length - 1; 0 <= s; s--) {
                                            var f = d.children[s];
                                            _(v.term, f.text, f) || l.children.splice(s, 1);
                                        }
                                        if (0 < l.children.length) return l;
                                    }
                                    return _(v.term, d.text, d) ? l : null;
                                };
                            };
                        }),
                        h.define("select2/compat/query", [], function () {
                            function y(_, v, d) {
                                d.get("debug") &&
                                    window.console &&
                                    console.warn &&
                                    console.warn(
                                        "Select2: The `query` option has been deprecated in favor of a custom data adapter that overrides the `query` method. Support will be removed for the `query` option in future versions of Select2."
                                    ),
                                    _.call(this, v, d);
                            }
                            return (
                                (y.prototype.query = function (_, v, d) {
                                    (v.callback = d), this.options.get("query").call(null, v);
                                }),
                                y
                            );
                        }),
                        h.define("select2/dropdown/attachContainer", [], function () {
                            function y(_, v, d) {
                                _.call(this, v, d);
                            }
                            return (
                                (y.prototype.position = function (_, v, d) {
                                    d.find(".dropdown-wrapper").append(v), v.addClass("select2-dropdown--below"), d.addClass("select2-container--below");
                                }),
                                y
                            );
                        }),
                        h.define("select2/dropdown/stopPropagation", [], function () {
                            function y() {}
                            return (
                                (y.prototype.bind = function (_, v, d) {
                                    _.call(this, v, d),
                                        this.$dropdown.on(
                                            [
                                                "blur",
                                                "change",
                                                "click",
                                                "dblclick",
                                                "focus",
                                                "focusin",
                                                "focusout",
                                                "input",
                                                "keydown",
                                                "keyup",
                                                "keypress",
                                                "mousedown",
                                                "mouseenter",
                                                "mouseleave",
                                                "mousemove",
                                                "mouseover",
                                                "mouseup",
                                                "search",
                                                "touchend",
                                                "touchstart",
                                            ].join(" "),
                                            function (l) {
                                                l.stopPropagation();
                                            }
                                        );
                                }),
                                y
                            );
                        }),
                        h.define("select2/selection/stopPropagation", [], function () {
                            function y() {}
                            return (
                                (y.prototype.bind = function (_, v, d) {
                                    _.call(this, v, d),
                                        this.$selection.on(
                                            [
                                                "blur",
                                                "change",
                                                "click",
                                                "dblclick",
                                                "focus",
                                                "focusin",
                                                "focusout",
                                                "input",
                                                "keydown",
                                                "keyup",
                                                "keypress",
                                                "mousedown",
                                                "mouseenter",
                                                "mouseleave",
                                                "mousemove",
                                                "mouseover",
                                                "mouseup",
                                                "search",
                                                "touchend",
                                                "touchstart",
                                            ].join(" "),
                                            function (l) {
                                                l.stopPropagation();
                                            }
                                        );
                                }),
                                y
                            );
                        }),
                        (X = function (y) {
                            var _,
                                v,
                                d = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
                                l = "onwheel" in document || 9 <= document.documentMode ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
                                s = Array.prototype.slice;
                            if (y.event.fixHooks) for (var f = d.length; f; ) y.event.fixHooks[d[--f]] = y.event.mouseHooks;
                            var b = (y.event.special.mousewheel = {
                                version: "3.1.12",
                                setup: function () {
                                    if (this.addEventListener) for (var L = l.length; L; ) this.addEventListener(l[--L], k, !1);
                                    else this.onmousewheel = k;
                                    y.data(this, "mousewheel-line-height", b.getLineHeight(this)), y.data(this, "mousewheel-page-height", b.getPageHeight(this));
                                },
                                teardown: function () {
                                    if (this.removeEventListener) for (var L = l.length; L; ) this.removeEventListener(l[--L], k, !1);
                                    else this.onmousewheel = null;
                                    y.removeData(this, "mousewheel-line-height"), y.removeData(this, "mousewheel-page-height");
                                },
                                getLineHeight: function (L) {
                                    var I = y(L),
                                        L = I["offsetParent" in y.fn ? "offsetParent" : "parent"]();
                                    return L.length || (L = y("body")), parseInt(L.css("fontSize"), 10) || parseInt(I.css("fontSize"), 10) || 16;
                                },
                                getPageHeight: function (L) {
                                    return y(L).height();
                                },
                                settings: { adjustOldDeltas: !0, normalizeOffset: !0 },
                            });
                            function k(L) {
                                var I,
                                    Z = L || window.event,
                                    Y = s.call(arguments, 1),
                                    at = 0,
                                    ft = 0,
                                    ct = 0,
                                    Pt = 0,
                                    ee = 0;
                                if (
                                    (((L = y.event.fix(Z)).type = "mousewheel"),
                                    "detail" in Z && (ct = -1 * Z.detail),
                                    "wheelDelta" in Z && (ct = Z.wheelDelta),
                                    "wheelDeltaY" in Z && (ct = Z.wheelDeltaY),
                                    "wheelDeltaX" in Z && (ft = -1 * Z.wheelDeltaX),
                                    "axis" in Z && Z.axis === Z.HORIZONTAL_AXIS && ((ft = -1 * ct), (ct = 0)),
                                    (at = ct === 0 ? ft : ct),
                                    "deltaY" in Z && (at = ct = -1 * Z.deltaY),
                                    "deltaX" in Z && ((ft = Z.deltaX), ct === 0 && (at = -1 * ft)),
                                    ct !== 0 || ft !== 0)
                                ) {
                                    Z.deltaMode === 1 ? ((at *= I = y.data(this, "mousewheel-line-height")), (ct *= I), (ft *= I)) : Z.deltaMode === 2 && ((at *= ne = y.data(this, "mousewheel-page-height")), (ct *= ne), (ft *= ne));
                                    var ne = Math.max(Math.abs(ct), Math.abs(ft));
                                    return (
                                        (!v || ne < v) && O(Z, (v = ne)) && (v /= 40),
                                        O(Z, ne) && ((at /= 40), (ft /= 40), (ct /= 40)),
                                        (at = Math[1 <= at ? "floor" : "ceil"](at / v)),
                                        (ft = Math[1 <= ft ? "floor" : "ceil"](ft / v)),
                                        (ct = Math[1 <= ct ? "floor" : "ceil"](ct / v)),
                                        b.settings.normalizeOffset && this.getBoundingClientRect && ((ne = this.getBoundingClientRect()), (Pt = L.clientX - ne.left), (ee = L.clientY - ne.top)),
                                        (L.deltaX = ft),
                                        (L.deltaY = ct),
                                        (L.deltaFactor = v),
                                        (L.offsetX = Pt),
                                        (L.offsetY = ee),
                                        (L.deltaMode = 0),
                                        Y.unshift(L, at, ft, ct),
                                        _ && clearTimeout(_),
                                        (_ = setTimeout(T, 200)),
                                        (y.event.dispatch || y.event.handle).apply(this, Y)
                                    );
                                }
                            }
                            function T() {
                                v = null;
                            }
                            function O(L, I) {
                                return b.settings.adjustOldDeltas && L.type === "mousewheel" && I % 120 == 0;
                            }
                            y.fn.extend({
                                mousewheel: function (L) {
                                    return L ? this.bind("mousewheel", L) : this.trigger("mousewheel");
                                },
                                unmousewheel: function (L) {
                                    return this.unbind("mousewheel", L);
                                },
                            });
                        }),
                        typeof h.define == "function" && h.define.amd ? h.define("jquery-mousewheel", ["jquery"], X) : (typeof exports == "undefined" ? "undefined" : _typeof(exports)) == "object" ? (module.exports = X) : X(i),
                        h.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults", "./select2/utils"], function (y, _, v, d, l) {
                            var s;
                            return (
                                y.fn.select2 == null &&
                                    ((s = ["open", "close", "destroy"]),
                                    (y.fn.select2 = function (f) {
                                        if (_typeof((f = f || {})) == "object")
                                            return (
                                                this.each(function () {
                                                    var T = y.extend(!0, {}, f);
                                                    new v(y(this), T);
                                                }),
                                                this
                                            );
                                        if (typeof f != "string") throw new Error("Invalid arguments for Select2: " + f);
                                        var b,
                                            k = Array.prototype.slice.call(arguments, 1);
                                        return (
                                            this.each(function () {
                                                var T = l.GetData(this, "select2");
                                                T == null && window.console && console.error && console.error("The select2('" + f + "') method was called on an element that is not using Select2."), (b = T[f].apply(T, k));
                                            }),
                                            -1 < y.inArray(f, s) ? this : b
                                        );
                                    })),
                                y.fn.select2.defaults == null && (y.fn.select2.defaults = d),
                                v
                            );
                        }),
                        { define: h.define, require: h.require }),
                    h = X.require("jquery.select2");
                function tt(y, _) {
                    return J.call(y, _);
                }
                function it(y, _) {
                    var v,
                        d,
                        l,
                        s,
                        f,
                        b,
                        k,
                        T,
                        O,
                        L,
                        I = _ && _.split("/"),
                        Z = F.map,
                        Y = (Z && Z["*"]) || {};
                    if (y) {
                        for (_ = (y = y.split("/")).length - 1, F.nodeIdCompat && zt.test(y[_]) && (y[_] = y[_].replace(zt, "")), y[0].charAt(0) === "." && I && (y = I.slice(0, I.length - 1).concat(y)), T = 0; T < y.length; T++)
                            (L = y[T]) === "." ? (y.splice(T, 1), --T) : L === ".." && (T === 0 || (T === 1 && y[2] === "..") || y[T - 1] === ".." || (0 < T && (y.splice(T - 1, 2), (T -= 2))));
                        y = y.join("/");
                    }
                    if ((I || Y) && Z) {
                        for (T = (v = y.split("/")).length; 0 < T; --T) {
                            if (((d = v.slice(0, T).join("/")), I)) {
                                for (O = I.length; 0 < O; --O)
                                    if ((l = (l = Z[I.slice(0, O).join("/")]) && l[d])) {
                                        (s = l), (f = T);
                                        break;
                                    }
                            }
                            if (s) break;
                            !b && Y && Y[d] && ((b = Y[d]), (k = T));
                        }
                        !s && b && ((s = b), (f = k)), s && (v.splice(0, f, s), (y = v.join("/")));
                    }
                    return y;
                }
                function lt(y, _) {
                    return function () {
                        var v = wt.call(arguments, 0);
                        return typeof v[0] != "string" && v.length === 1 && v.push(null), u.apply(r, v.concat([y, _]));
                    };
                }
                function ht(y) {
                    var _;
                    if ((tt(W, y) && ((_ = W[y]), delete W[y], (Q[y] = !0), p.apply(r, _)), !tt(A, y) && !tt(Q, y))) throw new Error("No " + y);
                    return A[y];
                }
                function _t(y) {
                    var _,
                        v = y ? y.indexOf("!") : -1;
                    return -1 < v && ((_ = y.substring(0, v)), (y = y.substring(v + 1, y.length))), [_, y];
                }
                function et(y) {
                    return y ? _t(y) : [];
                }
                return (i.fn.select2.amd = X), h;
            }),
            (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports
                ? (module.exports = function (i, h) {
                      return h === void 0 && (h = typeof window != "undefined" ? require("jquery") : require("jquery")(i)), ni(h), h;
                  })
                : ni(jQuery),
            (G = window.Zepto || window.jQuery),
            (Me = window),
            (qe = document),
            (K.Defaults = {
                items: 3,
                loop: !1,
                center: !1,
                rewind: !1,
                checkVisibility: !0,
                mouseDrag: !0,
                touchDrag: !0,
                pullDrag: !0,
                freeDrag: !1,
                margin: 0,
                stagePadding: 0,
                merge: !1,
                mergeFit: !0,
                autoWidth: !1,
                startPosition: 0,
                rtl: !1,
                smartSpeed: 250,
                fluidSpeed: !1,
                dragEndSpeed: !1,
                responsive: {},
                responsiveRefreshRate: 200,
                responsiveBaseElement: Me,
                fallbackEasing: "swing",
                slideTransition: "",
                info: !1,
                nestedItemSelector: !1,
                itemElement: "div",
                stageElement: "div",
                refreshClass: "owl-refresh",
                loadedClass: "owl-loaded",
                loadingClass: "owl-loading",
                rtlClass: "owl-rtl",
                responsiveClass: "owl-responsive",
                dragClass: "owl-drag",
                itemClass: "owl-item",
                stageClass: "owl-stage",
                stageOuterClass: "owl-stage-outer",
                grabClass: "owl-grab",
            }),
            (K.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
            (K.Type = { Event: "event", State: "state" }),
            (K.Plugins = {}),
            (K.Workers = [
                {
                    filter: ["width", "settings"],
                    run: function () {
                        this._width = this.$element.width();
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function (i) {
                        i.current = this._items && this._items[this.relative(this._current)];
                    },
                },
                {
                    filter: ["items", "settings"],
                    run: function () {
                        this.$stage.children(".cloned").remove();
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function (i) {
                        var h = this.settings.margin || "",
                            m = !this.settings.autoWidth,
                            e = this.settings.rtl,
                            h = { width: "auto", "margin-left": e ? h : "", "margin-right": e ? "" : h };
                        m || this.$stage.children().css(h), (i.css = h);
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function (i) {
                        var h = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
                            m = null,
                            e = this._items.length,
                            r = !this.settings.autoWidth,
                            p = [];
                        for (i.items = { merge: !1, width: h }; e--; )
                            (m = this._mergers[e]), (m = (this.settings.mergeFit && Math.min(m, this.settings.items)) || m), (i.items.merge = 1 < m || i.items.merge), (p[e] = r ? h * m : this._items[e].width());
                        this._widths = p;
                    },
                },
                {
                    filter: ["items", "settings"],
                    run: function () {
                        var i = [],
                            h = this._items,
                            m = this.settings,
                            e = Math.max(2 * m.items, 4),
                            r = 2 * Math.ceil(h.length / 2),
                            p = m.loop && h.length ? (m.rewind ? e : Math.max(e, r)) : 0,
                            u = "",
                            D = "";
                        for (p /= 2; 0 < p; ) i.push(this.normalize(i.length / 2, !0)), (u += h[i[i.length - 1]][0].outerHTML), i.push(this.normalize(h.length - 1 - (i.length - 1) / 2, !0)), (D = h[i[i.length - 1]][0].outerHTML + D), --p;
                        (this._clones = i), G(u).addClass("cloned").appendTo(this.$stage), G(D).addClass("cloned").prependTo(this.$stage);
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function () {
                        for (var i, h, m = this.settings.rtl ? 1 : -1, e = this._clones.length + this._items.length, r = -1, p = []; ++r < e; )
                            (i = p[r - 1] || 0), (h = this._widths[this.relative(r)] + this.settings.margin), p.push(i + h * m);
                        this._coordinates = p;
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function () {
                        var i = this.settings.stagePadding,
                            h = this._coordinates,
                            i = { width: Math.ceil(Math.abs(h[h.length - 1])) + 2 * i, "padding-left": i || "", "padding-right": i || "" };
                        this.$stage.css(i);
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function (i) {
                        var h = this._coordinates.length,
                            m = !this.settings.autoWidth,
                            e = this.$stage.children();
                        if (m && i.items.merge) for (; h--; ) (i.css.width = this._widths[this.relative(h)]), e.eq(h).css(i.css);
                        else m && ((i.css.width = i.items.width), e.css(i.css));
                    },
                },
                {
                    filter: ["items"],
                    run: function () {
                        this._coordinates.length < 1 && this.$stage.removeAttr("style");
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function (i) {
                        (i.current = i.current ? this.$stage.children().index(i.current) : 0), (i.current = Math.max(this.minimum(), Math.min(this.maximum(), i.current))), this.reset(i.current);
                    },
                },
                {
                    filter: ["position"],
                    run: function () {
                        this.animate(this.coordinates(this._current));
                    },
                },
                {
                    filter: ["width", "position", "items", "settings"],
                    run: function () {
                        for (var i, h, m = this.settings.rtl ? 1 : -1, e = 2 * this.settings.stagePadding, r = this.coordinates(this.current()) + e, p = r + this.width() * m, u = [], D = 0, j = this._coordinates.length; D < j; D++)
                            (i = this._coordinates[D - 1] || 0), (h = Math.abs(this._coordinates[D]) + e * m), ((this.op(i, "<=", r) && this.op(i, ">", p)) || (this.op(h, "<", r) && this.op(h, ">", p))) && u.push(D);
                        this.$stage.children(".active").removeClass("active"),
                            this.$stage.children(":eq(" + u.join("), :eq(") + ")").addClass("active"),
                            this.$stage.children(".center").removeClass("center"),
                            this.settings.center && this.$stage.children().eq(this.current()).addClass("center");
                    },
                },
            ]),
            (K.prototype.initializeStage = function () {
                (this.$stage = this.$element.find("." + this.settings.stageClass)),
                    this.$stage.length ||
                        (this.$element.addClass(this.options.loadingClass),
                        (this.$stage = G("<" + this.settings.stageElement + ">", { class: this.settings.stageClass }).wrap(G("<div/>", { class: this.settings.stageOuterClass }))),
                        this.$element.append(this.$stage.parent()));
            }),
            (K.prototype.initializeItems = function () {
                var i = this.$element.find(".owl-item");
                if (i.length)
                    return (
                        (this._items = i.get().map(function (h) {
                            return G(h);
                        })),
                        (this._mergers = this._items.map(function () {
                            return 1;
                        })),
                        void this.refresh()
                    );
                this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass);
            }),
            (K.prototype.initialize = function () {
                var i, h;
                this.enter("initializing"),
                    this.trigger("initialize"),
                    this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
                    this.settings.autoWidth &&
                        !this.is("pre-loading") &&
                        ((i = this.$element.find("img")), (h = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : Qt), (h = this.$element.children(h).width()), i.length && h <= 0 && this.preloadAutoWidthImages(i)),
                    this.initializeStage(),
                    this.initializeItems(),
                    this.registerEventHandlers(),
                    this.leave("initializing"),
                    this.trigger("initialized");
            }),
            (K.prototype.isVisible = function () {
                return !this.settings.checkVisibility || this.$element.is(":visible");
            }),
            (K.prototype.setup = function () {
                var i = this.viewport(),
                    h = this.options.responsive,
                    m = -1,
                    e = null;
                h
                    ? (G.each(h, function (r) {
                          r <= i && m < r && (m = Number(r));
                      }),
                      typeof (e = G.extend({}, this.options, h[m])).stagePadding == "function" && (e.stagePadding = e.stagePadding()),
                      delete e.responsive,
                      e.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + m)))
                    : (e = G.extend({}, this.options)),
                    this.trigger("change", { property: { name: "settings", value: e } }),
                    (this._breakpoint = m),
                    (this.settings = e),
                    this.invalidate("settings"),
                    this.trigger("changed", { property: { name: "settings", value: this.settings } });
            }),
            (K.prototype.optionsLogic = function () {
                this.settings.autoWidth && ((this.settings.stagePadding = !1), (this.settings.merge = !1));
            }),
            (K.prototype.prepare = function (i) {
                var h = this.trigger("prepare", { content: i });
                return (
                    h.data ||
                        (h.data = G("<" + this.settings.itemElement + "/>")
                            .addClass(this.options.itemClass)
                            .append(i)),
                    this.trigger("prepared", { content: h.data }),
                    h.data
                );
            }),
            (K.prototype.update = function () {
                for (
                    var i = 0,
                        h = this._pipe.length,
                        m = G.proxy(function (r) {
                            return this[r];
                        }, this._invalidated),
                        e = {};
                    i < h;

                )
                    (this._invalidated.all || 0 < G.grep(this._pipe[i].filter, m).length) && this._pipe[i].run(e), i++;
                (this._invalidated = {}), this.is("valid") || this.enter("valid");
            }),
            (K.prototype.width = function (i) {
                switch ((i = i || K.Width.Default)) {
                    case K.Width.Inner:
                    case K.Width.Outer:
                        return this._width;
                    default:
                        return this._width - 2 * this.settings.stagePadding + this.settings.margin;
                }
            }),
            (K.prototype.refresh = function () {
                this.enter("refreshing"),
                    this.trigger("refresh"),
                    this.setup(),
                    this.optionsLogic(),
                    this.$element.addClass(this.options.refreshClass),
                    this.update(),
                    this.$element.removeClass(this.options.refreshClass),
                    this.leave("refreshing"),
                    this.trigger("refreshed");
            }),
            (K.prototype.onThrottledResize = function () {
                Me.clearTimeout(this.resizeTimer), (this.resizeTimer = Me.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate));
            }),
            (K.prototype.onResize = function () {
                return (
                    !!this._items.length &&
                    this._width !== this.$element.width() &&
                    !!this.isVisible() &&
                    (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))
                );
            }),
            (K.prototype.registerEventHandlers = function () {
                G.support.transition && this.$stage.on(G.support.transition.end + ".owl.core", G.proxy(this.onTransitionEnd, this)),
                    this.settings.responsive !== !1 && this.on(Me, "resize", this._handlers.onThrottledResize),
                    this.settings.mouseDrag &&
                        (this.$element.addClass(this.options.dragClass),
                        this.$stage.on("mousedown.owl.core", G.proxy(this.onDragStart, this)),
                        this.$stage.on("dragstart.owl.core selectstart.owl.core", function () {
                            return !1;
                        })),
                    this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", G.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", G.proxy(this.onDragEnd, this)));
            }),
            (K.prototype.onDragStart = function (i) {
                var h = null;
                i.which !== 3 &&
                    ((h = G.support.transform
                        ? {
                              x: (h = this.$stage
                                  .css("transform")
                                  .replace(/.*\(|\)| /g, "")
                                  .split(","))[h.length === 16 ? 12 : 4],
                              y: h[h.length === 16 ? 13 : 5],
                          }
                        : ((h = this.$stage.position()), { x: this.settings.rtl ? h.left + this.$stage.width() - this.width() + this.settings.margin : h.left, y: h.top })),
                    this.is("animating") && (G.support.transform ? this.animate(h.x) : this.$stage.stop(), this.invalidate("position")),
                    this.$element.toggleClass(this.options.grabClass, i.type === "mousedown"),
                    this.speed(0),
                    (this._drag.time = new Date().getTime()),
                    (this._drag.target = G(i.target)),
                    (this._drag.stage.start = h),
                    (this._drag.stage.current = h),
                    (this._drag.pointer = this.pointer(i)),
                    G(qe).on("mouseup.owl.core touchend.owl.core", G.proxy(this.onDragEnd, this)),
                    G(qe).one(
                        "mousemove.owl.core touchmove.owl.core",
                        G.proxy(function (m) {
                            var e = this.difference(this._drag.pointer, this.pointer(m));
                            G(qe).on("mousemove.owl.core touchmove.owl.core", G.proxy(this.onDragMove, this)), (Math.abs(e.x) < Math.abs(e.y) && this.is("valid")) || (m.preventDefault(), this.enter("dragging"), this.trigger("drag"));
                        }, this)
                    ));
            }),
            (K.prototype.onDragMove = function (i) {
                var h,
                    m = null,
                    e = null,
                    r = this.difference(this._drag.pointer, this.pointer(i)),
                    p = this.difference(this._drag.stage.start, r);
                this.is("dragging") &&
                    (i.preventDefault(),
                    this.settings.loop
                        ? ((m = this.coordinates(this.minimum())), (e = this.coordinates(this.maximum() + 1) - m), (p.x = ((((p.x - m) % e) + e) % e) + m))
                        : ((m = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum())),
                          (e = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum())),
                          (h = this.settings.pullDrag ? (-1 * r.x) / 5 : 0),
                          (p.x = Math.max(Math.min(p.x, m + h), e + h))),
                    (this._drag.stage.current = p),
                    this.animate(p.x));
            }),
            (K.prototype.onDragEnd = function (i) {
                var h = this.difference(this._drag.pointer, this.pointer(i)),
                    m = this._drag.stage.current,
                    i = (0 < h.x) ^ this.settings.rtl ? "left" : "right";
                G(qe).off(".owl.core"),
                    this.$element.removeClass(this.options.grabClass),
                    ((h.x !== 0 && this.is("dragging")) || !this.is("valid")) &&
                        (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
                        this.current(this.closest(m.x, h.x !== 0 ? i : this._drag.direction)),
                        this.invalidate("position"),
                        this.update(),
                        (this._drag.direction = i),
                        (3 < Math.abs(h.x) || 300 < new Date().getTime() - this._drag.time) &&
                            this._drag.target.one("click.owl.core", function () {
                                return !1;
                            })),
                    this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"));
            }),
            (K.prototype.closest = function (i, h) {
                var m = -1,
                    e = this.width(),
                    r = this.coordinates();
                return (
                    this.settings.freeDrag ||
                        G.each(
                            r,
                            G.proxy(function (p, u) {
                                return (
                                    h === "left" && u - 30 < i && i < u + 30
                                        ? (m = p)
                                        : h === "right" && u - e - 30 < i && i < u - e + 30
                                        ? (m = p + 1)
                                        : this.op(i, "<", u) && this.op(i, ">", r[p + 1] !== Qt ? r[p + 1] : u - e) && (m = h === "left" ? p + 1 : p),
                                    m === -1
                                );
                            }, this)
                        ),
                    this.settings.loop || (this.op(i, ">", r[this.minimum()]) ? (m = i = this.minimum()) : this.op(i, "<", r[this.maximum()]) && (m = i = this.maximum())),
                    m
                );
            }),
            (K.prototype.animate = function (i) {
                var h = 0 < this.speed();
                this.is("animating") && this.onTransitionEnd(),
                    h && (this.enter("animating"), this.trigger("translate")),
                    G.support.transform3d && G.support.transition
                        ? this.$stage.css({ transform: "translate3d(" + i + "px,0px,0px)", transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "") })
                        : h
                        ? this.$stage.animate({ left: i + "px" }, this.speed(), this.settings.fallbackEasing, G.proxy(this.onTransitionEnd, this))
                        : this.$stage.css({ left: i + "px" });
            }),
            (K.prototype.is = function (i) {
                return this._states.current[i] && 0 < this._states.current[i];
            }),
            (K.prototype.current = function (i) {
                return i === Qt
                    ? this._current
                    : this._items.length === 0
                    ? Qt
                    : ((i = this.normalize(i)),
                      this._current !== i &&
                          ((h = this.trigger("change", { property: { name: "position", value: i } })).data !== Qt && (i = this.normalize(h.data)),
                          (this._current = i),
                          this.invalidate("position"),
                          this.trigger("changed", { property: { name: "position", value: this._current } })),
                      this._current);
                var h;
            }),
            (K.prototype.invalidate = function (i) {
                return (
                    G.type(i) === "string" && ((this._invalidated[i] = !0), this.is("valid") && this.leave("valid")),
                    G.map(this._invalidated, function (h, m) {
                        return m;
                    })
                );
            }),
            (K.prototype.reset = function (i) {
                (i = this.normalize(i)) !== Qt && ((this._speed = 0), (this._current = i), this.suppress(["translate", "translated"]), this.animate(this.coordinates(i)), this.release(["translate", "translated"]));
            }),
            (K.prototype.normalize = function (i, h) {
                var m = this._items.length,
                    h = h ? 0 : this._clones.length;
                return !this.isNumeric(i) || m < 1 ? (i = Qt) : (i < 0 || m + h <= i) && (i = ((((i - h / 2) % m) + m) % m) + h / 2), i;
            }),
            (K.prototype.relative = function (i) {
                return (i -= this._clones.length / 2), this.normalize(i, !0);
            }),
            (K.prototype.maximum = function (i) {
                var h,
                    m,
                    e,
                    r = this.settings,
                    p = this._coordinates.length;
                if (r.loop) p = this._clones.length / 2 + this._items.length - 1;
                else if (r.autoWidth || r.merge) {
                    if ((h = this._items.length)) for (m = this._items[--h].width(), e = this.$element.width(); h-- && !((m += this._items[h].width() + this.settings.margin) > e); );
                    p = h + 1;
                } else p = r.center ? this._items.length - 1 : this._items.length - r.items;
                return i && (p -= this._clones.length / 2), Math.max(p, 0);
            }),
            (K.prototype.minimum = function (i) {
                return i ? 0 : this._clones.length / 2;
            }),
            (K.prototype.items = function (i) {
                return i === Qt ? this._items.slice() : ((i = this.normalize(i, !0)), this._items[i]);
            }),
            (K.prototype.mergers = function (i) {
                return i === Qt ? this._mergers.slice() : ((i = this.normalize(i, !0)), this._mergers[i]);
            }),
            (K.prototype.clones = function (i) {
                function h(r) {
                    return r % 2 == 0 ? e + r / 2 : m - (r + 1) / 2;
                }
                var m = this._clones.length / 2,
                    e = m + this._items.length;
                return i === Qt
                    ? G.map(this._clones, function (r, p) {
                          return h(p);
                      })
                    : G.map(this._clones, function (r, p) {
                          return r === i ? h(p) : null;
                      });
            }),
            (K.prototype.speed = function (i) {
                return i !== Qt && (this._speed = i), this._speed;
            }),
            (K.prototype.coordinates = function (i) {
                var h,
                    m = 1,
                    e = i - 1;
                return i === Qt
                    ? G.map(
                          this._coordinates,
                          G.proxy(function (r, p) {
                              return this.coordinates(p);
                          }, this)
                      )
                    : (this.settings.center ? (this.settings.rtl && ((m = -1), (e = i + 1)), (h = this._coordinates[i]), (h += ((this.width() - h + (this._coordinates[e] || 0)) / 2) * m)) : (h = this._coordinates[e] || 0), Math.ceil(h));
            }),
            (K.prototype.duration = function (i, h, m) {
                return m === 0 ? 0 : Math.min(Math.max(Math.abs(h - i), 1), 6) * Math.abs(m || this.settings.smartSpeed);
            }),
            (K.prototype.to = function (i, h) {
                var m,
                    e = this.current(),
                    r = i - this.relative(e),
                    p = (0 < r) - (r < 0),
                    u = this._items.length,
                    D = this.minimum(),
                    j = this.maximum();
                this.settings.loop
                    ? (!this.settings.rewind && Math.abs(r) > u / 2 && (r += -1 * p * u), (m = (((((i = e + r) - D) % u) + u) % u) + D) !== i && m - r <= j && 0 < m - r && this.reset((e = (i = m) - r)))
                    : (i = this.settings.rewind ? ((i % (j += 1)) + j) % j : Math.max(D, Math.min(j, i))),
                    this.speed(this.duration(e, i, h)),
                    this.current(i),
                    this.isVisible() && this.update();
            }),
            (K.prototype.next = function (i) {
                (i = i || !1), this.to(this.relative(this.current()) + 1, i);
            }),
            (K.prototype.prev = function (i) {
                (i = i || !1), this.to(this.relative(this.current()) - 1, i);
            }),
            (K.prototype.onTransitionEnd = function (i) {
                if (i !== Qt && (i.stopPropagation(), (i.target || i.srcElement || i.originalTarget) !== this.$stage.get(0))) return !1;
                this.leave("animating"), this.trigger("translated");
            }),
            (K.prototype.viewport = function () {
                var i;
                return (
                    this.options.responsiveBaseElement !== Me
                        ? (i = G(this.options.responsiveBaseElement).width())
                        : Me.innerWidth
                        ? (i = Me.innerWidth)
                        : qe.documentElement && qe.documentElement.clientWidth
                        ? (i = qe.documentElement.clientWidth)
                        : console.warn("Can not detect viewport width."),
                    i
                );
            }),
            (K.prototype.replace = function (i) {
                this.$stage.empty(),
                    (this._items = []),
                    (i = i && (i instanceof jQuery ? i : G(i))),
                    (i = this.settings.nestedItemSelector ? i.find("." + this.settings.nestedItemSelector) : i)
                        .filter(function () {
                            return this.nodeType === 1;
                        })
                        .each(
                            G.proxy(function (h, m) {
                                (m = this.prepare(m)), this.$stage.append(m), this._items.push(m), this._mergers.push(+m.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1);
                            }, this)
                        ),
                    this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0),
                    this.invalidate("items");
            }),
            (K.prototype.add = function (i, h) {
                var m = this.relative(this._current);
                (h = h === Qt ? this._items.length : this.normalize(h, !0)),
                    (i = i instanceof jQuery ? i : G(i)),
                    this.trigger("add", { content: i, position: h }),
                    (i = this.prepare(i)),
                    this._items.length === 0 || h === this._items.length
                        ? (this._items.length === 0 && this.$stage.append(i),
                          this._items.length !== 0 && this._items[h - 1].after(i),
                          this._items.push(i),
                          this._mergers.push(+i.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1))
                        : (this._items[h].before(i), this._items.splice(h, 0, i), this._mergers.splice(h, 0, +i.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)),
                    this._items[m] && this.reset(this._items[m].index()),
                    this.invalidate("items"),
                    this.trigger("added", { content: i, position: h });
            }),
            (K.prototype.remove = function (i) {
                (i = this.normalize(i, !0)) !== Qt &&
                    (this.trigger("remove", { content: this._items[i], position: i }),
                    this._items[i].remove(),
                    this._items.splice(i, 1),
                    this._mergers.splice(i, 1),
                    this.invalidate("items"),
                    this.trigger("removed", { content: null, position: i }));
            }),
            (K.prototype.preloadAutoWidthImages = function (i) {
                i.each(
                    G.proxy(function (h, m) {
                        this.enter("pre-loading"),
                            (m = G(m)),
                            G(new Image())
                                .one(
                                    "load",
                                    G.proxy(function (e) {
                                        m.attr("src", e.target.src), m.css("opacity", 1), this.leave("pre-loading"), this.is("pre-loading") || this.is("initializing") || this.refresh();
                                    }, this)
                                )
                                .attr("src", m.attr("src") || m.attr("data-src") || m.attr("data-src-retina"));
                    }, this)
                );
            }),
            (K.prototype.destroy = function () {
                for (var i in (this.$element.off(".owl.core"),
                this.$stage.off(".owl.core"),
                G(qe).off(".owl.core"),
                this.settings.responsive !== !1 && (Me.clearTimeout(this.resizeTimer), this.off(Me, "resize", this._handlers.onThrottledResize)),
                this._plugins))
                    this._plugins[i].destroy();
                this.$stage.children(".cloned").remove(),
                    this.$stage.unwrap(),
                    this.$stage.children().contents().unwrap(),
                    this.$stage.children().unwrap(),
                    this.$stage.remove(),
                    this.$element
                        .removeClass(this.options.refreshClass)
                        .removeClass(this.options.loadingClass)
                        .removeClass(this.options.loadedClass)
                        .removeClass(this.options.rtlClass)
                        .removeClass(this.options.dragClass)
                        .removeClass(this.options.grabClass)
                        .attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), ""))
                        .removeData("owl.carousel");
            }),
            (K.prototype.op = function (i, h, m) {
                var e = this.settings.rtl;
                switch (h) {
                    case "<":
                        return e ? m < i : i < m;
                    case ">":
                        return e ? i < m : m < i;
                    case ">=":
                        return e ? i <= m : m <= i;
                    case "<=":
                        return e ? m <= i : i <= m;
                }
            }),
            (K.prototype.on = function (i, h, m, e) {
                i.addEventListener ? i.addEventListener(h, m, e) : i.attachEvent && i.attachEvent("on" + h, m);
            }),
            (K.prototype.off = function (i, h, m, e) {
                i.removeEventListener ? i.removeEventListener(h, m, e) : i.detachEvent && i.detachEvent("on" + h, m);
            }),
            (K.prototype.trigger = function (i, h, m, e, r) {
                var p = { item: { count: this._items.length, index: this.current() } },
                    u = G.camelCase(
                        G.grep(["on", i, m], function (j) {
                            return j;
                        })
                            .join("-")
                            .toLowerCase()
                    ),
                    D = G.Event([i, "owl", m || "carousel"].join(".").toLowerCase(), G.extend({ relatedTarget: this }, p, h));
                return (
                    this._supress[i] ||
                        (G.each(this._plugins, function (j, A) {
                            A.onTrigger && A.onTrigger(D);
                        }),
                        this.register({ type: K.Type.Event, name: i }),
                        this.$element.trigger(D),
                        this.settings && typeof this.settings[u] == "function" && this.settings[u].call(this, D)),
                    D
                );
            }),
            (K.prototype.enter = function (i) {
                G.each(
                    [i].concat(this._states.tags[i] || []),
                    G.proxy(function (h, m) {
                        this._states.current[m] === Qt && (this._states.current[m] = 0), this._states.current[m]++;
                    }, this)
                );
            }),
            (K.prototype.leave = function (i) {
                G.each(
                    [i].concat(this._states.tags[i] || []),
                    G.proxy(function (h, m) {
                        this._states.current[m]--;
                    }, this)
                );
            }),
            (K.prototype.register = function (i) {
                var h;
                i.type === K.Type.Event
                    ? (G.event.special[i.name] || (G.event.special[i.name] = {}),
                      G.event.special[i.name].owl ||
                          ((h = G.event.special[i.name]._default),
                          (G.event.special[i.name]._default = function (m) {
                              return !h || !h.apply || (m.namespace && m.namespace.indexOf("owl") !== -1) ? m.namespace && -1 < m.namespace.indexOf("owl") : h.apply(this, arguments);
                          }),
                          (G.event.special[i.name].owl = !0)))
                    : i.type === K.Type.State &&
                      (this._states.tags[i.name] ? (this._states.tags[i.name] = this._states.tags[i.name].concat(i.tags)) : (this._states.tags[i.name] = i.tags),
                      (this._states.tags[i.name] = G.grep(
                          this._states.tags[i.name],
                          G.proxy(function (m, e) {
                              return G.inArray(m, this._states.tags[i.name]) === e;
                          }, this)
                      )));
            }),
            (K.prototype.suppress = function (i) {
                G.each(
                    i,
                    G.proxy(function (h, m) {
                        this._supress[m] = !0;
                    }, this)
                );
            }),
            (K.prototype.release = function (i) {
                G.each(
                    i,
                    G.proxy(function (h, m) {
                        delete this._supress[m];
                    }, this)
                );
            }),
            (K.prototype.pointer = function (i) {
                var h = { x: null, y: null };
                return (
                    (i = (i = i.originalEvent || i || Me.event).touches && i.touches.length ? i.touches[0] : i.changedTouches && i.changedTouches.length ? i.changedTouches[0] : i).pageX
                        ? ((h.x = i.pageX), (h.y = i.pageY))
                        : ((h.x = i.clientX), (h.y = i.clientY)),
                    h
                );
            }),
            (K.prototype.isNumeric = function (i) {
                return !isNaN(parseFloat(i));
            }),
            (K.prototype.difference = function (i, h) {
                return { x: i.x - h.x, y: i.y - h.y };
            }),
            (G.fn.owlCarousel = function (i) {
                var h = Array.prototype.slice.call(arguments, 1);
                return this.each(function () {
                    var m = G(this),
                        e = m.data("owl.carousel");
                    e ||
                        ((e = new K(this, _typeof(i) == "object" && i)),
                        m.data("owl.carousel", e),
                        G.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function (r, p) {
                            e.register({ type: K.Type.Event, name: p }),
                                e.$element.on(
                                    p + ".owl.carousel.core",
                                    G.proxy(function (u) {
                                        u.namespace && u.relatedTarget !== this && (this.suppress([p]), e[p].apply(this, [].slice.call(arguments, 1)), this.release([p]));
                                    }, e)
                                );
                        })),
                        typeof i == "string" && i.charAt(0) !== "_" && e[i].apply(e, h);
                });
            }),
            (G.fn.owlCarousel.Constructor = K),
            (oe = window.Zepto || window.jQuery),
            (si = window),
            (Ge.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
            (Ge.prototype.watch = function () {
                this._interval || ((this._visible = this._core.isVisible()), (this._interval = si.setInterval(oe.proxy(this.refresh, this), this._core.settings.autoRefreshInterval)));
            }),
            (Ge.prototype.refresh = function () {
                this._core.isVisible() !== this._visible && ((this._visible = !this._visible), this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh());
            }),
            (Ge.prototype.destroy = function () {
                var i, h;
                for (i in (si.clearInterval(this._interval), this._handlers)) this._core.$element.off(i, this._handlers[i]);
                for (h in Object.getOwnPropertyNames(this)) typeof this[h] != "function" && (this[h] = null);
            }),
            (oe.fn.owlCarousel.Constructor.Plugins.AutoRefresh = Ge),
            (he = window.Zepto || window.jQuery),
            (gt = window),
            (En.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }),
            (En.prototype.load = function (i) {
                var h = this._core.$stage.children().eq(i),
                    i = h && h.find(".owl-lazy");
                !i ||
                    -1 < he.inArray(h.get(0), this._loaded) ||
                    (i.each(
                        he.proxy(function (m, e) {
                            var r = he(e),
                                p = (1 < gt.devicePixelRatio && r.attr("data-src-retina")) || r.attr("data-src") || r.attr("data-srcset");
                            this._core.trigger("load", { element: r, url: p }, "lazy"),
                                r.is("img")
                                    ? r
                                          .one(
                                              "load.owl.lazy",
                                              he.proxy(function () {
                                                  r.css("opacity", 1), this._core.trigger("loaded", { element: r, url: p }, "lazy");
                                              }, this)
                                          )
                                          .attr("src", p)
                                    : r.is("source")
                                    ? r
                                          .one(
                                              "load.owl.lazy",
                                              he.proxy(function () {
                                                  this._core.trigger("loaded", { element: r, url: p }, "lazy");
                                              }, this)
                                          )
                                          .attr("srcset", p)
                                    : (((e = new Image()).onload = he.proxy(function () {
                                          r.css({ "background-image": 'url("' + p + '")', opacity: "1" }), this._core.trigger("loaded", { element: r, url: p }, "lazy");
                                      }, this)),
                                      (e.src = p));
                        }, this)
                    ),
                    this._loaded.push(h.get(0)));
            }),
            (En.prototype.destroy = function () {
                var i, h;
                for (i in this.handlers) this._core.$element.off(i, this.handlers[i]);
                for (h in Object.getOwnPropertyNames(this)) typeof this[h] != "function" && (this[h] = null);
            }),
            (he.fn.owlCarousel.Constructor.Plugins.Lazy = En),
            (te = window.Zepto || window.jQuery),
            (xn = window),
            (Fn.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
            (Fn.prototype.update = function () {
                var i = this._core._current,
                    h = i + this._core.settings.items,
                    m = this._core.settings.lazyLoad,
                    i = this._core.$stage.children().toArray().slice(i, h),
                    e = [],
                    h = 0;
                te.each(i, function (r, p) {
                    e.push(te(p).height());
                }),
                    (h = Math.max.apply(null, e)) <= 1 && m && this._previousHeight && (h = this._previousHeight),
                    (this._previousHeight = h),
                    this._core.$stage.parent().height(h).addClass(this._core.settings.autoHeightClass);
            }),
            (Fn.prototype.destroy = function () {
                var i, h;
                for (i in this._handlers) this._core.$element.off(i, this._handlers[i]);
                for (h in Object.getOwnPropertyNames(this)) typeof this[h] != "function" && (this[h] = null);
            }),
            (te.fn.owlCarousel.Constructor.Plugins.AutoHeight = Fn),
            (Vt = window.Zepto || window.jQuery),
            (Zn = document),
            (cn.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
            (cn.prototype.fetch = function (i, h) {
                var m = i.attr("data-vimeo-id") ? "vimeo" : i.attr("data-vzaar-id") ? "vzaar" : "youtube",
                    e = i.attr("data-vimeo-id") || i.attr("data-youtube-id") || i.attr("data-vzaar-id"),
                    r = i.attr("data-width") || this._core.settings.videoWidth,
                    p = i.attr("data-height") || this._core.settings.videoHeight,
                    u = i.attr("href");
                if (!u) throw new Error("Missing video URL.");
                if (
                    -1 <
                    (e = u.match(
                        /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
                    ))[3].indexOf("youtu")
                )
                    m = "youtube";
                else if (-1 < e[3].indexOf("vimeo")) m = "vimeo";
                else {
                    if (!(-1 < e[3].indexOf("vzaar"))) throw new Error("Video URL not supported.");
                    m = "vzaar";
                }
                (e = e[6]), (this._videos[u] = { type: m, id: e, width: r, height: p }), h.attr("data-video", u), this.thumbnail(i, this._videos[u]);
            }),
            (cn.prototype.thumbnail = function (i, h) {
                function m(W) {
                    (e = A.lazyLoad ? Vt("<div/>", { class: "owl-video-tn " + j, srcType: W }) : Vt("<div/>", { class: "owl-video-tn", style: "opacity:1;background-image:url(" + W + ")" })),
                        i.after(e),
                        i.after('<div class="owl-video-play-icon"></div>');
                }
                var e,
                    r,
                    p = h.width && h.height ? "width:" + h.width + "px;height:" + h.height + "px;" : "",
                    u = i.find("img"),
                    D = "src",
                    j = "",
                    A = this._core.settings;
                if ((i.wrap(Vt("<div/>", { class: "owl-video-wrapper", style: p })), this._core.settings.lazyLoad && ((D = "data-src"), (j = "owl-lazy")), u.length)) return m(u.attr(D)), u.remove(), !1;
                h.type === "youtube"
                    ? ((r = "//img.youtube.com/vi/" + h.id + "/hqdefault.jpg"), m(r))
                    : h.type === "vimeo"
                    ? Vt.ajax({
                          type: "GET",
                          url: "//vimeo.com/api/v2/video/" + h.id + ".json",
                          jsonp: "callback",
                          dataType: "jsonp",
                          success: function (W) {
                              (r = W[0].thumbnail_large), m(r);
                          },
                      })
                    : h.type === "vzaar" &&
                      Vt.ajax({
                          type: "GET",
                          url: "//vzaar.com/api/videos/" + h.id + ".json",
                          jsonp: "callback",
                          dataType: "jsonp",
                          success: function (W) {
                              (r = W.framegrab_url), m(r);
                          },
                      });
            }),
            (cn.prototype.stop = function () {
                this._core.trigger("stop", null, "video"),
                    this._playing.find(".owl-video-frame").remove(),
                    this._playing.removeClass("owl-video-playing"),
                    (this._playing = null),
                    this._core.leave("playing"),
                    this._core.trigger("stopped", null, "video");
            }),
            (cn.prototype.play = function (i) {
                var h = Vt(i.target).closest("." + this._core.settings.itemClass),
                    m = this._videos[h.attr("data-video")],
                    e = m.width || "100%",
                    r = m.height || this._core.$stage.height();
                this._playing ||
                    (this._core.enter("playing"),
                    this._core.trigger("play", null, "video"),
                    (h = this._core.items(this._core.relative(h.index()))),
                    this._core.reset(h.index()),
                    (i = Vt('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')).attr("height", r),
                    i.attr("width", e),
                    m.type === "youtube"
                        ? i.attr("src", "//www.youtube.com/embed/" + m.id + "?autoplay=1&rel=0&v=" + m.id)
                        : m.type === "vimeo"
                        ? i.attr("src", "//player.vimeo.com/video/" + m.id + "?autoplay=1")
                        : m.type === "vzaar" && i.attr("src", "//view.vzaar.com/" + m.id + "/player?autoplay=true"),
                    Vt(i).wrap('<div class="owl-video-frame" />').insertAfter(h.find(".owl-video")),
                    (this._playing = h.addClass("owl-video-playing")));
            }),
            (cn.prototype.isInFullScreen = function () {
                var i = Zn.fullscreenElement || Zn.mozFullScreenElement || Zn.webkitFullscreenElement;
                return i && Vt(i).parent().hasClass("owl-video-frame");
            }),
            (cn.prototype.destroy = function () {
                var i, h;
                for (i in (this._core.$element.off("click.owl.video"), this._handlers)) this._core.$element.off(i, this._handlers[i]);
                for (h in Object.getOwnPropertyNames(this)) typeof this[h] != "function" && (this[h] = null);
            }),
            (Vt.fn.owlCarousel.Constructor.Plugins.Video = cn),
            (Ne = window.Zepto || window.jQuery),
            (Cn.Defaults = { animateOut: !1, animateIn: !1 }),
            (Cn.prototype.swap = function () {
                var i, h, m, e, r, p;
                this.core.settings.items === 1 &&
                    Ne.support.animation &&
                    Ne.support.transition &&
                    (this.core.speed(0),
                    (h = Ne.proxy(this.clear, this)),
                    (m = this.core.$stage.children().eq(this.previous)),
                    (e = this.core.$stage.children().eq(this.next)),
                    (r = this.core.settings.animateIn),
                    (p = this.core.settings.animateOut),
                    this.core.current() !== this.previous &&
                        (p &&
                            ((i = this.core.coordinates(this.previous) - this.core.coordinates(this.next)),
                            m
                                .one(Ne.support.animation.end, h)
                                .css({ left: i + "px" })
                                .addClass("animated owl-animated-out")
                                .addClass(p)),
                        r && e.one(Ne.support.animation.end, h).addClass("animated owl-animated-in").addClass(r)));
            }),
            (Cn.prototype.clear = function (i) {
                Ne(i.target).css({ left: "" }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd();
            }),
            (Cn.prototype.destroy = function () {
                var i, h;
                for (i in this.handlers) this.core.$element.off(i, this.handlers[i]);
                for (h in Object.getOwnPropertyNames(this)) typeof this[h] != "function" && (this[h] = null);
            }),
            (Ne.fn.owlCarousel.Constructor.Plugins.Animate = Cn),
            (ye = window.Zepto || window.jQuery),
            (on = window),
            (Ke = document),
            (ln.Defaults = { autoplay: !1, autoplayTimeout: 5e3, autoplayHoverPause: !1, autoplaySpeed: !1 }),
            (ln.prototype._next = function (i) {
                (this._call = on.setTimeout(ye.proxy(this._next, this, i), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read())),
                    this._core.is("interacting") || Ke.hidden || this._core.next(i || this._core.settings.autoplaySpeed);
            }),
            (ln.prototype.read = function () {
                return new Date().getTime() - this._time;
            }),
            (ln.prototype.play = function (i, h) {
                var m;
                this._core.is("rotating") || this._core.enter("rotating"),
                    (i = i || this._core.settings.autoplayTimeout),
                    (m = Math.min(this._time % (this._timeout || i), i)),
                    this._paused ? ((this._time = this.read()), (this._paused = !1)) : on.clearTimeout(this._call),
                    (this._time += (this.read() % i) - m),
                    (this._timeout = i),
                    (this._call = on.setTimeout(ye.proxy(this._next, this, h), i - m));
            }),
            (ln.prototype.stop = function () {
                this._core.is("rotating") && ((this._time = 0), (this._paused = !0), on.clearTimeout(this._call), this._core.leave("rotating"));
            }),
            (ln.prototype.pause = function () {
                this._core.is("rotating") && !this._paused && ((this._time = this.read()), (this._paused = !0), on.clearTimeout(this._call));
            }),
            (ln.prototype.destroy = function () {
                var i, h;
                for (i in (this.stop(), this._handlers)) this._core.$element.off(i, this._handlers[i]);
                for (h in Object.getOwnPropertyNames(this)) typeof this[h] != "function" && (this[h] = null);
            }),
            (ye.fn.owlCarousel.Constructor.Plugins.autoplay = ln),
            (function (i) {
                "use strict";
                function h(m) {
                    (this._core = m),
                        (this._initialized = !1),
                        (this._pages = []),
                        (this._controls = {}),
                        (this._templates = []),
                        (this.$element = this._core.$element),
                        (this._overrides = { next: this._core.next, prev: this._core.prev, to: this._core.to }),
                        (this._handlers = {
                            "prepared.owl.carousel": i.proxy(function (e) {
                                e.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + i(e.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>");
                            }, this),
                            "added.owl.carousel": i.proxy(function (e) {
                                e.namespace && this._core.settings.dotsData && this._templates.splice(e.position, 0, this._templates.pop());
                            }, this),
                            "remove.owl.carousel": i.proxy(function (e) {
                                e.namespace && this._core.settings.dotsData && this._templates.splice(e.position, 1);
                            }, this),
                            "changed.owl.carousel": i.proxy(function (e) {
                                e.namespace && e.property.name == "position" && this.draw();
                            }, this),
                            "initialized.owl.carousel": i.proxy(function (e) {
                                e.namespace &&
                                    !this._initialized &&
                                    (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), (this._initialized = !0), this._core.trigger("initialized", null, "navigation"));
                            }, this),
                            "refreshed.owl.carousel": i.proxy(function (e) {
                                e.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"));
                            }, this),
                        }),
                        (this._core.options = i.extend({}, h.Defaults, this._core.options)),
                        this.$element.on(this._handlers);
                }
                (h.Defaults = {
                    nav: !1,
                    navText: ['<span aria-label="' + theme.strings.previous + '">&#x2039;</span>', '<span aria-label="' + theme.strings.next + '">&#x203a;</span>'],
                    navSpeed: !1,
                    navElement: 'button type="button" role="presentation"',
                    navContainer: !1,
                    navContainerClass: "owl-nav",
                    navClass: ["owl-prev", "owl-next"],
                    slideBy: 1,
                    dotClass: "owl-dot",
                    dotsClass: "owl-dots",
                    dots: !0,
                    dotsEach: !1,
                    dotsData: !1,
                    dotsSpeed: !1,
                    dotsContainer: !1,
                }),
                    (h.prototype.initialize = function () {
                        var m,
                            e = this._core.settings;
                        for (m in ((this._controls.$relative = (e.navContainer ? i(e.navContainer) : i("<div>").addClass(e.navContainerClass).appendTo(this.$element)).addClass("disabled")),
                        (this._controls.$previous = i("<" + e.navElement + ">")
                            .addClass(e.navClass[0])
                            .html(e.navText[0])
                            .prependTo(this._controls.$relative)
                            .on(
                                "click",
                                i.proxy(function (r) {
                                    this.prev(e.navSpeed);
                                }, this)
                            )),
                        (this._controls.$next = i("<" + e.navElement + ">")
                            .addClass(e.navClass[1])
                            .html(e.navText[1])
                            .appendTo(this._controls.$relative)
                            .on(
                                "click",
                                i.proxy(function (r) {
                                    this.next(e.navSpeed);
                                }, this)
                            )),
                        e.dotsData || (this._templates = [i('<button role="button">').addClass(e.dotClass).append(i("<span>")).prop("outerHTML")]),
                        (this._controls.$absolute = (e.dotsContainer ? i(e.dotsContainer) : i("<div>").addClass(e.dotsClass).appendTo(this.$element)).addClass("disabled")),
                        this._controls.$absolute.on(
                            "click",
                            "button",
                            i.proxy(function (r) {
                                var p = (i(r.target).parent().is(this._controls.$absolute) ? i(r.target) : i(r.target).parent()).index();
                                r.preventDefault(), this.to(p, e.dotsSpeed);
                            }, this)
                        ),
                        this._overrides))
                            this._core[m] = i.proxy(this[m], this);
                    }),
                    (h.prototype.destroy = function () {
                        var m,
                            e,
                            r,
                            p,
                            u = this._core.settings;
                        for (m in this._handlers) this.$element.off(m, this._handlers[m]);
                        for (e in this._controls) e === "$relative" && u.navContainer ? this._controls[e].html("") : this._controls[e].remove();
                        for (p in this.overides) this._core[p] = this._overrides[p];
                        for (r in Object.getOwnPropertyNames(this)) typeof this[r] != "function" && (this[r] = null);
                    }),
                    (h.prototype.update = function () {
                        var m,
                            e,
                            r = this._core.clones().length / 2,
                            p = r + this._core.items().length,
                            u = this._core.maximum(!0),
                            D = this._core.settings,
                            j = D.center || D.autoWidth || D.dotsData ? 1 : D.dotsEach || D.items;
                        if ((D.slideBy !== "page" && (D.slideBy = Math.min(D.slideBy, D.items)), D.dots || D.slideBy == "page"))
                            for (this._pages = [], m = r, e = 0; m < p; m++) {
                                if (j <= e || e === 0) {
                                    if ((this._pages.push({ start: Math.min(u, m - r), end: m - r + j - 1 }), Math.min(u, m - r) === u)) break;
                                    e = 0;
                                }
                                e += this._core.mergers(this._core.relative(m));
                            }
                    }),
                    (h.prototype.draw = function () {
                        var m = this._core.settings,
                            e = this._core.items().length <= m.items,
                            r = this._core.relative(this._core.current()),
                            p = m.loop || m.rewind;
                        this._controls.$relative.toggleClass("disabled", !m.nav || e),
                            m.nav && (this._controls.$previous.toggleClass("disabled", !p && r <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !p && r >= this._core.maximum(!0))),
                            this._controls.$absolute.toggleClass("disabled", !m.dots || e),
                            m.dots &&
                                ((e = this._pages.length - this._controls.$absolute.children().length),
                                m.dotsData && e != 0
                                    ? this._controls.$absolute.html(this._templates.join(""))
                                    : 0 < e
                                    ? this._controls.$absolute.append(new Array(1 + e).join(this._templates[0]))
                                    : e < 0 && this._controls.$absolute.children().slice(e).remove(),
                                this._controls.$absolute.find(".active").removeClass("active"),
                                this._controls.$absolute.children().eq(i.inArray(this.current(), this._pages)).addClass("active"));
                    }),
                    (h.prototype.onTrigger = function (m) {
                        var e = this._core.settings;
                        m.page = { index: i.inArray(this.current(), this._pages), count: this._pages.length, size: e && (e.center || e.autoWidth || e.dotsData ? 1 : e.dotsEach || e.items) };
                    }),
                    (h.prototype.current = function () {
                        var m = this._core.relative(this._core.current());
                        return i
                            .grep(
                                this._pages,
                                i.proxy(function (e, r) {
                                    return e.start <= m && e.end >= m;
                                }, this)
                            )
                            .pop();
                    }),
                    (h.prototype.getPosition = function (m) {
                        var e,
                            r,
                            p = this._core.settings;
                        return (
                            p.slideBy == "page"
                                ? ((e = i.inArray(this.current(), this._pages)), (r = this._pages.length), m ? ++e : --e, (e = this._pages[((e % r) + r) % r].start))
                                : ((e = this._core.relative(this._core.current())), (r = this._core.items().length), m ? (e += p.slideBy) : (e -= p.slideBy)),
                            e
                        );
                    }),
                    (h.prototype.next = function (m) {
                        i.proxy(this._overrides.to, this._core)(this.getPosition(!0), m);
                    }),
                    (h.prototype.prev = function (m) {
                        i.proxy(this._overrides.to, this._core)(this.getPosition(!1), m);
                    }),
                    (h.prototype.to = function (m, e, r) {
                        !r && this._pages.length ? ((r = this._pages.length), i.proxy(this._overrides.to, this._core)(this._pages[((m % r) + r) % r].start, e)) : i.proxy(this._overrides.to, this._core)(m, e);
                    }),
                    (i.fn.owlCarousel.Constructor.Plugins.Navigation = h);
            })(window.Zepto || window.jQuery, document),
            (function (i, h) {
                "use strict";
                function m(e) {
                    (this._core = e),
                        (this._hashes = {}),
                        (this.$element = this._core.$element),
                        (this._handlers = {
                            "initialized.owl.carousel": i.proxy(function (r) {
                                r.namespace && this._core.settings.startPosition === "URLHash" && i(h).trigger("hashchange.owl.navigation");
                            }, this),
                            "prepared.owl.carousel": i.proxy(function (r) {
                                var p;
                                !r.namespace || ((p = i(r.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash")) && (this._hashes[p] = r.content));
                            }, this),
                            "changed.owl.carousel": i.proxy(function (r) {
                                var p;
                                r.namespace &&
                                    r.property.name === "position" &&
                                    ((p = this._core.items(this._core.relative(this._core.current()))),
                                    (r = i
                                        .map(this._hashes, function (u, D) {
                                            return u === p ? D : null;
                                        })
                                        .join()) &&
                                        h.location.hash.slice(1) !== r &&
                                        (h.location.hash = r));
                            }, this),
                        }),
                        (this._core.options = i.extend({}, m.Defaults, this._core.options)),
                        this.$element.on(this._handlers),
                        i(h).on(
                            "hashchange.owl.navigation",
                            i.proxy(function (r) {
                                var p = h.location.hash.substring(1),
                                    u = this._core.$stage.children(),
                                    p = this._hashes[p] && u.index(this._hashes[p]);
                                p !== void 0 && p !== this._core.current() && this._core.to(this._core.relative(p), !1, !0);
                            }, this)
                        );
                }
                (m.Defaults = { URLhashListener: !1 }),
                    (m.prototype.destroy = function () {
                        var e, r;
                        for (e in (i(h).off("hashchange.owl.navigation"), this._handlers)) this._core.$element.off(e, this._handlers[e]);
                        for (r in Object.getOwnPropertyNames(this)) typeof this[r] != "function" && (this[r] = null);
                    }),
                    (i.fn.owlCarousel.Constructor.Plugins.Hash = m);
            })(window.Zepto || window.jQuery, window, document),
            (We = window.Zepto || window.jQuery),
            (pi = void 0),
            (ii = We("<support>").get(0).style),
            (Fe = "Webkit Moz O ms".split(" ")),
            (Ue = {
                transition: { end: { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd", transition: "transitionend" } },
                animation: { end: { WebkitAnimation: "webkitAnimationEnd", MozAnimation: "animationend", OAnimation: "oAnimationEnd", animation: "animationend" } },
            }),
            (Pe = function () {
                return !!re("transform");
            }),
            (Be = function () {
                return !!re("perspective");
            }),
            (Ze = function () {
                return !!re("animation");
            }),
            (function () {
                return !!re("transition");
            })() && ((We.support.transition = new String(Wn("transition"))), (We.support.transition.end = Ue.transition.end[We.support.transition])),
            Ze() && ((We.support.animation = new String(Wn("animation"))), (We.support.animation.end = Ue.animation.end[We.support.animation])),
            Pe() && ((We.support.transform = new String(Wn("transform"))), (We.support.transform3d = Be()));
    })(theme.jQuery);
//# sourceMappingURL=/s/files/1/0549/1438/3926/t/2/assets/vendor.js.map?v=1634565304
